'use strict';

/* v 3.9
author http://codecanyon.net/user/creativeinteractivemedia/portfolio?ref=creativeinteractivemedia
*/

var FLIPBOOK = FLIPBOOK || {};
FLIPBOOK.IScroll = IScroll;

FLIPBOOK.PdfService = function(pdfDocument, model, options) {

    var self = this;
    this.pdfDocument = pdfDocument;
    this.pdfInfo = pdfDocument._pdfInfo;
    this.numPages = this.pdfInfo.numPages;
    this.webgl = options.viewMode == 'webgl' && this.numPages > 1;
    this.options = options;
    this.main = options.main;
    this.model = model;

    this.pages = [];
    this.thumbs = [];
    this.canvasBuffer = [];
    this.viewports = [];
    this.textContents = [];
    this.pdfPages = [];
    this.pdfAnnotations = [];
    this.eventBus = new EventBus();

    this.linkService = new PDFLinkService({
            eventBus : this.eventBus,
        });
    this.linkService.setViewer(this.main);
    this.linkService.setDocument(pdfDocument);
    this.linkService.externalLinkTarget = 2;

    window._dbg = 0;

    this.getCanvas = function() {

        var i, c;

        for (i = 0; i < this.canvasBuffer.length; i++) {
            c = this.canvasBuffer[i];
            if (c.available) {
                c.available = false;
                c.double = false;
                break;
            }
            c = null;

        }

        if(!c ){
            c = document.createElement('canvas');
            c.available = false;
            c.index = this.canvasBuffer.length;
            this.canvasBuffer.push(c);
        }

        c.rendering = true;

        return c

    };

    this.isRendering = function(pi, size){
        var val = false;
        this.canvasBuffer.forEach(function(c) {
            if(c.size == size && c.pdfPageIndex == pi && c.rendering)
                val = true;
        });
        return val
    };

    this.isRendered = function(pi, size){
        var val = false;
        this.canvasBuffer.forEach(function(c) {
            if(c.size == size && c.pdfPageIndex == pi && c.rendered)
                val = true;
        });
        return val
    };

    this.setRightIndex = function(ri) {

        var self = this;
        var unloadedPages = [];
        var d = this.options.isMobile ? 4 : 10;

        d = 6;

        this.canvasBuffer.forEach(function(c) {

            var canDelete = !c.rendering && ((ri - c.pageIndex) > (1 + d)) || ((ri - c.pageIndex) < (- d));
            if (canDelete && c.pageIndex > -1) {
                if(c.pdfPageIndex > -1){
                    // self.pdfPagesRendered[c.pdfPageIndex][c.size] = false
                    // self.pdfPagesRendering[c.pdfPageIndex][c.size] = false
                    delete self.pages[c.pdfPageIndex].canvas[c.size];
                    self.pages[c.pdfPageIndex].cleanup();
                }

                unloadedPages.push({ index: c.pageIndex, size: c.size });
                if (c.double)
                    unloadedPages.push({ index: c.pageIndex - 1, size: c.size });
                c.getContext('2d').clearRect(0, 0, c.width, c.height);
                c.width = c.height = 0;

                c.pageIndex = -100;
                c.available = true;
                c.rendered  = false;
                // c.size = null
                // c.pdfPageIndex = null
                // c.pageIndex = null
            }
        });

        if (unloadedPages.length > 0)
            this.model.trigger('pageUnloaded', {unloadedPages:unloadedPages});

    };

    this.loadThumbs = function(convertToBlob, callback) {

        var self = this;

        this.thumbLoading = this.thumbLoading || 0;

        if (this.thumbLoading >= this.pdfInfo.numPages)

            callback.call(self);

        else

            this.loadThumb(this.thumbLoading, function(c) {
                self.options.thumbLoaded(c);
                self.thumbLoading++;
                    self.loadThumbs(convertToBlob, callback);
            });

    };

    this.loadThumb = function(index, callback) {

        var self = this;

        this.getViewport(index, function() {

            var page = self.pages[index];

            var scale = 100 / page.getViewport({scale:1}).height;

            var viewport = page.getViewport({scale:scale});

            var c = document.createElement('canvas');
            c.index = index;
            var context = c.getContext('2d');
            c.height = viewport.height;
            c.width = viewport.width;

            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.cleanupAfterRender = true;
            page.render(renderContext).then(function() {

                page.cleanup();

                if (callback) callback.call(self, c);

            });

        });
    };

    this.init = function(backCover) {

        self.getViewport(0, function(viewport) {

                self.r1 = viewport.width / viewport.height;

                if (self.pdfInfo.numPages == 1) {
                    self.double = false;
                    self.model.trigger('pdfinit');
                    // self.trigger("init")
                } else {
                    self.getViewport(1, function(viewport) {
                        self.r2 = viewport.width / viewport.height;
                        self.double = self.r2 / self.r1 > 1.5;

                        //last page index
                        self.backCover = backCover || true;

                        self.model.trigger('pdfinit');

                        // out - caused entire pdf to be downloaded before displaying

                        /*self.getViewport(self.pdfInfo.numPages - 1, function(viewport) {
                            self.r3 = viewport.width / viewport.height
                            self.backCover = self.r3 / self.r1 < 1.5
                            self.trigger("init")
                        })*/

                    });

                }

            });
    };

    this.loadOutline = function(callback){

        var self = this;
        this.pdfDocument.getOutline().then(function(outline){
            self.outline = outline;
            self.outlineLoaded = true;
            callback.call(self, outline);
            // self.trigger("outlineLoaded")
        });

    };

    this.startLoadingText = function(){

        this.loadingText = true;

    };

    this.stopLoadingText = function(){

        this.loadingText = false;

    };

    this.getViewport = function(index, callback) {
        if (index >= self.pdfInfo.numPages)
            return
        if (!self.pages[index]) {
            // console.log('getViewport ',index)
            pdfDocument.getPage(index + 1).then(function(page) {
                self.pages[page.pageIndex] = page;
                // self.viewports[index] = page.getViewport(1);
                // callback.call(self, self.viewports[index]);

                self.getViewport(page.pageIndex, callback);
            });
        } else {
            self.viewports[index] = self.pages[index].getViewport({scale:1});
            callback.call(self, self.viewports[index]);
        }
    };

    this.getAllViewports = function(callback) {

    };

    this.getText = function(index, callback) {
        var self = this;
        this.getViewport(index, function(viewport) {
            var page = self.pages[index];

            self.getTextContent(page, function() {
                // console.log(page)
                callback.call(self, page);

            });

        });
    };

    this.getTextAllPages = function(callback) {

        var self = this;

        this.loadingTextFromPage = this.loadingTextFromPage || 0;

        this.getText(this.loadingTextFromPage, function() {

            if (self.loadingTextFromPage == (self.numPages - 1)){
                if (callback)
                    callback.call(self);
            } else {
                self.loadingTextFromPage++;
                    self.getTextAllPages(callback);
            }

        });

    };

    this.findInPage = function(str, index, callback) {

        //console.log("find ", str, index)
        var self = this;
        this.findInPageCallbacks = this.findInPageCallbacks || [];
        this.findInPageCallbacks[index] = callback;
        this.searchingString = str;

        if(this.pages[index] && this.pages[index].textContent){
            self.findInPageTextContentAvailable(this.pages[index],index);
        }else {
            this.getText(index, function(page) {
                self.findInPageTextContentAvailable(page,index);
            });
        }

    };

    this.findInPageTextContentAvailable = function(page,index){
         //console.log("page text ready ", index)
            var arr = page.textContent.items;
            var matches = 0;
            for (var i = 0; i < arr.length; i++) {
                var s = arr[i].str;
                if (s.includes(this.searchingString))
                    matches++;
                    if (s.toUpperCase().includes(this.searchingString.toUpperCase()))
                        matches++;
            }

            var callback = this.findInPageCallbacks[index];
            if(callback)
                callback.call(this, matches, page.htmlContent);
            this.findInPageCallbacks[index] = null;
    };

    this.getThumb = function(index, size, callback) {

        this.getViewport(index, function(viewport) {
            var page = self.pages[index];
            if (page.thumb)
                callback.call(self, page.thumb);
            else {
                //render thumb first
                var scale = size / self.viewports[index].height;
                var viewport = page.getViewport({scale:scale});
                var c = document.createElement('canvas');
                page.thumb = c;
                var context = c.getContext('2d');
                c.height = viewport.height;
                c.width = viewport.width;

                var renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };
                page.cleanupAfterRender = true;
                page.render(renderContext).then(function() {
                    page.cleanup();
                    callback.call(self, page.thumb);

                });

            }

        });
    };

    this.getPage = function(index, callback) {

        var self = this;
        var pdfPageIndex = self.double ? Math.round(index / 2) + 1 : index + 1;
        if (pdfPageIndex > this.pdfInfo.numPages)
            return;
        // if (self.pages[pdfPageIndex])
        //     self.renderPage(self.pages[pdfPageIndex], callback)
        // else {
        pdfDocument.getPage(index).then(function(p) {
            // self.pages[index] = p
            self.renderPage(p, callback);
        });
        // }
    };

    this.renderPage = function(page, size, callback) {

        var self = this;
        page.canvas = page.canvas || {};

        if (page.canvas[size] && page.canvas[size].rendered) {
            if(callback)
                callback.call(self, page);
            callback = null;
            return
        }

        if (page.rendering) {

            setTimeout(function() {
                self.renderPage(page, size, callback);
                return
            }, 300);
        }
        page.rendering = true;

        var canvas = self.getCanvas();
        canvas.size = size;
        canvas.pdfPageIndex = page.pageIndex;

        var v = page.getViewport({scale:1});
        var portrait = v.width <= v.height;
        var scale = portrait || !self.webgl ? size / v.height : size / v.width;
        var viewport = page.getViewport({scale:scale});

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        if (self.webgl) {

            if (portrait) {
                canvas.height = size;
                canvas.width = viewport.width > size ? viewport.width : size;
                canvas.scaleX = viewport.width / size;
                canvas.scaleY = 1;
            } else {
                canvas.width = size;
                canvas.height = viewport.height > size ? viewport.height : size;
                canvas.scaleY = viewport.height / size;
                canvas.scaleX = 1;
            }
        }

        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#FFFFFF';
        ctx.fillStyle = '#000000';

        var renderContext = {
            canvasContext: ctx,
            viewport: viewport,
            //renderInteractiveForms: false
            //textLayer: textLayer
        };

        page.scale = scale;
        page.canvas[size] = canvas;
        page.canvas[size].ratio = viewport.width / viewport.height;

        page.cleanupAfterRender = true;

        var renderTask = page.render(renderContext);
        renderTask.promise.then(function() {
            renderContext = null;
            if (callback)
                callback.call(self, page);
            page.rendering = false;
            callback = null;
        });

    };

    this.renderBookPage = function(bookPageIndex, size, callback) {

        var pageIndex = this.options.doublePage ? Math.round(bookPageIndex / 2) : bookPageIndex;

        this.renderPageFromPdf(pageIndex, size ,callback);

    };

    this.loadPageTextLayer = function(pageIndex, bookPageIndex, callback) {

        var self = this;
        var page = this.pages[pageIndex];

        if (pageIndex >= this.pdfInfo.numPages)
            callback.call(self);

        if (!this.pages[pageIndex]) {
            this.getViewport(pageIndex, function(viewport) {
                self.loadPageTextLayer(pageIndex, bookPageIndex, callback);
            });
            return
        }

        if (self.options.textLayer) {

            if(!page.textContentLoaded && !page.textContentLoading){

                page.textContentLoading = true;

                page.getTextContent().then(function(textContent) {

                    page.textContentLoaded = true;
                    page.textContentLoading = false;

                    page.textContent = textContent;

                    // self.eventBus.on("textlayerrendered", function(e){
                    self.loadPageTextLayer(pageIndex, bookPageIndex, callback);
                    // })

                });

                return

            }

        }

        if(!page.annotationsLoaded && !page.annotationsLoading){

            page.annotationsLoading = true;

            page.getAnnotations({ intent: "display" }).then(function (annotations) {

                page.annotationsLoaded = true;
                page.annotationsLoading = false;

                page.annotations = annotations;

                self.loadPageTextLayer(pageIndex, bookPageIndex, callback);

            });

            return

         }

        if(page.annotationsLoading || page.textContentLoading || !page.annotationsLoaded || !page.textContentLoaded){
            setTimeout(function(){
                self.loadPageTextLayer(pageIndex, bookPageIndex, callback);
            }, 100);

            return
        }

        callback.call(this, page, bookPageIndex);

    };

    this.loadTextLayer = function(bookPageIndex, callback) {

        var pageIndex = this.options.doublePage ? Math.round(bookPageIndex / 2) : bookPageIndex;
        var self = this;



            this.loadPageTextLayer(pageIndex, bookPageIndex, function(pdfPage, bookPageIndex){

                var page = options.pages[bookPageIndex] || {};
                page.index = bookPageIndex;

                if(!page.htmlContentInitialized){

                    page.htmlContentInitialized = true;
                    page.textRendering = true;

                    // console.log("initialized book page "+bookPageIndex)

                    var h = document.createElement('div');
                    h.classList.add('flipbook-page-htmlContent');

                    var textLayerDiv = document.createElement('div');
                    textLayerDiv.className = 'flipbook-textLayer';
                    h.appendChild(textLayerDiv);

                    var scale = 1000 / pdfPage.getViewport({scale:1}).height;

                    textLayerDiv.style.width = String(1000 * pdfPage.getViewport({scale:1}).width / pdfPage.getViewport({scale:1}).height) + "px";
                    textLayerDiv.style.height = "1000px";

                    var textLayer = new TextLayerBuilder({
                        eventBus : self.eventBus,
                        textLayerDiv: textLayerDiv,
                        pageIndex: pageIndex,
                        viewport: pdfPage.getViewport({scale:scale})
                    });

                    //the page. It is set to page.number - 1.
                    textLayer.setTextContent(pdfPage.textContent);
                    // textLayer.render(TEXT_LAYER_RENDER_DELAY);

                    textLayer.render();

                    if(pdfPage.annotations.length > 0){

                        var div = document.createElement('div');
                        div.className = 'annotationLayer';
                        h.appendChild(div);

                        var parameters = {
                            viewport: pdfPage.getViewport({scale:1000/pdfPage.getViewport({scale:1}).height}).clone({ dontFlip: true }),
                            div: div,
                            annotations: pdfPage.annotations,
                            page: pdfPage,
                            linkService: self.linkService
                        };

                        pdfjsLib.AnnotationLayer.render(parameters);

                    }

                    h.style.transformOrigin = '0 0';

                    self.eventBus.on("textlayerrendered", function(e){

                        if(e.source.pageIdx == pageIndex){

                            page.textRendering = false;

//                             console.log(e)
                            // console.log("textlayerrendered , book page index : "+bookPageIndex)
//                             console.log(encodeURIComponent(h.innerHTML))

                            callback.call(self);
                        }
                    });




                    if (page.htmlContent)
                        jQuery(h).append(jQuery(page.htmlContent));

                    page.htmlContent = h;

                    return



                }else if(!page.textRendering){

                    callback.call(self);

                }

            });


    };

    this.renderPageFromPdf = function(pageIndex, size, callback) {

        var self = this;

        if (pageIndex >= this.pdfInfo.numPages)
            callback.call(self);

        if (!this.pages[pageIndex]) {
            this.getViewport(pageIndex, function(viewport) {
                self.renderPageFromPdf(pageIndex, size, callback);
            });
            return
        }

        var pi = pageIndex,
            page = this.pages[pageIndex],
            v = page.getViewport({scale:1}),
            d = Math.max(v.width, v.height),
            d = v.height;


        if (this.isRendering(pi, size)){

            setTimeout(function(){
                self.renderPageFromPdf(pageIndex, size, callback);
                }, 300);
            return

        }else if (this.isRendered(pi, size)) {

            this.onPdfPageRendered(self.pages[pi], size, callback);

        } else {

            this.renderPage(page, size, function(page) {

                self.onPdfPageRendered(page, size, callback);

            });

        }
    };

    this.onBookPageRendered = function(page, canvas, index, size) {

        var index = index, size = size;

        this.model.trigger('pageLoaded', {index:index, size:size, canvas:canvas});

    };

    this.getBookPage = function(index, size){

        var toReturn = null;
        this.canvasBuffer.forEach(function(c){
            if(c.pageIndex == index && c.size == size)
                toReturn = c;
        });

        return toReturn
    };

    this.onPdfPageRendered = function(page, size, callback) {

        var self = this;

        if (!page.canvas) return;
        if (!page.canvas[size]) return;

        var c = page.canvas[size],
            pdfPageIndex = page.pageIndex;
            c.pdfPageIndex = pdfPageIndex;

        if (options.doublePage) {

            if (pdfPageIndex == 0) {

                c.pageIndex = 0;
                c.rendering = false;
                c.rendered = true;
                self.onBookPageRendered(page, c, 0, size);

            } else if (pdfPageIndex == options.pages.length / 2) {

                c.pageIndex = options.numPages - 1;
                c.rendering = false;
                c.rendered = true;
                self.onBookPageRendered(page, c, options.numPages - 1, size);

            } else {

                if (self.webgl) {

                    c.double = true;

                    c.scaleX = (c.width / 2) / size;
                    c.scaleY = c.scaleY;

                    c.pageIndex = 2 * pdfPageIndex;
                    c.rendering = false;
                    c.rendered = true;
                    self.onBookPageRendered(page, c, 2 * pdfPageIndex, size);
                    self.onBookPageRendered(page, c, 2 * pdfPageIndex - 1, size);


                } else {

                    // double page

                    var loadedIndexR = self.options.rightToLeft ? 2 * pdfPageIndex - 1 : 2 * pdfPageIndex;
                    var loadedIndexL = self.options.rightToLeft ? 2 * pdfPageIndex : 2 * pdfPageIndex - 1;
                    var lCanvas = this.getBookPage(loadedIndexL, size);

                    if(!lCanvas){
                        lCanvas = self.getCanvas();
                        lCanvas.size = size;

                        var lcontext = lCanvas.getContext('2d');


                        //set dimensions
                        lCanvas.width = c.width / 2;
                        lCanvas.height = c.height;

                        lcontext.fillStyle = '#FFFFFF';
                        lCanvas.pageIndex = loadedIndexL;
                        lCanvas.pdfPageIndex = pdfPageIndex;
                        lcontext.drawImage(c, 0, 0);

                        lCanvas.rendering = false;
                        lCanvas.rendered = true;
                    }

                    self.onBookPageRendered(page, lCanvas, loadedIndexL, size);

                    var rCanvas = this.getBookPage(loadedIndexR, size);

                    if(!rCanvas){
                        rCanvas = self.getCanvas();
                        rCanvas.size = size;
                        // console.log("            ++++++++++++  rendering book page "+loadedIndexR+" "+size+" to canvas "+ rCanvas.index)
                        var rcontext = rCanvas.getContext('2d');

                        rCanvas.width = c.width / 2;
                        rCanvas.height = c.height;

                        rcontext.fillStyle = '#FFFFFF';
                        rCanvas.pageIndex = loadedIndexR;
                        rCanvas.pdfPageIndex = pdfPageIndex;
                        rcontext.drawImage(c, c.width / 2, 0, c.width / 2, c.height, 0, 0, c.width / 2, c.height);

                        rCanvas.rendering = false;
                        rCanvas.rendered = true;

                    }

                    self.onBookPageRendered(page, rCanvas, loadedIndexR, size);

                    c.size = 200;
                    c.pageIndex = loadedIndexL;
                    c.rendering = false;
                    c.rendered = true;

                }

            }

        } else {

            c.pageIndex = pdfPageIndex;
            c.size = size;
            c.rendering = false;
            c.rendered = true;
            self.onBookPageRendered(page, c, pdfPageIndex, size);

        }

        if (callback)
            callback.call(self, { canvas: c, lCanvas: lCanvas, rCanvas: rCanvas, size: size, pdfPageIndex: pdfPageIndex, htmlContent: page.htmlContent });
        callback = null;

    };

    this.getTextContent = function(page, callback) {

        if (page.textContent)
            callback(page);
        else {

            page.getTextContent().then(function(textContent) {

                page.textContent = textContent;

                callback(page);

            });

        }

    };


    //////////////////napravi sa drawimage
    /*function cloneCanvas(c) {
        var data = c.getContext("2d").getImageData(0, 0, c.width, c.height)
        var c2 = document.createElement('canvas');
        c2.width = c.width;
        c2.height = c.height;
        var ctx2 = c2.getContext('2d');
        ctx2.putImageData(data, 0, 0);
        c.duplicate = c2
        return c2
    }*/

    this.getCanvasByHeight = function(index, height, onComplete) {

    };

    // this.getThumb = function(index, complete) {

    // }

};

FLIPBOOK.PdfService.prototype = {



};


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// var _dom_events = __webpack_require__(14);

// var _pdfjsLib = __webpack_require__(7);

// var _ui_utils = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var EventBus = function () {
  function EventBus() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$dispatchToDOM = _ref7.dispatchToDOM,
        dispatchToDOM = _ref7$dispatchToDOM === undefined ? false : _ref7$dispatchToDOM;

    _classCallCheck(this, EventBus);

    this._listeners = Object.create(null);
    this._dispatchToDOM = dispatchToDOM === true;
  }

  _createClass(EventBus, [{
    key: 'on',
    value: function on(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners) {
        eventListeners = [];
        this._listeners[eventName] = eventListeners;
      }
      eventListeners.push(listener);
    }
  }, {
    key: 'off',
    value: function off(eventName, listener) {
      var eventListeners = this._listeners[eventName];
      var i = void 0;
      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
        return;
      }
      eventListeners.splice(i, 1);
    }
  }, {
    key: 'dispatch',
    value: function dispatch(eventName) {
      var eventListeners = this._listeners[eventName];
      if (!eventListeners || eventListeners.length === 0) {
        if (this._dispatchToDOM) {
          var _args5 = Array.prototype.slice.call(arguments, 1);
          this._dispatchDOMEvent(eventName, _args5);
        }
        return;
      }
      var args = Array.prototype.slice.call(arguments, 1);
      eventListeners.slice(0).forEach(function (listener) {
        listener.apply(null, args);
      });
      if (this._dispatchToDOM) {
        this._dispatchDOMEvent(eventName, args);
      }
    }
  }, {
    key: '_dispatchDOMEvent',
    value: function _dispatchDOMEvent(eventName) {
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this._dispatchToDOM) {
        return;
      }
      var details = Object.create(null);
      if (args && args.length > 0) {
        var obj = args[0];
        for (var key in obj) {
          var value = obj[key];
          if (key === 'source') {
            if (value === window || value === document) {
              return;
            }
            continue;
          }
          details[key] = value;
        }
      }
      var event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, true, details);
      document.dispatchEvent(event);
    }
  }]);

  return EventBus;
}();





var EXPAND_DIVS_TIMEOUT = 300;
var MATCH_SCROLL_OFFSET_TOP = -50;
var MATCH_SCROLL_OFFSET_LEFT = -400;

var TextLayerBuilder = function () {
  function TextLayerBuilder(_ref) {
    var textLayerDiv = _ref.textLayerDiv,
        eventBus = _ref.eventBus,
        pageIndex = _ref.pageIndex,
        viewport = _ref.viewport,
        _ref$findController = _ref.findController,
        findController = _ref$findController === undefined ? null : _ref$findController,
        _ref$enhanceTextSelec = _ref.enhanceTextSelection,
        enhanceTextSelection = _ref$enhanceTextSelec === undefined ? false : _ref$enhanceTextSelec;

    _classCallCheck(this, TextLayerBuilder);

    this.textLayerDiv = textLayerDiv;
    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.textContent = null;
    this.textContentItemsStr = [];
    this.textContentStream = null;
    this.renderingDone = false;
    this.pageIdx = pageIndex;
    this.pageNumber = this.pageIdx + 1;
    this.matches = [];
    this.viewport = viewport;
    this.textDivs = [];
    this.findController = findController;
    this.textLayerRenderTask = null;
    this.enhanceTextSelection = enhanceTextSelection;
    this._boundEvents = Object.create(null);
    this._bindEvents();
    this._bindMouse();
  }

  _createClass(TextLayerBuilder, [{
    key: '_finishRendering',
    value: function _finishRendering() {
      this.renderingDone = true;
      if (!this.enhanceTextSelection) {
        var endOfContent = document.createElement('div');
        endOfContent.className = 'endOfContent';
        this.textLayerDiv.appendChild(endOfContent);
      }
      this.eventBus.dispatch('textlayerrendered', {
        source: this,
        pageNumber: this.pageNumber,
        numTextDivs: this.textDivs.length
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!(this.textContent || this.textContentStream) || this.renderingDone) {
        return;
      }
      this.cancel();
      this.textDivs = [];
      var textLayerFrag = document.createDocumentFragment();
      this.textLayerRenderTask = (0, pdfjsLib.renderTextLayer)({
        textContent: this.textContent,
        textContentStream: this.textContentStream,
        container: textLayerFrag,
        viewport: this.viewport,
        textDivs: this.textDivs,
        textContentItemsStr: this.textContentItemsStr,
        timeout: timeout,
        enhanceTextSelection: this.enhanceTextSelection
      });
      this.textLayerRenderTask.promise.then(function () {
        _this.textLayerDiv.appendChild(textLayerFrag);
        _this._finishRendering();
        _this.updateMatches();
      }, function (reason) {});
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (this.textLayerRenderTask) {
        this.textLayerRenderTask.cancel();
        this.textLayerRenderTask = null;
      }
    }
  }, {
    key: 'setTextContentStream',
    value: function setTextContentStream(readableStream) {
      this.cancel();
      this.textContentStream = readableStream;
    }
  }, {
    key: 'setTextContent',
    value: function setTextContent(textContent) {
      this.cancel();
      this.textContent = textContent;
    }
  }, {
    key: 'convertMatches',
    value: function convertMatches(matches, matchesLength) {
      var i = 0;
      var iIndex = 0;
      var textContentItemsStr = this.textContentItemsStr;
      var end = textContentItemsStr.length - 1;
      var queryLen = this.findController === null ? 0 : this.findController.state.query.length;
      var ret = [];
      if (!matches) {
        return ret;
      }
      for (var m = 0, len = matches.length; m < len; m++) {
        var matchIdx = matches[m];
        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        if (i === textContentItemsStr.length) {
          console.error('Could not find a matching mapping');
        }
        var match = {
          begin: {
            divIdx: i,
            offset: matchIdx - iIndex
          }
        };
        if (matchesLength) {
          matchIdx += matchesLength[m];
        } else {
          matchIdx += queryLen;
        }
        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
          iIndex += textContentItemsStr[i].length;
          i++;
        }
        match.end = {
          divIdx: i,
          offset: matchIdx - iIndex
        };
        ret.push(match);
      }
      return ret;
    }
  }, {
    key: 'renderMatches',
    value: function renderMatches(matches) {
      if (matches.length === 0) {
        return;
      }
      var textContentItemsStr = this.textContentItemsStr;
      var textDivs = this.textDivs;
      var prevEnd = null;
      var pageIdx = this.pageIdx;
      var isSelectedPage = this.findController === null ? false : pageIdx === this.findController.selected.pageIdx;
      var selectedMatchIdx = this.findController === null ? -1 : this.findController.selected.matchIdx;
      var highlightAll = this.findController === null ? false : this.findController.state.highlightAll;
      var infinity = {
        divIdx: -1,
        offset: undefined
      };
      function beginText(begin, className) {
        var divIdx = begin.divIdx;
        textDivs[divIdx].textContent = '';
        appendTextToDiv(divIdx, 0, begin.offset, className);
      }
      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
        var div = textDivs[divIdx];
        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
        var node = document.createTextNode(content);
        if (className) {
          var span = document.createElement('span');
          span.className = className;
          span.appendChild(node);
          div.appendChild(span);
          return;
        }
        div.appendChild(node);
      }
      var i0 = selectedMatchIdx,
          i1 = i0 + 1;
      if (highlightAll) {
        i0 = 0;
        i1 = matches.length;
      } else if (!isSelectedPage) {
        return;
      }
      for (var i = i0; i < i1; i++) {
        var match = matches[i];
        var begin = match.begin;
        var end = match.end;
        var isSelected = isSelectedPage && i === selectedMatchIdx;
        var highlightSuffix = isSelected ? ' selected' : '';
        if (this.findController) {
          if (this.findController.selected.matchIdx === i && this.findController.selected.pageIdx === pageIdx) {
            var spot = {
              top: MATCH_SCROLL_OFFSET_TOP,
              left: MATCH_SCROLL_OFFSET_LEFT
            };
            (0, _ui_utils.scrollIntoView)(textDivs[begin.divIdx], spot, true);
          }
        }
        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
          if (prevEnd !== null) {
            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
          }
          beginText(begin);
        } else {
          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
        }
        if (begin.divIdx === end.divIdx) {
          appendTextToDiv(begin.divIdx, begin.offset, end.offset, 'highlight' + highlightSuffix);
        } else {
          appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, 'highlight begin' + highlightSuffix);
          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
            textDivs[n0].className = 'highlight middle' + highlightSuffix;
          }
          beginText(end, 'highlight end' + highlightSuffix);
        }
        prevEnd = end;
      }
      if (prevEnd) {
        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
      }
    }
  }, {
    key: 'updateMatches',
    value: function updateMatches() {
      if (!this.renderingDone) {
        return;
      }
      var matches = this.matches;
      var textDivs = this.textDivs;
      var textContentItemsStr = this.textContentItemsStr;
      var clearedUntilDivIdx = -1;
      for (var i = 0, len = matches.length; i < len; i++) {
        var match = matches[i];
        var begin = Math.max(clearedUntilDivIdx, match.begin.divIdx);
        for (var n = begin, end = match.end.divIdx; n <= end; n++) {
          var div = textDivs[n];
          div.textContent = textContentItemsStr[n];
          div.className = '';
        }
        clearedUntilDivIdx = match.end.divIdx + 1;
      }
      if (!this.findController || !this.findController.highlightMatches) {
        return;
      }
      var pageMatches = void 0,
          pageMatchesLength = void 0;
      if (this.findController !== null) {
        pageMatches = this.findController.pageMatches[this.pageIdx] || null;
        pageMatchesLength = this.findController.pageMatchesLength ? this.findController.pageMatchesLength[this.pageIdx] || null : null;
      }
      this.matches = this.convertMatches(pageMatches, pageMatchesLength);
      this.renderMatches(this.matches);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      var _this2 = this;

      var eventBus = this.eventBus,
          _boundEvents = this._boundEvents;

      _boundEvents.pageCancelled = function (evt) {
        if (evt.pageNumber !== _this2.pageNumber) {
          return;
        }
        if (_this2.textLayerRenderTask) {
          console.error('TextLayerBuilder._bindEvents: `this.cancel()` should ' + 'have been called when the page was reset, or rendering cancelled.');
          return;
        }
        for (var name in _boundEvents) {
          eventBus.off(name.toLowerCase(), _boundEvents[name]);
          delete _boundEvents[name];
        }
      };
      _boundEvents.updateTextLayerMatches = function (evt) {
        if (evt.pageIndex !== _this2.pageIdx && evt.pageIndex !== -1) {
          return;
        }
        _this2.updateMatches();
      };
      eventBus.on('pagecancelled', _boundEvents.pageCancelled);
      eventBus.on('updatetextlayermatches', _boundEvents.updateTextLayerMatches);
    }
  }, {
    key: '_bindMouse',
    value: function _bindMouse() {
      var _this3 = this;

      var div = this.textLayerDiv;
      var expandDivsTimer = null;
      div.addEventListener('mousedown', function (evt) {
        if (_this3.enhanceTextSelection && _this3.textLayerRenderTask) {
          _this3.textLayerRenderTask.expandTextDivs(true);
          if (expandDivsTimer) {
            clearTimeout(expandDivsTimer);
            expandDivsTimer = null;
          }
          return;
        }
        var end = div.querySelector('.endOfContent');
        if (!end) {
          return;
        }
        var adjustTop = evt.target !== div;
        adjustTop = adjustTop && window.getComputedStyle(end).getPropertyValue('-moz-user-select') !== 'none';
        if (adjustTop) {
          var divBounds = div.getBoundingClientRect();
          var r = Math.max(0, (evt.pageY - divBounds.top) / divBounds.height);
          end.style.top = (r * 100).toFixed(2) + '%';
        }
        end.classList.add('active');
      });
      div.addEventListener('mouseup', function () {
        if (_this3.enhanceTextSelection && _this3.textLayerRenderTask) {
          expandDivsTimer = setTimeout(function () {
            if (_this3.textLayerRenderTask) {
              _this3.textLayerRenderTask.expandTextDivs(false);
            }
            expandDivsTimer = null;
          }, EXPAND_DIVS_TIMEOUT);
          return;
        }
        var end = div.querySelector('.endOfContent');
        if (!end) {
          return;
        }
        end.style.top = '';
        end.classList.remove('active');
      });
    }
  }]);

  return TextLayerBuilder;
}();

var DefaultTextLayerFactory = function () {
  function DefaultTextLayerFactory() {
    _classCallCheck(this, DefaultTextLayerFactory);
  }

  _createClass(DefaultTextLayerFactory, [{
    key: 'createTextLayerBuilder',
    value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
      var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      return new TextLayerBuilder({
        textLayerDiv: textLayerDiv,
        pageIndex: pageIndex,
        viewport: viewport,
        enhanceTextSelection: enhanceTextSelection
      });
    }
  }]);

  return DefaultTextLayerFactory;
}();


var PDFLinkService = function () {
  function PDFLinkService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        eventBus = _ref.eventBus,
        _ref$externalLinkTarg = _ref.externalLinkTarget,
        externalLinkTarget = _ref$externalLinkTarg === undefined ? null : _ref$externalLinkTarg,
        _ref$externalLinkRel = _ref.externalLinkRel,
        externalLinkRel = _ref$externalLinkRel === undefined ? null : _ref$externalLinkRel;

    _classCallCheck(this, PDFLinkService);

    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
    this.externalLinkTarget = externalLinkTarget;
    this.externalLinkRel = externalLinkRel;
    this.baseUrl = null;
    this.pdfDocument = null;
    this.pdfViewer = null;
    this.pdfHistory = null;
    this._pagesRefCache = null;
  }

  _createClass(PDFLinkService, [{
    key: 'setDocument',
    value: function setDocument(pdfDocument) {
      var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.baseUrl = baseUrl;
      this.pdfDocument = pdfDocument;
      this._pagesRefCache = Object.create(null);
    }
  }, {
    key: 'setViewer',
    value: function setViewer(pdfViewer) {
      this.pdfViewer = pdfViewer;
    }
  }, {
    key: 'setHistory',
    value: function setHistory(pdfHistory) {
      this.pdfHistory = pdfHistory;
    }
  }, {
    key: 'navigateTo',
    value: function navigateTo(dest) {
      var _this = this;

      var goToDestination = function goToDestination(_ref2) {
        var namedDest = _ref2.namedDest,
            explicitDest = _ref2.explicitDest;

        var destRef = explicitDest[0],
            pageNumber = void 0;
        if (destRef instanceof Object) {
          pageNumber = _this._cachedPageNumber(destRef);
          if (pageNumber === null) {
            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
              _this.cachePageRef(pageIndex + 1, destRef);
              goToDestination({
                namedDest: namedDest,
                explicitDest: explicitDest
              });
            }).catch(function () {
              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
            });
            return;
          }
        } else if (Number.isInteger(destRef)) {
          pageNumber = destRef + 1;
        } else {
          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
          return;
        }
        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
          return;
        }
        if (_this.pdfHistory) {
          _this.pdfHistory.pushCurrentPosition();
          _this.pdfHistory.push({
            namedDest: namedDest,
            explicitDest: explicitDest,
            pageNumber: pageNumber
          });
        }
        _this.pdfViewer.scrollPageIntoView({
          pageNumber: pageNumber,
          destArray: explicitDest
        });
      };
      new Promise(function (resolve, reject) {
        if (typeof dest === 'string') {
          _this.pdfDocument.getDestination(dest).then(function (destArray) {
            resolve({
              namedDest: dest,
              explicitDest: destArray
            });
          });
          return;
        }
        resolve({
          namedDest: '',
          explicitDest: dest
        });
      }).then(function (data) {
        if (!Array.isArray(data.explicitDest)) {
          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
          return;
        }
        goToDestination(data);
      });
    }
  }, {
    key: 'getDestinationHash',
    value: function getDestinationHash(dest) {
      if (typeof dest === 'string') {
        return this.getAnchorUrl('#' + escape(dest));
      }
      if (Array.isArray(dest)) {
        var str = JSON.stringify(dest);
        return this.getAnchorUrl('#' + escape(str));
      }
      return this.getAnchorUrl('');
    }
  }, {
    key: 'getAnchorUrl',
    value: function getAnchorUrl(anchor) {
      return (this.baseUrl || '') + anchor;
    }
  }, {
    key: 'setHash',
    value: function setHash(hash) {
      var pageNumber = void 0,
          dest = void 0;
      if (hash.includes('=')) {
        var params = (0, _ui_utils.parseQueryString)(hash);
        if ('search' in params) {
          this.eventBus.dispatch('findfromurlhash', {
            source: this,
            query: params['search'].replace(/"/g, ''),
            phraseSearch: params['phrase'] === 'true'
          });
        }
        if ('nameddest' in params) {
          this.navigateTo(params.nameddest);
          return;
        }
        if ('page' in params) {
          pageNumber = params.page | 0 || 1;
        }
        if ('zoom' in params) {
          var zoomArgs = params.zoom.split(',');
          var zoomArg = zoomArgs[0];
          var zoomArgNumber = parseFloat(zoomArg);
          if (!zoomArg.includes('Fit')) {
            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
          } else {
            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
              dest = [null, { name: zoomArg }];
            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
            } else if (zoomArg === 'FitR') {
              if (zoomArgs.length !== 5) {
                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
              } else {
                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
              }
            } else {
              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
            }
          }
        }
        if (dest) {
          this.pdfViewer.scrollPageIntoView({
            pageNumber: pageNumber || this.page,
            destArray: dest,
            allowNegativeOffset: true
          });
        } else if (pageNumber) {
          this.page = pageNumber;
        }
        if ('pagemode' in params) {
          this.eventBus.dispatch('pagemode', {
            source: this,
            mode: params.pagemode
          });
        }
      } else {
        dest = unescape(hash);
        try {
          dest = JSON.parse(dest);
          if (!Array.isArray(dest)) {
            dest = dest.toString();
          }
        } catch (ex) {}
        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
          this.navigateTo(dest);
          return;
        }
        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
      }
    }
  }, {
    key: 'executeNamedAction',
    value: function executeNamedAction(action) {
      switch (action) {
        case 'GoBack':
          if (this.pdfHistory) {
            this.pdfHistory.back();
          }
          break;
        case 'GoForward':
          if (this.pdfHistory) {
            this.pdfHistory.forward();
          }
          break;
        case 'NextPage':
          if (this.page < this.pagesCount) {
            this.page++;
          }
          break;
        case 'PrevPage':
          if (this.page > 1) {
            this.page--;
          }
          break;
        case 'LastPage':
          this.page = this.pagesCount;
          break;
        case 'FirstPage':
          this.page = 1;
          break;
      }
      this.eventBus.dispatch('namedaction', {
        source: this,
        action: action
      });
    }
  }, {
    key: 'cachePageRef',
    value: function cachePageRef(pageNum, pageRef) {
      if (!pageRef) {
        return;
      }
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      this._pagesRefCache[refStr] = pageNum;
    }
  }, {
    key: '_cachedPageNumber',
    value: function _cachedPageNumber(pageRef) {
      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
    }
  }, {
    key: 'pagesCount',
    get: function get() {
      return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
  }, {
    key: 'page',
    get: function get() {
      return this.pdfViewer.currentPageNumber;
    },
    set: function set(value) {
      this.pdfViewer.currentPageNumber = value;
    }
  }, {
    key: 'rotation',
    get: function get() {
      return this.pdfViewer.pagesRotation;
    },
    set: function set(value) {
      this.pdfViewer.pagesRotation = value;
    }
  }]);

  return PDFLinkService;
}();

function isValidExplicitDestination(dest) {
  if (!Array.isArray(dest)) {
    return false;
  }
  var destLength = dest.length,
      allowNull = true;
  if (destLength < 2) {
    return false;
  }
  var page = dest[0];
  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && Number.isInteger(page.num) && Number.isInteger(page.gen)) && !(Number.isInteger(page) && page >= 0)) {
    return false;
  }
  var zoom = dest[1];
  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
    return false;
  }
  switch (zoom.name) {
    case 'XYZ':
      if (destLength !== 5) {
        return false;
      }
      break;
    case 'Fit':
    case 'FitB':
      return destLength === 2;
    case 'FitH':
    case 'FitBH':
    case 'FitV':
    case 'FitBV':
      if (destLength !== 3) {
        return false;
      }
      break;
    case 'FitR':
      if (destLength !== 6) {
        return false;
      }
      allowNull = false;
      break;
    default:
      return false;
  }
  for (var i = 2; i < destLength; i++) {
    var param = dest[i];
    if (!(typeof param === 'number' || allowNull && param === null)) {
      return false;
    }
  }
  return true;
}

/* v 3.13
author http://codecanyon.net/user/creativeinteractivemedia/portfolio?ref=creativeinteractivemedia
*/
// var FLIPBOOK = FLIPBOOK || {};

{ /* Main */
    (function init(jQuery, window, document, undefined$1) {

        jQuery.fn.flipBook = function(options) {
            return new FLIPBOOK.Main(options, this);
        };

        jQuery.fn.swipeBook = function(options) {
            options.viewMode = "swipe";
            return new FLIPBOOK.Main(options, this);
        };

        // DEFAULT OPTIONS
        jQuery.fn.flipBook.options = {

            name: "",

            /*array of page objects - this must be passed to plugin constructor
            {
                src:"page url",
                thumb:"page thumb url",
                title:"page title",
                htmlContent:"page html content"
            }*/
            pages: [],

            /*array of table_of_content objects
            {
                title:"Cover",
                page:"1",
            }*/
            tableOfContent: [],

            tableOfContentCloseOnClick: true,
            thumbsCloseOnClick:true,

            //set unique prefix to enable deep linking, for example prefix "book1_" will add hash #book1_{page number} to the end of url
            deeplinkingEnabled: false,
            deeplinkingPrefix: '',

            assets: {
                preloader: "images/preloader.jpg",
                overlay: "images/overlay.png",
                flipMp3: "/mp3/turnPage.mp3",
                spinner: "images/spinner.gif"
            },

            //pdf source options
            pdfUrl: null,
            pdfBrowserViewerIfMobile: false,
            pdfBrowserViewerIfIE: false,
            pdfBrowserViewerFullscreen: true,
            pdfBrowserViewerFullscreenTarget: "_blank",
            pdfPageScale: 1,
            pdfOutline:true,
            rangeChunkSize:64,

            htmlLayer: true,

            rightToLeft: false,

            //page that will be displayed when the book starts
            startPage: 0,

            //if the sound is enabled
            sound: true,

            backgroundColor: "rgb(81, 85, 88)",
            backgroundImage: "",
            backgroundPattern: "",
            backgroundTransparent: false,

            //book default settings
            thumbSize: 130,

            loadAllPages: false,
            loadPagesF: 2,
            loadPagesB: 1,

            autoplayOnStart: false,
            autoplayInterval: 3000,
            autoplayLoop: true,

            //UI settings

            skin: "light", //"dark", "light", "gradient"
            layout: "1", //"1", "2", "3", "4"

            menuOverBook: false,
            menuFloating: false,
            menuBackground: '',
            menuShadow: '',
            menuMargin: 0,
            menuPadding: 0,
            menuTransparent:false,

            menu2OverBook:true,
            menu2Floating: false,
            menu2Background:'',
            menu2Shadow: '',
            menu2Margin: 0,
            menu2Padding: 0,
            menu2Transparent:true,

            skinColor:'',
            skinBackground:'',

            // menu buttons
            btnColor: '',
            btnBackground: 'none',
            btnSize: 14,
            btnRadius: 2,
            btnMargin: 2,
            btnShadow: '',
            btnTextShadow: '',
            btnBorder: '',
            btnColorHover: "",
            btnBackgroundHover: '',

            //side navigation arrows
            sideBtnColor: '#FFF',
            sideBtnBackground: '#00000033',
            sideBtnSize: 30,
            sideBtnRadius: 0,
            sideBtnMargin: 0,
            sideBtnPaddingV: 5,
            sideBtnPaddingH: 0,
            sideBtnShadow: '',
            sideBtnTextShadow: '',
            sideBtnBorder: '',
            sideBtnColorHover: "#FFF",
            sideBtnBackgroundHover: '#00000066',


            // menu buttons on transparent menu
            floatingBtnColor:"#EEE",
            floatingBtnBackground:"#00000044",
            floatingBtnSize: null,
            floatingBtnRadius: null,
            floatingBtnMargin: null,
            floatingBtnShadow: '',
            floatingBtnTextShadow: '',
            floatingBtnBorder: '',
            floatingBtnColorHover: "",
            floatingBtnBackgroundHover: '',

            btnOrder:[
                'currentPage',
                'btnFirst',
                'btnPrev',
                'btnNext',
                'btnLast',
                'btnZoomIn',
                'btnZoomOut',
                'btnRotateLeft',
                'btnRotateRight',
                'btnAutoplay',
                'btnSearch',
                'btnSelect',
                'btnBookmark',
                'btnToc',
                'btnThumbs',
                'btnShare',
                'btnPrint',
                'btnDownloadPages',
                'btnDownloadPdf',
                'btnSound',
                'btnExpand',
                'btnClose'
            ],

            currentPage: {
                enabled: true,
                title: "Current page",
                vAlign:'top',
                hAlign:'left',
                marginH:0,
                marginV:0,
                color:'',
                background:''
            },

            btnFirst: {
                enabled: false,
                title: "First page",
                icon: "fa-angle-double-left",
                icon2: "first_page"
            },

            btnPrev: {
                enabled: true,
                title: "Previous page",
                icon: "fa-angle-left",
                icon2: "chevron_left"
            },

            btnNext: {
                enabled: true,
                title: "Next page",
                icon: "fa-angle-right",
                icon2: "chevron_right"
            },

            btnLast: {
                enabled: false,
                title: "Last page",
                icon: "fa-angle-double-right",
                icon2: "last_page"
            },

            btnZoomIn: {
                enabled: true,
                title: "Zoom in",
                icon: "fa-plus",
                icon2: "zoom_in"
            },

            btnZoomOut: {
                enabled: true,
                title: "Zoom out",
                icon: "fa-minus",
                icon2: "zoom_out"
            },

            btnRotateLeft: {
                enabled: false,
                title: "Rotate left",
                icon: "fas fa-undo"
            },

            btnRotateRight: {
                enabled: false,
                title: "Rotate right",
                icon: "fas fa-redo"
            },

            btnAutoplay: {
                enabled: true,
                title: "Autoplay",
                icon: "fa-play",
                icon2: "play_arrow",
                iconAlt:"fa-pause",
                iconAlt2:"pause",
            },

            btnSearch: {
                enabled: false,
                title: "Search",
                icon: "fas fa-search",
                icon2: "search"
            },

            btnSelect: {
                enabled: true,
                title: "Select tool",
                icon: "fas fa-i-cursor",
                icon2: "text_format"
            },

            btnBookmark: {
                enabled: true,
                title: "Bookmark",
                icon: "fas fa-bookmark",
                icon2: "bookmark"
            },

            btnToc: {
                enabled: true,
                title: "Table of Contents",
                icon: "fa-list-ol",
                icon2: "toc"
            },

            btnThumbs: {
                enabled: true,
                title: "Pages",
                icon: "fa-th-large",
                icon2: "view_module"
            },

            btnShare: {
                enabled: true,
                title: "Share",
                icon: "fa-link",
                icon2: "share",
                hideOnMobile:true
            },

            btnPrint: {
                enabled: true,
                title: "Print",
                icon: "fa-print",
                icon2: "print",
                hideOnMobile:true
            },

            btnDownloadPages: {
                enabled: true,
                title: "Download pages",
                icon: "fa-download",
                icon2: "file_download",
                url: "images/pages.zip",
                name: "allPages.zip"
            },

            btnDownloadPdf: {
                forceDownload: false,
                enabled: true,
                title: "Download PDF",
                icon: "fa-file",
                icon2: "picture_as_pdf",
                url: null,
                openInNewWindow: true,
                name: "allPages.pdf"
            },

            btnSound: {
                enabled: true,
                title: "Volume",
                icon: "fa-volume-up",
                iconAlt: "fa-volume-off",
                icon2: "volume_up",
                iconAlt2: "volume_mute",
                hideOnMobile:true
            },

            btnExpand: {
                enabled: true,
                title: "Toggle fullscreen",
                icon: "fa-expand",
                icon2: "fullscreen",
                iconAlt: "fa-compress",
                iconAlt2: "fullscreen_exit"
            },

            btnClose: {
                title: "Close",
                icon: "fa-times",
                icon2: "close",
                hAlign:'right',
                vAlign:'top',
                size : 20
            },

            btnShareIfMobile: false,
            btnSoundIfMobile: false,
            btnPrintIfMobile: false,

            sideNavigationButtons: true,

            hideMenu: false,

            //share

            twitter: {
                enabled: true,
                url: null,
                description: null
            },

            facebook: {
                enabled: true,
                load_sdk: true,
                url: null,
                app_id: null,
                title: null,
                caption: null,
                description: null,
                image: null
            },

            pinterest: {
                enabled: true,
                url: null,
                image: null,
                description: null
            },

            email: {
                enabled: true,
                title: null,
                description: null,
                url:null
            },

            pdf: {
                annotationLayer: false,
            },

            pageTextureSize: 2048,
            pageTextureSizeSmall: 1500,

            pageTextureSizeMobile: null,
            pageTextureSizeMobileSmall: 1024,

            //flip animation type; can be "2d", "3d" , "webgl", "swipe"
            viewMode: 'webgl',
            singlePageMode: false,
            singlePageModeIfMobile: false,
            zoomMin: .95,
            zoomMax2: null,

            zoomSize: null,
            zoomStep: 2,
            zoomTime:300,
            zoomReset:false,
            zoomResetTime:300,

            wheelDisabledNotFullscreen: false,
            arrowsDisabledNotFullscreen: false,
            arrowsAlwaysEnabledForNavigation: false,
            touchSwipeEnabled: true,

            responsiveView: true,
            responsiveViewTreshold: 768,
            minPixelRatio: 1, //between 1 and 2, 1.5 = best ratio performance FPS / image quality

            pageFlipDuration: 1,

            contentOnStart: false,
            thumbnailsOnStart: false,
            searchOnStart: false,

            sideMenuOverBook:true,
            sideMenuOverMenu:false,
            sideMenuOverMenu2:true,
            sideMenuPosition: 'left',

            //lightbox settings

            lightBox: false,
            lightBoxOpened: false,
            lightBoxFullscreen: false,
            lightboxCloseOnClick: false,
            lightboxResetOnOpen: true,
            lightboxBackground: null, //CSS of flipbook background, rgba or hexadecimal color or bg image, for example 'rgba(0,0,0,.5)' or '#F0F0F0' or 'url("overlay.png" ) repeat'
            lightboxBackgroundColor: null,
            lightboxBackgroundPattern: null,
            lightboxBackgroundImage: null,
            lightboxStartPage: null,
            lightboxMarginV: '0',
            lightboxMarginH: '0',
            lightboxCSS: '',
            lightboxPreload:false,
            lightboxShowMenu:false, // show menu while book is loading so lightbox can be closed

            // WebGL settings

            disableImageResize:true, //disable image resize to power of 2 (needed for anisotropic filtering)

            pan: 0,
            panMax: 10,
            panMax2: 2,
            panMin: -10,
            panMin2: -2,
            tilt: 0,
            tiltMax: 0,
            tiltMax2: 0,
            tiltMin: -20,
            tiltMin2: -5,

            rotateCameraOnMouseMove: false,
            rotateCameraOnMouseDrag: true,

            lights: true,
            lightColor: 0xFFFFFF,
            lightPositionX: 0,
            lightPositionZ: 1400,
            lightPositionY: 350,
            lightIntensity: .6,

            shadows: true,
            shadowMapSize: 1024,
            shadowOpacity: .2,
            shadowDistance: 15,

            pageRoughness: 1,
            pageMetalness: 0,

            pageHardness: 2,
            coverHardness: 2,
            pageSegmentsW: 5,
            pageSegmentsH: 1,

            pageMiddleShadowSize: 2,
            pageMiddleShadowColorL: "#999999",
            pageMiddleShadowColorR: "#777777",

            antialias: false,

            // preloader

            preloaderText: '',

            fillPreloader: {
                enabled: false,
                imgEmpty: "images/logo_light.png",
                imgFull: "images/logo_dark.png",
            },

            // logo

            logoImg: '', //url of logo image
            logoUrl: '', // url target
            logoCSS: 'position:absolute;',
            logoHideOnMobile: false,

            printMenu: true,
            downloadMenu: true,

            cover: true,
            backCover: true,

            textLayer: false,

            googleAnalyticsTrackingCode:null,

            minimumAndroidVersion: 6,

            linkColor : 'rgba(255, 255, 0, .05)',
            linkColorHover : 'rgba(255, 255, 0, .2)',

            rightClickEnabled: true,

            // loadExtraPages:5,

            strings: {

                print: "Print",
                printLeftPage: "Print left page",
                printRightPage: "Print right page",
                printCurrentPage: "Print current page",
                printAllPages: "Print all pages",

                download: "Download",
                downloadLeftPage: "Download left page",
                downloadRightPage: "Download right page",
                downloadCurrentPage: "Download current page",
                downloadAllPages: "Download all pages",

                bookmarks: "Bookmarks",
                bookmarkLeftPage: "Bookmark left page",
                bookmarkRightPage: "Bookmark right page",
                bookmarkCurrentPage: "Bookmark current page",

                search: "Search",
                findInDocument: "Find in document",
                pagesFoundContaining: "pages found containing",

                thumbnails: "Thumbnails",
                tableOfContent: "Table of Contents",
                share: "Share",

                pressEscToClose:"Press ESC to close"


            },

            //mobile devices settings - override any setting for mobile devices
            mobile: {

                shadows: false

            }

        };

        FLIPBOOK.Main = function(options, elem) {

            var self = this;
            this.elem = elem;
            this.$elem = jQuery(elem);
            this.$body = jQuery("body");
            this.body = this.$body[0];
            this.$window = jQuery(window);

            this.bodyHasVerticalScrollbar = function() {
                return self.body.scrollHeight > window.innerHeight
            };
            this.isZoomed = function() {
                return self.zoom > 1
            };
            // console.log(this.fullscreenFlipbook)
            this.options = {};


            var dummyStyle = document.createElement('div').style,
                vendor = (function() {
                    var vendors = 't,webkitT,MozT,msT,OT'.split(','),
                        t,
                        i = 0,
                        l = vendors.length;

                    for (; i < l; i++) {
                        t = vendors[i] + 'ransform';
                        if (t in dummyStyle) {
                            return vendors[i].substr(0, vendors[i].length - 1);
                        }
                    }
                    return false;
                })(),
                prefixStyle = function(style) {
                    if (vendor === '')
                        return style;

                    style = style.charAt(0).toUpperCase() + style.substr(1);
                    return vendor + style;
                },

                isAndroid = (/android/gi).test(navigator.appVersion),
                isIDevice = (/iphone|ipad/gi).test(navigator.appVersion),
                has3d = prefixStyle('perspective') in dummyStyle;

            this.msie = window.navigator.userAgent.indexOf("MSIE ");

            this.isAndroid = isAndroid;
            this.has3d = has3d;

            //detect webgl


            function webgl_detect(return_context) {
                if (!!window.WebGLRenderingContext) {
                    var canvas = document.createElement("canvas"),
                        names = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
                        context = false;

                    for (var i = 0; i < 4; i++) {
                        try {
                            context = canvas.getContext(names[i]);
                            if (context && typeof context.getParameter == "function") {
                                // WebGL is enabled
                                if (return_context) {
                                    // return WebGL object if the function's argument is present
                                    return {
                                        name: names[i],
                                        gl: context
                                    };
                                }
                                FLIPBOOK.hasWebGl = true;
                                // else, return just true
                                return true;
                            }
                        } catch (e) {}
                    }

                    // WebGL is supported, but disabled
                    //return true;
                    FLIPBOOK.hasWebGl = false;
                    return false;
                }

                // WebGL not supported
                FLIPBOOK.hasWebGl = false;
                return false;
            }

            function getInternetExplorerVersion()
            {
              var rv = -1;
              if (navigator.appName == 'Microsoft Internet Explorer')
              {
                var ua = navigator.userAgent;
                var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                  rv = parseFloat( RegExp.$1 );
              }
              else if (navigator.appName == 'Netscape')
              {
                var ua = navigator.userAgent;
                var re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                  rv = parseFloat( RegExp.$1 );
              }
              return rv;
            }

            if(typeof FLIPBOOK.hasWebGl == 'undefined')
                webgl_detect();

            this.hasWebGl = FLIPBOOK.hasWebGl;

            var IEversion = getInternetExplorerVersion();
            if (IEversion > 0){
                this.hasWebGl = false;
                this.options.isIE = true;
            }

            this.thumbsShowing = false;
            this.bookmarkShowing = false;
            this.searchingString = false;
            this.tocShowing = false;
            this.menuShowing = true;
            this.fullscreenActive = false;

            // UI layouts

           var layouts = {
            "2":{ // bottom 2
                currentPage:{vAlign:'bottom', hAlign:'center'},
                btnAutoplay:{hAlign:'left'},
                btnSound:{hAlign:'left'},
                btnExpand:{hAlign:'right'},
                btnZoomIn:{hAlign:'right'},
                btnZoomOut:{hAlign:'right'},
                btnSearch:{hAlign:'left'},
                btnBookmark:{hAlign:'left'},
                btnToc:{hAlign:'left'},
                btnThumbs:{hAlign:'left'},
                btnShare:{hAlign:'right'},
                btnPrint:{hAlign:'right'},
                btnDownloadPages:{hAlign:'right'},
                btnDownloadPdf:{hAlign:'right'},
                btnSelect:{hAlign:'right'}
            },
            "3":{ // top
                menuTransparent:true,
                menu2Transparent:false,
                menu2OverBook:false,
                menu2Padding:5,
                btnMargin:5,
                currentPage:{vAlign:'top', hAlign:'center'},
                btnPrint:{vAlign:'top',hAlign:'right'},
                btnDownloadPdf:{vAlign:'top',hAlign:'right'},
                btnDownloadPages:{vAlign:'top',hAlign:'right'},
                btnThumbs:{vAlign:'top',hAlign:'left'},
                btnToc:{vAlign:'top',hAlign:'left'},
                btnBookmark:{vAlign:'top',hAlign:'left'},
                btnSearch:{vAlign:'top',hAlign:'left'},
                btnSelect:{vAlign:'top',hAlign:'right'},
                btnShare:{vAlign:'top',hAlign:'right'},
                btnAutoplay:{hAlign:'right'},
                btnExpand:{hAlign:'right'},
                btnZoomIn:{hAlign:'right'},
                btnZoomOut:{hAlign:'right'},
                btnSound:{hAlign:'right'},
                menuPadding:5
            },
            "4":{ // top 2
                menu2Transparent:false,
                menu2OverBook:false,
                sideMenuOverMenu2:false,
                currentPage:{vAlign:'top', hAlign:'center'},
                btnAutoplay:{vAlign:'top', hAlign:'left'},
                btnSound:{vAlign:'top', hAlign:'left'},
                btnExpand:{vAlign:'top', hAlign:'right'},
                btnZoomIn:{vAlign:'top', hAlign:'right'},
                btnZoomOut:{vAlign:'top', hAlign:'right'},
                btnSearch:{vAlign:'top', hAlign:'left'},
                btnBookmark:{vAlign:'top', hAlign:'left'},
                btnToc:{vAlign:'top', hAlign:'left'},
                btnThumbs:{vAlign:'top', hAlign:'left'},
                btnShare:{vAlign:'top', hAlign:'right'},
                btnPrint:{vAlign:'top', hAlign:'right'},
                btnDownloadPages:{vAlign:'top', hAlign:'right'},
                btnDownloadPdf:{vAlign:'top', hAlign:'right'},
                btnSelect:{vAlign:'top', hAlign:'right'}

            }
        };


            var skins = {
                'dark':{
                    skinColor:"#EEE",
                    btnColorHover:"#FFF",
                    skinBackground:"#313538"
                },
                'light':{
                    skinColor:"#222",
                    btnColorHover:"#000",
                    skinBackground:"#FFF",
                    floatingBtnColor:"#FFF",
                    floatingBtnBackground:"#00000055"
                },
                'gradient':{
                    skinColor:"#EEE",
                    btnColor:"#EEE",
                    btnColorHover:"#FFF",
                    skinBackground:"#313538DD",
                    zoomMin:.85,
                    menuOverBook:true,
                    menu2OverBook:true,
                    sideMenuOverMenu:true,
                    sideMenuOverMenu2:true,
                    menuBackground: 'linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, transparent 100%)',
                    menu2Background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.65) 0%, transparent 100%)'
                }
            };

            for(var key in skins){
                if(options.skin == key)
                    options = jQuery.extend(true, {}, skins[key], options);
            }

            for(var key in layouts){
                if(String(options.layout) === key)
                    options = jQuery.extend(true, {}, layouts[key], options);
            }


            //default options are overridden by options object passed to plugin constructor
            this.options = jQuery.extend(true, {}, jQuery.fn.flipBook.options, options);

            var o = this.options;

            o.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            if (o.isMobile) {

                for (var key in o.mobile) {
                    o[key] = o.mobile[key];
                }

            }

            this.strings = o.strings;

            o.pageShininess = o.pageShininess / 2;

            this.s = 0;

            if(o.googleAnalyticsTrackingCode){
                this.gaCode = o.googleAnalyticsTrackingCode;
                if(!window.ga){
                    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
                    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
                }

                ga('create', this.gaCode, 'auto');
            }

            if (o.isMobile) {

                o.singlePageMode = o.singlePageModeIfMobile ? true : o.singlePageMode;

                if (o.viewModeMobile)
                    o.viewMode = o.viewModeMobile;

                if (o.pageTextureSizeMobile)
                    o.pageTextureSize = o.pageTextureSizeMobile;

                if (o.pageTextureSizeMobileSmall)
                    o.pageTextureSizeSmall = o.pageTextureSizeMobileSmall;

                o.touchSwipeEnabled = true;
            }

            if (o.viewMode == "3dSinglePage") {
                o.singlePageMode = true;
            }
            if (o.viewMode == "2dSinglePage") {
                o.singlePageMode = true;
                o.viewMode = "2d";
            }

            if (o.singlePageMode) {
                if (o.viewMode != '2d'
                && o.viewMode != 'swipe'
                ) o.viewMode = '3d';

                if(o.rightToLeft)
                    o.viewMode = 'swipe';
            }

            if (o.singlePageMode && o.viewMode == "3d")
                o.rightToLeft = false;

            if(o.viewMode == "simple"){
                o.viewMode = "3d";
                o.instantFlip = true;
            }

            o.sideMenuPosition = o.rightToLeft ? 'right' : 'left';

            function getAndroidVersion(ua) {
                ua = (ua || navigator.userAgent).toLowerCase();
                var match = ua.match(/android\s([0-9\.]*)/);
                return match ? match[1] : false;
            }
            if (o.viewMode == 'webgl') {
                if (!this.hasWebGl || ((parseFloat(getAndroidVersion()) <  o.minimumAndroidVersion) && this.isAndroid))
                    o.viewMode = '3d';
            }
            if (o.viewMode == '3d' && !self.has3d)
                o.viewMode = '2d';

            this.webgl = o.viewMode == 'webgl';

            if(o.menuFloating){
                o.menuOverBook = true;
                o.sideMenuOverMenu = true;
            }

            if(o.menu2Floating){
                o.menu2OverBook = true;
                o.sideMenuOverMenu2 = true;
            }

            if(o.menuTransparent){
                o.menuOverBook = true;
                o.sideMenuOverMenu = true;
                o.menuBackground = 'none';
            }

            if(o.menu2Transparent){
                o.menu2OverBook = true;
                o.sideMenuOverMenu2 = true;
                o.menu2Background = 'none';
            }else {
                o.sideMenuOverMenu2 = false;
            }

            if(o.menuOverBook)
                o.sideMenuOverMenu = true;

            if(o.menu2OverBook)
                o.sideMenuOverMenu2 = true;

            if (o.isMobile && o.pdfBrowserViewerIfMobile && o.pdfUrl) {

                // if( options.pdfBrowserViewerIfMobile && options.pdfUrl){  // TEST mobile = true

                if (o.lightBox && !o.lightBoxOpened) {
                    this.$elem.on("touched click", function() {
                        openPdfBrowserViewer();
                    }).css('cursor', 'pointer');
                } else {
                    openPdfBrowserViewer();
                }
                return;
            }

            if (o.isIE && o.pdfBrowserViewerIfIE && o.pdfUrl) {

                // if( options.pdfBrowserViewerIfMobile && options.pdfUrl){  // TEST mobile = true

                if (o.lightBox && !o.lightBoxOpened) {
                    this.$elem.on("touched click", function() {
                        openPdfBrowserViewer();
                    }).css('cursor', 'pointer');
                } else {
                    openPdfBrowserViewer();
                }
                return;
            }

            function openPdfBrowserViewer() {
                if (o.pdfBrowserViewerFullscreen) {
                    window.open(o.pdfUrl, o.pdfBrowserViewerFullscreenTarget);
                } else {
                    jQuery('<object type="application/pdf"/>').width("100%").height("100%").attr('data', o.pdfUrl).appendTo(self.$elem);
                    //<div> <object data="test.pdf" type="application/pdf" width="300" height="200"> alt : <a href="test.pdf">test.pdf</a> </object> </div>
                }
            }

            o.pdfMode = Boolean(o.pdfUrl && o.pdfUrl != "");

            if (o.backgroundTransparent)
                o.backgroundColor = 'none';

            this.wrapper = jQuery(document.createElement('div'))
                .addClass('flipbook-main-wrapper');

            if (o.backgroundColor != "")
                this.wrapper.css('background', o.backgroundColor);

            if (o.backgroundPattern != "")
                this.wrapper.css('background', 'url(' + o.backgroundPattern + ') repeat');

            if (o.backgroundImage != "") {
                this.wrapper.css('background', 'url(' + o.backgroundImage + ') no-repeat');
                this.wrapper.css('background-size', 'cover');
                this.wrapper.css('background-position', 'center center');
            }

            this.bookLayer = jQuery(document.createElement('div'))
                .addClass('flipbook-bookLayer')
                .appendTo(self.wrapper);

            if(!o.rightClickEnabled)
                this.bookLayer.bind('contextmenu', function(e) {
                    return false;
                });

            if (o.hideMenu){
                this.bookLayer.css('bottom', '0');
                o.menuOverBook = true;
            }

            this.book = jQuery(document.createElement('div'))
                .addClass('book')
                .appendTo(self.bookLayer);

            if (o.preloader)
                this.preloader = o.preloader;
            else if(!jQuery('.flipbook-preloader').length && o.lightBox)
                this.preloader = jQuery('<div class="flipbook-preloader cssload-container"><div class="cssload-speeding-wheel"/><div class="flipbook-loading-text"></div><div class="flipbook-loading-bg"></div></div>');
            else if(!o.lightBox)
                this.preloader = jQuery('<div class="flipbook-preloader-2 cssload-container"><div class="cssload-speeding-wheel"/><div class="flipbook-loading-text"></div><div class="flipbook-loading-bg"></div></div>');
            else
                this.preloader = jQuery('.flipbook-preloader');


            jQuery('.flipbook-loading-text').text(o.preloaderText);

            this.setLoadingProgress(0);

            function checkHash(){
                if(self.disposed)
                    return

                var fullHash = window.location.hash;

                var targetPage = self.getPageFromHash(), startPage = targetPage;
                if(targetPage){
                    targetPage = o.rightToLeft ? o.pages.length - targetPage + 1 : targetPage;
                 if(!self.started){
                    o.startPage = startPage;

                    if(o.lightBox){
                        init();

                        if (o.lightBoxFullscreen) {

                            setTimeout(function() {
                                self.toggleExpand();
                            }, 100);

                        }
                    }

                    }else if(self.Book){
                         if (self.lightbox) {
                            self.lightbox.openLightbox();
                            self.lightboxStart();
                         }
                         self.goToPage(targetPage, fullHash.indexOf('flip') == -1);
                    }
                }
            }

            if(!o.deeplinkingPrefix && o.deeplinking && o.deeplinking.prefix)
                o.deeplinkingPrefix = o.deeplinking.prefix;

            o.deeplinkingEnabled = o.deeplinkingPrefix || o.deeplinkingEnabled || (o.deeplinking && o.deeplinking.enabled);

            if (o.deeplinkingEnabled) {

                checkHash();
                jQuery(window).bind('hashchange', function(e) {
                    checkHash();
                });
            }

            function preload(){
                if (typeof IScroll == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.iscrollSrc]) {
                    self.loadScript(FLIPBOOK.iscrollSrc, function() {});
                    }


                    if (typeof FLIPBOOK.PdfService == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.pdfServiceSrc]) {
                        self.loadScript(FLIPBOOK.pdfServiceSrc, function() {});
                    }


                if(o.pdfMode){
                    if (typeof pdfjsLib == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.pdfjsSrc]) {
                    self.loadScript(FLIPBOOK.pdfjsSrc, function() {});
                    }
                    // if (!FLIPBOOK.scriptsAdded[FLIPBOOK.pdfjsworkerSrc]) {
                    //     self.loadScript(FLIPBOOK.pdfjsworkerSrc, function() {})
                    // }
                    if (typeof FLIPBOOK.PdfService == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.pdfServiceSrc]) {
                        self.loadScript(FLIPBOOK.pdfServiceSrc, function() {});
                    }

                    if (o.btnSearch.enabled){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.markSrc]) {
                            self.loadScript(FLIPBOOK.markSrc, function(){});
                        }
                    }


                }
                if(o.viewMode == "webgl"){
                    if (typeof THREE == 'undefined' && !FLIPBOOK.scriptsAdded[FLIPBOOK.threejsSrc]) {
                    self.loadScript(FLIPBOOK.threejsSrc, function() {});
                    }
                    // if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipbookWebGlSrc]) {
                    // self.loadScript(FLIPBOOK.flipbookWebGlSrc, function() {})
                    // }
                }

            }

            function init() {


                if (o.fillPreloader.enabled) {

                    self.$fillPreloader = jQuery("<div>").addClass("flipbook-fillPreloader");
                    var empty = new Image();
                    empty.src = o.fillPreloader.imgEmpty;
                    empty.onload = function() {
                        var full = new Image();
                        full.src = o.fillPreloader.imgFull;
                        full.onload = function() {
                            //fill preloder ready

                            jQuery(empty).appendTo(self.$fillPreloader);
                            self.$fillPreloaderImg = jQuery(full).appendTo(self.$fillPreloader);

                            self.$fillPreloader.appendTo(self.wrapper);

                            initBook();

                        };

                    };

                } else {

                    initBook();

                }


            }

            function initBook() {

                self.id = Date.now();

                self.addPageItems();

                if (o.pdfMode)
                    self.initPdf();
                else {
                    // o.btnSearch.enabled = false
                    self.initJpg();
                }

                self.setLoadingProgress(.1);

                if(self.lightbox && self.options.lightboxShowMenu) self.createMenu();

            }

            this.dispose = function(){
                this.disposed = true;
            };

            o.main = this;

            var model = {

                _events: {},

                on: function(type, fn) {
                    if (!this._events[type]) {
                        this._events[type] = [];
                    }

                    this._events[type].push(fn);
                },

                off: function(type, fn) {
                    if (!this._events[type]) {
                        return;
                    }

                    var index = this._events[type].indexOf(fn);

                    if (index > -1) {
                        this._events[type].splice(index, 1);
                    }
                },

                trigger: function(type) {
                    if (!this._events[type]) {
                        return;
                    }

                    var i = 0,
                        l = this._events[type].length;

                    if (!l) {
                        return;
                    }

                    for (; i < l; i++) {
                        this._events[type][i].apply(this, [].slice.call(arguments, 1));
                    }
                },
            };

            model.on('pageLoaded', function(e){

                o.pages[e.index] = o.pages[e.index] || {};
                o.pages[e.index].canvas = o.pages[e.index].canvas || {};
                o.pages[e.index].canvas[e.size] = e.canvas;

                if (self.searchingString)
                    self.mark(self.searchingString);

            });

            model.on('pageUnloaded', function(e){

                e.unloadedPages.forEach(function(elem) {
                    if (self.Book.onPageUnloaded)
                        self.Book.onPageUnloaded(elem.index, elem.size);
                });

            });

            model.on('pdfinit', function(){

                o.tableOfContent = self.pdfService.outline || o.tableOfContent;

                o.doublePage = self.pdfService.double;

                self.viewportOriginal = self.pdfService.viewports[0];

                o.firstPage = {
                    width: self.pdfService.viewports[0].width,
                    height: self.pdfService.viewports[0].height,
                    ratio: self.pdfService.viewports[0].width / self.pdfService.viewports[0].height
                };

                if (self.pdfService.numPages > 1)
                    o.secondPage = {
                        width: self.pdfService.viewports[1].width,
                        height: self.pdfService.viewports[1].height,
                        ratio: self.pdfService.viewports[1].width / self.pdfService.viewports[1].height
                    };

                o.numPages = self.pdfService.numPages;

                if (o.numPages == 1) {
                    o.viewMode = "swipe";
                    o.singlePageMode = true;
                    o.btnNext.enabled = false;
                    o.btnPrev.enabled = false;
                    o.btnFirst.enabled = false;
                    o.btnLast.enabled = false;
                    o.sideNavigationButtons = false;
                    o.btnAutoplay.enabled = false;

                    o.printMenu = false;
                    o.downloadMenu = false;

                    self.webgl = false;
                }

                var pages = [];

                for (var i = 0; i < o.numPages; i++) {

                    var p = {
                        canvas: {}
                    };

                    if (o.pages && o.pages[i]) {
                        jQuery.extend(p, o.pages[i]);
                    } else {
                        p.title = i + 1;
                    }

                    pages[i] = p;
                }

                o.pages = pages;

                var bh = self.book.height();
                //var pageSize = 1000
                var pageSize = o.pageTextureSize;
                o.pageWidth = parseInt(pageSize * self.viewportOriginal.width / self.viewportOriginal.height);
                o.pageHeight = pageSize;

                o.pw = o.pageWidth;
                o.ph = o.pageHeight;

                o.zoomSize = o.zoomSize || o.pageTextureSize;

                self.start();

            });


            model.on("toolSelect", function() {

                self.bookLayer.removeClass("flipbook-move");
                if(self.btnSelect)
                    self.btnSelect.addClass("flipbook-btn-active");
                // jQuery('.flipbook-page-htmlContent').css('userSelect', 'auto')
                self.bookLayer.removeClass('flipbook-disable-text-selection');

            });

            model.on("toolMove", function() {

                self.bookLayer.addClass("flipbook-move");
                if(self.btnSelect)
                    self.btnSelect.removeClass("flipbook-btn-active");
                // jQuery('.flipbook-page-htmlContent').css('userSelect', 'none')
                self.bookLayer.addClass('flipbook-disable-text-selection');

            });

            this.model = model;


            if (o.lightBox) {

                o.btnClose.enabled = true;

                this.lightbox = new FLIPBOOK.Lightbox(this, this.wrapper, o);
                this.lightboxStartedTimes = 0;
                this.wrapper.css('background', 'none');
                this.bookLayer.css('background', 'none');
                this.book.css('background', 'none');

                this.preloader.appendTo(this.$body).css('position', 'fixed');


                this.$elem.css('cursor', 'pointer')

                    .bind('tap click', function(e) {

                        self.lightboxStartPage = jQuery(this).attr("data-page");

                        if (self.started) {

                            self.lightboxStart();

                            if (o.lightBoxFullscreen) {

                                setTimeout(function() {
                                    self.toggleExpand();
                                }, 0);

                            }

                        } else {

                            init();

                            if (o.lightBoxFullscreen) {

                                setTimeout(function() {
                                    self.toggleExpand();
                                }, 100);

                            }

                        }

                    });

                if (o.lightBoxOpened) {
                    init();
                    jQuery(this).trigger('lightboxLoadingStarted');
                }else if(o.lightboxPreload){
                    preload();
                }

                this.fullscreenElement = document.documentElement;

            } else {

                o.btnClose.enabled = false;

                this.preloader.appendTo(this.wrapper);

                this.wrapper.appendTo(this.$elem);

                this.fullscreenElement = this.$elem[0];

                init();

            }

        };

        FLIPBOOK.Main.prototype = {

            start: function() {

                if (this.options.dp) {
                    this.options.doublePage = true;
                }

                if (this.started)
                    return;

                this.model.pageW = this.options.pageWidth;
                this.model.bookW = 2 * this.options.pageWidth;
                if(this.options.singlePageMode)
                    this.model.bookW /= 2;
                this.model.pageH = this.options.pageHeight;
                this.model.bookH = this.options.pageHeight;

                // if (this.options.numPages == 1) {
                //     this.options.viewMode = "3d"
                //     this.webgl = false
                // }

                if (this.options.numPages % 2 == 0) {
                    this.options.numSheets = (this.options.numPages + 2) / 2;
                } else {
                    this.options.numSheets = (this.options.numPages + 1) / 2;
                }

                // if(!this.options.backCover)
                //     this.options.numSheets++;

                this.started = true;

                if (this.options.lightBox) {
                    this.lightbox.openLightbox();
                    this.lightboxStart();

                }

                this.createBook();

                this.updateSkinColors();


            },

            updateSkinColors:function(){

                var o = this.options;

                if(o.skinColor)
                    this.wrapper.find('.skin-color').css('color', o.skinColor);
                if(o.skinBackground)
                    this.wrapper.find('.skin-color-bg').css('background', o.skinBackground);

            },

            lightboxStart: function() {

                var self = this;
                if (!this.started) this.start();

                if (typeof this.Book == 'undefined') {

                    setTimeout(function() {
                        self.lightboxStart();
                    }, 100);
                    return;

                }

                this.Book.enable();

                if(this.lightboxStartPage) this.goToPage(this.lightboxStartPage, true);

                else if(this.options.lightboxStartPage) this.goToPage(this.options.lightboxStartPage, true);

                this.lightboxStartedTimes ++;

                if(this.gaCode){
                    ga('send', {
                       hitType: 'event',
                       eventCategory: 'Flipbook : '+this.options.name,
                       eventAction: 'lightbox open' ,
                       eventLabel: 'lightbox open',
                       eventValue: this.lightboxStartedTimes,
                       nonInteraction: true
                   });
                }

                this.updateCurrentPage();
                this.initColors();
                this.resize();

                jQuery(this).trigger('lightboxOpened');

            },

            setHash: function(page) {

                if (page < 1) page = 1;

                if (this.options.deeplinkingEnabled && this.Book.enabled)
                    window.location.hash = "#" + this.options.deeplinkingPrefix + String(page);

            },

            clearHash: function() {

                var scrollV, scrollH, loc = window.location;
                if ("pushState" in history)
                    history.pushState("", document.title, loc.pathname + loc.search);
                else {
                    // Prevent scrolling by storing the page's current scroll offset
                    scrollV = document.body.scrollTop;
                    scrollH = document.body.scrollLeft;

                    loc.hash = "";

                    // Restore the scroll offset, should be flicker free
                    document.body.scrollTop = scrollV;
                    document.body.scrollLeft = scrollH;
                }

            },

            getPageFromHash: function() {
                 var page = null;
                 var string = window.location.hash,
                 substring = "#" + this.options.deeplinkingPrefix,
                 hasPrefix = string.indexOf(substring) !== -1;
                 if(hasPrefix){
                    page = parseInt(window.location.hash.replace(/#/g, '').replace(this.options.deeplinkingPrefix, ""));
                    if (isNaN(page)) page = 0;
                }
                return page;
            },

            initColors: function() {

                this.wrapper.find(".skin-color-bg")
                    .removeClass("flipbook-bg-light")
                    .removeClass("flipbook-bg-dark")
                    .addClass("flipbook-bg-" + this.options.skin);

                this.wrapper.find(".skin-color")
                    .removeClass("flipbook-color-light")
                    .removeClass("flipbook-color-dark")
                    .addClass("flipbook-color-" + this.options.skin);

                this.updateSkinColors();
            },

            lightboxEnd: function() {

                if(typeof screenfull != "undefined" && screenfull.isFullscreen)

                    screenfull.exit();

                if (window.location.hash) {
                    // var urlWithoutHash = document.location.href.replace(location.hash , "" );
                    this.clearHash();
                }

                this.setLoadingProgress(1);

                this.Book.disable();

            },

            turnPageComplete: function() {

                this.animating = false;
                this.updateCurrentPage();

                var rightIndex = this.Book.rightIndex || 0;

                if (this.options.rightToLeft)
                    rightIndex = this.options.pages.length - rightIndex;
                if (this.pdfService)
                    this.pdfService.setRightIndex(rightIndex);

                if(this.options.zoomReset)
                    this.Book.zoomTo(this.options.zoomMin);

            },

            updateCurrentPage: function() {

                var rtl = this.options.rightToLeft,
                total = this.options.numPages,
                rightIndex = this.Book.rightIndex || 0,
                s;

                if (rtl) rightIndex = this.options.pages.length - rightIndex;

                if (this.options.singlePageMode || this.Book.singlePage || this.Book.view == 1) {

                    if(this.Book.getCurrentPageNumber){

                        s = this.Book.getCurrentPageNumber();
                        this.currentPageNumber = s - 1;
                        this.setHash(s);
                        this.cPage = [s - 1];

                    }else {

                        if(rtl) rightIndex--;

                        s = rightIndex+1;

                        this.currentPageNumber = rightIndex;
                        this.setHash(s);

                        this.cPage = [rightIndex];

                    }

                }else {

                    if (rightIndex > total || (rightIndex == total && total % 2 == 0)) {
                        s = total;
                        this.cPage = [total - 1];
                    } else if (rightIndex < 1) {
                        s = 1;
                        this.cPage = [0];
                    } else {
                        s = String(rightIndex) + '-' + String(rightIndex + 1);
                        this.cPage = [rightIndex - 1, rightIndex];
                    }

                    this.setHash(rightIndex);

                }

                if(rtl){

                    this.enableNext(rightIndex > 0);
                    this.enablePrev(rightIndex < total - 1);

                }else {

                    this.enablePrev(rightIndex > 0);
                    this.enableNext(rightIndex < total - 1);
                }

                if (this.cPage.length == 2) {

                    this.wrapper.find(".c-l-p").show();
                    this.wrapper.find(".c-r-p").show();
                    this.wrapper.find(".c-p").hide();

                } else {

                    this.wrapper.find(".c-l-p").hide();
                    this.wrapper.find(".c-r-p").hide();
                    this.wrapper.find(".c-p").show();

                }

                if (typeof this.currentPage === 'undefined')
                    return;

                this.s && this.options.pdfPageScale > 0 && this.goToPage(0);


                if (s != this.currentPageValue){

                    this.currentPageValue = String(s);
                    this.currentPage.text(s + ' / ' + String(total));


                    this.currentPageInput.width(this.currentPageHolder.width());

                    this.resize();

                    // console.log(this.currentPageValue)

                    jQuery(this).trigger({
                        type: "pagechange",
                        page: this.currentPageValue,
                        name: this.options.name
                    });

                    if(this.gaCode){
                        ga('send', {
                           hitType: 'event',
                           eventCategory: 'Flipbook : ' + this.options.name,
                           eventAction: 'page ' +  this.currentPageValue,
                           eventLabel: 'page' + this.currentPageValue,
                           nonInteraction: true
                       });
                    }

                }


            },

            initJpg: function() {

                var self = this;

                if (this.options.numPages == 1) {
                    this.options.viewMode = "swipe";
                    this.options.singlePageMode = true;
                    this.webgl = false;
                }

                this.loadPage(0, this.options.pageTextureSize, function() {

                    self.setLoadingProgress(.5);

                    if(self.options.pages.length == 1){

                        var p1 = self.options.pages[0].img;

                        self.options.pw = p1.width;
                        self.options.ph = p1.height;

                        self.options.pageWidth = p1.width;
                        self.options.pageHeight = p1.height;

                        self.options.pageMode = 'singlePage';

                        self.options.doublePage = false;

                        self.options.zoomSize = self.options.zoomSize || p1.height;

                        self.setLoadingProgress(.7);

                        self.options.btnNext.enabled = false;
                        self.options.btnPrev.enabled = false;
                        self.options.btnFirst.enabled = false;
                        self.options.btnLast.enabled = false;
                        self.options.sideNavigationButtons = false;
                        self.options.btnAutoplay.enabled = false;

                        self.start();

                    }else {
                        self.loadPage(1, self.options.pageTextureSize, function() {

                            var p1 = self.options.pages[0].img;
                            var p2 = self.options.pages[1].img;
                            var r1 = p1.width / p1.height;
                            var r2 = p2.width / p2.height;

                            self.options.pw = p1.width;
                            self.options.ph = p1.height;

                            self.options.pageWidth = p1.width;
                            self.options.pageHeight = p1.height;

                            self.options.doublePage = (r2 / r1 > 1.5);

                            self.options.zoomSize = self.options.zoomSize || p1.height;

                            self.setLoadingProgress(.7);

                            self.start();

                        });
                    }
                });

            },

            initPdf: function() {


                if (this.started) return;

                if (this.options.viewMode == "swipe" || this.options.btnSearch && this.options.btnSearch.enabled)
                    this.options.textLayer = true;

                this.options.textLayer = true;

                var self = this;

                if(typeof pdfjsLib == 'undefined'){
                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.pdfjsSrc]) {
                        self.loadScript(FLIPBOOK.pdfjsSrc, function() {
                            self.initPdf();
                        });
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.pdfjsSrc]) {
                        setTimeout(function(){
                            self.initPdf();
                        },100);
                        return;
                    }
                }

                this.setLoadingProgress(.2);

                if(typeof FLIPBOOK.PdfService == 'undefined'){

                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.pdfServiceSrc]) {
                        self.loadScript(FLIPBOOK.pdfServiceSrc, function() {
                            self.initPdf();
                        });
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.pdfServiceSrc]) {
                        setTimeout(function(){
                            self.initPdf();
                        },100);
                        return;
                    }

                }

                this.setLoadingProgress(.3);

                //fix for IE10
                if(window.CanvasPixelArray) {
                    CanvasPixelArray.prototype.set = function(arr) {
                        var l=this.length, i=0;

                        for(;i<l;i++) {
                            this[i] = arr[i];
                        }
                    };
                }

                // PDFJS = pdfjsLib;

                //PDFJS.disableWorker = this.options.disableWorker || false;
                pdfjsLib.externalLinkTarget = pdfjsLib.LinkTarget.BLANK;
                // pdfjsLib.GlobalWorkerOptions.workerSrc = this.options.pdfjsworkerSrc || FLIPBOOK.pdfjsworkerSrc;
                // PDFJS.disableAutoFetch = true;

                // PDFJS.disableStream = true;

                // PDFJS.cMapUrl = 'cmaps/';
                // PDFJS.cMapPacked = true;

                //match page protocol
                if(location.protocol == "https:")
                    self.options.pdfUrl = self.options.pdfUrl.replace("http://","https://");
                else if(location.protocol == "http:")
                    self.options.pdfUrl = self.options.pdfUrl.replace("https://","http://");

                var params = {
                    cMapPacked: true,
                    cMapUrl: "cmaps/",
                    // disableAutoFetch: false,
                    // disableCreateObjectURL: false,
                    // disableFontFace: false,
                    // disableRange: false,
                    disableAutoFetch: true,
                    disableStream: true,
                    // isEvalSupported: true,
                    // maxImageSize: -1,
                    // pdfBug: false,
                    // postMessageTransfers: true,
                    url: self.options.pdfUrl,
                    rangeChunkSize: Number(self.options.rangeChunkSize) * 1024
                    // verbosity: 1
                };


                if(this.pdfinitStarted) return;
                    this.pdfinitStarted = true;

                var loadingTask = pdfjsLib.getDocument(params);

                loadingTask.promise.then(function(pdf) {

                    self.pdfDocument = pdf;

                    self.pdfService = new FLIPBOOK.PdfService(pdf, self.model, self.options);

                    self.options.thumbLoaded = function(c) {
                        self.options.thumbs = self.options.thumbs || [];
                        self.options.thumbs[c.index] = c;
                    };

                    self.setLoadingProgress(.5);

                    self.pdfService.init();
                },
                function error(e){
                    alert(e);
                });


            },

            loadPageHTML: function(index, callback){

                var self = this, index = index, options = this.options;

                if(this.options.pdfMode){

                    this.pdfService.loadTextLayer(index, function(page){

                        callback.call(self, self.options.pages[index].htmlContent);

                    });

                }else if(options.pages[index].json ){

                    this.loadPageJSON(index, function(json){

                        var page = options.pages[index] || {};

                         if(!page.htmlContentInitialized){

                            var h = document.createElement('div');
                            h.classList.add('flipbook-page-htmlContent');
                            h.classList.add('page'+String(index));
                            h.innerHTML = decodeURIComponent(json.data);

                            if (page.htmlContent)
                                jQuery(h).append(jQuery(page.htmlContent));

                            page.htmlContent = h;

                            jQuery(page.htmlContent).find(".internalLink").each(function(){

                                var main = self;

                                this.onclick = function(){
                                    var num = Number(this.dataset.page);
                                    num = main.options.rightToLeft ? main.options.pages.length - num + 1 : num;

                                    main.goToPage(num);

                                    return false
                                };
                            });

                            page.htmlContentInitialized = true;

                         }

                        callback.call(self, page.htmlContent);

                    });

                }else {

                    callback.call(this, options.pages[index].htmlContent);
                }

            },


            loadPageJSON : function(index, callback) {

                var options = this.options,
                page = options.pages[index] || {},
                self = this;


                if(!page.jsonLoading && !page.jsonLoaded){

                    page.jsonLoading = true;

                     jQuery.getJSON(page.json, function(json) {

                         page.jsonLoaded = true;
                         page.jsonLoading = false;

                        callback.call(self, json);

                     });

                     return

                 }

                if(!page.jsonLoaded){
                     setTimeout(function(){
                        self.loadPageJSON(index, callback);
                    }, 100);

                    return
                }

                callback.call(self);


            },




            loadPage: function(index, size, callback) {

                var self = this, pageSrc = this.options.pages && this.options.pages[index] && this.options.pages[index].src;

                if (this.options.pdfMode && !pageSrc) {

                    this.loadPageFromPdf(index, size, callback);

                } else {

                    var self = this, page = this.options.pages[index];

                    if (!page.img) {

                        page.img = document.createElement('img');
                        page.img.setAttribute("data-id", index);

                        page.img.onload = function() {

                            page.imgLoaded = true;

                            self.pageLoaded({ index: index, size: size, image: page.img }, callback);

                        };

                        // crossOrigin is used only for mode webgl
                        if(this.options.viewMode == "webgl")
                            page.img.crossOrigin = 'Anonymous';

                        if(location.protocol == "https:")
                            page.src = page.src.replace("http://","https://");
                        else if(location.protocol == "http:")
                            page.src = page.src.replace("https://","http://");

                        page.img.src = page.src;

                    } else if (page.imgLoaded) {

                        self.pageLoaded({ index: index, size: size, image: page.img }, callback);

                    } else {
                        setTimeout(function() {
                            self.loadPage(index, size, callback);
                        }, 300);
                    }

                }

            },

            pageLoaded: function(page, callback) {

                callback.call(this, page, callback);

                if (this.options.loadAllPages && page.index < (this.options.numPages - 1)) {

                    this.loadPage(page.index + 1, page.size, function() {});
                }

            },

            loadPageFromPdf: function(pageIndex, size, callback) {

                var self = this;

                size = size || this.options.pageTextureSize;

                if (!self.options.pages[pageIndex]) {
                    callback.call(self);
                } else {

                    this.pdfService.renderBookPage(pageIndex, size, callback);
                }

            },

            getString:function(name){
                return this.options.strings[name]
            },

            mark: function(str) {

                var c = jQuery('.flipbook-page-htmlContent');
                c.unmark({
                    done: function() {
                        c.mark(str,{
                            acrossElements: true,
                            separateWordSearch:false
                        });
                    }
                });

            },

            unmark: function() {

                this.searchingString = null;

                var c = jQuery('.flipbook-page-htmlContent');
                c.unmark();

            },

            setTool: function(tool) {

                this.tool = tool;
                this.model.trigger(tool);

            },

            toggleTool: function() {

                var tool = this.tool == "toolSelect" ? "toolMove" : "toolSelect";
                this.setTool(tool);

            },

            toggleSound:function(){

                var o = this.options;
                if (o.sound) {
                    o.sound = false;
                    this.btnSound.$icon.hide();
                    this.btnSound.$iconAlt.show();
                } else {
                    o.sound = true;
                    this.btnSound.$icon.show();
                    this.btnSound.$iconAlt.hide();
                }

            },

            scrollPageIntoView: function(obj) {

                var num = this.options.rightToLeft ? this.options.pages.length - obj.pageNumber + 1 : obj.pageNumber;

                this.goToPage(num);

            },

            loadScript: function(src, callback) {

                var self = this;
                var script = document.createElement('script');
                var prior = document.getElementsByTagName('script')[0];
                script.async = 1;
                prior.parentNode.insertBefore(script, prior);

                FLIPBOOK.scriptsAdded[src] = true;

                script.onload = script.onreadystatechange = function(_, isAbort) {
                    if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                        script.onload = script.onreadystatechange = null;
                        script = undefined$1;

                        if (!isAbort) {
                            if (callback) callback.call(self);
                        }
                        FLIPBOOK.scriptsLoaded[src] = true;
                    }
                };

                script.src = src;

            },

            createBook: function() {

                var self = this,
                    model = this.model,
                    options = this.options;

                if(options.icons == "material" && !FLIPBOOK.MaterialIconsLoaded){
                    FLIPBOOK.MaterialIconsLoaded = true;
                    jQuery('head').append('<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">');
                }

                if(typeof IScroll == 'undefined'){

                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.iscrollSrc]) {
                        self.loadScript(FLIPBOOK.iscrollSrc, self.createBook);
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.iscrollSrc]) {
                        setTimeout(function(){
                            self.createBook();
                        },100);
                        return
                    }
                }

                if(this.options.searchOnStart) this.options.btnSearch.enabled = true;

                if (this.options.btnSearch.enabled){

                    if (!FLIPBOOK.scriptsAdded[FLIPBOOK.markSrc]) {
                        self.loadScript(FLIPBOOK.markSrc, self.createBook);
                        return;
                    }

                    if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.markSrc]) {
                        setTimeout(function(){
                            self.createBook();
                        },100);
                        return
                    }

                }

                self.setLoadingProgress(.9);

                if (self.options.viewMode == "webgl") {

                    if(typeof THREE == 'undefined'){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.threejsSrc]) {
                            self.loadScript(FLIPBOOK.threejsSrc, self.createBook);
                            return;
                        }

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.threejsSrc]) {
                            setTimeout(function(){
                                self.createBook();
                            },100);
                            return
                        }
                    }

                    if(typeof FLIPBOOK.BookWebGL == 'undefined'){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipbookWebGlSrc]) {
                            self.loadScript(FLIPBOOK.flipbookWebGlSrc, self.createBook);
                            return;
                        }

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.flipbookWebGlSrc]) {
                            setTimeout(function(){
                                self.createBook();
                            },100);
                            return
                        }

                    }

                } else if (self.options.viewMode == "swipe") {

                    if(typeof FLIPBOOK.BookSwipe == 'undefined'){

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipBookSwipeSrc]) {
                            self.loadScript(FLIPBOOK.flipBookSwipeSrc, self.createBook);
                            return;
                        }

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.flipBookSwipeSrc]) {
                            setTimeout(function(){
                                self.createBook();
                            },100);
                            return
                        }

                    }

                } else {

                    if(typeof FLIPBOOK.Book3 == 'undefined'){

                        if (!FLIPBOOK.scriptsLoaded[FLIPBOOK.flipbookBook3Src]) {
                            self.loadScript(FLIPBOOK.flipbookBook3Src, self.createBook);
                            return;
                        }

                        if (!FLIPBOOK.scriptsAdded[FLIPBOOK.flipbookBook3Src]) {
                            setTimeout(function(){
                                self.createBook();
                            },100);
                            return
                        }

                    }

                }

                this.setLoadingProgress(1);

                this.initEasing();

                //console.log(self.options.pages)

                if ( /*!self.options.pdfMode && */ self.options.doublePage && self.options.pages.length > 2) {
                    var newArr = [self.options.pages[0]];
                    for (var i = 1; i <= self.options.pages.length - 2; i++) {
                        var p = self.options.pages[i];
                        var left = {
                            src: p.src,
                            thumb: p.thumb,
                            title: p.title,
                            htmlContent: p.htmlContent,
                            json: p.json,
                            side: 'left'
                        };
                        var right = {
                            src: p.src,
                            thumb: p.thumb,
                            title: p.title,
                            htmlContent: p.htmlContent,
                            json: p.json,
                            side: 'right'
                        };

                        newArr.push(left);
                        newArr.push(right);

                    }
                    newArr.push(self.options.pages[self.options.pages.length - 1]);
                    self.options.pages = newArr;
                }

                this.options.numPages = this.options.pages.length;
                if (this.options.numPages % 2 != 0 && !this.options.singlePageMode  /*&& this.options.viewMode != 'swipe' */) {
                    this.oddPages = true;
                    this.options.oddPages = true;
                    //because of RTL - pages array needs to have even number of pages
                    this.options.pages.push({
                        src: this.options.assets.preloader,
                        empty: true
                    });
                }

                if (self.options.pages.length > 0) {
                    for (var i = 0; i < self.options.pages.length; i++) {
                        if (typeof(self.options.pages[i].htmlContent) != 'undefined') {
                            // self.options.viewMode = '3d'
                            self.options.hasHtmlContent = true;
                            self.options.pages[i].htmlContent = jQuery(self.options.pages[i].htmlContent);
                        }
                    }
                }

                function initSound() {

                    self.flipsound = document.createElement('audio');
                    self.flipsound.setAttribute('src', self.options.assets.flipMp3);
                    self.flipsound.setAttribute('type', 'audio/mpeg');


                }

                if (self.options.viewMode == "webgl") {

                    var bookOptions = self.options;
                    // bookOptions.pagesArr = self.options.pages;
                    bookOptions.scroll = self.scroll;
                    bookOptions.parent = self;
                    self.Book = new FLIPBOOK.BookWebGL(self.book[0], model, bookOptions);
                    self.webglMode = true;

                    self.initSwipe();
                    initSound();


                } else if (self.options.viewMode == "swipe") {

                    self.Book = new FLIPBOOK.BookSwipe(self.book[0], self.bookLayer[0], model, options);

                    self.initSwipe();

                } else {

                    if (self.options.viewMode != "2d")
                        self.options.viewMode = "3d";

                    self.Book = new FLIPBOOK.Book3(self.book[0], model, options);

                    self.initSwipe();

                    self.webglMode = false;
                    initSound();
                }

                self.Book.enable();
                self.book.hide().fadeIn("slow");

                this.tocCreated = false;

                this.createMenu();

                this.onZoom(this.options.zoom);

                // this.createCurrentPage();
                // if (!this.options.currentPage.enabled) {
                //     this.currentPageHolder.hide()
                // }

                if (this.options.pages.length == 1) {
                    this.rightToLeft = false;
                }

                FLIPBOOK.books = FLIPBOOK.books || {};
                FLIPBOOK.books[self.id] = self.Book;

                var $book = jQuery(self.Book);

                $book.bind('loadPagesFromPdf', function(e, arr, size, callback) {
                    self.loadPagesFromPdf(arr, size, callback);
                });

                $book.bind('turnPageComplete', function(e) {
                    self.turnPageComplete();
                });

                $book.bind('initEasing', function(e) {
                    self.initEasing();
                });

                $book.bind('playFlipSound', function(e) {
                    self.playFlipSound();
                });

                $book.bind('closeLightbox', function(e) {
                    self.closeLightbox();
                });

                $book.bind('updateCurrentPage', function(e) {
                    self.updateCurrentPage();
                });

                this.createLogo();

                this.onBookCreated();
            },

            addPageItems:function(){

                var pages = this.options.pages;
                var id = this.id;
                for(var key in pages){
                    var page = pages[key];
                    page.htmlContent = page.htmlContent || '';
                    var el;
                    if(page.items){

                        for(var key2 in page.items){

                            var item = page.items[key2];

                            switch(item.type){

                                case "iframe":
                                    el = '<iframe src="'+item.src+'" width="'+item.width+'" height="'+item.height+'" style="position:absolute;top:'+item.y +'px;left:'+item.x+'px;bottom:auto;right:auto;" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
                                    page.htmlContent  += el;
                                    break;

                                case "image":
                                    el = '<img src="'+item.src+'" style="position:absolute;top:'+item.y+'px;left:'+item.x+'px;width:'+item.width+'px;height:'+item.height+'px;bottom:auto;right:auto;">';
                                    page.htmlContent  += el;
                                    break;

                                case "link":
                                    el = jQuery('<a>')
                                    .addClass('flipbook-page-item')
                                    .width(item.width)
                                    .height(item.height)
                                    .css({
                                        'top': item.y + 'px',
                                        'left': item.x + 'px',
                                        'background' : this.options.linkColor
                                    })
                                    .attr('onmouseover', 'this.style.background="'+ this.options.linkColorHover+'"')
                                    .attr('onmouseout', 'this.style.background="'+ this.options.linkColor+'"');

                                    if(item.url){
                                        el.attr('href', item.url).attr('target', '_blank');
                                    } else if(item.page){
                                        var hash = '#' + this.options.deeplinkingPrefix + item.page;
                                        if(item.flip) hash += 'flip';
                                        el.attr('href', hash );
                                    }

                                    page.htmlContent  += el[0].outerHTML;

                                    break;

                                case "video":

                                    var el = jQuery('<video>')
                                    .addClass('flipbook-page-item');
                                    if(item.width) el.attr('width', item.width);
                                    if(item.height) el.attr('height', item.height);
                                    if(item.x) el.css('left', item.x + 'px');
                                    if(item.y) el.css('top', item.y + 'px');
                                    if(item.controls) el.prop('controls', 'true');
                                    if(item.autoplay) el.prop('autoplay', 'true');

                                    var src = jQuery('<source type="video/mp4">').attr('src', item.src).appendTo(el);

                                    page.htmlContent  += el[0].outerHTML;

                                    break;

                                // case "audio":
                                //     el = '<audio src="'+item.src+'" style="position:absolute;top:'+item.y+'px;left:'+item.x+'px;width:'+item.width+'px;height:'+item.height+'px;bottom:auto;right:auto;">'
                                //     page.htmlContent  += el
                                    // break;

                                // default:
                                //     el = '<div data-bookid="'+id+'" data-page="'+(item.page || '')+'" data-url="'+(item.url || '') +'" style="position:absolute;top:'+item.y+'px;left:'+item.x+'px;width:'+item.width+'px;height:'+item.height+'px;background:#FFFF0033;cursor:pointer;" onclick="FLIPBOOK.onPageLinkClick(this)"></div>'
                                //     page.htmlContent  += el
                                //     break;
                            }

                        }
                    }
                }

            },

            onBookCreated: function() {

                var o = this.options;

                var self = this;

                if (o.rightToLeft) {
                    self.goToPage(Number(o.pages.length - Number(o.startPage) + 1), true);
                } else {
                    self.goToPage(Number(o.startPage), true);
                }


                jQuery(window).resize(function() {
                    self.resize();
                });

                self.resize();


                self.Book.updateVisiblePages();
                self.Book.zoomTo(o.zoomMin);

                this.updateCurrentPage();

                //keyboard evetns
                document.addEventListener("keydown", function(e) {
                    if (!self.Book.enabled)
                        return;

                    if(self.options.arrowsAlwaysEnabledForNavigation && ( e.keyCode == 37 || e.keyCode == 39));else {

                        if (!self.options.lightBox && !self.fullscreenActive){
                            if(self.options.arrowsDisabledNotFullscreen || self.bodyHasVerticalScrollbar())
                                return;
                        }

                    }

                    e = e || window.event;
                    switch (e.keyCode) {
                        //left
                        case 37:
                            self.prevPage();
                            break;
                            //up
                        case 38:
                            self.zoomIn();
                            break;
                            //right
                        case 39:
                            self.nextPage();
                            break;
                            //down
                        case 40:
                            self.zoomOut();
                            break;
                    }
                    return false;
                });

                document.addEventListener("MSFullscreenChange", function(e) {
                    self.handleFsChange();
                });

                document.addEventListener("mozfullscreenchange", function(e) {
                    self.handleFsChange();
                });

                document.addEventListener("webkitfullscreenchange", function(e) {
                    self.handleFsChange();
                });

                document.addEventListener("fullscreenchange", function(e) {
                    self.handleFsChange();
                });

                // if (!o.zoomDisabled) {
                //disable page scrolling
                // jQuery(this.wrapper).on('DOMMouseScroll', function(e) {
                //     e.preventDefault();
                // });
                // jQuery(this.wrapper).on('mousewheel', function(e) {
                //     e.preventDefault();
                // });
                // }

                this.zoom = o.zoomMin;

                //add mouse scroll listeners
                // if (!o.zoomDisabled) {
                //Firefox
                this.bookLayer.bind('DOMMouseScroll', function(e) {

                    if (!self.Book.enabled)
                        return;

                    if (!self.options.lightBox && !self.fullscreenActive){
                        if(self.options.wheelDisabledNotFullscreen || self.bodyHasVerticalScrollbar())
                            return;
                    }

                    e.stopPropagation();
                    e.preventDefault();

                    if (e.originalEvent.detail > 0) {
                        //scroll down
                        // console.log('Down');
                        self.zoomOut(e.originalEvent);
                    } else {
                        //scroll up
                        // console.log('Up');
                        self.zoomIn(e.originalEvent);
                    }
                    //prevent page fom scrolling
                    return false;
                });

                //IE, Opera, Safari
                this.bookLayer.bind('mousewheel', function(e) {

                    if (!self.Book.enabled)
                        return;

                    if (!self.options.lightBox && !self.fullscreenActive){
                        if(self.options.wheelDisabledNotFullscreen || self.bodyHasVerticalScrollbar())
                            return;
                    }

                    e.stopPropagation();
                    e.preventDefault();

                    // alert("mousewheel")
                    if (e.originalEvent.wheelDelta < 0 /*|| e.originalEvent.deltaY < 0  -> zoom in does not work in chrome*/ ) {
                        //scroll down
                        // console.log('Down');
                        self.zoomOut(e.originalEvent);
                    } else {
                        //scroll up
                        // console.log('Up');
                        self.zoomIn(e.originalEvent);
                    }
                    //prevent page fom scrolling
                    return false;
                });

                this.setTool("toolMove");

                if (self.options.contentOnStart) self.toggleToc(true);

                else if (self.options.thumbnailsOnStart) self.toggleThumbs(true);

                else if (self.options.searchOnStart) {
                    self.toggleSearch(true);
                    if(typeof self.options.searchOnStart == 'string'){
                        self.thumbs.$findInput.val(self.options.searchOnStart).trigger('keyup');
                    }
                }

                if (o.autoplayOnStart) self.toggleAutoplay(true);

                if (self.options.lightBox)
                    self.Book.disable();

                self.initColors();

                setTimeout(function() {
                    self.resize();
                    self.Book.updateVisiblePages();
                    self.Book.zoomTo(o.zoomMin);
                }, 500);

                if (o.onbookcreated)
                    o.onbookcreated.call(this);

            },

            initSwipe: function() {

                if(this.options.numPages == 1 || !this.options.touchSwipeEnabled)
                    return;

                var self = this;

                window.jQuery(this.bookLayer).swipe({

                    swipeStatus: function(e, phase, direction, distance, duration, fingerCount, fingerData) {
                        // console.log(e,phase,direction,distance,duration,fingerCount,fingerData)

                        // if(fingerCount > 1){
                        //     if(self.Book.disablePan)
                        //         self.Book.disablePan()
                        // }

                        // if(phase == 'end' || phase == 'cancel'){
                        //     if(self.Book.enablePan)
                        //         self.Book.enablePan()
                        // }

                        if (phase == 'start') {

                            try {
                                self.currentPageInput.trigger('blur');
                            } catch (e) {}
                        }

                        if (self.options.sideNavigationButtons && (e.target === self.arrowL[0] || e.target === self.arrowR[0])) return;

                        //gesture for fullscreen disabled

                        // if (phase == 'cancel' && duration < 200 && distance > 10 && direction == 'up') {
                        //     if (!self.fullscreenActive) self.toggleExpand();
                        // }

                        // if (phase == 'cancel' && duration < 200 && distance > 10 && direction == 'down') {
                        //     if (self.fullscreenActive) self.toggleExpand();
                        // }

                        /*if (e.type == 'touchend' && duration < 200 && distance < 10) {
                            // console.log("tap")
                            var posX = e.changedTouches[0].pageX
                            var w = self.bookLayer.width()

                            if (posX < (w / 3)) {
                                self.Book.prevPage()
                                e.preventDefault()
                                e.stopPropagation()
                            } else if (posX > (w * 2 / 3)) {
                                self.Book.nextPage()
                                e.preventDefault()
                                e.stopPropagation()
                            } else {
                                //tap in the middle
                                //                                 self.toggleMenu()
                                //                                 e.preventDefault()
                                //                                 e.stopPropagation()
                            }
                        } else */
                        if ((phase == "end" || phase == "cancel") && duration < 200 && distance < 10) {

                            // double tap zoom if text layer not active
                            // if (!self.options.textLayer && !self.options.doubleClickZoomDisabled) {
                            if (self.tool == "toolMove" && !self.options.doubleClickZoomDisabled) {

                                if (self.clickTimer == null) {
                                    self.clickTimer = setTimeout(function() {
                                        self.clickTimer = null;
                                        // console.log("single")
                                        if (e.type == 'touchend') {

                                            var posX = e.changedTouches[0].pageX;

                                        } else if (e.type == 'mouseup') {
                                            var posX = e.offsetX;
                                        }

                                        //turn page on click - disabled

                                        // var w = self.bookLayer.width()

                                        // if (posX < (w * 0.4) && self.zoom <= 1) {
                                        //     self.Book.prevPage()
                                        //     e.preventDefault()
                                        //     e.stopPropagation()
                                        // } else if (posX > (w * 0.6) && self.zoom <= 1) {
                                        //     self.Book.nextPage()
                                        //     e.preventDefault()
                                        //     e.stopPropagation()
                                        // }

                                    }, 300);
                                } else {
                                    clearTimeout(self.clickTimer);
                                    self.clickTimer = null;
                                    // console.log("double")

                                    var t = self.options.zoomTime;
                                    if (self.zoom >= self.options.zoomMax)
                                        self.zoomTo(self.options.zoomMin, t, e);
                                    else
                                        self.zoomTo(self.options.zoomMax, t, e);

                                }
                            }

                            //start timer, if another click arrives
                        } else {

                            if ((direction == "up" || direction == "down") && phase == 'move' || self.zoom > 1 || self.tool == "toolSelect") return;
                            // console.log(phase,direction,distance, fingerCount, fingerData)
                            self.Book.onSwipe(e, phase, direction, distance, duration, fingerCount, fingerData);
                        }

                        /*if (e.type == 'mouseup' && duration < 100 && distance < 10) {
                            var posX = e.pageX
                            var w = self.bookLayer.width()

                            if (posX < (w / 3)) {
                               e.stopPropagation();
                            e.preventDefault();
                            self.Book.prevPage();
                            } else if (posX > (w * 2 / 3)) {
                                e.stopPropagation();
                            e.preventDefault();
                            self.Book.nextPage();
                            } else {

                            }
                        }*/
                    },

                    // pinchIn: function(event, direction, distance, duration, fingerCount, pinchZoom) {
                        // console.log("pinch in")
                        // jQuery("#trace").text("You pinched " + direction + " by " + distance + "px, zoom scale is " + pinchZoom);
                    // },
                    // pinchOut: function(event, direction, distance, duration, fingerCount, pinchZoom) {
                        // console.log("pinch out")
                        // jQuery("#trace").text("You pinched " + direction + " by " + distance + "px, zoom scale is " + pinchZoom);
                    // },
                    pinchStatus: function(event, phase, direction, distance, duration, fingerCount, pinchZoom) {
                        // console.log(event, phase, direction, distance, duration, fingerCount, pinchZoom)
                        // console.log(pinchZoom)
                        if (phase == "start")
                            self.zoomStart = self.zoom;

                        if (fingerCount > 1 && phase == "move"){

                            event.preventDefault();

                            if(event.scale)
                                pinchZoom = event.scale;

                            // if (self.options.viewMode == "webgl"){
                                self.zoomTo(self.zoomStart * pinchZoom, 0, event);
                                // console.log("zoom to ",self.zoomStart * pinchZoom, event)
                            // }

                        }

                   },

                    fingers: 2,

                    pinchThreshold: 0,

                    allowPageScroll: 'vertical',

                    preventDefaultEvents: false

                });

                this.swipeEnabled = true;

            },

            toggleMenu: function() {

                if (this.menuShowing) {
                    //hide menu
                    this.menuShowing = false;

                    this.bookLayer.css('bottom', '0px');
                    this.menuBottom.fadeOut();
                    this.currentPageHolder.fadeOut();
                    jQuery('.flipbook-nav').fadeOut();
                    this.Book.onResize();

                } else {
                    //show menu
                    this.menuShowing = true;

                    this.bookLayer.css('bottom', this.menuBottom.height() + 'px');
                    this.menuBottom.fadeIn();
                    this.currentPageHolder.fadeIn();
                    jQuery('.flipbook-nav').fadeIn();
                    this.Book.onResize();

                }

            },

            createIcon:function(btn, alt, transparent){

                var o = this.options, $icon;

                if (o.icons == "material") {
                    $icon = jQuery('<i>')
                        .addClass('material-icons flipbook-icon-material flipbook-menu-btn skin-color')
                        .attr('title', btn.title)
                        .text(alt ? btn.iconAlt2 : btn.icon2);
                }else {
                    $icon = jQuery(document.createElement('span'))
                        .attr('aria-hidden', 'true')
                        .addClass(alt ? btn.iconAlt : btn.icon)
                        .addClass('flipbook-icon-fa flipbook-menu-btn skin-color fa');

                }
                if(!transparent)
                    $icon.addClass('skin-color-bg');

                return $icon;
            },

            createButton: function(btn) {

                var o = this.options;
                var floating = ((btn.vAlign == 'top' && o.menu2Transparent) || (btn.vAlign != 'top' && o.menuTransparent));
                var bgColor =  btn.background || (floating ? o.floatingBtnBackground : o.btnBackground);
                var bgColorHover =  btn.backgroundHover || (floating ? o.floatingBtnBackgroundHover : o.btnBackgroundHover);
                var color = btn.color || (floating ? o.floatingBtnColor : o.btnColor);
                var colorHover = btn.colorHover || (floating ? o.floatingBtnColorHover : o.btnColorHover);
                var textShadiw = floating ? o.floatingBtnTextShadow : o.btnTextShadow;
                var radius = btn.radius || (floating ? o.floatingBtnRadius : o.btnRadius);
                var border = btn.border || (floating ? o.floatingBtnBorder : o.btnBorder);
                var margin = floating ? o.floatingBtnMargin : o.btnMargin;
                var $btn = jQuery(document.createElement('span'));
                var material = o.icons == "material";
                var btnSize = material ? (btn.size || o.btnSize) + 8 : btn.size || o.btnSize;
                var btnWidth = (btn.size || o.btnSize) + 24;

                function addCSS($icon){
                    $icon.css({
                        'width': btnWidth + 'px',
                        'font-size': btnSize + 'px',
                        'margin': margin + 'px',
                        'border-radius': radius + 'px',
                        'text-shadow': o.btnTextShadow,
                        'box-shadow': o.btnShadow,
                        'border': border,
                        'color': color,
                        'background': bgColor,
                        'text-shadow' : textShadiw
                    });

                    if(color) $icon.removeClass('skin-color');
                    if(bgColor) $icon.removeClass('skin-color-bg');
                }

                $btn.$icon = this.createIcon(btn)
                    .appendTo($btn);
                addCSS($btn.$icon);

                if(btn.iconAlt2){

                    $btn.$iconAlt = this.createIcon(btn, true)
                        .appendTo($btn)
                        .hide();
                    addCSS($btn.$iconAlt);

                }


                $btn.icon = btn.icon;
                $btn.iconAlt = btn.iconAlt;

                if (btn.onclick)
                    $btn.bind('tap click', function(e) {
                        btn.onclick();
                    });

                if (colorHover || bgColorHover )

                    $btn.mouseenter(function() {
                        $btn.$icon.css({
                            'color': colorHover,
                            'background': bgColorHover
                        });
                        if($btn.$iconAlt) $btn.$iconAlt.css({
                            'color': colorHover,
                            'background': bgColorHover
                        });
                    }).mouseleave(function() {
                        $btn.$icon.css({
                            'color': color,
                            'background': bgColor
                        });
                        if($btn.$iconAlt) $btn.$iconAlt.css({
                            'color': color,
                            'background': bgColor
                        });
                    });


                var menu, cssClass = '';

                if(btn.vAlign == 'top'){
                    if(o.menu2Floating){
                        menu = this.menuTC;
                    }else if(btn.hAlign == 'left'){
                        menu = this.menuTL;
                    }else if(btn.hAlign == 'right'){
                        menu = this.menuTR;
                    }else {
                        menu = this.menuTC;
                    }
                }else {
                    if(o.menuFloating){
                        menu = this.menuBC;
                    }else if(btn.hAlign == 'left'){
                        menu = this.menuBL;
                    }else if(btn.hAlign == 'right'){
                        menu = this.menuBR;
                    }else {
                        menu = this.menuBC;
                    }
                }

                $btn.attr('data-name', btn.name)
                    .appendTo(menu)
                    .attr('title', btn.title)
                    .addClass(cssClass)
                    .css('order', btn.order);


                    //button titles

                // jQuery("<span></span>").css({
                //     'fontSize':'10px',
                //     'display':'block',
                //     'marginTop':'-8px',
                //     'maxWidth':'40px'
                //     }).appendTo($btn).text(btn.title)


                return $btn

            },

            createMenu: function() {

                if(this.menuBottom)
                    return

                var o = this.options;

                var menuBottomClass = o.menuFloating ? 'flipbook-menu-floating' : 'flipbook-menu-fixed';
                var menuTopClass = o.menu2Floating ? 'flipbook-menu-floating' : 'flipbook-menu-fixed';

                var self = this;
                this.menuBottom = jQuery(document.createElement('div'))
                    .addClass('flipbook-menuBottom')
                    .addClass(menuBottomClass)
                    .appendTo(this.wrapper)
                    .css({
                        'background': o.menuBackground,
                        'box-shadow': o.menuShadow,
                        'margin': o.menuMargin + 'px',
                        'padding': o.menuPadding + 'px',
                    });

                if(!o.menuTransparent && !o.menuBackground)
                    this.menuBottom.addClass('skin-color-bg');


                if (o.hideMenu)
                    this.menuBottom.hide();

                this.menuTop = jQuery(document.createElement('div'))
                    .addClass('flipbook-menuTop')
                    .addClass(menuTopClass)
                    .appendTo(this.wrapper)
                    .css({
                        'background': o.menu2Background,
                        'box-shadow': o.menu2Shadow,
                        'margin': o.menu2Margin + 'px',
                        'padding': o.menu2Padding + 'px',
                    });

                if(!o.menu2Transparent && !o.menu2Background)
                    this.menuTop.addClass('skin-color-bg');

                // if (o.hideMenu)
                //     this.menuTop.hide();

                if (o.viewMode == "swipe") o.btnSound.enabled = false;

                this.menuBL = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu flipbook-menu-left')
                    .appendTo(this.menuBottom);


                this.menuBC = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu flipbook-menu-center')
                    .appendTo(this.menuBottom);

                this.menuBR = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu flipbook-menu-right')
                    .appendTo(this.menuBottom);

                this.menuTL = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu flipbook-menu-left')
                    .appendTo(this.menuTop);

                this.menuTC = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu flipbook-menu-center')
                    .appendTo(this.menuTop);

                this.menuTR = jQuery(document.createElement('div'))
                    .addClass('flipbook-menu flipbook-menu-right')
                    .appendTo(this.menuTop);

                if(o.isMobile){
                    if(typeof o.btnTocIfMobile != 'undefined') o.btnToc.hideOnMobile = !o.btnTocIfMobile;
                    if(typeof o.btnThumbsIfMobile != 'undefined') o.btnThumbs.hideOnMobile = !o.btnThumbsIfMobile;
                    if(typeof o.btnShareIfMobile != 'undefined') o.btnShare.hideOnMobile = !o.btnShareIfMobile;
                    if(typeof o.btnDownloadPagesIfMobile != 'undefined') o.btnDownloadPages.hideOnMobile = !o.btnDownloadPagesIfMobile;
                    if(typeof o.btnDownloadPdfIfMobile != 'undefined') o.btnDownloadPdf.hideOnMobile = !o.btnDownloadPdfIfMobile;
                    if(typeof o.btnSoundIfMobile != 'undefined') o.btnSound.hideOnMobile = !o.btnSoundIfMobile;
                    if(typeof o.btnExpandIfMobile != 'undefined') o.btnExpand.hideOnMobile = !o.btnExpandIfMobile;
                    if(typeof o.btnPrintIfMobile != 'undefined') o.btnPrint.hideOnMobile = !o.btnPrintIfMobile;
                }

                //arrows
                if (o.sideNavigationButtons) {

                    //if (self.options.btnNext.enabled)
                    this.btnNext = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"></div></div>')
                        .appendTo(this.bookLayer)
                        .bind('tap click', function(e) {

                            if (self.btnNext.disabled) return;
                            self.btnNext.disabled = true;
                            setTimeout(function() {
                                self.btnNext.disabled = false;
                            }, 300);

                            e.stopPropagation();
                            e.preventDefault();
                            self.nextPage();
                        });

                    this.arrowR = this.createIcon(o.btnNext).appendTo(this.btnNext.first())
                        .addClass('flipbook-right-arrow')
                        .css({
                            'width': o.sideBtnSize + 'px',
                            'height': o.sideBtnSize + 'px',
                            'font-size': o.sideBtnSize + 'px',
                            'border-radius': o.sideBtnRadius + 'px',
                            'margin-top': String(-o.sideBtnSize / 2) + 'px',
                            'margin-right': o.sideBtnMargin + 'px',
                            'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                            'text-shadow': o.sideBtnTextShadow,
                            'box-shadow': o.sideBtnShadow,
                            'border': o.sideBtnBorder,
                            'color': o.sideBtnColor,
                            'background': o.sideBtnBackground,
                            'box-sizing': 'initial'
                        });

                   if(o.sideBtnColor) this.arrowR.removeClass("skin-color");
                   if(o.sideBtnBackground) this.arrowR.removeClass("skin-color-bg");



                    //if (self.options.btnPrev.enabled)
                    this.btnPrev = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"></div></div>')
                        .appendTo(self.bookLayer)
                        .bind('tap click', function(e) {

                            if (self.btnPrev.disabled) return;
                            self.btnPrev.disabled = true;
                            setTimeout(function() {
                                self.btnPrev.disabled = false;
                            }, 300);

                            e.stopPropagation();
                            e.preventDefault();
                            self.prevPage();
                        });

                    this.arrowL = this.createIcon(o.btnPrev).appendTo(this.btnPrev.first())
                        .addClass('flipbook-left-arrow')
                        .css({
                            'width': o.sideBtnSize + 'px',
                            'height': o.sideBtnSize + 'px',
                            'font-size': o.sideBtnSize + 'px',
                            'border-radius': o.sideBtnRadius + 'px',
                            'margin-top': String(-o.sideBtnSize / 2) + 'px',
                            'margin-left': o.sideBtnMargin + 'px',
                            'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                            'text-shadow': o.sideBtnTextShadow,
                            'box-shadow': o.sideBtnShadow,
                            'border': o.sideBtnBorder,
                            'color': o.sideBtnColor,
                            'background': o.sideBtnBackground,
                            'box-sizing': 'initial'
                        });

                    if(o.sideBtnColor) this.arrowL.removeClass("skin-color");
                    if(o.sideBtnBackground) this.arrowL.removeClass("skin-color-bg");


                    if (o.btnFirst.enabled) {
                        this.btnFirst = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"></div></div>')
                            .appendTo(this.bookLayer)
                            .bind('tap click', function(e) {

                                if (self.btnFirst.disabled) return;
                                self.btnFirst.disabled = true;
                                setTimeout(function() {
                                    self.btnFirst.disabled = false;
                                }, 300);

                                e.stopPropagation();
                                e.preventDefault();
                                self.firstPage();
                            });

                        this.arrowFirst = this.createIcon(o.btnFirst).appendTo(this.btnFirst.first())
                            .addClass('flipbook-first-arrow')
                            .css({
                                'width': o.sideBtnSize + 'px',
                                'height': o.sideBtnSize * .66 + 'px',
                                'font-size': o.sideBtnSize * .66 + 'px',
                                'border-radius': o.sideBtnRadius + 'px',
                                'margin-top': String(o.sideBtnSize / 2 + o.sideBtnMargin + 2 * o.sideBtnPaddingV) + 'px',
                                'margin-left': o.sideBtnMargin + 'px',
                                'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                                'text-shadow': o.sideBtnTextShadow,
                                'box-shadow': o.sideBtnShadow,
                                'border': o.sideBtnBorder,
                                'color': o.sideBtnColor,
                                'background': o.sideBtnBackground,
                                'box-sizing': 'initial'
                            });
                            if(o.sideBtnColor) this.arrowFirst.removeClass("skin-color");
                            if(o.sideBtnBackground) this.arrowFirst.removeClass("skin-color-bg");

                    }

                    if (o.btnLast.enabled) {
                        this.btnLast = jQuery('<div class="flipbook-nav"><div class="flipbook-arrow-wrapper"></div></div>')
                            .appendTo(self.bookLayer)
                            .bind('tap click', function(e) {

                                if (self.btnLast.disabled) return;
                                self.btnLast.disabled = true;
                                setTimeout(function() {
                                    self.btnLast.disabled = false;
                                }, 300);


                                e.stopPropagation();
                                e.preventDefault();
                                self.lastPage();
                            });

                        this.arrowLast = this.createIcon(o.btnLast).appendTo(this.btnLast.first())
                            .addClass('flipbook-last-arrow')
                            .css({
                                'width': o.sideBtnSize + 'px',
                                'height': o.sideBtnSize * .66 + 'px',
                                'font-size': o.sideBtnSize * .66 + 'px',
                                'border-radius': o.sideBtnRadius + 'px',
                                'margin-top': String(o.sideBtnSize / 2 + o.sideBtnMargin + 2 * o.sideBtnPaddingV) + 'px',
                                'margin-right': o.sideBtnMargin + 'px',
                                'padding': o.sideBtnPaddingV + 'px ' + o.sideBtnPaddingH + 'px',
                                'text-shadow': o.sideBtnTextShadow,
                                'box-shadow': o.sideBtnShadow,
                                'border': o.sideBtnBorder,
                                'color': o.sideBtnColor,
                                'background': o.sideBtnBackground,
                                'box-sizing': 'initial'
                            });

                        if(o.sideBtnColor) this.arrowLast.removeClass("skin-color");
                         if(o.sideBtnBackground) this.arrowLast.removeClass("skin-color-bg");


                    }

                    if(o.btnOrder.indexOf('btnFirst') >= 0) o.btnOrder.splice(o.btnOrder.indexOf('btnFirst'), 1);
                    if(o.btnOrder.indexOf('btnPrev') >= 0) o.btnOrder.splice(o.btnOrder.indexOf('btnPrev'), 1);
                    if(o.btnOrder.indexOf('btnNext') >= 0) o.btnOrder.splice(o.btnOrder.indexOf('btnNext'), 1);
                    if(o.btnOrder.indexOf('btnLast') >= 0) o.btnOrder.splice(o.btnOrder.indexOf('btnLast'), 1);

                }

                if (o.pdfMode && !o.btnDownloadPdf.url)
                    o.btnDownloadPdf.url = o.pdfUrl;

                if(!o.textLayer && o.btnSelect) o.btnSelect.enabled = false;

                for (var i = 0; i < o.btnOrder.length; i++) {

                    var btnName = o.btnOrder[i];
                    var btn = o[btnName];

                    if(o.isMobile && btn.hideOnMobile) btn.enabled = false;

                    if(btn.enabled){

                        btn.name = btnName;

                        if(btn.name == 'currentPage'){
                            this.createCurrentPage();
                        }else {
                            this[btnName] = this.createButton(btn)
                            .bind('touchend click', function(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                self.onButtonClick(this,e);
                            });
                        }
                    }
                }

                if (o.buttons) {
                    for (var i = 0; i < o.buttons.length; i++) {
                        var btn = o.buttons[i];
                        self.createButton(btn).index(1);
                    }
                }

            },

            onButtonClick:function(btn,e){

                var name = jQuery(btn).attr('data-name'),
                o = this.options;

                switch(name){
                    case 'btnFirst':
                        this.firstPage();
                        break;
                    case 'btnPrev':
                        this.prevPage();
                        break;
                    case 'btnNext':
                        this.nextPage();
                        break;
                    case 'btnLast':
                        this.lastPage();
                        break;
                    case 'btnZoomIn':
                        this.zoomIn();
                        break;
                    case 'btnZoomOut':
                        this.zoomOut();
                        break;
                    case 'btnAutoplay':
                        if (!this.autoplay)
                            this.nextPage();
                        this.toggleAutoplay();
                        break;
                    case 'btnSearch':
                        this.toggleSearch();
                        break;
                    case 'btnBookmark':
                        this.toggleBookmark();
                        break;
                    case 'btnRotateLeft':
                        if(this.Book.rotateLeft) this.Book.rotateLeft();
                        break;
                    case 'btnRotateRight':
                        if(this.Book.rotateRight) this.Book.rotateRight();
                        break;
                    case 'btnToc':
                        this.toggleToc();
                        break;
                    case 'btnThumbs':
                        this.toggleThumbs();
                        break;
                    case 'btnShare':
                        this.toggleShareMenu();
                        break;
                    case 'btnDownloadPages':

                        if (o.downloadMenu) {

                            this.toggleDownloadMenu();

                        } else {

                            var link = document.createElement('a');
                            link.href = o.btnDownloadPages.url;
                            link.download = o.btnDownloadPages.name;
                            link.dispatchEvent(new MouseEvent('click'));

                        }

                        break;

                    case 'btnPrint':

                        if (o.printMenu)
                            this.togglePrintMenu();
                         else
                            this.togglePrintWindow();

                        break;

                    case 'btnDownloadPdf':

                        if (o.btnDownloadPdf.forceDownload) {

                            var path = o.btnDownloadPdf.url;
                            var save = document.createElement('a');
                            save.href = path;
                            var filename = save.href.split('/').pop().split('#')[0].split('?')[0];
                            save.download = filename;
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);

                        } else {

                            var target = o.btnDownloadPdf.openInNewWindow || typeof(o.btnDownloadPdf.openInNewWindow == 'undefined') ? '_blank' : '_self';
                            window.open(o.btnDownloadPdf.url, target);

                        }

                        if(this.gaCode){
                            ga('send', {
                               hitType: 'event',
                               eventCategory: 'Flipbook : '+o.name,
                               eventAction: 'download PDF' ,
                               eventLabel: o.btnDownloadPdf.url,
                               nonInteraction: true
                           });
                        }

                        break;

                    case 'btnSound':
                        this.toggleSound();
                        break;
                    case 'btnSelect':
                        this.toggleTool();
                        break;
                    case 'btnExpand':
                        // requestFullscreen() has to be directly in the user-triggered event listener
                        if (document.fullscreenElement == null) {
                            document.documentElement.requestFullscreen();
                        } else {
                            document.exitFullscreen();
                        }
                        break;
                    case 'btnClose':
                       // if(!this.lightbox) return;
                       // var $target = jQuery(e.target)
                       // if (!$target.parents().hasClass('flipbook-overlay') || $target.hasClass('flipbook-bookLayer'))
                            this.lightbox.closeLightbox();
                        break;

                }
            },

            handleFsChange: function(e) {
                if (!this.Book || !this.Book.enabled)
                    return;

                if (document.fullscreenElement) {
                    this.btnExpand.$icon.hide();
                    this.btnExpand.$iconAlt.show();
                } else {
                    this.btnExpand.$icon.show();
                    this.btnExpand.$iconAlt.hide();
                }
            },

            createLogo: function() {
                var o = this.options;
                if (!o.logoImg) return;
                if (o.isMobile && o.logoHideOnMobile) return;

                var $logo = jQuery('<img>')
                    .attr('src', o.logoImg)
                    .attr('style', o.logoCSS)
                    .appendTo(this.wrapper);

                if (o.logoAlignH == 'right')
                    $logo.css('right', '0');
                if (o.logoAlignV == 'bottom')
                    $logo.css('bottom', '0');

                if (o.logoUrl) {
                    $logo.bind('touchend click', function() {
                        window.open(o.logoUrl, '_blank');
                    });
                }
            },

            setLoadingProgress: function(percent) {

                if(this.disposed)
                    return

                if(this.$fillPreloader)
                    this.setFillPreloaderProgress(percent);
                else {
                    if (percent > 0 && percent < 1) {
                        jQuery(this.preloader).stop(true, true).show();
                    } else {
                        jQuery(this.preloader).stop(true, true).hide();
                    }
                }


            },

            setFillPreloaderProgress: function(percent) {

                if (!this.$fillPreloader)
                    return;

                if (percent > 0 && percent < 1) {

                    this.fillPreloaderProgress = this.fillPreloaderProgress || 0;

                    if (percent < this.fillPreloaderProgress)
                        return;
                    else
                        this.fillPreloaderProgress = percent;
                    // percent = .5
                    var img = this.$fillPreloaderImg[0];
                    img.style.clip = "rect(0px," + img.width * percent + "px," + img.height + "px,0px)";
                    this.$fillPreloader.show();

                } else {
                    this.$fillPreloader.hide();

                }
            },

            createNavigation: function() {
                var self = this;

                this.navLeft = jQuery('<div />');
                this.navLeft
                    // .appendTo(this.bookLayer)
                    // .css('position','absolute')
                    // .css('width','200px')
                    // .css('height','200px')
                    .css('background', '#f00')
                    .css('left', '0')
                    .css('top', '200px')
                    .attr('aria-hidden', 'true')
                    .addClass('skin-color fa fa-chevron-left fa-5x')
                    .css('margin-top', this.navLeft.height() + 'px')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.prevPage();
                    });

                this.navRight = jQuery('<div />')
                    .appendTo(this.bookLayer)
                    .css('position', 'absolute')
                    .css('width', '200px')
                    .css('height', '200px')
                    .css('margin-top', '-100px')
                    .css('background', '#f00')
                    .css('right', '0')
                    .css('top', '200px')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.nextPage();
                    });


            },
            playFlipSound: function() {

                var self = this;

                if (this.options.sound && this.Book.enabled && typeof(this.flipsound.play) != 'undefined') {

                    this.flipsound.currentTime = 0;

                    setTimeout(function() {

                        try {

                            self.flipsound.play();

                        } catch (e) {

                        }

                    }, 100);
                }
            },

            onMouseWheel: function(e) {
                //console.log(e)

                if ('wheelDeltaX' in e) {
                    wheelDeltaX = e.wheelDeltaX / 12;
                    wheelDeltaY = e.wheelDeltaY / 12;
                } else if ('wheelDelta' in e) {
                    wheelDeltaX = wheelDeltaY = e.wheelDelta / 12;
                } else if ('detail' in e) {
                    wheelDeltaX = wheelDeltaY = -e.detail * 3;
                } else {
                    return;
                }
                if (wheelDeltaX > 0)
                    this.zoomIn(e);
                else
                    this.zoomOut(e);

            },

            zoomTo: function(val, time, e) {

                this.zoom = val;

                var x, y;

                if (typeof e == 'undefined') {

                    //zoom to middle
                    x = this.model.wrapperW / 2;
                    y = this.model.wrapperH / 2;

                } else {

                    if (e.touches && e.touches[0]) {

                        x = e.touches[0].pageX;
                        y = e.touches[0].pageY;

                    } else if (e.changedTouches && e.changedTouches[0]) {

                        x = e.changedTouches[0].pageX;
                        y = e.changedTouches[0].pageY;

                    } else {

                        x = e.pageX;
                        y = e.pageY;
                    }

                    //main wrapper offset - works for all modes

                    // if(!this.fullscreenActive){
                        x = x - this.wrapper.offset().left;
                        y = y - this.wrapper.offset().top;
                    // }

                }

                // console.log(this.zoom, this.options.zoomMin, this.options.zoomMax)
                if(this.zoom < this.options.zoomMin)
                    this.zoom = this.options.zoomMin;
                if(this.zoom > this.options.zoomMax)
                    this.zoom = this.options.zoomMax;

                if(this.options.zoomMax2 && this.zoom > this.options.zoomMax2)
                    this.zoom = this.options.zoomMax2;

                this.model.zoom = this.zoom;

                this.Book.zoomTo(this.zoom, time, x, y);

                this.onZoom(this.zoom);

            },

            zoomOut: function(e) {

                var newZoom = this.zoom / this.options.zoomStep;
                if(newZoom < 1 && this.zoom > 1) newZoom = 1;
                newZoom = newZoom < this.options.zoomMin ? this.options.zoomMin : newZoom;

                if(this.zoom == newZoom)
                    return

                this.zoom = newZoom;

                var t = this.options.zoomTime;

                this.zoomTo(this.zoom, t, e);

            },

            zoomIn: function(e) {

                var newZoom = this.zoom * this.options.zoomStep;
                if(newZoom > 1 && this.zoom < 1) newZoom = 1;

                if (this.bookLayer.height() * newZoom > this.options.zoomSize)
                    newZoom = this.options.zoomSize / this.bookLayer.height();
                //newZoom = newZoom > this.options.zoomMax ? this.options.zoomMax : newZoom;

                if(this.zoom == newZoom)
                    return

                this.zoom = newZoom;

                var t = this.options.zoomTime;

                this.zoomTo(this.zoom, t, e);

            },

            nextPage:function(){

                if(this.Book) this.Book.nextPage();

            },

            prevPage:function(){

                if(this.Book) this.Book.prevPage();

            },

            firstPage:function(){

                this.goToPage(1);

            },

            lastPage:function(){

                this.goToPage(this.options.pages.length);

            },

            goToPage: function(pageNumber, instant) {

                if(this.Book)
                    this.Book.goToPage(pageNumber, instant);

            },

            onZoom: function(newZoom) {

                this.zoom = newZoom;
                this.enableButton(this.btnZoomIn, newZoom < this.options.zoomMax);
                this.enableButton(this.btnZoomOut, newZoom > this.options.zoomMin);
                this.enableSwipe(newZoom <= 1);
                this.model.zoom = newZoom;

            },

            enableSwipe: function(val) {

                this.swipeEnabled = val;

            },

            createCurrentPage: function() {

                var self = this, o = this.options;
                var menu, cssClass = 'flipbook-currentPageHolder ';

                if(o.currentPage.vAlign == 'top'){
                    if(o.currentPage.hAlign == 'left'){
                        menu = this.menuTL;
                    }else if(o.currentPage.hAlign == 'right'){
                        menu = this.menuTR;
                    }else
                        menu = this.menuTC;
                }else {
                    if(o.currentPage.hAlign == 'left'){
                        menu = this.menuBL;
                    }else if(o.currentPage.hAlign == 'right'){
                        menu = this.menuBR;
                    }else
                        menu = this.menuBC;

                }

                var floating = ((o.currentPage.vAlign == 'top' && o.menu2Transparent) || (o.currentPage.vAlign != 'top' && o.menuTransparent));
                var bgColor =  floating ? o.floatingBtnBackground : '';
                var color = floating ? o.floatingBtnColor : o.btnColor;
                var textShadiw = floating ? o.floatingBtnTextShadow : '';
                var radius = floating ? o.floatingBtnRadius : o.btnRadius;
                var margin = floating ? o.floatingBtnMargin : o.btnMargin;

                var currentPageHolder = jQuery('<div>')
                    .appendTo(menu);

                currentPageHolder.css('margin', o.currentPage.marginV + 'px ' + o.currentPage.marginH + 'px');

                if(!floating)
                    cssClass += "skin-color ";

                currentPageHolder
                    .addClass(cssClass)
                    .css({
                        'color':color,
                        'background':bgColor,
                        'text-shadow':textShadiw,
                        'border-radius':radius + 'px'
                    });

                if(o.currentPage.order)
                    currentPageHolder.css('order', o.currentPage.order);

                this.currentPageHolder = currentPageHolder;
                this.currentPage = jQuery(document.createElement('div'))
                    .addClass('flipbook-currentPageNumber')
                    .appendTo(currentPageHolder);

                var $form = jQuery('<form>')
                    .appendTo(currentPageHolder)
                    .submit(function(e) {

                        var value = parseInt(self.currentPageInput.val());
                        value = value > o.pages.length ? o.pages.length : value;
                        if (self.options.rightToLeft) {

                            value = o.pages.length - value + 1;
                        }
                        //self.updateCurrentPage();
                        //if (self.options.singlePageMode) value--;
                        self.goToPage(value);
                        self.currentPageInput.trigger('blur');
                        return false
                    });

                this.currentPageInput = jQuery('<input type="text" maxlength="4">')
                    .addClass('flipbook-currentPageInput')
                    .css({
                        'margin': o.currentPage.marginV + 'px ' + o.currentPage.marginH + 'px',
                        'color':color
                    })
                    .appendTo($form)
                    .val('')
                    .focus(function() {

                        self.currentPageInput.val('');
                        self.currentPage.addClass('flipbook-color-transparent');

                    })
                    .blur(function() {

                        self.currentPageInput.val('');
                        self.currentPage.removeClass('flipbook-color-transparent');

                    });

                if(!floating)
                    this.currentPageInput.addClass('skin-color');

            },

            createMenuHeader: function(elem, title, onClose) {

                var self = this;

                var header = jQuery("<div>")
                    .addClass("flipbook-menu-header skin-clor flipbook-font")
                    .appendTo(elem);

                var title = jQuery('<span>')
                    .text(title)
                    .addClass('flipbook-menu-title skin-color')
                    .appendTo(header);

                var btnClose = jQuery('<span>').appendTo(header)
                    .addClass('flipbook-btn-close')
                    .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        self.closeMenus();
                    });

                var $icon = this.createIcon(this.options.btnClose, null, true)
                    .appendTo(btnClose);
                    // .attr('aria-hidden', 'true')
                    // .addClass('fa fa-times flipbook-btn-close-icon skin-color')


            },

            createToc: function() {

                var self = this,
                tocArray = this.options.tableOfContent;

                if((!tocArray || !tocArray.length) && this.pdfService && !this.pdfService.outlineLoaded){
                    self.pdfService.loadOutline(function(outline){
                        self.options.tableOfContent = outline;
                        self.createToc();
                    });
                    return
                }

                this.tocHolder = jQuery('<div>')
                    .addClass('flipbook-tocHolder flipbook-side-menu skin-color-bg')
                    .appendTo(this.wrapper)
                    .css(this.options.sideMenuPosition, '0')
                    .hide();

                this.createMenuHeader(this.tocHolder, this.strings.tableOfContent, this.toggleToc);

                // .css('left', '-1000px')
                this.toc = jQuery('<div>')
                    .addClass('flipbook-toc')
                    .appendTo(this.tocHolder);

                this.tocScroller = jQuery('<div>')
                    .addClass('flipbook-toc-scroller')
                    .appendTo(this.toc);

                this.tocScroll = new FLIPBOOK.IScroll(self.toc[0], {
                    bounce: false,
                    mouseWheel: true,
                    scrollbars: true,
                    interactiveScrollbars: true
                });

                 if (tocArray && tocArray.length > 0) {

                    var pages = this.options.pages;
                    for (var i = 0; i < tocArray.length; i++) {

                        this.createTocItem(tocArray[i]);
                    }

                } else {

                    var arr = this.options.pages;
                    for (var i = 0; i < arr.length; i++) {
                        var title = arr[i].title;
                        if (title == "" || typeof title == 'undefined')
                            continue;
                        var page = String(i + 1);
                        var item = {title:title, page:page};

                        this.createTocItem(item);

                    }

                }

                this.initColors();
                this.tocScroll.refresh();
                this.tocCreated = true;
                this.toggleToc();

            },

            createTocItem:function(item, parent, level){

                var self = this;
                var parent = parent || this.tocScroller;
                var rtl = this.options.rightToLeft;

                var tocItem = jQuery(document.createElement('a'))
                .attr('class', 'flipbook-tocItem')
                .addClass('skin-color')
                .css('direction', rtl ? 'rtl' : 'ltr')
                .appendTo(parent)
                .bind('touchend click', function(e) {
                    e.stopPropagation();
                    e.preventDefault();

                    if (self.tocScroll.moved)
                        return;

                    if (self.options.tableOfContentCloseOnClick)
                        self.toggleToc(false);

                    if(!item.page && item.dest){
                        self.pdfService.pdfDocument.getPageIndex(item.dest[0]).then(function(index){
                            // item.page = index + 1

                            var targetPage = index + 1;

                            targetPage = self.options.rightToLeft ? self.options.pages.length - targetPage + 1 : targetPage;

                            setTimeout(function(){
                                self.goToPage(targetPage);
                            },200);

                        });
                    }else {

                        var targetPage = Number(item.page);

                        targetPage = self.options.rightToLeft ? self.options.pages.length - targetPage + 1 : targetPage;

                        setTimeout(function(){
                            self.goToPage(targetPage);
                        },200);

                    }

                });

                if(!level)
                    level = 0;

                tocItem.level = level;

                tocItem.css('padding','8px 0');
                tocItem.css('margin-' + (rtl ? 'right' : 'left'),'10px');
                if(!level){
                    tocItem.css('margin-right','15px');
                    tocItem.css('padding-left','10px');
                }
                else {
                    tocItem.css('margin-top','8px');
                    tocItem.css('padding-bottom','0');
                }

                var expandBtn = jQuery(document.createElement('span'))
                .appendTo(tocItem)
                .css('width','20px')
                .css('display','inline-block')
                .css('cursor','auto')
                .bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        for (var i = 0; i < tocItem.items.length; i++) {
                           tocItem.items[i].toggle();
                        }
                        $icon.toggle();
                        $icon2.toggle();
                        self.tocScroll.refresh();
                    });

                var $icon = jQuery('<span>')
                .attr('aria-hidden', 'true')
                .appendTo(expandBtn)
                .addClass('fa fa-chevron-' + (rtl ? 'left' : 'right') +' skin-color')
                .hide();

                var $icon2 = jQuery('<span>')
                .attr('aria-hidden', 'true')
                .appendTo(expandBtn)
                .addClass('fa fa-chevron-down skin-color')
                .hide();


                jQuery(document.createElement('span'))
                    .appendTo(tocItem)
                    .addClass('title')
                    .text(item.title)
                    .css('width', String(170 - tocItem.level * 10) + 'px');
                jQuery(document.createElement('span'))
                    .appendTo(tocItem)
                    .width('25px')
                    .css('display', 'inline-block')
                    .css('text-align','right')
                    .text(item.page);

                if(item.items && item.items.length){
                    tocItem.items = [];
                    for (var i = 0; i < item.items.length; i++) {
                        var subItem = this.createTocItem(item.items[i], tocItem, tocItem.level + 1);
                        tocItem.items.push(subItem);
                        subItem.hide();
                    }
                    $icon.show();
                }

                return tocItem

            },

            enablePrev: function(val) {

                this.enableButton(this.btnPrev, val);
                this.enableButton(this.btnFirst, val);
                this.Book.enablePrev(val);

            },

            enableNext: function(val) {

                this.enableButton(this.btnNext, val);
                this.enableButton(this.btnLast, val);
                this.Book.enableNext(val);

            },

            /* enableAutoplay: function(val) {

                 this.enableButton(this.btnAutoplay, val)
                 this.enableButton(this.btnAutoplay, val)

             },*/

            enableButton: function(button, enabled) {
                if (typeof(button) == 'undefined')
                    return;
                if (enabled) {
                    button.css('opacity', '1');
                    button.css('pointer-events', 'auto');
                } else {
                    button.css('opacity', '0.2');
                    button.css('pointer-events', 'none');
                }
                button.enabled = enabled;
            },

            resize: function() {

                if(!this.Book || !this.Book.enabled)
                    return

                var o = this.options;

                if (!o.menuOverBook && this.menuShowing && this.menuBottom){
                    this.bookLayer.css('bottom', this.menuBottom.outerHeight() + 'px');
                }else {
                    this.bookLayer.css('bottom', '0px');
                }

                if (!o.menu2OverBook && this.menuShowing && this.menuTop){
                    this.bookLayer.css('top', this.menuTop.outerHeight() + 'px');
                } else {
                    this.bookLayer.css('top', '0px');
                }

                if(this.tocShowing || this.thumbsShowing || this.searchShowing || this.bookmarkShowing){
                    if(!o.sideMenuOverBook){
                        this.bookLayer.css(this.options.sideMenuPosition, '250px');
                    }
                    if(!this.options.sideMenuOverMenu){
                        this.wrapper.find('.flipbook-side-menu').css('bottom', this.menuBottom.outerHeight() + 'px');
                    }
                    if(!this.options.sideMenuOverMenu2){
                        this.wrapper.find('.flipbook-side-menu').css('top', this.menuTop.outerHeight() + 'px');
                    }
                }else {
                    this.bookLayer.css(this.options.sideMenuPosition, '0px');
                }

                var model = this.model;
                model.wrapperW = this.bookLayer.width();
                model.wrapperH = this.bookLayer.height();

                // if(o.menuFloating){
                //     this.menuBottom.css('left', model.wrapperW/2 - this.menuBottom.width()/2)
                // }
                // if(o.menu2Floating){
                //     this.menuTop.css('left', model.wrapperW/2 - this.menuTop.width()/2)
                // }

                o.zoomMax = o.zoomSize / model.wrapperH;

                model.zoom = o.zoomMin;
                this.Book.onResize();

                if(this.options.zoomReset)
                    this.Book.zoomTo(this.options.zoomMin);


            },

            pdfResize: function() {
                var self = this;

                /*
                    //this.pdfDocument.getPage(1).then(function(page) {
                    //self.viewportOriginal = page.getViewport(1);
                var bh = self.bookLayer.height()
                scale = bh / self.viewportOriginal.height
                scale *= self.zoom

                function findClosestInArray(num, arr) {
                    var minDist = null
                    var dist
                    for (var i = 0; i < arr.length; i++) {
                        dist = Math.abs(num - arr[i])
                        if (!minDist || dist < minDist) {
                            minDist = dist
                            min = arr[i]
                        }
                    }
                    return min
                }

                scale = findClosestInArray(scale, self.options.pdf.supportedScales)


                if (self.Book && self.options.pdf.currentScale != scale)*/
                self.Book.onZoom();
                //});


            },

            createThumbs: function() {

                this.thumbs = new FLIPBOOK.Thumbnails(this);

            },

            toggleThumbs: function(value) {

                if (!this.thumbs) {
                    this.createThumbs();
                }

                if(typeof value != 'undefined')
                    this.thumbsShowing = !value;

                if(!this.thumbsShowing){
                    this.closeMenus();
                    this.thumbs.show();
                    this.thumbsShowing = true;

                }else {

                    this.thumbs.hide();
                    this.thumbsShowing = false;

                }

                this.resize();

            },

            toggleToc: function(value) {

                if (!this.tocCreated) {

                    this.createToc();
                    return

                }

                if (!this.tocShowing || value) {

                    this.closeMenus();
                    this.tocShowing = true;
                    this.tocHolder.show();
                    this.tocScroll.refresh();


                } else {

                    this.tocHolder.hide();
                    this.tocShowing = false;

                }

                this.resize();

            },

            toggleSearch: function(value) {

                if (!this.thumbs) {
                    this.createThumbs();
                }

                if(typeof value != 'undefined')
                    this.searchShowing = !value;

                if(!this.searchShowing){
                    this.closeMenus();
                    this.thumbs.show();
                    this.thumbs.showSearch();
                    this.searchShowing = true;

                }else {

                    this.thumbs.hide();
                    this.searchShowing = false;
                    this.unmark();

                }

                this.resize();

            },

            toggleBookmark: function(value) {

                if (!this.thumbs) {
                    this.createThumbs();
                }

                if(typeof value != 'undefined')
                    this.bookmarkShowing = !value;

                if(!this.bookmarkShowing){
                    this.closeMenus();
                    this.thumbs.show();
                    this.thumbs.showBookmarks();
                    this.bookmarkShowing = true;

                }else {

                    this.thumbs.hide();
                    this.bookmarkShowing = false;

                }

                this.resize();

            },

            closeMenus: function() {

                if (this.thumbsShowing) this.toggleThumbs();
                if (this.tocShowing) this.toggleToc();
                if (this.searchShowing) this.toggleSearch();
                if (this.bookmarkShowing) this.toggleBookmark();

                if (this.printMenuShowing) this.togglePrintMenu();
                if (this.dlMenuShowing) this.toggleDownloadMenu();
                if (this.shareMenuShowing) this.toggleShareMenu();

            },

            togglePrintMenu: function() {

                var self = this;

                if (!this.printMenu) {

                    this.printMenu = jQuery('<div class="flipbook-sub-menu flipbook-font">').appendTo(this.wrapper);

                    var center = jQuery('<idv class="flipbook-sub-menu-center">').appendTo(this.printMenu);
                    var content = jQuery('<idv class="flipbook-sub-menu-content skin-color-bg">').appendTo(center);

                    this.createMenuHeader(content, this.strings.print, this.togglePrintMenu);

                    var current = jQuery('<a><div class="c-p skin-color flipbook-btn">'+this.strings.printCurrentPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.printPage(self.cPage[0], this);
                        });
                    var left = jQuery('<a><div class="c-l-p skin-color flipbook-btn">'+this.strings.printLeftPage+'</div></a>').appendTo(this.printMenu)
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.printPage(self.cPage[0], this);
                        });

                    var right = jQuery('<a><div class="c-r-p skin-color flipbook-btn">'+this.strings.printRightPage+'</div></a>').appendTo(this.printMenu)
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.printPage(self.cPage[1], this);
                        });

                    var all = jQuery('<a><div class="skin-color flipbook-btn">'+this.strings.printAllPages+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {

                            self.togglePrintWindow();

                        });

                    this.closeMenus();
                    this.printMenuShowing = true;
                    this.initColors();
                    this.updateCurrentPage();

                } else if (!this.printMenuShowing) {

                    this.closeMenus();

                    // this.printMenu.show()
                    this.printMenu.show();
                    this.printMenuShowing = true;
                    this.updateCurrentPage();

                } else {

                    this.printMenu.hide();
                    this.printMenuShowing = false;

                }

            },

            toggleDownloadMenu: function() {

                var self = this;

                if (!this.dlMenu) {

                    this.dlMenu = jQuery('<div class="flipbook-sub-menu flipbook-font">').appendTo(this.wrapper);

                    var center = jQuery('<idv class="flipbook-sub-menu-center">').appendTo(this.dlMenu);
                    var content = jQuery('<idv class="flipbook-sub-menu-content skin-color-bg">').appendTo(center);

                    this.createMenuHeader(content, this.strings.download, this.toggleDownloadMenu);

                    var current = jQuery('<a><div class="c-p skin-color flipbook-btn">'+this.strings.downloadCurrentPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.downloadPage(self.cPage[0], this);
                        });
                    var left = jQuery('<a><div class="c-l-p skin-color flipbook-btn">'+this.strings.downloadLeftPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.downloadPage(self.cPage[0], this);
                        });

                    var right = jQuery('<a><div class="c-r-p skin-color flipbook-btn">'+this.strings.downloadRightPage+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {
                            self.downloadPage(self.cPage[1], this);
                        });

                    var all = jQuery('<a><div class="skin-color flipbook-btn">'+this.strings.downloadAllPages+'</div></a>')
                        .appendTo(content)
                        .bind('touchend click', function(e) {

                            var link = document.createElement('a');
                            link.href = self.options.btnDownloadPages.url;
                            var filename = link.href.split('/').pop().split('#')[0].split('?')[0];
                            link.download = filename;
                            link.dispatchEvent(new MouseEvent('click'));

                            // window.location = self.options.btnDownloadPages.url;
                        });

                    this.closeMenus();
                    this.dlMenuShowing = true;
                    this.initColors();
                    this.updateCurrentPage();

                } else if (!this.dlMenuShowing) {

                    // this.dlMenu.show()
                    this.dlMenu.show();
                    this.closeMenus();
                    this.dlMenuShowing = true;
                    this.updateCurrentPage();

                } else {

                    this.dlMenu.hide();
                    this.dlMenuShowing = false;

                }

            },

            toggleShareMenu: function() {

                if (!this.shareMenu) {

                    this.shareMenu = jQuery('<div class="flipbook-sub-menu flipbook-font">').appendTo(this.wrapper);

                    var center = jQuery('<idv class="flipbook-sub-menu-center">').appendTo(this.shareMenu);
                    var content = jQuery('<idv class="flipbook-sub-menu-content skin-color-bg">').appendTo(center);

                    this.createMenuHeader(content, "Share", this.toggleShareMenu);

                    var shareBtn = jQuery('<idv class="flipbook-share">').appendTo(content);

                    var o = this.options;

                    this.share = new Share(shareBtn[0], {
                        networks: {
                            twitter: o.twitter,
                            facebook: o.facebook,
                            pinterest: o.pinterest,
                            email: o.email
                        }
                    });

                    this.closeMenus();
                    this.shareMenuShowing = true;
                    this.initColors();

                } else if (!this.shareMenuShowing) {

                    // this.shareMenu.show()
                    this.shareMenu.show();

                    this.closeMenus();
                    this.shareMenuShowing = true;

                } else {

                    this.shareMenu.hide();
                    this.shareMenuShowing = false;

                }



            },

            bookmarkPage: function(index) {

                var arr = this.getBookmarkedPages();
                if (arr.indexOf(String(index)) < 0)
                    arr.push(index);
                this.setBookmarkedPages(arr);

                this.thumbs.showBookmarkedThumbs();

                if (!this.bookmarkShowing)
                    this.toggleBookmark();

            },

            removeBookmark: function(index) {

                var arr = this.getBookmarkedPages();
                if (arr.indexOf(String(index)) > -1)
                    arr.splice(arr.indexOf(String(index)), 1);
                this.setBookmarkedPages(arr);

                this.thumbs.showBookmarkedThumbs();

                if (!this.bookmarkShowing)
                    this.toggleBookmark();

            },


            isBookmarked: function(index) {
                var arr = this.getBookmarkedPages();
                return (arr.indexOf(String(index)) > 0)
            },

            getBookmarkedPages: function() {
                var str = localStorage.getItem(this.options.name + "_flipbook_bookmarks");
                if (str)
                    return str.split(";")
                else
                    return []
            },

            setBookmarkedPages: function(arr) {
                localStorage.setItem(this.options.name + "_flipbook_bookmarks", arr.join(";"));

            },


            printPage: function(index, link) {

                var url;

                if (this.options.pages[index] && this.options.pages[index].print) {

                    url = this.options.pages[index].print;

                } else if (this.options.pages[index] &&
                    this.options.pages[index].canvas &&
                    this.options.pages[index].canvas[this.options.pageTextureSize]) {

                    url = this.options.pages[index].canvas[this.options.pageTextureSize].toDataURL();
                } else if (this.options.pages[index] && this.options.pages[index].src) {

                    url = this.options.pages[index].src;

                }

                if (url) {

                    var windowContent = '<!DOCTYPE html>';
                    windowContent += '<html>';
                    windowContent += '<head><title>Print canvas</title></head>';
                    windowContent += '<body>';
                    windowContent += '<img src="' + url + '">';
                    windowContent += '</body>';
                    windowContent += '</html>';
                    var printWin = window.open("", 'Print', 'height=1600,width=800');
                    printWin.document.open();
                    printWin.document.write(windowContent);
                    printWin.document.close();

                    printWin.document.addEventListener('load', function() {
                        printWin.focus();
                        printWin.print();
                        printWin.document.close();
                        printWin.close();
                    }, true);

                }else {
                            var self = this;
                            this.loadPage(index, this.options.pageTextureSize, function(){
                                        self.printPage(index);
                            });
                }

            },

            downloadPage: function(index) {

                var url;

                if (this.options.pages[index] && this.options.pages[index].download) {

                    url = this.options.pages[index].download;

                } else if (this.options.pages[index] && this.options.pages[index].src) {

                    url = this.options.pages[index].src;

                } else if (this.options.pages[index] &&
                    this.options.pages[index].canvas &&
                    this.options.pages[index].canvas[this.options.pageTextureSize]) {

                    var c = document.createElement("canvas");
                    var r = this.options.pageWidth / this.options.pageHeight;
                    c.width = this.options.pageTextureSize * r;
                    c.height = this.options.pageTextureSize;
                    var ctx = c.getContext("2d");
                    ctx.drawImage(this.options.pages[index].canvas[this.options.pageTextureSize], 0, 0);

                    // url = this.options.pages[index].canvas[this.options.pageTextureSize].toDataURL('image/jpeg', 0.5);
                    url = c.toDataURL('image/jpeg', 0.5);
                    // delete c;

                }

                if (url) {

                    var link = document.createElement('a');
                    link.href = url;
                    link.download = "page" + String(index + 1);
                    // link.dispatchEvent(new MouseEvent('click'));

                    document.body.appendChild(link);
                    link.click();
                    // Cleanup the DOM
                    document.body.removeChild(link);
                    // delete link;


                }else {
                            var self = this;
                            this.loadPage(index, this.options.pageTextureSize, function(){
                                        self.downloadPage(index);
                            });
                }

            },

            printPdf: function(url) {

                    if(this.options.isMobile){

                        var w = window.open(url, '_blank', 'directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0');
                        w.onload = function() {
                            this.document.body.children[0].style.display = 'none';
                            this.print();
                        };

                    }else {

                        var iframe = this._printIframe;
                      if (!this._printIframe) {
                        iframe = this._printIframe = document.createElement('iframe');
                        document.body.appendChild(iframe);

                        iframe.style.display = 'none';
                        iframe.onload = function() {
                          setTimeout(function() {
                            iframe.focus();
                            iframe.contentWindow.print();
                          }, 1);
                        };
                      }

                    iframe.src = url;

                    }
            },
            togglePrintWindow: function(value) {
                var self = this;

                if (self.options.printPdfUrl) {
                    self.printPdf(self.options.printPdfUrl);
                    return
                }

                if (self.options.pdfUrl) {
                    self.printPdf(self.options.pdfUrl);
                    return
                }

                function printme() {
                    link = "about:blank";
                    var pw = window.open(link, "_new");
                    pw.document.open();
                    var images = "";
                    for (var i = 0; i < self.options.pages.length; i++) {
                        if (self.options.pages[i].src)
                            images += '<img src="' + self.options.pages[i].src.toString() + '"/>\n';
                    }
                    var printHtml = printWindowHtml(images);
                    pw.document.write(printHtml);
                    pw.document.close();
                }


                function printWindowHtml(images) {
                    // We break the closing script tag in half to prevent
                    // the HTML parser from seeing it as a part of
                    // the *main* page.

                    return "<html>\n" +
                        "<head>\n" +
                        "<title>Temporary Printing Window</title>\n" +
                        "<script>\n" +
                        "function step1() {\n" +
                        "  setTimeout('step2()', 10);\n" +
                        "}\n" +
                        "function step2() {\n" +
                        "  window.print();\n" +
                        "  window.close();\n" +
                        "}\n" +
                        "</scr" + "ipt>\n" +
                        "</head>\n" +
                        "<body onLoad='step1()'>\n" +
                        images +
                        "</body>\n" +
                        "</html>\n";
                }

                printme();
                return;


                var self = this;
            },
            thumbsVertical: function() {
                if (!this.thumbsCreated)
                    return;
                this.thumbScroll.hScroll = false;
                this.thumbScroll.vScroll = true;
                this.thumbScroll.refresh();
            },

            toggleExpand: function(e) {

                this.browserFullscreen = true;

                if (screenfull.enabled) {

                    screenfull.toggle(this.fullscreenElement);

                } else {

                    this.isFullscreen = !this.isFullscreen;
                    this.handleFsChange();

                }

            },

            expand: function() {

            },

            toggleAutoplay: function(value) {
                var self = this;
                this.autoplay = value || !this.autoplay;

                if (this.autoplay) {

                    this.btnAutoplay.$icon.hide();
                    this.btnAutoplay.$iconAlt.show();


                    this.autoplayTimer = setInterval(function() {

                        if (self.autoplay) {

                            var autoplayStartPage = self.options.autoplayStartPage || 1;

                            if (self.options.rightToLeft) {
                                if (self.Book.prevEnabled)
                                    self.prevPage();
                                else if(self.options.autoplayLoop)
                                    self.goToPage(self.options.pages.length - autoplayStartPage + 1);
                            } else {
                                if (self.Book.nextEnabled)
                                    self.nextPage();
                                else if(self.options.autoplayLoop)
                                    self.goToPage(autoplayStartPage);
                            }

                        }
                    }, self.options.autoplayInterval);
                } else {
                    this.btnAutoplay.$icon.show();
                    this.btnAutoplay.$iconAlt.hide();
                    clearInterval(self.autoplayTimer);
                }
            },

            triggerResizeOnce: function() {
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 100);
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 500);
            },

            triggerResize: function() {

                // var self = this
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 100);
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 500);
                setTimeout(function() {
                    jQuery(window).trigger('resize');
                }, 2000);

            },

            initEasing: function() {
                //easign functions
                window.jQuery.extend(window.jQuery.easing, {
                    def: 'easeOutQuad',
                    swing: function(x, t, b, c, d) {
                        //alert(jQuery.easing.default);
                        return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
                    },
                    easeInQuad: function(x, t, b, c, d) {
                        return c * (t /= d) * t + b;
                    },
                    easeOutQuad: function(x, t, b, c, d) {
                        return -c * (t /= d) * (t - 2) + b;
                    },
                    easeInOutQuad: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t + b;
                        return -c / 2 * ((--t) * (t - 2) - 1) + b;
                    },
                    easeInCubic: function(x, t, b, c, d) {
                        return c * (t /= d) * t * t + b;
                    },
                    easeOutCubic: function(x, t, b, c, d) {
                        return c * ((t = t / d - 1) * t * t + 1) + b;
                    },
                    easeInOutCubic: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t * t + b;
                        return c / 2 * ((t -= 2) * t * t + 2) + b;
                    },
                    easeInQuart: function(x, t, b, c, d) {
                        return c * (t /= d) * t * t * t + b;
                    },
                    easeOutQuart: function(x, t, b, c, d) {
                        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
                    },
                    easeInOutQuart: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t * t * t + b;
                        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
                    },
                    easeInQuint: function(x, t, b, c, d) {
                        return c * (t /= d) * t * t * t * t + b;
                    },
                    easeOutQuint: function(x, t, b, c, d) {
                        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
                    },
                    easeInOutQuint: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return c / 2 * t * t * t * t * t + b;
                        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
                    },
                    easeInSine: function(x, t, b, c, d) {
                        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
                    },
                    easeOutSine: function(x, t, b, c, d) {
                        return c * Math.sin(t / d * (Math.PI / 2)) + b;
                    },
                    easeInOutSine: function(x, t, b, c, d) {
                        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
                    },
                    easeInExpo: function(x, t, b, c, d) {
                        return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
                    },
                    easeOutExpo: function(x, t, b, c, d) {
                        return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
                    },
                    easeInOutExpo: function(x, t, b, c, d) {
                        if (t == 0)
                            return b;
                        if (t == d)
                            return b + c;
                        if ((t /= d / 2) < 1)
                            return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
                        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
                    },
                    easeInCirc: function(x, t, b, c, d) {
                        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
                    },
                    easeOutCirc: function(x, t, b, c, d) {
                        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
                    },
                    easeInOutCirc: function(x, t, b, c, d) {
                        if ((t /= d / 2) < 1)
                            return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
                        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
                    },
                    easeInElastic: function(x, t, b, c, d) {
                        var s = 1.70158;
                        var p = 0;
                        var a = c;
                        if (t == 0)
                            return b;
                        if ((t /= d) == 1)
                            return b + c;
                        if (!p)
                            p = d * .3;
                        if (a < Math.abs(c)) {
                            a = c;
                            var s = p / 4;
                        } else
                            var s = p / (2 * Math.PI) * Math.asin(c / a);
                        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
                    },
                    easeOutElastic: function(x, t, b, c, d) {
                        var s = 1.70158;
                        var p = 0;
                        var a = c;
                        if (t == 0)
                            return b;
                        if ((t /= d) == 1)
                            return b + c;
                        if (!p)
                            p = d * .3;
                        if (a < Math.abs(c)) {
                            a = c;
                            var s = p / 4;
                        } else
                            var s = p / (2 * Math.PI) * Math.asin(c / a);
                        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
                    },
                    easeInOutElastic: function(x, t, b, c, d) {
                        var s = 1.70158;
                        var p = 0;
                        var a = c;
                        if (t == 0)
                            return b;
                        if ((t /= d / 2) == 2)
                            return b + c;
                        if (!p)
                            p = d * (.3 * 1.5);
                        if (a < Math.abs(c)) {
                            a = c;
                            var s = p / 4;
                        } else
                            var s = p / (2 * Math.PI) * Math.asin(c / a);
                        if (t < 1)
                            return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
                        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
                    },
                    easeInBack: function(x, t, b, c, d, s) {
                        if (s == undefined$1)
                            s = 1.70158;
                        return c * (t /= d) * t * ((s + 1) * t - s) + b;
                    },
                    easeOutBack: function(x, t, b, c, d, s) {
                        if (s == undefined$1)
                            s = 1.70158;
                        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
                    },
                    easeInOutBack: function(x, t, b, c, d, s) {
                        if (s == undefined$1)
                            s = 1.70158;
                        if ((t /= d / 2) < 1)
                            return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
                        return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
                    },
                    easeInBounce: function(x, t, b, c, d) {
                        return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
                    },
                    easeOutBounce: function(x, t, b, c, d) {
                        if ((t /= d) < (1 / 2.75)) {
                            return c * (7.5625 * t * t) + b;
                        } else if (t < (2 / 2.75)) {
                            return c * (7.5625 * (t -= (1.5 / 2.75)) * t + .75) + b;
                        } else if (t < (2.5 / 2.75)) {
                            return c * (7.5625 * (t -= (2.25 / 2.75)) * t + .9375) + b;
                        } else {
                            return c * (7.5625 * (t -= (2.625 / 2.75)) * t + .984375) + b;
                        }
                    },
                    easeInOutBounce: function(x, t, b, c, d) {
                        if (t < d / 2)
                            return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
                        return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
                    }
                });
            }
        };

        {

            FLIPBOOK.Book = function() {};

            FLIPBOOK.Book.prototype = {

                rightIndex: 0,

                goToPage: function() {

                }
            };

        }

        { /* FLIPBOOK.Thumbnails */

            FLIPBOOK.Thumbnails = function(main) {

                var self = this,
                options = main.options,
                wrapper = main.wrapper;

                this.main = main;
                this.options = options;
                this.wrapper = wrapper;
                this.active = null;

                if (!options.btnThumbs.enabled) {
                    return;
                }

                jQuery(main).bind('pagechange', function(){
                    // console.log(self.bookmark.height())
                    self.thumbsWrapper.css("top", self.bookmark.height() + 50 + "px");

                });

                this.thumbHolder = jQuery(document.createElement('div'))
                    .addClass('flipbook-thumbHolder flipbook-side-menu skin-color-bg')
                    .appendTo(wrapper)
                    .css(this.options.sideMenuPosition, '0')
                    .hide();

                this.thumbsWrapper = jQuery(document.createElement('div'))
                    .appendTo(this.thumbHolder)
                    .addClass('flipbook-thumbsWrapper');

                this.thumbsScroller = jQuery(document.createElement('div'))
                    .appendTo(this.thumbsWrapper)
                    .addClass('flipbook-thumbsScroller');

                main.createMenuHeader(this.thumbHolder, main.strings.thumbnails, main.toggleThumbs);

                //bookmark

                this.bookmark = jQuery('<div>')
                    .addClass('flipbook-font')
                    .appendTo(this.thumbHolder)
                    .hide();

                var current = jQuery('<a><div class="c-p skin-color flipbook-btn">'+options.strings.bookmarkCurrentPage+'</div></a>')
                    .appendTo(this.bookmark)
                    .bind('touchend click', function(e) {
                        main.bookmarkPage(main.cPage[0], this);
                        e.preventDefault();
                        e.stopPropagation();
                    });

                var left = jQuery('<a><div class="c-l-p skin-color flipbook-btn">'+options.strings.bookmarkLeftPage+'</div></a>')
                    .appendTo(this.bookmark)
                    .bind('touchend click', function(e) {
                        main.bookmarkPage(main.cPage[0], this);
                        e.preventDefault();
                        e.stopPropagation();
                    });

                var right = jQuery('<a><div class="c-r-p skin-color flipbook-btn">'+options.strings.bookmarkRightPage+'</div></a>')
                    .appendTo(this.bookmark)
                    .bind('touchend click', function(e) {
                        main.bookmarkPage(main.cPage[1], this);
                        e.preventDefault();
                        e.stopPropagation();
                    });

                this.search = jQuery('<div>')
                    .addClass('flipbook-search')
                    .appendTo(this.thumbHolder)
                    .hide();

                this.$searchBar = jQuery(
                    '<div class="flipbook-findbar" id="findbar" deluminate_imagetype="png">' +
                    '<div id="findbarInputContainer">' +
                    '<input id="findInput" class="toolbarField" title="Find" placeholder="'+options.strings.findInDocument+'...">' +
                    '</div>' +
                    '<div class="flipbook-find-info skin-color"/>' +
                    '</div>').appendTo(this.search);

                this.$findInput = this.$searchBar.find('#findInput').keyup(function() {

                    var str = this.value;
                    var main = self.main;

                    if (str != ''){

                        if(main.pdfService){

                            self.hideAllThumbs();
                            self.pagesFound = 0;
                            self.$findInfo.hide();
                            main.unmark();
                            main.searchingString = str;

                            if (main.pdfService) {
                                for (var i = 0; i < main.pdfService.pdfInfo.numPages; i++) {
                                    self.findInPage(str, i);
                                }
                            }

                        }

                    }

                });

                this.$findInfo = this.$searchBar.find('.flipbook-find-info');

                this.thumbs = [];

                var arr2 = options.pages;

                var arr = [];

                if (options.doublePage) {
                    for (var i = 0; i < arr2.length; i++) {
                        if (i == 0 || i % 2 != 0)
                            arr.push(arr2[i]);
                    }
                } else {
                    arr = arr2;
                }

                if (options.pdfMode) {

                    this.loadThumbsFromPdf(arr);

                }

                var h = options.thumbSize;
                var w = options.thumbSize * options.pageWidth / options.pageHeight;

                for (var i = 0; i < arr.length; i++) {

                    var th = arr[i].thumb;

                    if(arr[i].empty) continue;

                    var $thumb = jQuery('<div>')
                        .addClass("flipbook-thumb")
                        .appendTo(self.thumbsScroller)
                        .attr('data-thumb-index', i)
                        .width(w)
                        .height(h);

                    var btnClose = jQuery('<span>')
                        .appendTo($thumb)
                        .addClass('thumb-btn-close')
                        .bind('touchend click', function(e) {
                            e.stopPropagation();
                            e.preventDefault();
                            main.removeBookmark(jQuery(this).parent().attr("data-thumb-index"));
                        });

                    var $icon = jQuery('<span>')
                        .attr('aria-hidden', 'true')
                        .appendTo(btnClose)
                        .addClass('fa fa-times skin-color');

                    this.thumbs.push($thumb);

                    if (arr[i].thumbCanvas) {
                        var $thumbImg = jQuery(arr[i].thumbCanvas);
                    } else if (th) {
                        var $thumbImg = jQuery('<img/>').attr('src', th);
                        $thumbImg[0].onload = function() {
                            self.thumbScroll.refresh();
                        };
                    } else
                        continue;

                    $thumbImg.appendTo($thumb);
                    jQuery('<br/>').appendTo($thumb);

                    var hasBackCover = options.doublePage && options.pages.length % 2 == 0;
                    var isBackCover = hasBackCover && i == arr.length -1;
                    var isCover = options.doublePage && i == 0;
                    var isDouble = options.doublePage && !isCover && !isBackCover;

                    if(isBackCover){
                        $thumbImg
                            .height(h)
                            .width(w)
                            .attr('page-title', 2 * i);

                        var $pageNumber = jQuery(document.createElement('soan')).text(String(2 * i))
                            .appendTo($thumb)
                            .addClass('skin-color')
                            .addClass('flipbook-thumb-num');

                    }else if(isDouble) {
                        $thumb.width(2 * w);

                        $thumbImg
                            .height(h)
                            .width(2 * w)
                            .attr('page-title', 2 * i + 1);

                        var $pageNumber = jQuery(document.createElement('soan')).text(String(2 * i) + "-" + String(2 * i + 1))
                            .appendTo($thumb)
                            .addClass('skin-color')
                            .addClass('flipbook-thumb-num');

                    } else {
                        $thumbImg
                            .height(h)
                            .width(w)
                            .attr('page-title', i + 1);

                        var $pageNumber = jQuery(document.createElement('span')).text(i + 1)
                            .appendTo($thumb)
                            .addClass('skin-color')
                            .addClass('flipbook-thumb-num');
                        // .width(self.options.thumbSize);


                    }

                    $thumbImg.bind('touchend click', function(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        if (!self.thumbScroll.moved) {
                            var clickedPage = Number(jQuery(this).attr('page-title'));
                            if (options.rightToLeft)
                                clickedPage = options.pages.length - clickedPage + 1;

                            //if (self.options.singlePageMode) clickedPage--;
                           // if (self.Book.goingToPage != clickedPage)
                           setTimeout(function(){
                                main.goToPage(clickedPage);
                           },200);


                            if(self.active != "search" && options.thumbsCloseOnClick)
                                main.toggleThumbs(false);
                        }
                    });

                }

                this.thumbScroll = new FLIPBOOK.IScroll(this.thumbsWrapper[0], {
                    bounce: false,
                    mouseWheel: true,
                    scrollbars: true,
                    interactiveScrollbars: true
                });

                main.initColors();

            };

            FLIPBOOK.Thumbnails.prototype = {

                loadThumbsFromPdf: function(arr) {

                    // return;

                    var pdf = this.main.pdfDocument,
                        info = pdf._pdfInfo,
                        numPages = info.numPages;

                    for (var i = 0; i < numPages; i++) {

                        var c = document.createElement('canvas');
                        arr[i].thumbCanvas = c;

                    }

                    this.loadThumbFromPdf(0, arr);

                },

                loadVisibleThumbs:function(){

                    // this.thumbs.forEach(function(thumb){
                    //     console.log(thumb.offset().top)
                    // })

                },

                loadThumbFromPdf: function(i, arr) {

                    var self = this;

                    this.main.pdfDocument.getPage(i + 1).then(function(page) {

                        var v = page.getViewport({scale:1});

                        var scale = self.options.thumbSize / v.height;

                        var viewport = page.getViewport({scale:scale});

                        var c = arr[page.pageIndex].thumbCanvas;
                        var context = c.getContext('2d');
                        c.height = viewport.height;
                        c.width = viewport.width;

                        var renderContext = {
                            canvasContext: context,
                            viewport: viewport
                        };

                        page.cleanupAfterRender = true;

                        var renderTask = page.render(renderContext);
                        renderTask.promise.then(function () {
                          page.cleanup();
                            if ((page.pageIndex + 1) < self.main.pdfDocument._pdfInfo.numPages)
                                self.loadThumbFromPdf(page.pageIndex + 1, arr);
                        });

                        // page.render(renderContext).then(function() {
                        //     page.cleanup()
                        //     if ((page.pageIndex + 1) < self.main.pdfDocument._pdfInfo.numPages)
                        //         self.loadThumbFromPdf(page.pageIndex + 1, arr)

                        // })
                        self.thumbScroll.refresh();

                    });
                },

                showAllThumbs: function() {

                    jQuery(".flipbook-thumb").show();
                    this.thumbScroll.refresh();

                },

                 hideAllThumbs: function() {

                    jQuery(".flipbook-thumb").hide();
                    this.thumbScroll.refresh();

                },

                showThumb: function(index) {
                    if(this.thumbs[index])
                        this.thumbs[index].show();
                    this.thumbScroll.refresh();

                },

                hideThumb: function(index) {

                    this.thumbs[index].hide();
                    this.thumbScroll.refresh();

                },

                showBookmarks:function(){

                    jQuery(".thumb-btn-close").show();
                    this.showBookmarkedThumbs();
                    this.bookmark.show();
                    this.setTitle(this.options.strings.bookmarks);
                    this.main.updateCurrentPage();
                    this.active = "bookmarks";

                },

                showSearch:function(){

                    this.thumbsWrapper.css("top", "120px");
                    this.hideAllThumbs();
                    this.search.show();
                    this.$findInfo.hide();
                    jQuery(".thumb-btn-close").hide();
                    this.setTitle(this.options.strings.search);
                    this.$findInput.val('').focus();
                    this.active = "search";

                },

                showBookmarkedThumbs: function() {

                    var arr = this.main.getBookmarkedPages();

                    this.hideAllThumbs();

                    for (var i = 0; i < arr.length; i++) {
                        var index = arr[i];
                        if(index)
                        this.showThumb(index);
                    }

                    this.thumbsWrapper.css("top", 50 + this.bookmark.height() + 'px');

                },

                show:function(){

                    this.setTitle(this.options.strings.thumbnails);
                    this.bookmark.hide();
                    this.search.hide();
                    this.thumbHolder.show();
                    this.main.thumbsVertical();

                    this.thumbsWrapper.css("top", "50px");
                    this.showAllThumbs();
                    jQuery(".thumb-btn-close").hide();
                    this.loadVisibleThumbs();
                    this.main.resize();
                    this.active = "thumbs";

                },

                hide:function(){

                    this.thumbHolder.hide();

                    this.main.resize();
                    this.active = null;

                },

                setTitle:function(str){

                    this.thumbHolder.find('.flipbook-menu-title').text(str);

                },

                findInPage: function(str, index) {

                    var self = this;
                    this.main.pdfService.findInPage(str, index, function(matches) {
                        if (matches > 0) {
                            self.showThumb(index);
                            self.pagesFound++;
                            self.$findInfo.show().text(self.pagesFound + ' ' + self.options.strings.pagesFoundContaining + ' "' + str + '"');
                            self.main.mark(str);

                        }

                    });

                }

            };

        }

        { /* FLIPBOOK.Lightbox */

            FLIPBOOK.Lightbox = function(context, content, options) {

                var self = this;
                this.context = context;
                this.options = options;
                context.$elem.bind('tap click', function(e) {
                    if(content.disposed)
                        return

                    self.openLightbox();
                    e.stopPropagation();

                    /*if (self.context.options.lightBoxFullscreen) {
                        self.context.toggleExpand()
                    }*/
                });

                var img = jQuery(context.elem).find('img');

                self.overlay = jQuery(document.createElement('div'))
                    .attr('style', options.lightboxCSS)
                    .addClass('flipbook-overlay')
                    .css('display', 'none')
                    .css('top', self.options.lightboxMarginV)
                    .css('bottom', self.options.lightboxMarginV)
                    .css('left', self.options.lightboxMarginH)
                    .css('right', self.options.lightboxMarginH)
                    // .bind('tap click', function(e) {
                    //     if (jQuery(e.target).hasClass('flipbook-bookLayer') && self.options.lightboxCloseOnClick) {
                    //         self.closeLightbox();
                    //     }
                    // })
                    .appendTo('body');

                    if(self.options.lightboxCloseOnClick){
                        jQuery('body').bind('tap click', function(e){
                            var $target = jQuery(e.target);
                            if (!$target.parents().hasClass('flipbook-overlay') || $target.hasClass('flipbook-bookLayer'))
                                self.closeLightbox();
                        });
                    }

                if (options.lightboxBackground)
                    self.overlay.css('background', options.lightboxBackground);


                if (options.lightboxBackgroundColor)
                    self.overlay.css('background', options.lightboxBackgroundColor);

                if (options.lightboxBackgroundPattern)
                    self.overlay.css('background', 'url(' + options.lightboxBackgroundPattern + ') repeat');

                if (options.lightboxBackgroundImage) {
                    self.overlay.css('background', 'url(' + options.lightboxBackgroundImage + ') no-repeat');
                    self.overlay.css('background-size', 'cover');
                    self.overlay.css('background-position', 'center center');
                }

                jQuery(document).keyup(function(e) {
                    if (e.keyCode == 27) {
                        self.closeLightbox();
                    } // escape key maps to keycode `27`
                });


                self.wrapper = jQuery(document.createElement('div'))
                    .css('height', 'auto')
                    .appendTo(self.overlay);
                // .hide()

                self.wrapper
                    .attr('class', 'flipbook-wrapper-transparent')
                    .css('margin', '0px auto')
                    .css('padding', '0px')
                    .css('height', '100%')
                    .css('width', '100%');

                content
                    .appendTo(self.wrapper);

                // close button
                var $toolbar = jQuery('<div/>')
                    .appendTo(self.wrapper)
                    .addClass('flipbook-lightbox-toolbar');

            };

            FLIPBOOK.Lightbox.prototype = {

                openLightbox: function() {

                    if (FLIPBOOK.lightboxOpened)
                        return;
                    FLIPBOOK.lightboxOpened = true;
                    this.overlay.css('display', 'none');
                    this.overlay.fadeIn("slow");
                    jQuery('body').addClass('flipbook-overflow-hidden');
                    jQuery('html').addClass('flipbook-overflow-hidden');
                },
                closeLightbox: function() {
                    var self = this;
                    FLIPBOOK.lightboxOpened = false;
                    this.overlay.fadeOut("fast");
                    jQuery('body').removeClass('flipbook-overflow-hidden');
                    jQuery('html').removeClass('flipbook-overflow-hidden');

                    jQuery(this.context.fullscreenElement).removeClass('flipbook-browser-fullscreen');

                    self.context.lightboxEnd();
                },
                resize: function() {
                    var jQuerywindow = jQuery(window),
                        ww = jQuerywindow.width(),
                        wh = jQuerywindow.height();

                }
            };
        }

        {
            FLIPBOOK.getFlipbookSrc = function() {
                var scripts = document.getElementsByTagName("script");
                for (var i = 0; i < scripts.length; i++) {
                    var src = String(scripts[i].src);
                    if (src.match("flipbook\\.js") || src.match("flipbook\\.min\\.js"))
                        // if (src.match("flipbook.js") || src.match("flipbook.min.js"))
                        return src

                    else if (src.match("flipbook\\.lite\\.js") || src.match("flipbook\\.lite\\.min\\.js"))
                        // if (src.match("flipbook.js") || src.match("flipbook.min.js"))
                        return src.replace(".lite", "")
                }
                return "";
            };

            FLIPBOOK.flipbookSrc = FLIPBOOK.getFlipbookSrc();

            FLIPBOOK.iscrollSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/iscroll.');
            FLIPBOOK.threejsSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/three.');
            FLIPBOOK.flipbookWebGlSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/flipbook.webgl.');
            FLIPBOOK.flipbookBook3Src = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/flipbook.book3.');
            FLIPBOOK.flipBookSwipeSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/flipbook.swipe.');
            FLIPBOOK.pdfjsSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/pdf.');
            FLIPBOOK.pdfServiceSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/flipbook.pdfservice.');
            FLIPBOOK.pdfjsworkerSrc = FLIPBOOK.flipbookSrc.replace("/flipbook.", '/pdf.worker.');
            // FLIPBOOK.markSrc = "https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/jquery.mark.min.js"
            FLIPBOOK.markSrc = "https://cdnjs.cloudflare.com/ajax/libs/mark.js/8.11.1/jquery.mark.js";

            FLIPBOOK.scriptsLoaded = {};
            FLIPBOOK.scriptsAdded = {};

        }

        // {/*image loader object*/

        //     FLIPBOOK.ImageLoader = function(){

        //         console.log("new ImageLoader()")

        //         this.images = {}

        //     }

        //     FLIPBOOK.ImageLoader.prototype = {

        //         loadImage : function(src, onComplete){

        //             console.log('load ',src)

        //             // var onComplete = onComplete || function(){}

        //             var images = this.images

        //             if(!images[src]){
        //                 images[src] = document.createElement('img')
        //             }

        //             var img = images[src]

        //             if(img.loaded){
        //                 console.log("already loaded");
        //                 if(onComplete) onComplete(img);
        //                 return;
        //             }

        //             img.onComplete = img.onComplete || []
        //             img.onComplete.push(onComplete)

        //             if(img.loading){
        //                  console.log("loading...")
        //             }else{
        //                 img.onload = function(){

        //                     img.loading = false
        //                     img.loaded = true
        //                     for (var i = 0; i < img.onComplete.length; i ++) {
        //                         var callback = img.onComplete[i]
        //                         if(callback) callback(img)
        //                         img.onComplete[i] = null
        //                     }
        //                 }
        //                 img.src = src
        //                 img.loading = true


        //             }


        //         }

        //     }

        // }

    })(jQuery, window, document);
}

{

    FLIPBOOK.onPageLinkClick = function(link){
        var id = link.dataset.bookid;
        var page = link.dataset.page;
        if(page)
            FLIPBOOK.books[id].goToPage(Number(page));
        var _url = link.dataset.url;
        if(_url)
            window.open(_url, '_blank');
    };

}

{ /* screenfull.js */

  /*!
    * screenfull
    * v4.0.0 - 2018-12-15
    * (c) Sindre Sorhus; MIT License
    */

    !function(){var u="undefined"!=typeof window&&void 0!==window.document?window.document:{},e="undefined"!=typeof module&&module.exports,t="undefined"!=typeof Element&&"ALLOW_KEYBOARD_INPUT"in Element,c=function(){for(var e,n=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],r=0,l=n.length,t={};r<l;r++)if((e=n[r])&&e[1]in u){for(r=0;r<e.length;r++)t[n[0][r]]=e[r];return t}return !1}(),l={change:c.fullscreenchange,error:c.fullscreenerror},n={request:function(l){return new Promise(function(e){var n=c.requestFullscreen,r=function(){this.off("change",r),e();}.bind(this);l=l||u.documentElement,/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)?l[n]():l[n](t?Element.ALLOW_KEYBOARD_INPUT:{}),this.on("change",r);}.bind(this))},exit:function(){return new Promise(function(e){var n=function(){this.off("change",n),e();}.bind(this);u[c.exitFullscreen](),this.on("change",n);}.bind(this))},toggle:function(e){return this.isFullscreen?this.exit():this.request(e)},onchange:function(e){this.on("change",e);},onerror:function(e){this.on("error",e);},on:function(e,n){var r=l[e];r&&u.addEventListener(r,n,!1);},off:function(e,n){var r=l[e];r&&u.removeEventListener(r,n,!1);},raw:c};c?(Object.defineProperties(n,{isFullscreen:{get:function(){return Boolean(u[c.fullscreenElement])}},element:{enumerable:!0,get:function(){return u[c.fullscreenElement]}},enabled:{enumerable:!0,get:function(){return Boolean(u[c.fullscreenEnabled])}}}),e?module.exports=n:window.screenfull=n):e?module.exports=!1:window.screenfull=!1;}();
}

{
    /*!
     * @fileOverview TouchSwipe - jQuery Plugin
     * @version 1.6.18
     *
     * @author Matt Bryson http://www.github.com/mattbryson
     * @see https://github.com/mattbryson/TouchSwipe-Jquery-Plugin
     * @see http://labs.rampinteractive.co.uk/touchSwipe/
     * @see http://plugins.jquery.com/project/touchSwipe
     * @license
     * Copyright (c) 2010-2015 Matt Bryson
     * Dual licensed under the MIT or GPL Version 2 licenses.
     *
     */
    ! function(factory) { "function" == typeof define && define.amd && define.amd.jQuery ? define(["jquery"], factory) : factory("undefined" != typeof module && module.exports ? require("jquery") : jQuery); }(function($) {

        function init(options) {
            return !options || void 0 !== options.allowPageScroll || void 0 === options.swipe && void 0 === options.swipeStatus || (options.allowPageScroll = NONE), void 0 !== options.click && void 0 === options.tap && (options.tap = options.click), options || (options = {}), options = $.extend({}, $.fn.swipe.defaults, options), this.each(function() {
                var $this = $(this),
                    plugin = $this.data(PLUGIN_NS);
                plugin || (plugin = new TouchSwipe(this, options), $this.data(PLUGIN_NS, plugin));
            })
        }

        function TouchSwipe(element, options) {
            function touchStart(jqEvent) {
                if (!(getTouchInProgress() || $(jqEvent.target).closest(options.excludedElements, $element).length > 0)) {
                    var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
                    if (!event.pointerType || "mouse" != event.pointerType || 0 != options.fallbackToMouseEvents) {
                        var ret, touches = event.touches,
                            evt = touches ? touches[0] : event;
                        return phase = PHASE_START, touches ? fingerCount = touches.length : options.preventDefaultEvents !== !1 && jqEvent.preventDefault(), distance = 0, direction = null, currentDirection = null, pinchDirection = null, duration = 0, startTouchesDistance = 0, endTouchesDistance = 0, pinchZoom = 1, pinchDistance = 0, maximumsMap = createMaximumsData(), cancelMultiFingerRelease(), createFingerData(0, evt), !touches || fingerCount === options.fingers || options.fingers === ALL_FINGERS || hasPinches() ? (startTime = getTimeStamp(), 2 == fingerCount && (createFingerData(1, touches[1]), startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start)), (options.swipeStatus || options.pinchStatus) && (ret = triggerHandler(event, phase))) : ret = !1, ret === !1 ? (phase = PHASE_CANCEL, triggerHandler(event, phase), ret) : (options.hold && (holdTimeout = setTimeout($.proxy(function() { $element.trigger("hold", [event.target]), options.hold && (ret = options.hold.call($element, event, event.target)); }, this), options.longTapThreshold)), setTouchInProgress(!0), null)
                    }
                }
            }

            function touchMove(jqEvent) {
                var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
                if (phase !== PHASE_END && phase !== PHASE_CANCEL && !inMultiFingerRelease()) {
                    var ret, touches = event.touches,
                        evt = touches ? touches[0] : event,
                        currentFinger = updateFingerData(evt);
                    if (endTime = getTimeStamp(), touches && (fingerCount = touches.length), options.hold && clearTimeout(holdTimeout), phase = PHASE_MOVE, 2 == fingerCount && (0 == startTouchesDistance ? (createFingerData(1, touches[1]), startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start)) : (updateFingerData(touches[1]), endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end), pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end)), pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance), pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance)), fingerCount === options.fingers || options.fingers === ALL_FINGERS || !touches || hasPinches()) {
                        if (direction = calculateDirection(currentFinger.start, currentFinger.end), currentDirection = calculateDirection(currentFinger.last, currentFinger.end), validateDefaultEvent(jqEvent, currentDirection), distance = calculateDistance(currentFinger.start, currentFinger.end), duration = calculateDuration(), setMaxDistance(direction, distance), ret = triggerHandler(event, phase), !options.triggerOnTouchEnd || options.triggerOnTouchLeave) {
                            var inBounds = !0;
                            if (options.triggerOnTouchLeave) {
                                var bounds = getbounds(this);
                                inBounds = isInBounds(currentFinger.end, bounds);
                            }!options.triggerOnTouchEnd && inBounds ? phase = getNextPhase(PHASE_MOVE) : options.triggerOnTouchLeave && !inBounds && (phase = getNextPhase(PHASE_END)), phase != PHASE_CANCEL && phase != PHASE_END || triggerHandler(event, phase);
                        }
                    } else phase = PHASE_CANCEL, triggerHandler(event, phase);
                    ret === !1 && (phase = PHASE_CANCEL, triggerHandler(event, phase));
                }
            }

            function touchEnd(jqEvent) {
                var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent,
                    touches = event.touches;
                if (touches) { if (touches.length && !inMultiFingerRelease()) return startMultiFingerRelease(event), !0; if (touches.length && inMultiFingerRelease()) return !0 }
                return inMultiFingerRelease() && (fingerCount = fingerCountAtRelease), endTime = getTimeStamp(), duration = calculateDuration(), didSwipeBackToCancel() || !validateSwipeDistance() ? (phase = PHASE_CANCEL, triggerHandler(event, phase)) : options.triggerOnTouchEnd || options.triggerOnTouchEnd === !1 && phase === PHASE_MOVE ? (options.preventDefaultEvents !== !1 && jqEvent.cancelable !== !1 && jqEvent.preventDefault(), phase = PHASE_END, triggerHandler(event, phase)) : !options.triggerOnTouchEnd && hasTap() ? (phase = PHASE_END, triggerHandlerForGesture(event, phase, TAP)) : phase === PHASE_MOVE && (phase = PHASE_CANCEL, triggerHandler(event, phase)), setTouchInProgress(!1), null
            }

            function touchCancel() { fingerCount = 0, endTime = 0, startTime = 0, startTouchesDistance = 0, endTouchesDistance = 0, pinchZoom = 1, cancelMultiFingerRelease(), setTouchInProgress(!1); }

            function touchLeave(jqEvent) {
                var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
                options.triggerOnTouchLeave && (phase = getNextPhase(PHASE_END), triggerHandler(event, phase));
            }

            function removeListeners() { $element.unbind(START_EV, touchStart), $element.unbind(CANCEL_EV, touchCancel), $element.unbind(MOVE_EV, touchMove), $element.unbind(END_EV, touchEnd), LEAVE_EV && $element.unbind(LEAVE_EV, touchLeave), setTouchInProgress(!1); }

            function getNextPhase(currentPhase) {
                var nextPhase = currentPhase,
                    validTime = validateSwipeTime(),
                    validDistance = validateSwipeDistance(),
                    didCancel = didSwipeBackToCancel();
                return !validTime || didCancel ? nextPhase = PHASE_CANCEL : !validDistance || currentPhase != PHASE_MOVE || options.triggerOnTouchEnd && !options.triggerOnTouchLeave ? !validDistance && currentPhase == PHASE_END && options.triggerOnTouchLeave && (nextPhase = PHASE_CANCEL) : nextPhase = PHASE_END, nextPhase
            }

            function triggerHandler(event, phase) { var ret, touches = event.touches; return (didSwipe() || hasSwipes()) && (ret = triggerHandlerForGesture(event, phase, SWIPE)), (didPinch() || hasPinches()) && ret !== !1 && (ret = triggerHandlerForGesture(event, phase, PINCH)), didDoubleTap() && ret !== !1 ? ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP) : didLongTap() && ret !== !1 ? ret = triggerHandlerForGesture(event, phase, LONG_TAP) : didTap() && ret !== !1 && (ret = triggerHandlerForGesture(event, phase, TAP)), phase === PHASE_CANCEL && touchCancel(), phase === PHASE_END && (touches ? touches.length || touchCancel() : touchCancel()), ret }

            function triggerHandlerForGesture(event, phase, gesture) {
                var ret;
                if (gesture == SWIPE) {
                    if ($element.trigger("swipeStatus", [phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection]), options.swipeStatus && (ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection), ret === !1)) return !1;
                    if (phase == PHASE_END && validateSwipe()) {
                        if (clearTimeout(singleTapTimeout), clearTimeout(holdTimeout), $element.trigger("swipe", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipe && (ret = options.swipe.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection), ret === !1)) return !1;
                        switch (direction) {
                            case LEFT:
                                $element.trigger("swipeLeft", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeLeft && (ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                                break;
                            case RIGHT:
                                $element.trigger("swipeRight", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeRight && (ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                                break;
                            case UP:
                                $element.trigger("swipeUp", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeUp && (ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                                break;
                            case DOWN:
                                $element.trigger("swipeDown", [direction, distance, duration, fingerCount, fingerData, currentDirection]), options.swipeDown && (ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection));
                        }
                    }
                }
                if (gesture == PINCH) {
                    if ($element.trigger("pinchStatus", [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]), options.pinchStatus && (ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData), ret === !1)) return !1;
                    if (phase == PHASE_END && validatePinch()) switch (pinchDirection) {
                        case IN:
                            $element.trigger("pinchIn", [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]), options.pinchIn && (ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData));
                            break;
                        case OUT:
                            $element.trigger("pinchOut", [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]), options.pinchOut && (ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData));
                    }
                }
                return gesture == TAP ? phase !== PHASE_CANCEL && phase !== PHASE_END || (clearTimeout(singleTapTimeout), clearTimeout(holdTimeout), hasDoubleTap() && !inDoubleTap() ? (doubleTapStartTime = getTimeStamp(), singleTapTimeout = setTimeout($.proxy(function() { doubleTapStartTime = null, $element.trigger("tap", [event.target]), options.tap && (ret = options.tap.call($element, event, event.target)); }, this), options.doubleTapThreshold)) : (doubleTapStartTime = null, $element.trigger("tap", [event.target]), options.tap && (ret = options.tap.call($element, event, event.target)))) : gesture == DOUBLE_TAP ? phase !== PHASE_CANCEL && phase !== PHASE_END || (clearTimeout(singleTapTimeout), clearTimeout(holdTimeout), doubleTapStartTime = null, $element.trigger("doubletap", [event.target]), options.doubleTap && (ret = options.doubleTap.call($element, event, event.target))) : gesture == LONG_TAP && (phase !== PHASE_CANCEL && phase !== PHASE_END || (clearTimeout(singleTapTimeout), doubleTapStartTime = null, $element.trigger("longtap", [event.target]), options.longTap && (ret = options.longTap.call($element, event, event.target)))), ret
            }

            function validateSwipeDistance() { var valid = !0; return null !== options.threshold && (valid = distance >= options.threshold), valid }

            function didSwipeBackToCancel() { var cancelled = !1; return null !== options.cancelThreshold && null !== direction && (cancelled = getMaxDistance(direction) - distance >= options.cancelThreshold), cancelled }

            function validatePinchDistance() { return null === options.pinchThreshold || pinchDistance >= options.pinchThreshold }

            function validateSwipeTime() { var result; return result = !options.maxTimeThreshold || !(duration >= options.maxTimeThreshold) }

            function validateDefaultEvent(jqEvent, direction) {
                if (options.preventDefaultEvents !== !1)
                    if (options.allowPageScroll === NONE) jqEvent.preventDefault();
                    else {
                        var auto = options.allowPageScroll === AUTO;
                        switch (direction) {
                            case LEFT:
                                (options.swipeLeft && auto || !auto && options.allowPageScroll != HORIZONTAL) && jqEvent.preventDefault();
                                break;
                            case RIGHT:
                                (options.swipeRight && auto || !auto && options.allowPageScroll != HORIZONTAL) && jqEvent.preventDefault();
                                break;
                            case UP:
                                (options.swipeUp && auto || !auto && options.allowPageScroll != VERTICAL) && jqEvent.preventDefault();
                                break;
                            case DOWN:
                                (options.swipeDown && auto || !auto && options.allowPageScroll != VERTICAL) && jqEvent.preventDefault();
                                break;
                        }
                    }
            }

            function validatePinch() {
                var hasCorrectFingerCount = validateFingers(),
                    hasEndPoint = validateEndPoint(),
                    hasCorrectDistance = validatePinchDistance();
                return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance
            }

            function hasPinches() { return !!(options.pinchStatus || options.pinchIn || options.pinchOut) }

            function didPinch() { return !(!validatePinch() || !hasPinches()) }

            function validateSwipe() {
                var hasValidTime = validateSwipeTime(),
                    hasValidDistance = validateSwipeDistance(),
                    hasCorrectFingerCount = validateFingers(),
                    hasEndPoint = validateEndPoint(),
                    didCancel = didSwipeBackToCancel(),
                    valid = !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;
                return valid
            }

            function hasSwipes() { return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown) }

            function didSwipe() { return !(!validateSwipe() || !hasSwipes()) }

            function validateFingers() { return fingerCount === options.fingers || options.fingers === ALL_FINGERS || !SUPPORTS_TOUCH }

            function validateEndPoint() { return 0 !== fingerData[0].end.x }

            function hasTap() { return !!options.tap }

            function hasDoubleTap() { return !!options.doubleTap }

            function hasLongTap() { return !!options.longTap }

            function validateDoubleTap() { if (null == doubleTapStartTime) return !1; var now = getTimeStamp(); return hasDoubleTap() && now - doubleTapStartTime <= options.doubleTapThreshold }

            function inDoubleTap() { return validateDoubleTap() }

            function validateTap() { return (1 === fingerCount || !SUPPORTS_TOUCH) && (isNaN(distance) || distance < options.threshold) }

            function validateLongTap() { return duration > options.longTapThreshold && distance < DOUBLE_TAP_THRESHOLD }

            function didTap() { return !(!validateTap() || !hasTap()) }

            function didDoubleTap() { return !(!validateDoubleTap() || !hasDoubleTap()) }

            function didLongTap() { return !(!validateLongTap() || !hasLongTap()) }

            function startMultiFingerRelease(event) { previousTouchEndTime = getTimeStamp(), fingerCountAtRelease = event.touches.length + 1; }

            function cancelMultiFingerRelease() { previousTouchEndTime = 0, fingerCountAtRelease = 0; }

            function inMultiFingerRelease() {
                var withinThreshold = !1;
                if (previousTouchEndTime) {
                    var diff = getTimeStamp() - previousTouchEndTime;
                    diff <= options.fingerReleaseThreshold && (withinThreshold = !0);
                }
                return withinThreshold
            }

            function getTouchInProgress() { return !($element.data(PLUGIN_NS + "_intouch") !== !0) }

            function setTouchInProgress(val) { $element && (val === !0 ? ($element.bind(MOVE_EV, touchMove), $element.bind(END_EV, touchEnd), LEAVE_EV && $element.bind(LEAVE_EV, touchLeave)) : ($element.unbind(MOVE_EV, touchMove, !1), $element.unbind(END_EV, touchEnd, !1), LEAVE_EV && $element.unbind(LEAVE_EV, touchLeave, !1)), $element.data(PLUGIN_NS + "_intouch", val === !0)); }

            function createFingerData(id, evt) { var f = { start: { x: 0, y: 0 }, last: { x: 0, y: 0 }, end: { x: 0, y: 0 } }; return f.start.x = f.last.x = f.end.x = evt.pageX || evt.clientX, f.start.y = f.last.y = f.end.y = evt.pageY || evt.clientY, fingerData[id] = f, f }

            function updateFingerData(evt) {
                var id = void 0 !== evt.identifier ? evt.identifier : 0,
                    f = getFingerData(id);
                return null === f && (f = createFingerData(id, evt)), f.last.x = f.end.x, f.last.y = f.end.y, f.end.x = evt.pageX || evt.clientX, f.end.y = evt.pageY || evt.clientY, f
            }

            function getFingerData(id) { return fingerData[id] || null }

            function setMaxDistance(direction, distance) { direction != NONE && (distance = Math.max(distance, getMaxDistance(direction)), maximumsMap[direction].distance = distance); }

            function getMaxDistance(direction) { if (maximumsMap[direction]) return maximumsMap[direction].distance }

            function createMaximumsData() { var maxData = {}; return maxData[LEFT] = createMaximumVO(LEFT), maxData[RIGHT] = createMaximumVO(RIGHT), maxData[UP] = createMaximumVO(UP), maxData[DOWN] = createMaximumVO(DOWN), maxData }

            function createMaximumVO(dir) { return { direction: dir, distance: 0 } }

            function calculateDuration() { return endTime - startTime }

            function calculateTouchesDistance(startPoint, endPoint) {
                var diffX = Math.abs(startPoint.x - endPoint.x),
                    diffY = Math.abs(startPoint.y - endPoint.y);
                return Math.round(Math.sqrt(diffX * diffX + diffY * diffY))
            }

            function calculatePinchZoom(startDistance, endDistance) { var percent = endDistance / startDistance * 1; return percent.toFixed(2) }

            function calculatePinchDirection() { return pinchZoom < 1 ? OUT : IN }

            function calculateDistance(startPoint, endPoint) { return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2))) }

            function calculateAngle(startPoint, endPoint) {
                var x = startPoint.x - endPoint.x,
                    y = endPoint.y - startPoint.y,
                    r = Math.atan2(y, x),
                    angle = Math.round(180 * r / Math.PI);
                return angle < 0 && (angle = 360 - Math.abs(angle)), angle
            }

            function calculateDirection(startPoint, endPoint) { if (comparePoints(startPoint, endPoint)) return NONE; var angle = calculateAngle(startPoint, endPoint); return angle <= 45 && angle >= 0 ? LEFT : angle <= 360 && angle >= 315 ? LEFT : angle >= 135 && angle <= 225 ? RIGHT : angle > 45 && angle < 135 ? DOWN : UP }

            function getTimeStamp() { var now = new Date; return now.getTime() }

            function getbounds(el) {
                el = $(el);
                var offset = el.offset(),
                    bounds = { left: offset.left, right: offset.left + el.outerWidth(), top: offset.top, bottom: offset.top + el.outerHeight() };
                return bounds
            }

            function isInBounds(point, bounds) { return point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom }

            function comparePoints(pointA, pointB) { return pointA.x == pointB.x && pointA.y == pointB.y }
            var options = $.extend({}, options),
                useTouchEvents = SUPPORTS_TOUCH || SUPPORTS_POINTER || !options.fallbackToMouseEvents,
                START_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerDown" : "pointerdown" : "touchstart" : "mousedown",
                MOVE_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerMove" : "pointermove" : "touchmove" : "mousemove",
                END_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerUp" : "pointerup" : "touchend" : "mouseup",
                LEAVE_EV = useTouchEvents ? SUPPORTS_POINTER ? "mouseleave" : null : "mouseleave",
                CANCEL_EV = SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? "MSPointerCancel" : "pointercancel" : "touchcancel",
                distance = 0,
                direction = null,
                currentDirection = null,
                duration = 0,
                startTouchesDistance = 0,
                endTouchesDistance = 0,
                pinchZoom = 1,
                pinchDistance = 0,
                pinchDirection = 0,
                maximumsMap = null,
                $element = $(element),
                phase = "start",
                fingerCount = 0,
                fingerData = {},
                startTime = 0,
                endTime = 0,
                previousTouchEndTime = 0,
                fingerCountAtRelease = 0,
                doubleTapStartTime = 0,
                singleTapTimeout = null,
                holdTimeout = null;
            try { $element.bind(START_EV, touchStart), $element.bind(CANCEL_EV, touchCancel); } catch (e) { $.error("events not supported " + START_EV + "," + CANCEL_EV + " on jQuery.swipe"); } this.enable = function() { return this.disable(), $element.bind(START_EV, touchStart), $element.bind(CANCEL_EV, touchCancel), $element }, this.disable = function() { return removeListeners(), $element }, this.destroy = function() { removeListeners(), $element.data(PLUGIN_NS, null), $element = null; }, this.option = function(property, value) {
                if ("object" == typeof property) options = $.extend(options, property);
                else if (void 0 !== options[property]) {
                    if (void 0 === value) return options[property];
                    options[property] = value;
                } else {
                    if (!property) return options;
                    $.error("Option " + property + " does not exist on jQuery.swipe.options");
                }
                return null
            };
        }
        var VERSION = "1.6.18",
            LEFT = "left",
            RIGHT = "right",
            UP = "up",
            DOWN = "down",
            IN = "in",
            OUT = "out",
            NONE = "none",
            AUTO = "auto",
            SWIPE = "swipe",
            PINCH = "pinch",
            TAP = "tap",
            DOUBLE_TAP = "doubletap",
            LONG_TAP = "longtap",
            HORIZONTAL = "horizontal",
            VERTICAL = "vertical",
            ALL_FINGERS = "all",
            DOUBLE_TAP_THRESHOLD = 10,
            PHASE_START = "start",
            PHASE_MOVE = "move",
            PHASE_END = "end",
            PHASE_CANCEL = "cancel",
            SUPPORTS_TOUCH = "ontouchstart" in window,
            SUPPORTS_POINTER_IE10 = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled && !SUPPORTS_TOUCH,
            SUPPORTS_POINTER = (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && !SUPPORTS_TOUCH,
            PLUGIN_NS = "TouchSwipe",
            defaults = { fingers: 1, threshold: 75, cancelThreshold: null, pinchThreshold: 20, maxTimeThreshold: null, fingerReleaseThreshold: 250, longTapThreshold: 500, doubleTapThreshold: 200, swipe: null, swipeLeft: null, swipeRight: null, swipeUp: null, swipeDown: null, swipeStatus: null, pinchIn: null, pinchOut: null, pinchStatus: null, click: null, tap: null, doubleTap: null, longTap: null, hold: null, triggerOnTouchEnd: !0, triggerOnTouchLeave: !1, allowPageScroll: "auto", fallbackToMouseEvents: !0, excludedElements: ".noSwipe", preventDefaultEvents: !0 };
        $.fn.swipe = function(method) {
            var $this = $(this),
                plugin = $this.data(PLUGIN_NS);
            if (plugin && "string" == typeof method) {
                if (plugin[method]) return plugin[method].apply(plugin, Array.prototype.slice.call(arguments, 1));
                $.error("Method " + method + " does not exist on jQuery.swipe");
            } else if (plugin && "object" == typeof method) plugin.option.apply(plugin, arguments);
            else if (!(plugin || "object" != typeof method && method)) return init.apply(this, arguments);
            return $this
        }, $.fn.swipe.version = VERSION, $.fn.swipe.defaults = defaults, $.fn.swipe.phases = { PHASE_START: PHASE_START, PHASE_MOVE: PHASE_MOVE, PHASE_END: PHASE_END, PHASE_CANCEL: PHASE_CANCEL }, $.fn.swipe.directions = { LEFT: LEFT, RIGHT: RIGHT, UP: UP, DOWN: DOWN, IN: IN, OUT: OUT }, $.fn.swipe.pageScroll = { NONE: NONE, HORIZONTAL: HORIZONTAL, VERTICAL: VERTICAL, AUTO: AUTO }, $.fn.swipe.fingers = { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5, ALL: ALL_FINGERS };
    });


}


//share
{
    ! function(t) {
        if ("object" == typeof exports && "undefined" != typeof module) module.exports = t();
        else if ("function" == typeof define && define.amd) define([], t);
        else {
            var e;
            e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, e.Share = t();
        }
    }(function() {
        var t;
        "classList" in document.documentElement || !Object.defineProperty || "undefined" == typeof HTMLElement || Object.defineProperty(HTMLElement.prototype, "classList", {
            get: function() {
                var t, e, o;
                return o = function(t) {
                    return function(o) {
                        var n, i;
                        n = e.className.split(/\s+/), i = n.indexOf(o), t(n, i, o), e.className = n.join(" ");
                    }
                }, e = this, t = {
                    add: o(function(t, e, o) {
                        ~
                        e || t.push(o);
                    }),
                    remove: o(function(t, e) {
                        ~
                        e && t.splice(e, 1);
                    }),
                    toggle: o(function(t, e, o) {
                        ~
                        e ? t.splice(e, 1) : t.push(o);
                    }),
                    contains: function(t) {
                        return !!~e.className.split(/\s+/).indexOf(t)
                    },
                    item: function(t) {
                        return e.className.split(/\s+/)[t] || null
                    }
                }, Object.defineProperty(t, "length", {
                    get: function() {
                        return e.className.split(/\s+/).length
                    }
                }), t
            }
        }), String.prototype.to_rfc3986 = function() {
            var t;
            return t = encodeURIComponent(this), t.replace(/[!'()*]/g, function(t) {
                return "%" + t.charCodeAt(0).toString(16)
            })
        }, t = function() {
            function t() {}
            return t.prototype.extend = function(t, e, o) {
                var n, i;
                for (i in e) n = void 0 !== t[i], n && "object" == typeof e[i] ? this.extend(t[i], e[i], o) : (o || !n) && (t[i] = e[i]);
            }, t.prototype.hide = function(t) {
                return t.style.display = "none"
            }, t.prototype.show = function(t) {
                return t.style.display = "block"
            }, t.prototype.has_class = function(t, e) {
                return t.classList.contains(e)
            }, t.prototype.add_class = function(t, e) {
                return t.classList.add(e)
            }, t.prototype.remove_class = function(t, e) {
                return t.classList.remove(e)
            }, t.prototype.is_encoded = function(t) {
                return t = t.to_rfc3986(), decodeURIComponent(t) !== t
            }, t.prototype.encode = function(t) {
                return "undefined" == typeof t || this.is_encoded(t) ? t : t.to_rfc3986()
            }, t.prototype.popup = function(t, e) {
                var o, n, i, r;
                return null == e && (e = {}), n = {
                    width: 500,
                    height: 350
                }, n.top = screen.height / 2 - n.height / 2, n.left = screen.width / 2 - n.width / 2, i = function() {
                    var t;
                    t = [];
                    for (o in e) r = e[o], t.push(o + "=" + this.encode(r));
                    return t
                }.call(this).join("&"), i && (i = "?" + i), window.open(t + i, "targetWindow", "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,left=" + n.left + ",top=" + n.top + ",width=" + n.width + ",height=" + n.height)
            }, t
        }();
        var e, o = function(t, e) {
                function o() {
                    this.constructor = t;
                }
                for (var i in e) n.call(e, i) && (t[i] = e[i]);
                return o.prototype = e.prototype, t.prototype = new o, t.__super__ = e.prototype, t
            },
            n = {}.hasOwnProperty;
        return e = function(t) {
            function e(t, e) {
                return this.element = t, this.el = {
                    head: document.getElementsByTagName("head")[0],
                    body: document.getElementsByTagName("body")[0]
                }, this.config = {
                    enabled_networks: 0,
                    protocol: -1 === ["http", "https"].indexOf(window.location.href.split(":")[0]) ? "https://" : "//",
                    url: window.location.href,
                    caption: null,
                    title: this.default_title(),
                    image: this.default_image(),
                    description: this.default_description(),
                    ui: {
                        flyout: "top center",
                        button_text: "Share",
                        button_font: !0,
                        icon_font: !0
                    },
                    networks: {
                        twitter: {
                            enabled: !0,
                            url: null,
                            description: null
                        },
                        facebook: {
                            enabled: !0,
                            load_sdk: !0,
                            url: null,
                            app_id: null,
                            title: null,
                            caption: null,
                            description: null,
                            image: null
                        },
                        pinterest: {
                            enabled: !0,
                            url: null,
                            image: null,
                            description: null
                        },
                        email: {
                            enabled: !0,
                            title: null,
                            description: null,
                            url:null
                        }
                    }
                }, this.setup(this.element, e), this
            }
            return o(e, t), e.prototype.setup = function(t, e) {
                var o, n, i, r, s;
                for (r = [t], this.extend(this.config, e, !0), this.set_global_configuration(), this.normalize_network_configuration(), this.config.networks.facebook.enabled && this.config.networks.facebook.load_sdk && this.inject_facebook_sdk(), n = o = 0, s = r.length; s > o; n = ++o) i = r[n], this.setup_instance(t, n);
            }, e.prototype.setup_instance = function(t, e) {
                var o, n, i, r, s, l, c, a, p;
                for (r = t, this.add_class(r, "sharer-" + e), this.inject_html(r), document.getElementById("flipbook-share-facebook").style.display = this.config.networks.facebook.display, document.getElementById("flipbook-share-twitter").style.display = this.config.networks.twitter.display, document.getElementById("flipbook-share-pinterest").style.display = this.config.networks.pinterest.display, document.getElementById("flipbook-share-email").style.display = this.config.networks.email.display, s = r.getElementsByTagName("label")[0], n = r.getElementsByClassName("social")[0], a = r.getElementsByTagName("li"), this.add_class(n, "networks-" + this.config.enabled_networks), r.addEventListener("click", function(t) {
                        return function() {
                            return t.event_toggle(n)
                        }
                    }(this)), o = this, p = [], e = i = 0, l = a.length; l > i; e = ++i) c = a[e], p.push(c.addEventListener("click", function() {
                    return o.event_network(r, this), o.event_close(n)
                }));
                return p
            }, e.prototype.event_toggle = function(t) {
                return this.has_class(t, "active") ? this.event_close(t) : this.event_open(t)
            }, e.prototype.event_open = function(t) {
                return this.has_class(t, "load") && this.remove_class(t, "load"), this.add_class(t, "active")
            }, e.prototype.event_close = function(t) {
                return this.remove_class(t, "active")
            }, e.prototype.event_network = function(t, e) {
                var o;
                return o = e.getAttribute("data-network"), this.hook("before", o, t), this["network_" + o](), this.hook("after", o, t)
            }, e.prototype.open = function() {
                return this["public"]("open")
            }, e.prototype.close = function() {
                return this["public"]("close")
            }, e.prototype.toggle = function() {
                return this["public"]("toggle")
            }, e.prototype["public"] = function(t) {
                var e, o, n, i, r, s, l;
                for (s = document.querySelectorAll(this.element), l = [], n = o = 0, r = s.length; r > o; n = ++o) i = s[n], e = i.getElementsByClassName("social")[0], l.push(this["event_" + t](e));
                return l
            }, e.prototype.network_facebook = function() {
                return this.config.networks.facebook.load_sdk ? window.FB ? FB.ui({
                    method: "feed",
                    name: this.config.networks.facebook.title,
                    link: this.config.networks.facebook.url,
                    picture: this.config.networks.facebook.image,
                    caption: this.config.networks.facebook.caption,
                    description: this.config.networks.facebook.description
                }) : console.error("The Facebook JS SDK hasn't loaded yet.") : this.popup("https://www.facebook.com/sharer/sharer.php", {
                    u: this.config.networks.facebook.url
                })
            }, e.prototype.network_twitter = function() {
                return this.popup("https://twitter.com/intent/tweet", {
                    text: this.config.networks.twitter.description,
                    url: this.config.networks.twitter.url
                })
            }, e.prototype.network_google_plus = function() {
                return this.popup("https://plus.google.com/share", {
                    url: this.config.networks.google_plus.url
                })
            }, e.prototype.network_pinterest = function() {
                return this.popup("https://www.pinterest.com/pin/create/button", {
                    url: this.config.networks.pinterest.url,
                    media: this.config.networks.pinterest.image,
                    description: this.config.networks.pinterest.description
                })
            }, e.prototype.network_email = function() {
                return this.popup("mailto:", {
                    subject: this.config.networks.email.title,
                    body: this.config.networks.email.description + '%0D%0A' + this.config.networks.email.url  || this.config.url
                })
            }, e.prototype.inject_stylesheet = function(t) {
                var e;
                return this.el.head.querySelector('link[href="' + t + '"]') ? void 0 : (e = document.createElement("link"), e.setAttribute("rel", "stylesheet"), e.setAttribute("href", t), this.el.head.appendChild(e))
            }, e.prototype.inject_html = function(t) {
                return t.innerHTML = "<div class='social load " + this.config.ui.flyout + "'><ul><li id='flipbook-share-pinterest' data-network='pinterest'><i class='fab fa-pinterest-p skin-color'></i></li><li id='flipbook-share-twitter' data-network='twitter'><i class='fab fa-twitter skin-color'></i></li><li id='flipbook-share-facebook' data-network='facebook'><i class='fab fa-facebook-f skin-color'></i></li><li id='flipbook-share-email' data-network='email'><i class='fas fa-at skin-color'></i></li></ul></div>"
            }, e.prototype.inject_facebook_sdk = function() {
                var t, e;
                return window.FB || !this.config.networks.facebook.app_id || this.el.body.querySelector("#fb-root") ? void 0 : (e = document.createElement("script"), e.text = "window.fbAsyncInit=function(){FB.init({appId:'" + this.config.networks.facebook.app_id + "',status:true,xfbml:true})};(function(e,t,n){var r,i=e.getElementsByTagName(t)[0];if(e.getElementById(n)){return}r=e.createElement(t);r.id=n;r.src='" + this.config.protocol + "connect.facebook.net/en_US/all.js';i.parentNode.insertBefore(r,i)})(document,'script','facebook-jssdk')", t = document.createElement("div"), t.id = "fb-root", this.el.body.appendChild(t), this.el.body.appendChild(e))
            }, e.prototype.hook = function(t, e, o) {
                var n, i;
                n = this.config.networks[e][t], "function" == typeof n && (i = n.call(this.config.networks[e], o), void 0 !== i && (i = this.normalize_filter_config_updates(i), this.extend(this.config.networks[e], i, !0), this.normalize_network_configuration()));
            }, e.prototype.default_title = function() {
                var t;
                return (t = document.querySelector('meta[property="og:title"]') || document.querySelector('meta[name="twitter:title"]')) ? t.getAttribute("content") : (t = document.querySelector("title")) ? t.innerText : void 0
            }, e.prototype.default_image = function() {
                var t;
                return (t = document.querySelector('meta[property="og:image"]') || document.querySelector('meta[name="twitter:image"]')) ? t.getAttribute("content") : void 0
            }, e.prototype.default_description = function() {
                var t;
                return (t = document.querySelector('meta[property="og:description"]') || document.querySelector('meta[name="twitter:description"]') || document.querySelector('meta[name="description"]')) ? t.getAttribute("content") : ""
            }, e.prototype.set_global_configuration = function() {
                var t, e, o, n, i, r;
                i = this.config.networks, r = [];
                for (e in i) {
                    n = i[e];
                    for (o in n) null == this.config.networks[e][o] && (this.config.networks[e][o] = this.config[o]);
                    this.config.networks[e].enabled ? (t = "block", this.config.enabled_networks += 1) : t = "none", r.push(this.config.networks[e].display = t);
                }
                return r
            }, e.prototype.normalize_network_configuration = function() {
                return this.config.networks.facebook.app_id || (this.config.networks.facebook.load_sdk = !1), this.is_encoded(this.config.networks.twitter.description) || (this.config.networks.twitter.description = encodeURIComponent(this.config.networks.twitter.description)), "number" == typeof this.config.networks.facebook.app_id ? this.config.networks.facebook.app_id = this.config.networks.facebook.app_id.toString() : void 0
            }, e.prototype.normalize_filter_config_updates = function(t) {
                return this.config.networks.facebook.app_id !== t.app_id && (console.warn("You are unable to change the Facebook app_id after the button has been initialized. Please update your Facebook filters accordingly."), delete t.app_id), this.config.networks.facebook.load_sdk !== t.load_sdk && (console.warn("You are unable to change the Facebook load_sdk option after the button has been initialized. Please update your Facebook filters accordingly."), delete t.app_id), t
            }, e
        }(t)
    });

}

/* v 3.11
author http://codecanyon.net/user/creativeinteractivemedia/portfolio?ref=creativeinteractivemedia
*/

// var FLIPBOOK = FLIPBOOK || {};

FLIPBOOK.Book3 = function(el, model, options) {

    this.options = options;
    this.model = model;

    this.singlePage = options.singlePageMode;
    this.pageWidth = this.options.pageWidth;
    this.pageHeight = this.options.pageHeight;

    this.wrapper = el;
    this.$wrapper = jQuery(this.wrapper).addClass('flipbook-book3');
    this.$bookLayer = this.$wrapper.parent();
    this.bookLayer = this.$bookLayer[0];

    this.flipEasing = 'easeInOutCubic';
    this.flipEasing = 'easeOutSine';
    this.flipEasing = 'easeOutQuad';

    this.scroll = new FLIPBOOK.IScroll(this.bookLayer, {
        zoom: true,
        scrollX: true,
        scrollY: true,
        scrollbars: true,
        // mouseWheel: true,
        // wheelAction: 'zoom',
        keepInCenterV: true,
        keepInCenterH: true,
        freeScroll:true,
        // eventPassthrough:true,
        preventDefault: false, //for text selection and other events in html layer,

    });

    var self = this;

    model.on("toolMove", function() {
        self.updateTool();
    });

    model.on("toolSelect", function() {
        self.updateTool();
    });

    this.scroll.on("zoomEnd", function() {

        // self.zooming = false

        if (isNaN(self.scroll.scale)) {
            self.zoomTo(options.zoomMin);
            return
        }
        options.main.onZoom(self.scroll.scale / self.ratio);
        var scale = options.main.zoom;

        self.scroll.options.eventPassthrough = scale > 1 ? '' : 'vertical';
        // self.scroll.options.scrollY = scale > 1
        self.scroll.options.freeScroll = scale > 1;
        // self.scroll.options.freeScroll = false

        self.scroll.refresh();
        // self.scroll.enable()
    });

    this.scroll.on('zoomStart', function() {

        // self.zooming = true
        // self.scroll.disable()
    });

    var s = this.wrapper.style;
    // s.width = String(2 * this.pageWidth) + 'px';
    /* if (this.singlePage)
        s.width = String(this.pageWidth) + 'px';
    else
        s.width = String(2 * this.pageWidth) + 'px';

*/

    s.width = String(2 * this.pageWidth) + 'px';
    s.height = String(this.pageHeight) + 'px';

    var perspective = (3 * this.pageHeight) + 'px';

    this.$centerContainer = jQuery('<div>').appendTo(this.$wrapper).addClass('flipbook-center-container3');
    if (this.options.singlePageMode) {
        this.$centerContainer.css({
            '-webkit-perspective-origin-x': '0',
            'perspective-origin-x': '0'
        });
    }

    this.$centerContainer.css({
        '-webkit-perspective': perspective,
        'perspective': perspective
    });


    this.centerContainerStyle = this.$centerContainer[0].style;
    this.centerContainerStyle.width = 2 * this.pageWidth + 'px';
    this.centerContainerStyle.height = this.pageHeight + 'px';
    this.pagesArr = [];
    this.animating = false;
    // this.rightIndex =
    this.setRightIndex(options.rightToLeft ? options.pages.length : 0);

    this.flippedleft = this.rightIndex;
    this.flippedright = options.pages.length - this.rightIndex;
    //create pages
    this.numPages = options.pages.length;

    var page;
    //double page mode
    for (var i = 0; i < options.numPages; i++) {
        page = new FLIPBOOK.Page3(this, i, options.pages[i].src, options.pages[i].htmlContent);
        page.hideHtml();
        this.pagesArr.push(page);
        this.$centerContainer.append(page.$wrapper);
        this.flippedright++;
        /*if (options.loadAllPages)
            page.load() */
    }
    this.pagesArr[0].show();

    this.nextEnabled = true;
    this.prevEnabled = true;
    //this.updateVisiblePages()

};

FLIPBOOK.Book3.prototype = {};

FLIPBOOK.Book3.prototype.enableMouseWheelZoom = function() {

    this.scroll.options.eventPassthrough = 'vertical';
    this.scroll.refresh();

};

FLIPBOOK.Book3.prototype.disableMouseWheelZoom = function() {

    this.scroll.options.eventPassthrough = '';
    this.scroll.refresh();

};

FLIPBOOK.Book3.prototype.enablePrev = function(val) {

    this.prevEnabled = val;

};

FLIPBOOK.Book3.prototype.enablePan = function() {

    this.scroll.enable();

};

FLIPBOOK.Book3.prototype.disablePan = function() {

    this.scroll.disable();

};

FLIPBOOK.Book3.prototype.setRightIndex = function(val) {

    this.rightIndex = val;
    // $(this).trigger('rightIndexChange', [val])
    // this.options.main.onRightIndexChange(val)

};

FLIPBOOK.Book3.prototype.updateTool = function() {

    switch (this.options.main.tool) {

        case "toolSelect":
            this.disablePan();
            jQuery(".flipbook-textLayer").css("pointer-events", "auto").removeClass(".flipbook-noselect");
            break;

        case "toolMove":
            this.enablePan();
            jQuery(".flipbook-textLayer").css("pointer-events", "none").addClass(".flipbook-noselect");
            break;
    }

};

FLIPBOOK.Book3.prototype.enableNext = function(val) {

    this.nextEnabled = val;

};

FLIPBOOK.Book3.prototype.isZoomed = function() {
    return this.options.main.zoom > this.options.zoomMin && this.options.main.zoom > 1
};

FLIPBOOK.Book3.prototype.onZoom = function() {
    /* if (!this.enabled) return;
     for (var i = 0; i < this.pagesArr.length; i++) {
         this.pagesArr[i].loaded = false
     }
     var self = this;
     setTimeout(function() {
         self.updateVisiblePages(false)
     }, 100); */
};

FLIPBOOK.Book3.prototype.getNumPages = function() {};


FLIPBOOK.Book3.prototype.zoomTo = function(zoom, time, x, y) {

    if (!this.enabled) return;

    var x = x || 0;
    var y = y || 0;
    var time = time || 0;
    this.zoom = zoom;

    time = 0;

    var scroll = this.scroll;
    if (scroll) {
        // this.disablePan()
        scroll.zoom(zoom * this.ratio, x, y, time);

        // setTimeout(function(){
        //     scroll.enable()
        // },300)

    }
};

FLIPBOOK.Book3.prototype.setWrapperW = function(w) {
    if (this.$wrapperW != w) {
        this.$wrapper.width(w);
        this.$wrapperW = w;
    }
};

FLIPBOOK.Book3.prototype.updateBookPosition = function() {

    if (this.options.singlePageMode) {
        this.setWrapperW(this.pageWidth);

        this.$wrapper.width(this.pageWidth);
        if (this.scroll)
            this.scroll.refresh();
        this.focusBoth();
        this.view = 1;
        this.focusLeft();
        return
    }

    if (this.view == 1) {
        this.setWrapperW(this.pageWidth);
        // this.$wrapper.width(this.pageWidth)
        // .css('left',-this.ratio * this.pageWidth/2+'px')

        // this.scroll.scroller.offsetWidth = this.pageWidth
    } else {
        this.setWrapperW(2 * this.pageWidth);
        // this.$wrapper.width(2 * this.pageWidth)
        // .css('left','0')
        // this.scroll.scroller.offsetWidth = 2*this.pageWidth
    }
    if (this.scroll)
        this.scroll.refresh();
    if (this.view == 2) {
        if (this.isCover()) {
            this.focusRight();
        } else if (this.isBackCover()) {
            this.focusLeft();
        } else {
            this.focusBoth();
        }
    } else if (this.view == 1) {
        if (this.isCover()) {
            this.focusRight();
        } else if (this.isBackCover()) {
            this.focusLeft();
        }
    }

};

FLIPBOOK.Book3.prototype.focusLeft = function(time, delay) {

    var pos = this.view == 1 ? 0 : this.pageWidth / 2;

    this.setBookPosition(pos, time, delay);

};

FLIPBOOK.Book3.prototype.focusRight = function(time, delay) {

    var pos = this.view == 1 ? -this.pageWidth : -this.pageWidth / 2;

    this.setBookPosition(pos, time, delay);

};

FLIPBOOK.Book3.prototype.focusBoth = function(time, delay) {

    var pos = this.view == 1 ? -this.pageWidth / 2 : 0;

    this.setBookPosition(pos, time, delay);

};

FLIPBOOK.Book3.prototype.setBookPosition = function(pos, time, delay) {

    if (this.centerContainerPosition == pos)
        return
    var start = this.centerContainerPosition;

    // var transform = 'translateX(' + pos + 'px) translateZ(0)'

    if (time) {

        // var nextEnabled = this.nextEnabled
        // var prevEnabled = this.prevEnabled

        // this.nextEnabled = false
        // this.prevEnabled = false

        var self = this;
        delay = delay || 0;

        jQuery({
            someValue: start
        }).delay(delay).animate({
            someValue: pos
        }, {
            duration: time,
            // easing: "easeInOutQuad",
            // easing: "easeInOutCubic",
            easing: this.flipEasing,
            // easing: "easeInQuad",
            step: function(now) {
                self._setStyle(self.centerContainerStyle, FLIPBOOK.IScroll.utils.style.transform, 'translateX(' + now + 'px) translateZ(0)');
            },
            complete: function() {
                self.centerContainerPosition = pos;
                // self.nextEnabled = nextEnabled
                // self.prevEnabled = prevEnabled
            }
        });


    } else {
        var transform = 'translateX(' + pos + 'px)';
        this.centerContainerPosition = pos;
        this._setStyle(this.centerContainerStyle, FLIPBOOK.IScroll.utils.style.transform, transform);
    }
};

FLIPBOOK.Book3.prototype.updateVisiblePages = function(loadNextPrev) {
    var self = this;
    var transform = FLIPBOOK.IScroll.utils.style.transform;
    for (var i = 0; i < this.pagesArr.length; i++) {
        if (i == this.flippedleft)
            this.pagesArr[i].show();
        else if (i == (this.flippedleft - 1) && !this.options.singlePageMode)
            this.pagesArr[i].show();
        else
            this.pagesArr[i].hide();
        this.pagesArr[i]._setZIndex(0);
        this.pagesArr[i]._setStyle(this.pagesArr[i].wrapper.style, transform, '');
    }
    this.updateBookPosition();

    var right = this.pagesArr[this.rightIndex];
    var left = this.pagesArr[this.rightIndex - 1];
    var next = this.pagesArr[this.rightIndex + 1];
    var afterNext = this.pagesArr[this.rightIndex + 2];
    var prev = this.pagesArr[this.rightIndex - 2];
    var beforePrev = this.pagesArr[this.rightIndex - 3];

    if (left) {
        self.options.main.setLoadingProgress(.1);
        left.load(function() {

            self.options.main.setLoadingProgress(1);
            left.showHtml();
            if (right) {
                right.load(function() {
                    self.options.main.setLoadingProgress(1);
                    if (prev) prev.load();
                    if (beforePrev) beforePrev.load();
                    if (next) next.load();
                    if (afterNext) afterNext.load();
                    right.showHtml();
                });
            } else {
                if (prev) prev.load();
                if (beforePrev) beforePrev.load();
            }

        });
    } else {
        self.options.main.setLoadingProgress(.1);
        right.load(function() {
            self.options.main.setLoadingProgress(1);
            if (next) next.load();
            if (afterNext) afterNext.load();
            right.showHtml();
        });
    }

    var xPos = this.options.rightToLeft ? -this.model.bookW : 0;
    this.scroll.scrollTo(xPos, 0, 300);
};


FLIPBOOK.Book3.prototype.enable = function() {
    this.onResize();
    this.enabled = true;
};

FLIPBOOK.Book3.prototype.disable = function() {
    this.onResize();
    this.enabled = false;
};

FLIPBOOK.Book3.prototype.getLeftPage = function() {
    return this.pagesArr[this.flippedleft - 1]
};

FLIPBOOK.Book3.prototype.getRightPage = function() {
    return this.pagesArr[this.flippedleft]
};

FLIPBOOK.Book3.prototype.getLeftBackPage = function() {
    return this.pagesArr[this.flippedleft - 2]
};

FLIPBOOK.Book3.prototype.getRightBackPage = function() {
    return this.pagesArr[this.flippedleft + 1]
};

FLIPBOOK.Book3.prototype.getNextPage = function() {
    return this.pagesArr[this.flippedleft + 2]
};

FLIPBOOK.Book3.prototype.getPrevPage = function() {
    return this.pagesArr[this.flippedleft - 3]
};

FLIPBOOK.Book3.prototype.nextPage = function() {
    if (!this.nextEnabled) return

    if (this.view == 1 && this.isFocusedLeft() && !this.options.singlePageMode) {
        var duration = 700;
        var d = this.options.pageFlipDuration * duration / 2;
        this.focusRight(d);
        return
    }
    this.goToPage(this.rightIndex + 2);
};

FLIPBOOK.Book3.prototype.prevPage = function() {
    if (!this.prevEnabled) return

    if (this.view == 1 && this.isFocusedRight() && !this.options.singlePageMode) {
        var duration = 700;
        var d = this.options.pageFlipDuration * duration / 2;
        this.focusLeft(d);
        return
    }
    var target = this.options.singlePageMode ? this.rightIndex : this.rightIndex - 2;
    this.goToPage(target);
};

FLIPBOOK.Book3.prototype.goToPage = function(index, instant) {

    if (!this.enabled) return

    if (this.flipping)
        return;

    if (this.options.singlePageMode || index % 2 != 0) {
        index--;
    }

    if (index < 0)
        index = 0;

    if (index > this.pagesArr.length)
        index = this.pagesArr.length;

    if (index == this.rightIndex) {
        this.options.main.turnPageComplete();

        return;
    }
    if (instant || this.options.instantFlip) {
        this.flippedleft = index;
        this.flippedright = this.pagesArr.length - index;
        this.setRightIndex(index);
        this.updateVisiblePages();
        this.options.main.turnPageComplete();

        return;
    }

    this.flipping = true;
    // var easing = "easeInOutQuad"
    // var easing = "easeInOutCubic"
    var easing = this.flipEasing;
    // var easing = "easeInCubic"
    // var easing = "easeInOutSine"
    if (typeof jQuery.easing[easing] == 'undefined') {
        this.options.main.initEasing();
    }

    var duration = 700;
    var d = this.options.pageFlipDuration * duration;

    if (!this.options.singlePageMode) {

        if (this.view == 1) {
            if (index < this.rightIndex)
                this.focusRight(d);
            else
                this.focusLeft(d);
        } else {
            if (index == 0)
                this.focusRight(d);
            else if (index == this.pagesArr.length)
                this.focusLeft(d);
            else
                this.focusBoth(d);

        }
    }

    //if(this.singlePage)
    var self = this;
    this.goingToPage = index;

    if (index > this.rightIndex) {
        end = 180;
        if (self.angle <= 0 || self.angle >= 180 || !self.angle) self.angle = 1;
    } else if (index < this.rightIndex) {
        end = -180;
        if (self.angle >= 0 || self.angle <= -180 || !self.angle)
            self.angle = -1;
    }
    // d *= Math.abs(end - this.angle) / 180
    if (this.options.singlePageMode)
        d /= 2;
    jQuery({
        someValue: self.angle
    }).animate({
        someValue: end
    }, {
        duration: d,
        easing: easing, // can be anything
        step: function(now) {
            self._setPageAngle(now);
        },
        complete: function() {
            self.setRightIndex(index);
            self.flippedleft = index;
            self.flippedright = self.pagesArr.length - index;
            self.updateVisiblePages();
            self.angle = 0;
            self.flipping = false;

            self.options.main.turnPageComplete();
        }
    });



    self.options.main.playFlipSound();
};

FLIPBOOK.Book3.prototype.onSwipe = function(event, phase, direction, distance, duration, fingerCount, fingerData) {
    if (this.isZoomed())
        return;
    if (event.target.className == "flipbook-page-link")
        return;
    // if (jQuery(event.target).parents().hasClass('flipbook-page-htmlContent'))
    //     return;
    if (phase == 'start')
        return;
    if (direction == 'up' || direction == 'down')
        return


    // out because distance is already calculated correctly
    // distance = fingerData[0].start.x - fingerData[0].end.x

    if (this.flipping)
        return

    if (direction == "right")
        distance *= -1;

    // console.log(direction)
    var angle = distance * 180 / this.model.wrapperW;
    if (phase == 'cancel' && fingerCount <= 1) {

        if (angle > 0)
            this.nextPage();
        else if (angle < 0)
            this.prevPage();
    }

    if (phase == 'end' && fingerCount <= 1) {
        if (angle > 0)
            this.nextPage();
        else if (angle < 0)
            this.prevPage();
    }

    if (phase == 'move' && fingerCount <= 1) {
        if (angle > 0) {
            if (!this.nextEnabled)
                return
            if (this.options.singlePageMode) {
                if (this.rightIndex == (this.pagesArr.length - 1))
                    return
            }
            this.goingToPage = this.options.singlePageMode ? this.rightIndex + 1 : this.rightIndex + 2;
        } else if (angle < 0) {
            if (!this.prevEnabled)
                return
            this.goingToPage = this.options.singlePageMode ? this.rightIndex - 1 : this.rightIndex - 2;
        }
        if (this.goingToPage != this.rightIndex && this.goingToPage >= 0 && this.goingToPage <= this.pagesArr.length)
            if(!this.options.instantFlip)
                this._setPageAngle(angle);

    }

};

FLIPBOOK.Book3.prototype.hideHtml = function(style, name, value) {

    for (i = 0; i < this.pagesArr.length; i++) {
        this.pagesArr[i].hideHtml();
    }

};

FLIPBOOK.Book3.prototype._setStyle = function(style, name, value) {
    // console.log(value)

    if (style) {
        // console.log(name)
        // console.log(value)
        style[name] = value;
    }

};

FLIPBOOK.Book3.prototype._setPageAngle = function(angle) {

    var prev, next, front, back;
    this.angle = angle;
    this.hideHtml();
    if (this.options.singlePageMode) {
        if (angle > 0) {
            front = this.pagesArr[this.rightIndex];
            front._setAngle(angle / 2);
            next = this.pagesArr[this.goingToPage];
            // front.shadow.style.opacity = (angle - 30) / 900
            if (next) {
                next.show();
                // next.shadow.style.opacity = 1 - (angle) / 90
            }
        } else {
            back = this.pagesArr[this.goingToPage];
            back.show();
            back._setAngle(angle / 2 + 90);
            // back.shadow.style.opacity = (180 + angle - 30) / 900
            front = this.pagesArr[this.rightIndex];
            // front.shadow.style.opacity = 1 - (180 + angle) / 90
        }
        return;
    }

    // console.log(angle)

    if (angle > 0) {
        if (this.view == 1 && this.isFocusedLeft())
            return
        //flipping from right to left
        // angle 0 -> 180
        front = this.pagesArr[this.rightIndex];
        back = this.pagesArr[this.goingToPage - 1];
        this.applyAngles(front, back, angle, 90, 0);
        next = this.pagesArr[back.index + 1];

        front.setShadowOpacity((angle - 10) / 600);
        back.setShadowOpacity((180 - angle - 10) / 600);
        // front.shadow.style.opacity = (angle - 10) / 600
        // back.shadow.style.opacity = (180 - angle - 10) / 600

        // console.log(angle)
        if (next) {
            next.show();
            // next.shadow.style.opacity = 1 - angle * 3 / 180
            // next.shadow.style.opacity = (90-angle) / 200
        }
        // prev = this.pagesArr[this.goingToPage - 3]
        // console.log(angle)
        // if(prev)
        //     prev.shadow.style.opacity = (angle - 90) / 200

        /*  var transform = FLIPBOOK.IScroll.utils.style.transform
          var pos
          var progress = angle / 180

          if (this.isCover())
              pos = -this.pageWidth / 2 + progress * this.options.pageWidth / 2

          if (this.view == 1 || !next)
              pos = progress * this.options.pageWidth / 2

          this.setBookPosition(pos)*/
        // if (newX)
        // this._setStyle(this.centerContainerStyle, transform, 'translateX(' + newX + 'px)')


    } else {
        if (this.view == 1 && this.isFocusedRight())
            return
        //flipping from left to right
        //angle 0 -> -180
        back = this.pagesArr[this.rightIndex - 1];
        front = this.pagesArr[this.goingToPage];
        this.applyAngles(front, back, angle, -90, 180);

        // back.shadow.style.opacity = (-angle - 10) / 600
        // front.shadow.style.opacity = (180 + angle - 10) / 600

        front.setShadowOpacity((180 + angle - 10) / 600);
        back.setShadowOpacity((-angle - 10) / 600);

        prev = this.pagesArr[this.goingToPage - 1];
        // console.log(angle)
        if (prev) {
            prev.show();
            // prev.shadow.style.opacity = 1 - (180 + angle ) / 90
            // prev.shadow.style.opacity = (90+angle) / 200
        }
        // next = this.pagesArr[this.goingToPage + 2]
        // if(next)
        //     next.shadow.style.opacity = (-angle-90) / 200
        /*    var transform = FLIPBOOK.IScroll.utils.style.transform
                var pos
                var progress = -angle / 180
                if (this.isBackCover())
                    pos = this.pageWidth / 2 - progress * this.pageWidth / 2

                if (!prev)
                    pos = -progress * this.pageWidth / 2

                if (this.view == 1)
                    pos = -this.pageWidth - progress * this.pageWidth

                if (pos)
                    this.setBookPosition(pos)*/
    }

    // console.log(angle)

    // if (prev) {
    //         prev.$shadow.css('opacity', 1+angle / 180)
    //     }
    //     if (next) {
    //         next.$shadow.css('opacity', 1-angle / 180)
    //     }
    // console.log(front,back,angle)
};

FLIPBOOK.Book3.prototype.isCover = function() {
    return this.rightIndex == 0
};

FLIPBOOK.Book3.prototype.isBackCover = function() {
    return this.rightIndex == this.pagesArr.length
};


FLIPBOOK.Book3.prototype.applyAngles = function(front, back, angle, x, y) {

    if (angle < x) {
        if (front) {
            front.show();
            front._setAngle(angle + y);
        }
        if (back) {
            back.hide();
            back._setAngle(45);
        }
    } else {
        if (back) {
            back.show();
            back._setAngle(angle + y);
        }
        if (front) {
            front.hide();
            front._setAngle(45);
        }
    }
};

FLIPBOOK.Book3.prototype.onPageUnloaded = function(index, size) {

    var pageIndex = index;

    if (this.options.rightToLeft)
        pageIndex = this.options.pages.length - index - 1;

    if(this.pagesArr[pageIndex])
        this.pagesArr[pageIndex].unload();

};

FLIPBOOK.Book3.prototype.onResize = function() {

    var model = this.model,
        w = model.wrapperW,
        h = model.wrapperH,
        bw = model.bookW,
        bh = model.bookH,
        pw = model.pageW,
        ph = model.pageH,
        r1 = w / h,
        r2 = pw / ph;

    var main = this.options.main;
    var options = this.options;

    var self = this;

    function fitToHeight() {
        // console.log('fit to height')

        self.ratio = h / bh;
        fit();

    }

    function fitToWidth() {
        // console.log('fit to width')

        self.ratio = self.view == 1 ? w / pw : w / bw;
        fit();

    }

    function fit() {

        if (self.scroll)
            self.scroll.options.zoomMin = self.ratio * options.zoomMin;
        if (self.scroll)
            self.scroll.options.zoomMax = self.ratio * options.zoomMax;

        self.updateBookPosition();
        if (self.scroll)
            self.scroll.zoom(self.ratio * options.main.zoom, w / 2, h / 2, 0);

    }

    var s = Math.min(this.zoom, 1);

    var zoomMin = Number(this.options.zoomMin);

    // var sp = 1

    if (this.options.responsiveView && w <= this.options.responsiveViewTreshold && r1 < 2 * r2) {

        this.view = 1;

        if (w / h > pw / ph)
            fitToHeight();
        else
            fitToWidth();


    } else {

        this.view = 2;

        if (w / h >= bw / bh)
            fitToHeight();
        else
            fitToWidth();


    }

    this.updateBookPosition();

};

FLIPBOOK.Book3.prototype.isFocusedRight = function() {

    var center = this.view == 1 ? -this.pageWidth / 2 : 0;

    return this.centerContainerPosition < center

};

FLIPBOOK.Book3.prototype.isFocusedLeft = function() {

    var center = this.view == 1 ? -this.pageWidth / 2 : 0;

    return this.centerContainerPosition > center

};

FLIPBOOK.Page3 = function(book, index, texture, html) {

    this.book = book;
    this.options = book.options;
    this.texture = texture;
    this.html = html;
    this.index = index;
    this.$wrapper = jQuery('<div>').addClass('flipbook-page3').width(book.options.pageWidth).height(book.options.pageHeight);
    this.wrapper = this.$wrapper[0];

    this.htmlContentScale = this.book.$wrapper.height() / 1000;

    var options = book.options;

    this.$inner = jQuery('<div>').appendTo(this.$wrapper).addClass('flipbook-page3-inner');
    this.$bg = jQuery('<div>').appendTo(this.$inner).addClass('flipbook-page3-bg');
    this.$html = jQuery('<div>').appendTo(this.$inner).addClass('flipbook-page3-html').addClass('page_'+index);

    this.$shadow = jQuery('<div>')
        .appendTo(this.$wrapper)
        .addClass('flipbook-page3-shadow');

    if (options.pagePreloader)
        this.$preloader = jQuery('<img src="' + options.pagePreloader + '" class="flipbook-page-preloader-image">').appendTo(this.$wrapper);
    else
        this.$preloader = jQuery('<img src="' + options.assets.spinner + '" class="flipbook-page-preloader">').appendTo(this.$wrapper);

    this.shadow = this.$shadow[0];
    this.hidden = false;
    this.hide();
    this.zIndex = 0;
    if (this.options.singlePageMode) {
        this.$wrapper.addClass('flipbook-page3-front');
        this.type = "front";
    } else if (index % 2 == 0) {
        this.$wrapper.css('left', String(this.book.options.pageWidth - 1) + 'px').addClass('flipbook-page3-front');
        this.type = "front";
    } else {
        this.$wrapper.addClass('flipbook-page3-back');
        this.type = 'back';
    }


};

FLIPBOOK.Page3.prototype = {

    load: function(callback) {
        if (this.loaded == true) {
            if (callback) callback.call(this);
            return
        }

        this.loaded = true;

        var self = this;

        var index = self.options.rightToLeft ? this.book.pagesArr.length - this.index - 1 : this.index;

        this.options.main.loadPageHTML(index, function(c) {

            //if (h && (!self.options.doublePage || self.index == 0 || self.index % 2 != 0)) {
            if(c){
                self.$html.empty().append(jQuery(c));
                // jQuery(c).appendTo(self.$html)

                // jQuery('<div>ttt</div>').appendTo(self.$html)
                // jQuery(document.body).append(jQuery(c))
                self.$html[0].style.transform = 'scale(' + self.htmlContentScale + ') translateZ(0)';
            }

            if (self.options.doublePage) {

                if (self.index % 2 == 0 && self.index > 0)
                    self.$html[0].style.left = '-100%';
                // else
                //     self.$html[0].style.left = '0'

            }

            if (self.hidden)
                self.hideHtml();

        });

        this.options.main.loadPage(index, this.options.pageTextureSize, function(page) {

            if(page.image){

                // var img = document.createElement('img')
                // img.src = page.image.src

                var img = page.image;

                var imgW = page.image.naturalHeight;
                var imgH = page.image.naturalHeight;
                var pw = self.options.pageWidth;
                var ph = self.options.pageHeight;

                if(self.options.pages[page.index].side == 'left' || self.options.pages[page.index].side == 'right'){
                    if(self.index % 2 == 0)
                        jQuery(img).css(FLIPBOOK.IScroll.utils.style.transform, 'translateX(-50%) translateZ(0)');

                }

                self.$bg.empty().append(jQuery(img));

                self.$preloader.hide();


            }

            if(page.canvas && self.pageSize != page.size){

                self.pageSize = page.size;
                self.$bg.empty();

                if (self.options.doublePage && self.index % 2 == 0 && self.index != 0) {
                    jQuery(page.rCanvas).appendTo(self.$bg);
                } else if(self.options.doublePage && self.index % 2 == 1 && self.index != (self.options.pages.length - 1)){
                    jQuery(page.lCanvas).appendTo(self.$bg);
                } else
                    jQuery(page.canvas).appendTo(self.$bg);

                self.$preloader.hide();

            }

            if (callback) callback.call(self);

        });

    },

    unload: function() {

        this.loaded = false;
        this.mat = false;
        this.pageSize = null;
        // this.$wrapper.css('background', '#eee')

    },

    setMat: function(c, h, front) {



    },

    hideHtml: function() {

        if (this.$html && !this.htmlHidden) {
            this.$html.hide();
            // console.log("hide html "+this.index)
        }
        this.htmlHidden = true;
    },

    showHtml: function() {
        if (this.$html && this.htmlHidden) {
            this.$html.show();
            // console.log("show html "+this.index)
        }
        this.htmlHidden = false;
    },

    setDataUrl: function(dataUrl, h) {

        var self = this;

        this.$img.attr('src', dataUrl);
        this.$img[0].onload = function() {
            self.$wrapper.css({ 'background': 'none' });

        };
        if (self.html)
            jQuery(self.html).appendTo(self.$inner);

    },

    show: function() {
        if (this.hidden) {
            this.$wrapper[0].style.display = 'block';
            // this.shadow.style.opacity = '0'
            this.setShadowOpacity(0);

            // console.log("show "+this.index)
        }
        this.hidden = false;
    },

    setShadowOpacity: function(val) {
        this.shadow.style.opacity = val;
    },

    hide: function() {
        if (!this.hidden) {
            this.$wrapper[0].style.display = 'none';
            // this.shadow.style.opacity = '0'
            this.setShadowOpacity(0);

            // console.log("hide "+this.index)
        }

        this.hidden = true;


    },

    _setScale: function(value) {
        if (this.scale != value) {
            var transform = FLIPBOOK.IScroll.utils.style.transform;
            var transformStyle = 'scaleX(' + String(value) + ') translateZ(0)';
            this.scale = value;
            this._setStyle(transform, transformStyle);
        }
    },

    _setAngle: function(angle) {

        if (this.angle == angle) return;
        this.angle = angle;
        var transform = FLIPBOOK.IScroll.utils.style.transform;
        var transformStyle;
        var suffix = 'translateZ(0)';
        if (this.book.options.viewMode == "3d") {
            if (this.type == 'front') {
                transformStyle = 'rotateY(' + String(-angle) + 'deg) ' + suffix;
            } else {
                transformStyle = 'rotateY(' + String(180 - angle) + 'deg) ' + suffix;
            }
        } else if (this.book.options.viewMode == "2d") {
            if (this.type == 'front') {
                if (angle > 90) angle = 90;
                transformStyle = 'scaleX(' + String((180 - 2 * angle) / 180) + ') ' + suffix;
            } else {
                if (angle < 90) angle = 90;
                transformStyle = 'scaleX(' + String(-1 + (2 * angle) / 180) + ') ' + suffix;
            }
        }

        this._setStyle(this.wrapper.style, transform, transformStyle);
        var i;
        var max = 0;
        for (i = 0; i < this.book.pagesArr.length; i++) {
            if (i != this.index && this.book.pagesArr[i].zIndex > max)
                max = this.book.pagesArr[i].zIndex;
        }
        this._setZIndex(max + 1);
    },

    _setZIndex: function(val) {
        if (this.zIndex != val)
            this.wrapper.style['z-index'] = val;
        this.zIndex = val;
    },

    _setStyle: function(style, name, value) {

        if (style)
            style[name] = value;
    }

};

/* v 3.9.2
author http://codecanyon.net/user/creativeinteractivemedia/portfolio?ref=creativeinteractivemedia
*/

// var FLIPBOOK = FLIPBOOK || {};

FLIPBOOK.BookSwipe = function(el, wrapper, model, options) {

    this.options = options;
    this.singlePage = options.singlePageMode;
    this.pageWidth = this.options.pageWidth;
    this.pageHeight = this.options.pageHeight;
    this.slides = [];
    this.pagesArr = [];
    this.leftPage = 0;
    this.rightPage = 0;
    this.rotation = 0;

    this.prevPageEnabled = false;

    this.setRightIndex(options.rightToLeft ? options.pages.length : 0);
    this.currentSlide = 0;
    this.flipping = false;

    this.wrapper = wrapper;

    this.$wrapper = jQuery(wrapper);

    this.scroller = el;
    this.$scroller = jQuery(this.scroller).removeClass('book').addClass('flipbook-carousel-scroller');

    this.iscroll = new IScroll(this.wrapper, {

        // momentum: true,
        snap: true,
        snapSpeed: 200 * this.options.pageFlipDuration,
        // snapSpeed: 500,
        // keyBindings: false,
        // hScrollbar: false
        // zoom: true,
        // mouseWheel: true,
        // wheelAction: 'zoom',

        freeScroll: true,

        scrollX: true,
        scrollY: false,

        // preventDefault: true,
        preventDefault: false,

        // disableTouch:true,
        eventPassthrough  : 'vertical'

        // HWCompositing:false,

        // mouseWheel: true,
        // wheelAction: 'zoom',
        // scrollbars: true
    });


    for (var i = 0; i < 3; i++) {

        var $slide = jQuery('<div class="flipbook-carousel-slide"><div class="slide-inner"/></div>"').appendTo(this.$scroller);
        this.slides.push($slide);

    }

    this.slides[0].iscroll = new IScroll(this.slides[0][0], {
          // scrollbars: true,
        zoom: true,
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        keepInCenterV: true,
        keepInCenterH: true,
        preventDefault: false,
    });

    // this.slides[0].iscroll.refresh()

    this.slides[2].iscroll = new IScroll(this.slides[2][0], {
          // scrollbars: true,
        zoom: true,
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        keepInCenterV: true,
        keepInCenterH: true,
        preventDefault: false,
    });

    // this.slides[2].iscroll.refresh()


    this.slides[1].iscroll = new IScroll(this.slides[1][0], {
        // scrollbars: true,
        zoom: true,
        scrollX: true,
        scrollY: true,
        freeScroll: true,
        keepInCenterV: true,
        keepInCenterH: true,
        // scrollbars: false,
        preventDefault: false,
        // preventDefault: true,
        // HWCompositing:false,
    });

    // this.slides[1].iscroll.refresh()

    for (var i = 0; i < 3; i++) {

        this.slides[i].iscroll.on("zoomEnd", function() {

            var scale = options.main.zoom;
            this.options.eventPassthrough = scale > 1 ? '' : 'vertical';
            this.options.freeScroll = scale > 1;
            this.refresh();

        });

    }


    this.resizeInnerSlides();

    var page;

    var pageOptions = {
        rightToLeft: options.rightToLeft,
        numPages: options.numPages,
        pdfMode: options.pdfMode
    };

    for (var i = 0; i < options.numPages; i++) {

        page = new FLIPBOOK.PageSwipe(model, options, i, options.pages[i].src, options.pages[i].htmlContent);

        this.pagesArr.push(page);

        if (options.loadAllPages)
            page.load();
    }

    var self = this;

    this.iscroll.on("scrollStart", function() {

        return
    });

    this.iscroll.on("scrollEnd", function() {

        var sliderPage = this.currentPage.pageX;

        if(self.currentSlide == sliderPage)
            return

        if (self.singlePage) {

            if (sliderPage > self.currentSlide)

                self.setRightIndex(self.rightIndex + 1);

            else if (sliderPage < self.currentSlide)

                self.setRightIndex(self.rightIndex - 1);

        } else {

            if (sliderPage > self.currentSlide)

                self.setRightIndex(self.rightIndex + 2);

            else if (sliderPage < self.currentSlide)

                self.setRightIndex(self.rightIndex - 2);
        }

        self.currentSlide = sliderPage;

        self.updateVisiblePages();

        self.flipping = false;

    });

    this.flipEnabled = true;

    this.nextEnabled = true;
    this.prevEnabled = true;

    model.on("toolMove", function() {
        self.updateTool();
    });

    model.on("toolSelect", function() {
        self.updateTool();
    });

    model.on('pageLoaded', function(e){

    });

};

FLIPBOOK.BookSwipe.prototype.constructor = FLIPBOOK.BookSwipe;

FLIPBOOK.BookSwipe.prototype = {

    goToPage: function(value, instant) {

        if (!this.enabled)
            return

        if (!this.flipEnabled) return

        if (value > this.options.pages.length)
            value = this.options.pages.length;

        if (this.singlePage || value % 2 != 0)
            value--;

        if (isNaN(value) || value < 0)
            value = 0;

        this.resetZoom();

        if (instant) {
            this.setRightIndex(value);
            this.updateVisiblePages();
            return
        }


        if (this.singlePage) {

            if (this.options.rightToLeft && this.options.oddPages && value < 1)
                value = 1;

            if (value > this.rightIndex) {

                this.setSlidePages(this.currentSlide + 1, [value]);
                this.setRightIndex(value - 1);
                this.nextPage(instant);

            } else if (value < this.rightIndex) {

                this.setSlidePages(this.currentSlide - 1, [value]);
                this.setRightIndex(value + 1);
                this.prevPage(instant);

            }

        } else {

            if (this.options.rightToLeft && this.options.oddPages && value < 2)
                value = 2;

            if (value > this.rightIndex) {

                if (value >= this.pagesArr.length) {

                    this.setSlidePages(2, [value - 1, value]);
                    this.setRightIndex(value - 2);
                    this.goToSlide(2, instant);

                } else {

                    this.setSlidePages(this.currentSlide + 1, [value - 1, value]);
                    this.setRightIndex(value - 2);
                    this.nextPage(instant);

                }

            } else if (value < this.rightIndex) {

                if (value == 0) {

                    this.setRightIndex(value + 2);
                    this.setSlidePages(0, [value]);
                    this.goToSlide(0, instant);

                } else {

                    this.setRightIndex(value + 2);
                    this.setSlidePages(this.currentSlide - 1, [value - 1, value]);
                    this.prevPage(instant);

                }

            }
        }

    },

    setRightIndex: function(value) {

        this.rightIndex = value;

    },

    nextPage: function(instant) {

       // if (!this.flipEnabled) return

        /*if (this.flipping)
            return;*/

        if (this.currentSlide == 2)
            return

        this.flipping = true;

        this.goToSlide(this.currentSlide + 1, instant);

        /*if(this.mode == 1)
            this.rightIndex++;*/

    },

    prevPage: function(instant) {

      //  if (!this.flipEnabled) return

        /*if (this.flipping)
            return;*/

        if (this.currentSlide == 0)
            return;

        this.flipping = true;

        this.goToSlide(this.currentSlide - 1, instant);

        /*if(this.mode == 1)
            this.rightIndex--;*/

    },

    enablePrev: function(val) {

        this.prevEnabled = val;

    },

    enableNext: function(val) {

        this.nextEnabled = val;

    },

    // onPageUnloaded:function(index,size){

    //     var pageIndex = index

    //     if (this.options.rightToLeft)
    //         pageIndex = this.options.pages.length - index - 1

    //     this.pagesArr[pageIndex].unload()

    // },

    resetZoom: function() {

        return
    },

    setSlidePages: function(slide, pages) {

        var arr = [];
        for (var i = 0; i < pages.length; i++) {
            if (pages[i])
                arr.push(pages[i].index);
        }

       // console.log(slide,pages)

        if (this.slides[slide].pages) {

            if (arr.join("") === this.slides[slide].pages.join("")){
                // console.log(arr)
                // console.log(this.slides[slide].pages)
                return
            }

        }

        /*if(this.slides[slide].pages && (this.slides[slide].pages.join("") == pages.join("")))
            return;*/

        this.clearSlidePages(slide);

        var slideInner = this.slides[slide].find('.slide-inner');

        // slideInner.width(2 * this.options.pageTextureSize * this.options.pageWidth / this.options.pageHeight)

        for (var i = 0; i < pages.length; i++) {

            var pageIndex = pages[i].index;

            // console.log("setSlidePages slide:"+slide+" pageIndex:"+pageIndex)

            if (this.pagesArr[pageIndex]) {

                slideInner.append(this.pagesArr[pageIndex].$wrapper);
                this.slides[slide].pages.push(pageIndex);

            }

        }

        this.resizeInnerSlides();

        if (this.slides[slide].iscroll)
            this.slides[slide].iscroll.refresh();

        // this.zoomTo(.25)
        // this.slides[slide].iscroll.refresh()

        // this.slides[slide].iscroll.zoom(.1, 0, 0, 0);

        // this.slides[slide].show()

    },

    updateTool: function() {

        switch (this.options.main.tool) {

            case "toolSelect":
                this.disableFlip();
                this.disablePan();
                jQuery(".flipbook-textLayer").css("pointer-events", "auto").removeClass(".flipbook-noselect");
                break;

            case "toolMove":
                this.onZoom(this.options.main.zoom);
                jQuery(".flipbook-textLayer").css("pointer-events", "none").addClass(".flipbook-noselect");
                break;
        }

    },

    clearSlidePages: function(slide) {

        this.slides[slide].find('.slide-inner').empty();
        this.slides[slide].pages = [];

        // var test = jQuery("<p>SLIDE</p>")

        // this.slides[slide].find('.slide-inner').append(test)
        // this.slides[slide].hide()

    },

    setZoomPages: function(pages) {

        if (this.$zoomScroller.pages && (this.$zoomScroller.pages.join("") == pages.join("")))
            return;

        this.$zoomScroller.empty();
        this.$zoomScroller.pages = [];

        for (var i = 0; i < pages.length; i++) {

            var pageIndex = pages[i];

            if (this.pagesArr[pageIndex]) {

                this.$zoomScroller.append(this.pagesArr[pageIndex].$wrapper);
                this.$zoomScroller.pages.push(pageIndex);

            }

        }
    },

    resizeZoomPages: function(pages, scale) {

        var h = this.$wrapper.height() * scale;

        // this.options.pageTextureSize = pdfSize

        for (var i = 0; i < pages.length; i++) {

            var pageIndex = pages[i];

            if (this.pagesArr[pageIndex]) {
                /*this.pagesArr[pageIndex].$wrapper.height(this.zoomScroll.scrollerHeight)
                this.pagesArr[pageIndex].$wrapper.width(this.zoomScroll.scrollerWidth/2)*/
                //this.pagesArr[pageIndex].pageTextureSize = pdfSize
                this.pagesArr[pageIndex].load();

            }

        }
    },

    getCurrentSlidePages: function() {

        if (this.singlePage)

            return [this.rightIndex];

        else
            return [this.rightIndex - 1, this.rightIndex];


    },

    clearSlide: function(slide) {

        this.slides[slide].empty();

    },

    hasPage: function(slide, page) {


    },

    loadVisiblePages: function() {
        var main = this.options.main;

        var index = this.rightIndex;

        if(this.options.rightToLeft && this.options.oddPages) index--;

        var right = this.pagesArr[index];
        var left = this.pagesArr[index - 1];
        var next = this.pagesArr[index + 1];
        var afterNext = this.pagesArr[index + 2];
        var prev = this.pagesArr[index - 2];
        var beforePrev = this.pagesArr[index - 3];

        if(this.singlePage){

            if(right){

                right.load(function() {

                    main.setLoadingProgress(1);
                    if (left) left.load();
                    if (next) next.load();

                });

            }else if(left){
                left.load();
            }



        }else {
            if (left) {

                left.load(function() {

                    if (right) {
                        right.load(function() {

                            main.setLoadingProgress(1);
                            if (prev) prev.load();
                            if (beforePrev) beforePrev.load();
                            if (next) next.load();
                            if (afterNext) afterNext.load();

                        });
                    } else {

                        main.setLoadingProgress(1);
                        if (prev) prev.load();

                        if (beforePrev) beforePrev.load();
                    }

                });
            } else {

                if (right) {

                    right.load(function() {

                        main.setLoadingProgress(1);
                        if (next) next.load();
                        if (afterNext) afterNext.load();

                    });
                }

            }
        }

    },

    updateVisiblePages: function() {
        var main = this.options.main;

        var index = this.rightIndex;

        if(this.options.rightToLeft && this.options.oddPages) index--;

        var right = this.pagesArr[index];
        var left = this.pagesArr[index - 1];
        var next = this.pagesArr[index + 1];
        var afterNext = this.pagesArr[index + 2];
        var prev = this.pagesArr[index - 2];
        var beforePrev = this.pagesArr[index - 3];

        if (this.singlePage) {

           if(!left){
                //cover
                this.setSlidePages(0, [right]);

                if(next)
                    this.setSlidePages(1, [next]);
                else
                    this.clearSlidePages(1);
                this.goToSlide(0,true);

                this.clearSlidePages(2);

            }else {

               if(next){

                    this.setSlidePages(1, [right]);
                    if(left) this.setSlidePages(0, [left]);
                    this.setSlidePages(2, [next]);
                    this.goToSlide(1,true);

               }else {
                    if(right) this.setSlidePages(2, [right]);
                    if(left) this.setSlidePages(1, [left]);
                    this.goToSlide(2,true);

                    this.clearSlidePages(0);

               }

            }


        } else {

            if(!left){
                //cover
                this.setSlidePages(0, [right]);

                if(afterNext)
                    this.setSlidePages(1, [next, afterNext]);
                else
                    this.setSlidePages(1, [next]);

                this.goToSlide(0,true);

                this.clearSlidePages(2);

            }else {

                if(right){

                    //L R

                    if(!next){

                        this.setSlidePages(2, [left, right]);

                        if(beforePrev)
                            this.setSlidePages(1, [beforePrev, prev]);
                        else
                            this.setSlidePages(1, [prev]);

                        this.goToSlide(2,true);

                        this.clearSlidePages(0);

                    }else {

                        if(prev){

                            this.setSlidePages(1, [left, right]);

                            if(beforePrev)
                                this.setSlidePages(0, [beforePrev, prev]);
                            else
                                this.setSlidePages(0, [prev]);

                           if(afterNext)
                            this.setSlidePages(2, [next, afterNext]);
                        else
                            this.setSlidePages(2, [next]);

                            this.goToSlide(1,true);

                        }else {
                            this.setSlidePages(0, [left, right]);

                            if(afterNext)
                            this.setSlidePages(1, [next, afterNext]);
                        else
                            this.setSlidePages(1, [next]);

                            this.clearSlidePages(2);
                        }





                    }

                }else {
                    this.setSlidePages(2, [left]);

                    if(beforePrev)
                        this.setSlidePages(1, [beforePrev, prev]);
                    else
                        this.setSlidePages(1, [prev]);

                    this.goToSlide(2,true);
                    this.clearSlidePages(0);

                }
            }

        }

        this.loadVisiblePages();

        this.options.main.turnPageComplete();

    },

    loadPage: function(index) {

        if (this.pagesArr[index])
            this.pagesArr[index].load();

    },

    hidePage: function(index) {

    },

    showPage: function(index) {

    },

    disable: function() {

        this.enabled = false;

    },

    enable: function() {

        this.enabled = true;
        this.onResize();

    },

    resize: function() {

    },

    onResize: function() {

        var w = this.$wrapper.width();
        var h = this.$wrapper.height();
        this.w = w;
        this.h = h;

        if (w == 0 || h == 0) return;

        var pw = this.pageWidth;
        var ph = this.pageHeight;

        var portrait = 2 * this.options.zoomMin * pw / ph > w / h;
        var doublePage = !this.options.singlePageMode && (!this.options.responsiveView || (w > this.options.responsiveViewTreshold || !portrait));
         //console.log("doublePage:", doublePage)
        var bw = doublePage ? 2*pw : pw;
        var bh = ph;
        this.bw = bw;
        this.bh = bh;

        var scale;
        if (h / w > bh / bw) {
            //fit to width
            scale = (bh / bw) * w / this.options.pageTextureSize;
        } else {
            scale = h / this.options.pageTextureSize;
        }

        var spaceBetweenSlides = 0;

        for (var i = 0; i < this.slides.length; i++) {

            this.slides[i].width(w + spaceBetweenSlides).height(h);
            this.slides[i].css("left", Number(i * w + i * spaceBetweenSlides) + "px").height(h);

            if (this.slides[i].iscroll) {

                this.slides[i].iscroll.options.zoomMin = this.options.zoomMin * scale;
                this.slides[i].iscroll.options.zoomMax = this.options.zoomMax * scale;
                this.slides[i].iscroll.refresh();
            }

        }

        this.$scroller.width(this.$scroller.children().length * (w+spaceBetweenSlides));
        this.iscroll.refresh();

        //var portrait = bw / bh > w / h && w < this.options.responsiveViewTreshold && this.options.responsiveView
        // var portrait = 2 * this.options.zoomMin * this.pageWidth / this.pageHeight > w / h
        // var pw, ph

        // if (portrait) {
        //     pw = w
        //     ph = parseInt(w * this.pageHeight / this.pageWidth)
        // } else {
        //     ph = h
        //     pw = parseInt(h * this.pageWidth / this.pageHeight)
        // }

        if ((!doublePage || this.options.singlePageMode) && !this.singlePage) {

            // console.log("single page mode")

            if (this.rightIndex % 2 == 0 && this.rightIndex > 0)
                this.setRightIndex(this.rightIndex - 1);

            this.singlePage = true;

            this.resizeInnerSlides();

        } else if (doublePage && !this.options.singlePageMode && this.singlePage) {

            // console.log("double page mode")


            if (this.rightIndex % 2 != 0)
                this.setRightIndex(this.rightIndex + 1);

            this.singlePage = false;

            this.resizeInnerSlides();

        }

        this.updateVisiblePages();


    },

    resizeInnerSlides: function() {
        var pw = this.options.pageTextureSize * this.pageWidth / this.pageHeight;

        if(this.rotation == 90 || this.rotation == 270)
            pw = this.options.pageTextureSize * this.pageHeight / this.pageWidth;

        var sw = this.singlePage ? pw : 2 * pw;

        // debugger
        for (var i = 0; i < 3; i++) {
            sw = this.slides[i].pages && this.slides[i].pages.length == 1 ? pw : 2 * pw;
            this.slides[i].find(".slide-inner").width(sw);
        }
    },

    resizeInnerSlide: function(slide) {

        var pw = this.options.pageTextureSize * this.pageWidth / this.pageHeight;

        if (this.slides[slide].pages.length == 1)
            this.slides[slide].find(".slide-inner").width(pw);
        else
            this.slides[slide].find(".slide-inner").width(pw);

    },


    goToSlide: function(slideIndex, instant) {

        var time = instant ? 0 : 300 * this.options.pageFlipDuration;
        var slide = this.slides[slideIndex];

        if(slide.pages && slide.pages[0])
            this.pagesArr[slide.pages[0]].updateHtmlContent();

        if (this.iscroll.pages.length > 0)
            this.iscroll.goToPage(slideIndex, 0, time);

        if (instant)
            this.currentSlide = slideIndex;

        this.zoomTo(this.options.zoomMin);

    },

    getCurrentSlide: function() {

        return this.currentSlide

    },

    zoomIn: function(value, time, e) {

        if (e && e.type === 'mousewheel')
            return
        this.zoomTo(value);

    },

    zoomTo: function(zoom, time, x, y) {

        if (!this.enabled)
            return

        var x = x || 0;
        var y = y || 0;
        var time = time || 0;

        if (zoom > 1) {
            this.disableFlip();
        }

        if (w == 0 || h == 0) return;

        var w = this.w;
        var h = this.h;
        var pw = this.pageWidth;
        var ph = this.pageHeight;
        var bw = this.bw;
        var bh = this.bh;

        var scale;
        if (h / w > bh / bw) {
            //fit to width
            scale = (bh / bw) * zoom * w / this.options.pageTextureSize;
        } else {
            scale = zoom * h / this.options.pageTextureSize;
        }

        //var scale = zoom * this.$wrapper.height() / this.options.pageTextureSize

        // console.log(zoom)

        time = 0;

        for (var i = 0; i < 3; i++) {

            if (this.slides[i].iscroll){

                if(scale < this.slides[i].iscroll.options.zoomMin) scale = this.slides[i].iscroll.options.zoomMin;

                this.slides[i].iscroll.zoom(scale, x, y, time);

            }

        }

        this.onZoom(zoom);

        this.loadVisiblePages();

        // if (this.slides[this.currentSlide].iscroll)
        //     this.slides[this.currentSlide].iscroll.zoom(zoom, x, y, time);


    },

    zoomOut: function(value) {

        this.zoomTo(value);

    },

    onZoom: function(zoom) {
        // debugger
        // console.log("on zoom : ",zoom)
        if(this.options.main.tool == "toolSelect"){
            this.disableFlip();
            this.disablePan();
        } else if (zoom > 1) {
            this.disableFlip();
            this.enablePan();
        } else {
            this.enableFlip();
            // this.disablePan()
        }

        this.options.main.onZoom(zoom);

    },

    rotateLeft:function(){

        this.rotation = (this.rotation + 360 - 90)%360;

        for (var i = 0; i < this.pagesArr.length; i++) {
            var page = this.pagesArr[i];
            page.setRotation(this.rotation);
        }

        this.resizeInnerSlides();
        this.onResize();
        console.log(this.rotation);

    },

    rotateRight:function(){

        this.rotation = (this.rotation + 360 + 90)%360;

        for (var i = 0; i < this.pagesArr.length; i++) {
            var page = this.pagesArr[i];
            page.setRotation(this.rotation);
        }

        this.resizeInnerSlides();
        this.onResize();
        console.log(this.rotation);

    },

    enableAutoplay: function(val) {

        // this.main.enableAutoplay(val)

    },

    updateCurrentPage: function(val) {


    },

    enable: function() {
        this.enabled = true;
    },

    disable: function() {
        this.enabled = false;
    },

    onSwipe: function(event, phase, direction, distance, duration, fingerCount, fingerData) {
        //console.log(event, phase, direction, distance, duration, fingerCount, fingerData)
        /*if(e.type == 'touchend' && !direction)
            this.main.toggleMenu()*/

        if (phase == 'start')
            return;
        if (direction == 'up' || direction == 'down')
            return


        // if(fingerCount > 1){
        //     this.disablePan()
        // }
    },

    onPageUnloaded: function(i, size) {

        var index = this.options.rightToLeft ? this.options.numPages - i - 1 : i;

        // this.pagesArr[index].onPageUnloaded(size)
        this.pagesArr[index].unload();
    },

    disableFlip: function() {

        this.flipEnabled = false;
        this.iscroll.disable();
    },

    enableFlip: function() {

        if(this.options.numPages == 1){
            this.disableFlip();
            return
        }

        this.flipEnabled = true;
        this.iscroll.enable();
    },

    enablePan: function() {

        if (this.slides[0].iscroll)
            this.slides[0].iscroll.enable();
        if (this.slides[1].iscroll)
            this.slides[1].iscroll.enable();
        if (this.slides[2].iscroll)
            this.slides[2].iscroll.enable();
    },

    disablePan: function() {

        if (this.slides[0].iscroll)
            this.slides[0].iscroll.disable();
        if (this.slides[1].iscroll)
            this.slides[1].iscroll.disable();
        if (this.slides[2].iscroll)
            this.slides[2].iscroll.disable();
    }

};

FLIPBOOK.PageSwipe = function(model, options, index, texture, html) {

    this.rotation = 0;
    this.index = index;
    this.options = options;
    this.texture = texture;
    this.html = html;
    this.index = index;
    this.$wrapper = jQuery('<div>').addClass('flipbook-carousel-page');
    this.wrapper = this.$wrapper[0];
    this.model = model;

    this.$inner = jQuery('<div>').appendTo(this.$wrapper).addClass('flipbook-carousel-page-inner');
    this.$bg = jQuery('<div>').appendTo(this.$inner).addClass('flipbook-carousel-page-bg');
    this.$html = jQuery('<div>').appendTo(this.$inner).addClass('flipbook-page-htmlContent');

    if(options.pagePreloader)
        this.$preloader = jQuery('<img src="' + options.pagePreloader + '" class="flipbook-page-preloader-image">').appendTo(this.$inner);
    else
        this.$preloader = jQuery('<img src="' + options.assets.spinner + '" class="flipbook-page-preloader">').appendTo(this.$inner);

    this.setSize(this.pw, this.ph);

};

FLIPBOOK.PageSwipe.prototype = {

    load: function(callback) {

        var index = this.options.rightToLeft ? this.options.numPages - this.index - 1 : this.index;

        var self = this;

            if (this.loaded) {
            if (callback) callback.call(this);
            return
        }

        this.loaded = true;

        this.options.main.loadPageHTML(index, function(html) {
            self.htmlContent = html;
            self.updateHtmlContent();
        });

        this.options.main.loadPage(index, this.options.pageTextureSize, function(page) {

            if(page.image){
                // var img = document.createElement('img')
                // img.src = page.image.src
                var img = page.image;
                self.$img = jQuery(img).addClass("page-carousel-img");

                var imgW = page.image.naturalHeight;
                var imgH = page.image.naturalHeight;
                var pw = self.options.pageWidth;
                var ph = self.options.pageHeight;

                self.$img.appendTo(self.$bg);

                if (self.options.doublePage && self.index > 0 && self.index % 2 == 0) {

                    self.$img.css('left', '-100%');

                }

                if (self.options.doublePage) {

                    if (self.index == 0 || (self.index == (self.options.pages.length - 1) && !self.options.oddPages))
                        self.$img.css('width', '100%');
                    else
                        self.$img.css('width', '200%');

                } else
                    self.$img.css('width', '100%');

                self.$preloader.remove();

            }

            if(page.canvas && self.pageSize != page.size){

                self.pageSize = page.size;
                self.$bg.empty();

                if (self.options.doublePage && self.index % 2 == 0 && self.index != 0) {
                    jQuery(page.rCanvas).appendTo(self.$bg);
                } else if(self.options.doublePage && self.index % 2 == 1 && self.index != (self.options.pages.length - 1)){
                    jQuery(page.lCanvas).appendTo(self.$bg);
                } else
                    jQuery(page.canvas).appendTo(self.$bg);

                self.$preloader.remove();

            }

            self.setRotation();

            if (callback) callback.call(self);

        });
    },

    unload: function() {

        this.loaded = false;
        this.pageSize = 0;
        this.size = 0;

        this.$preloader.appendTo(this.$inner);

    },

    dispose: function() {

        if (this.pageSize) {

            this.pageSize = null;
            this.$bg.empty();

        }

    },

    setSize: function() {

        var h = this.options.pageTextureSize, w;

        if(this.rotation == 0 || this.rotation == 180){
            w = h * this.options.pageWidth / this.options.pageHeight;
        }
        else {
            this.$wrapper.width(h).height(w);
            w = h * this.options.pageHeight / this.options.pageWidth;
        }
        this.pw = w;
        this.ph = h;
        this.$wrapper.width(w).height(h);
        this.updateHtmlContent();

    },

    setRotation: function(val) {

        this.setSize();

        if(this.options.doublePage)
            return

        if(typeof val != 'undefined')
            this.rotation = val;
        if(this.$img){

              this.$img.css('transform', 'rotate('+ this.rotation + 'deg) translateZ(0)');
        if(this.rotation == 90 || this.rotation == 270)
            this.$img.width(this.$wrapper.height()).height(this.$wrapper.width());
        else
            this.$img.width(this.$wrapper.width()).height(this.$wrapper.height());


        }
       },

    updateHtmlContent: function() {

        var scale = this.ph / 1000;
        var c = this.htmlContent;

        if (c) {

            this.$html.empty().append(jQuery(c));

            this.$html[0].style.transform = 'scale(' + scale + ') translateZ(0)';

            if (this.options.doublePage) {

                if (this.index % 2 == 0 && this.index > 0)
                    this.$html[0].style.left = '-100%';
                else
                    this.$html[0].style.left = '0';

            }

        }

    }

};

/* v 3.12.3
author http://codecanyon.net/user/creativeinteractivemedia/portfolio?ref=creativeinteractivemedia
*/
// var FLIPBOOK = FLIPBOOK || {};

{ /* FLIPBOOK.PageWebGL */
    FLIPBOOK.PageWebGL = function(book, i, hard, options, preloaderMatF, preloaderMatB) {

        THREE.Object3D.call(this);
        this.book = book;
        this.index = i;
        this.pW = options.pageWidth;
        this.pH = options.pageHeight;
        this.nfacesw = options.pageSegmentsW;
        this.nfacesh = options.pageSegmentsH;

        this.mats = [];
        this.pageHardness = hard;
        this.pageThickness = hard;
        this.duration = options.pageFlipDuration;
        this.angle = .25 * Math.PI * this.pW / this.pH;
        this.force = 10;
        this.offset = 0;
        this.to = null;
        this.mod = null;
        this.bend = null;
        this.pivot = null;
        this.isFlippedLeft = false;
        this.isFlippedRight = true;
        this.flippingLeft = false;
        this.flippingRight = false;
        this.options = options;

        var index = options.rightToLeft ? options.pages.length / 2 - this.index - 1 : this.index;
        this.indexF = options.rightToLeft ? 2 * index + 1 : 2 * index;
        this.indexB = options.rightToLeft ? 2 * index : 2 * index + 1;

        this.showing = false;

        this.preloaderMatF = preloaderMatF;
        this.preloaderMatB = preloaderMatB;

        var self = this;

        if (i == 0 && this.options.cornerCurl) {
            this.nfacesw = 20;
            this.nfacesh = 20;

             this.cornerCurlTween = new FLIPBOOK.TWEEN.Tween(0).to(1, 1000)
            .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.Out)
            .onUpdate(function(f) {
                if(self.cornerCurl){
                    self.b2.force = f * -1.8;
                    self.modF.apply();
                }
            })
            .repeat(11000)
            .start();

        }

        this.gF = new THREE.BoxGeometry(this.pW, this.pH, 0.01, this.nfacesw, this.nfacesh, 0);
        var basicMat = new THREE.MeshBasicMaterial({
            color: 0xededed
        });
        var mats = [
            basicMat,
            basicMat,
            basicMat,
            basicMat,
            preloaderMatF,
            preloaderMatB
        ];

        var mats2 = [
            basicMat,
            basicMat,
            basicMat,
            basicMat,
            basicMat,
            basicMat
        ];

        if (this.options.pagePreloader)
            var mats2 = [
                basicMat,
                basicMat,
                basicMat,
                basicMat,
                preloaderMatF,
                preloaderMatB
            ];

        this.cube = new THREE.Mesh(this.gF, mats);
        this.cube.position.x = this.pW * 0.5;
        if (this.options.shadows) {

            this.cube.castShadow = true;
            this.cube.receiveShadow = true;
        }

        // this.castShadow = true
        // this.receiveShadow  = true


        // if(this.index ==  1)
        // this.cube.castShadow = true
        // else
        // this.cube.receiveShadow = true

        this.gF.faceVertexUvs[1] = this.gF.faceVertexUvs[0];

        this.showMat();


        this.cubeEmpty = new THREE.Mesh(
            new THREE.BoxGeometry(this.pW, this.pH, 0.01, 1, 1, 0), mats2
        );

        this.cubeEmpty.position.x = this.pW * 0.5;

        this.pageFlippedAngle = Math.PI * this.options.pageFlippedAngle / 180;

        this.bendF = new MOD3.Bend(0, 0, 0);
        this.bendF.constraint = MOD3.ModConstant.LEFT;
        if (this.pH > this.pW)
            this.bendF.switchAxes = true;


        this.b2 = new MOD3.Bend(0, 0, 0);
        this.b2.constraint = MOD3.ModConstant.LEFT;
        if (this.pH > this.pW)
            this.b2.switchAxes = true;
        this.b2.offset = .98;
        this.b2.setAngle(1);

        this.modF = new MOD3.ModifierStack(new MOD3.LibraryThree(), this.cube);
        this.modF.addModifier(this.bendF);

        if (i == 0 && this.options.cornerCurl) {
            this.modF.addModifier(this.b2);
        }

        // this.modF.addModifier(this.b2);

        this.modF.apply();

    };

    FLIPBOOK.PageWebGL.prototype = new THREE.Object3D();
    FLIPBOOK.PageWebGL.prototype.constructor = FLIPBOOK.PageWebGL;

    FLIPBOOK.PageWebGL.prototype.startCornerCurl = function() {

        this.cornerCurl = true;

    };

    FLIPBOOK.PageWebGL.prototype.stopCornerCurl = function() {

        this.cornerCurl = false;
        this.b2.force = 0;
        this.modF.apply();

    };

    FLIPBOOK.PageWebGL.prototype.onPageCanvasLoaded = function(page, side, callback) {

        if (side == 'front' && this.sizeFront != page.size) {

            this.sizeFront = page.size;
            var c = page.canvas;
            var t1 = new THREE.CanvasTexture(c);

            // t1.anisotropy = this.book.renderer.capabilities.getMaxAnisotropy();

            t1.minFilter = THREE.LinearFilter;
            //t1.generateMipmaps = false
            t1.needsUpdate = true;
            t1.repeat.x = c.scaleX;
            t1.repeat.y = c.scaleY;
            t1.offset.y = 1 - c.scaleY;
            //             if (c.double && c.pageIndex % 2 != 0) t1.offset.x = .5

            if (c.double) t1.offset.x = .5;

            this.frontMaterial = this.createMaterial(t1, 'front');
            this.frontMaterial.needsUpdate = true;
            this.setFrontMat(this.frontMaterial);

        } else if (side == 'back' && this.sizeBack != page.size) {

            // console.log("onPageCanvasLoaded ", page, side)

            // this.loadedBack = true
            this.sizeBack = page.size;
            var c = page.canvas;
            var t2 = new THREE.CanvasTexture(c);
            //t2.generateMipmaps = false

            // t2.anisotropy = this.book.renderer.capabilities.getMaxAnisotropy();
            t2.minFilter = THREE.LinearFilter;
            t2.needsUpdate = true;
            t2.repeat.x = c.scaleX;
            t2.repeat.y = c.scaleY;
            t2.offset.y = 1 - c.scaleY;
            //             if (c.double && c.pageIndex % 2 != 0) t2.offset.x = .5

            this.backMaterial = this.createMaterial(t2, 'back');
            this.backMaterial.needsUpdate = true;
            // FLIPBOOK.Buffer.addMaterial(self.backMaterial)
            this.setBackMat(this.backMaterial);

        }

        callback.call(this);

    };

    FLIPBOOK.PageWebGL.prototype.loadHTML = function(side, callback) {

        var index = side == "front" ? this.indexF : this.indexB, self = this;

        if(!this.htmlLoaded){
            // self.htmlLoaded = true
            this.options.main.loadPageHTML(index, function(html) {
               callback.call(self);

            });

        }
        else
             callback.call(this);

    };

    FLIPBOOK.PageWebGL.prototype.load = function(side, callback) {

        var model = this.book.model;

        if(!model.wrapperH) return;
        if(!model.zoom) return;

        var pages = this.book.pages;
        var self = this;
        var options = this.book.options;

        for (var i = 0; i < pages.length; i++) {
            var p = pages[i];
            if (p.flippingLeft || p.flippingRight)
                return
        }

        this.disposed = false;

        var o = options;
        var pageSize = model.wrapperH * model.zoom;
        var size = pageSize < o.pageTextureSizeSmall * .8 ? o.pageTextureSizeSmall : o.pageTextureSize;

        if (side == 'front') {

            if (this.sizeFront == size) {
                if (callback) callback.call(this);
            } else {

                this.options.main.loadPage(this.indexF, size, function(page) {

                    if (!page) {
                        if (callback) callback.call(self);
                        return
                    }

                    if (page.canvas) {

                        self.onPageCanvasLoaded(page, "front", callback);

                    } else if (page.image) {

                        if (self.loadedFront) {
                            callback.call(self);
                            return
                        }

                        self.loadedFront = true;

                        var t1 = new THREE.Texture();
                        t1.image = page.image;

                        t1.minFilter = THREE.LinearFilter;

                        // if (textureNeedsPowerOfTwo(t1) && !isPowerOfTwo(t1.image))
                        //     t1.image = makePowerOfTwo(t1.image);

                        // // t1.generateMipmaps = false;
                        // t1.anisotropy = self.book.renderer.capabilities.getMaxAnisotropy();
                        t1.needsUpdate = true;

                        if (self.options.pages[2 * self.index].side == 'left') {
                            t1.repeat.x = .5;
                        } else if (self.options.pages[2 * self.index].side == 'right') {
                            t1.repeat.x = .5;
                            t1.offset.x = .5;
                        }
                        //front loaded
                        self.frontMaterial = self.createMaterial(t1);

                        self.setFrontMat(self.frontMaterial);

                        callback.call(self);

                    }

                });
            }
        } else if (side == "back") {

            if (this.sizeBack == size) {
                if (callback) callback.call(this);
            } else {

                this.options.main.loadPage(this.indexB, size, function(page) {

                    if (!page) {
                        if (callback) callback.call(self);
                        return
                    }


                    if (page.canvas) {

                        self.onPageCanvasLoaded(page, "back", callback);

                    } else if (page.image) {

                        if (self.loadedBack) {
                            callback.call(self);
                            return
                        }

                        self.loadedBack = true;

                        var t2 = new THREE.Texture();
                        t2.image = page.image;

                        t2.minFilter = THREE.LinearFilter;

                        t2.needsUpdate = true;

                        if (self.options.pages[2 * self.index + 1].side == 'left') {
                            t2.repeat.x = .5;
                        } else if (self.options.pages[2 * self.index + 1].side == 'right') {
                            t2.repeat.x = .5;
                            t2.offset.x = .5;
                        }
                        //back loaded
                        self.backMaterial = self.createMaterial(t2, 'back');
                        self.setBackMat(self.backMaterial);

                        callback.call(self);

                    }

                });
            }
        }

    };

    FLIPBOOK.PageWebGL.prototype.unload = function(side) {

        if (side == 'front' && this.sizeFront) {

            var mat = this.cube.material[4];

            var t = mat.map;

            mat.dispose();

            if (t) t.dispose();

            this.loadedFront = false;
            this.sizeFront = 0;

            this.setFrontMat(this.preloaderMatF);

        } else if (side == 'back' && this.sizeBack) {

            var mat = this.cube.material[5];

            var t = mat.map;

            mat.dispose();

            if (t) t.dispose();

            this.loadedBack = false;
            this.sizeBack = 0;

            this.setBackMat(this.preloaderMatB);

        }

    };

    // FLIPBOOK.PageWebGL.prototype.reload = function() {

    //     if (this.loadedFront) {

    //         this.loadedFront = false
    //         this.load("front", this.options.pageTextureSize, function(){})

    //     }

    // }

    FLIPBOOK.PageWebGL.prototype.disposeMat = function() {

        /*if(this.disposed) return;*/

        if (!this.loaded)
            return

        var matF = this.cube.material[4];
        var matB = this.cube.material[5];

        var tF = matF.map;
        var tB = matB.map;

        matF.dispose();
        matB.dispose();

        if (tF) tF.dispose();
        if (tB) tB.dispose();

        this.disposed = true;

        this.loaded = false;

    };

    FLIPBOOK.PageWebGL.prototype.createMaterial = function(map, side) {

        var mat;
        if (this.options.lights) {

            var sTexture = side == 'back' ? this.book.specularB : this.book.specularF;
            var o = this.options;
            mat = new THREE.MeshStandardMaterial({
                map: map,
                roughness: o.pageRoughness,
                metalness: o.pageMetalness,
                emissive: 0x000000,
                color: 0xffffff,
                lightMap: sTexture
            });

        } else {

            mat = new THREE.MeshBasicMaterial({
                map: map
            });

        }
        return mat

    };

    FLIPBOOK.PageWebGL.prototype._setAngle = function(angle, direction) {
        //console.log(angle,this.index)
        // console.log(angle)
        if (angle <= 180 && angle >= -180) {

            angle = (angle / 180) * Math.PI;
            if (this.singlePage) {
                if (angle >= 90)
                    angle = 90;
                if (angle < 0 /*&& angle > -90*/ )
                    angle -= 90;
                if (angle < -180)
                    angle = -180;
                if (this.index == (this.book.pages.length - 1))
                    return;

            }

            if (angle < 0 /*|| (angle == 0 && this.flippingRight)*/ ) {
                angle = angle + Math.PI;
            }

            this.angle = angle;

            this.positionZ(200);
            this.dragging = true;

            this.rotation.y = -angle;

            // this.bend.force = Math.sin(-angle*2)/2
            if (this.isFlippedLeft)
                this.bendF.force = /*this.bendB.force =*/ 1.35 * Math.pow(-Math.abs(Math.cos(-angle / 2)), 1) / Math.pow(this.pageHardness, 1.5);
            else
                this.bendF.force = /*this.bendB.force =*/ 1.35 * Math.pow(Math.abs(Math.sin(-angle / 2)), 1) / Math.pow(this.pageHardness, 1.5);
            this.updateBend();

            if (this.book.htmlLayerVisible) {
                this.book.$pageL.hide();
                this.book.$pageR.hide();
                this.book.$pageC.hide();
                this.book.htmlLayerVisible = false;
            }

            this.book.needsUpdate = true;
        }
    };

    FLIPBOOK.PageWebGL.prototype.updateBend = function() {

        this.stopCornerCurl();

        // this.b2.force = this.rotation.y + Math.PI / 2
        // console.log(this.rotation.y)
        this.modF.apply();
        /*this.modB.apply();*/
        // this.gF.mergeVertices();
        this.gF.computeFaceNormals();
        this.gF.computeVertexNormals(true);

        this.book.needsUpdate = true;
        // this.gB.mergeVertices();
        /* this.gB.computeFaceNormals();
        this.gB.computeVertexNormals(true);*/

    };

    FLIPBOOK.PageWebGL.prototype.flipLeft = function(onComplete) {

        this.onComplete = onComplete;
        this.dragging = false;
        if (!this.isFlippedLeft && !this.flippingLeft && !this.flippingRight && this.index == this.book.flippedleft) {

            if (this.duration > 0) {

                this.flippingLeft = true;
                this.flipping = true;

                this.force = 0;
                var newForce = (1 + Math.random() * .5) / this.pageHardness;
                var newOffset = .1 + Math.random() * .2;
                this.to = {
                    angle: this.rotation.y,
                    t: -1,
                    xx: 0,
                    thiss: this,
                    force: this.force,
                    offset: this.offset
                };
                // this.bendIn(this.pageFlippedAngle, newForce, newOffset);
                this.bendIn(-Math.PI, newForce, newOffset);

            } else {

                // this.rotation.y = this.pageFlippedAngle;
                this.rotation.y = -Math.PI;
                this.flippingLeft = false;
                this.isFlippedLeft = true;
                this.flippingRight = false;
                this.isFlippedRight = false;

            }

            this.correctZOrder();

        }
    };

    FLIPBOOK.PageWebGL.prototype.correctZOrder = function() {

        var th = 4,
            i;

        // th = 50
        //correct z order
        this.position.z = th / 2 + 1;
        //console.log(this.position.z)
        /*this.showMat()*/
        //left side
        for (i = this.index - 1; i >= 0; i--) {

            this.book.pages[i].position.z = this.book.pages[i + 1].position.z - th / 2 - th / 2 - 1;
            //console.log(this.book.pages[i].position.z)

        }
        //right side
        for (i = this.index + 1; i < this.book.pages.length; i++) {

            this.book.pages[i].position.z = this.book.pages[i - 1].position.z - th / 2 - th / 2 - 1;
            //console.log(this.book.pages[i].position.z)

        }
    };

    FLIPBOOK.PageWebGL.prototype.flipLeftInstant = function(onComplete) {

        this.onComplete = onComplete;
        this.dragging = false;

        if (!this.isFlippedLeft && !this.flippingLeft && !this.flippingRight && this.index == this.book.flippedleft) {

            this.thiss = this;
            this.xx = 0;
            this.angle = -Math.PI;
            this.flippingLeft = true;
            this.isFlippedLeft = false;
            this.renderFlip();
            this.flippingLeft = false;
            this.isFlippedLeft = true;
            this.flippingRight = false;
            this.isFlippedRight = false;

            var th = 4;
            //correct z order
            this.position.z = th / 2 + 1;


            //right side
            for (var i = this.index + 1; i < this.book.pages.length; i++) {

                this.book.pages[i].position.z = this.book.pages[i - 1].position.z - th / 2 - th / 2 - 1;

            }

            //left side
            if (this.index < this.book.pages.length - 1) {

                this.position.z = this.book.pages[this.index + 1].position.z;
                for (var i = this.index - 1; i >= 0; i--) {

                    this.book.pages[i].position.z = this.book.pages[i + 1].position.z - th / 2 - th / 2 - 1;

                }

            } else {

                if (this.index > 0) this.book.pages[this.index].position.z = this.book.pages[this.index - 1].position.z + th / 2 + th / 2 - 1;
            }

            this.flipFinished();
        }
    };

    FLIPBOOK.PageWebGL.prototype.hideMat = function() {

        if (this.showing) {

            this.remove(this.cube);
            this.add(this.cubeEmpty);
            this.showing = false;
            //console.log('hiding ' + this.index)

        }

    };

    FLIPBOOK.PageWebGL.prototype.showMat = function() {

        if (!this.showing) {

            this.add(this.cube);
            this.remove(this.cubeEmpty);
            this.showing = true;
            this.book.needsUpdate = true;
            //console.log('---showing ' + this.index)

        }

    };

    FLIPBOOK.PageWebGL.prototype.setFrontMat = function(m) {

        if (this.cube.material[4] === m)
            return
        this.cube.material[4] = m;
        this.book.needsUpdate = true;
        //this.frontMaterial = m

    };

    FLIPBOOK.PageWebGL.prototype.setBackMat = function(m) {

        if (this.cube.material[5] === m)
            return
        this.cube.material[5] = m;
        this.book.needsUpdate = true;
        //this.backMaterial = m

    };

    FLIPBOOK.PageWebGL.prototype.flipRightInstant = function(onComplete) {

        this.onComplete = onComplete;
        this.dragging = false;
        if (!this.isFlippedRight && !this.flippingRight && !this.flippingLeft && this.index == this.book.getNumPages() - this.book.flippedright - 1) {

            this.thiss = this;
            this.xx = 0;
            this.angle = 0;
            this.flippingRight = true;
            this.isFlippedRight = false;
            this.renderFlip();
            this.flippingLeft = false;
            this.isFlippedLeft = false;
            this.flippingRight = false;
            this.isFlippedRight = true;

            var th = 4;
            //correct z order
            this.position.z = th / 2 + 1;

            //left side
            for (var i = this.index - 1; i >= 0; i--) {
                this.book.pages[i].position.z = this.book.pages[i + 1].position.z - th / 2 - th / 2 - 1;
            }

            //right side
            if (this.index > 0) {

                this.position.z = this.book.pages[this.index - 1].position.z;
                for (var i = this.index + 1; i < this.book.pages.length; i++) {

                    this.book.pages[i].position.z = this.book.pages[i - 1].position.z - th / 2 - th / 2 - 1;

                }

            } else {

                if (this.book.pages.length > 1)
                    this.position.z = this.book.pages[this.index + 1].position.z + th / 2 + th / 2 - 1;
            }

            this.flipFinished();
        }

    };

    FLIPBOOK.PageWebGL.prototype.flipRight = function(onComplete) {

        this.onComplete = onComplete;
        this.dragging = false;
        if (!this.isFlippedRight && !this.flippingRight && !this.flippingLeft && this.index == this.book.getNumPages() - this.book.flippedright - 1) {

            if (this.duration > 0) {

                this.flippingRight = true;
                this.flipping = true;

                this.force = 0;
                this.to = {
                    angle: this.rotation.y,
                    t: -1,
                    xx: 0,
                    thiss: this,
                    force: this.force,
                    offset: this.offset
                };
                var newForce = (-1 - Math.random() * .5) / this.pageHardness;
                var newOffset = .1 + Math.random() * .2;
                this.bendIn(0, newForce, newOffset);

            } else {

                this.rotation.y = 0;
                this.flippingLeft = false;
                this.isFlippedLeft = false;
                this.flippingRight = false;
                this.isFlippedRight = true;

            }

            this.correctZOrder();

        }

    };

    FLIPBOOK.PageWebGL.prototype.bendIn = function(angle, newForce, newOffset) {

        // var rand = Math.random() * (Math.PI / 24) - (Math.PI / 48)
        // this.bendF.setAngle(rand);
        // this.bendB.setAngle(rand);
        this.bendF.force = 0.0;
        this.bendF.offset = 0.0;

        this.updateBend();

        var time1 = 2 * this.duration * 240 * Math.pow((Math.abs(this.rotation.y - angle) / Math.PI), .5) * Math.pow(this.pageHardness, .25);
        //tween page rotation Y
        new FLIPBOOK.TWEEN.Tween(this.to).to({

                angle: angle,
                xx: 1,
                t: 1

            }, time1)
            .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.In)
            .onUpdate(this.renderFlip)
            .onComplete(this.bendOut)
            .start();

        // jQuery(this.book).trigger('playFlipSound')
        this.options.main.playFlipSound();

    };

    FLIPBOOK.PageWebGL.prototype.bendOut = function() {

        //tween bend.force to 0
        var self = this.thiss;
        var time = self.duration * Math.pow(Math.abs(self.bendF.force), .5) * 1000;
        new FLIPBOOK.TWEEN.Tween(self.bendF).to({
                force: 0,
                offset: 1
            }, time)
            .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.Out)
            .onUpdate(function() {
                self.updateBend();
            })
            .onComplete(function() {
                self.flipFinished(self);
            })
            .start();

        var th = 4;
        if (self.flippingLeft) {


            if (self.index < self.book.pages.length - 1) {

                self.position.z = self.book.pages[self.index + 1].position.z;
                for (var i = self.index - 1; i >= 0; i--) {

                    self.book.pages[i].position.z = self.book.pages[i + 1].position.z - th / 2 - th / 2 - 1;

                }

            } else {

                if (self.book.pages.length > 1)
                    self.book.pages[self.index].position.z = self.book.pages[self.index - 1].position.z + th / 2 + th / 2 - 1;

            }

        }
        if (self.flippingRight) {

            if (self.index > 0) {

                self.position.z = self.book.pages[self.index - 1].position.z;
                for (var i = self.index + 1; i < self.book.pages.length; i++) {

                    self.book.pages[i].position.z = self.book.pages[i - 1].position.z - th / 2 - th / 2 - 1;
                }

            } else {

                if (self.book.pages.length > 1)
                    self.position.z = self.book.pages[self.index + 1].position.z + th / 2 + th / 2 - 1;

            }

        }

    };
    FLIPBOOK.PageWebGL.prototype.modApply = function() {
        this.thiss.bendF.force = this.thiss.bendB.force = this.force;
        this.thiss.bendF.offset = this.thiss.bendB.offset = this.offset;
        this.thiss.updateBend();
    };
    FLIPBOOK.PageWebGL.prototype.renderFlip = function() {
        this.thiss._setAngle(-this.angle * 180 / Math.PI);
    };
    FLIPBOOK.PageWebGL.prototype.flipFinished = function() {
        var self = this;

        if (self.flippingLeft) {

            self.flippingLeft = false;
            self.isFlippedLeft = true;
            self.flippingRight = false;
            self.isFlippedRight = false;

        } else if (self.flippingRight) {

            self.flippingLeft = false;
            self.isFlippedRight = true;
            self.flippingRight = false;
            self.isFlippedLeft = false;

        }

        self.bendF.force = 0.0;
        self.bendF.offset = 0.0;
        self.updateBend();
        self.flipping = false;
        self.dragging = false;
        if (typeof(self.onComplete) != 'undefined') self.onComplete(self);
        self.book.flipFinnished();

        //self.book.options.main.turnPageComplete()
    };
    FLIPBOOK.PageWebGL.prototype.isFlippedLeft = function() {

        return this.thiss.isFlippedLeft;

    };
    FLIPBOOK.PageWebGL.prototype.isFlippedRight = function() {

        return this.thiss.isFlippedRight;

    };

    FLIPBOOK.PageWebGL.prototype.positionZ = function() {

    };
}

{ /* FLIPBOOK.BookWebGL */
    FLIPBOOK.BookWebGL = function(el, model, options) {

        this.wrapper = el;
        this.options = options;
        this.model = model;

        this.options.cameraDistance = 2800;

        this.pageW = options.pageWidth;
        this.pageH = options.pageHeight;

        this.pageW = 1000 * options.pageWidth / options.pageHeight;
        this.pageH = 1000;

        options.pageWidth = this.pageW;
        options.pageHeight = this.pageH;

        this.scroll = options.scroll;
        this.pagesArr = options.pages;
        this.pages = [];
        this.animating = false;

        this.sc = 1;

        var s = this.wrapper.style;
        s.width = '100%';
        s.height = '100%';
        s.position = 'absolute';
        s.overflow = 'hidden';

        this.options.cameraDistance = this.options.cameraDistance / 1.5;
        //this.goToPage(options.startPage, true)
        // this.stats = new Stats();
        // this.stats.domElement.style.position = 'absolute';
        // this.stats.domElement.style.top = '0px';
        // this.wrapper.appendChild( this.stats.domElement );

        /*window.rendererStats   = new THREEx.RendererStats()
        window.rendererStats.domElement.style.position = 'absolute';
        window.rendererStats.domElement.style.top = '0px';
        this.wrapper.appendChild( window.rendererStats.domElement );*/

    };

    FLIPBOOK.BookWebGL.prototype = Object.create(FLIPBOOK.Book.prototype);

    FLIPBOOK.BookWebGL.prototype.constructor = FLIPBOOK.BookWebGL;


    FLIPBOOK.BookWebGL.prototype.init3d = function() {
        // WebGL starts here
        var self = this,
            VIEW_ANGLE = 30,
            w = jQuery(self.wrapper).width(),
            h = jQuery(self.wrapper).height(),
            ASPECT = w / h,
            NEAR = 1,
            FAR = 10000,
            o = this.options;

        //scene
        this.Scene = new THREE.Scene();
        this.centerContainer = new THREE.Object3D();
        this.Scene.add(this.centerContainer);

        this.Camera = new THREE.PerspectiveCamera(VIEW_ANGLE, ASPECT, NEAR, FAR);
        //this.Camera.position.set(0,0,500)
        this.Scene.add(this.Camera);
        this.zoom = o.zoom;
        this.pan = o.pan;
        this.tilt = o.tilt;

        this.updateCameraPosition();

        var container = this.wrapper;
        var c = document.createElement('canvas');
        var ctx = c.getContext('webgl');

        var renderer = new THREE.WebGLRenderer({
            antialias: this.options.antialias,
            alpha: true
        });

        window.renderer = renderer;

        renderer.gammaInput = true;
        renderer.gammaOutput = true;

        if (this.options.shadows) {
            renderer.shadowMap.enabled = true;
            // renderer.shadowMap.type = THREE.PCFSoftShadowMap;
            renderer.shadowMap.type = THREE.PCFShadowMap;
            // renderer.shadowMap.type = THREE.BasicShadowMap;
        }


        window.webglrenderer = this.renderer = renderer;
        this.renderer.setSize(container.clientWidth, container.clientHeight);
        var pr = window.devicePixelRatio < o.minPixelRatio ? o.minPixelRatio : window.devicePixelRatio;
        // pr = 1
        this.renderer.setPixelRatio(pr);
        container.appendChild(this.renderer.domElement);

        var htmlLayer = false;
        var pages = this.options.pages;
        for (var i = 0; i < pages.length; i++) {
            if (pages[i].htmlContent) htmlLayer = true;
        }
        this.options.hasHtmlContent = htmlLayer || o.pdfMode;
        if (this.options.hasHtmlContent)
            this.initHtmlContent();

        this.canvas = this.renderer.domElement;

        this._bind('mousedown', this.canvas.parentNode.parentNode);
        this._bind('mousemove', this.canvas.parentNode.parentNode);
        this._bind('mouseout', this.canvas.parentNode.parentNode);
        this._bind('mouseup', this.canvas.parentNode.parentNode);

        this._bind('touchstart', this.canvas.parentNode.parentNode);
        this._bind('touchmove', this.canvas.parentNode.parentNode);
        this._bind('touchend', this.canvas.parentNode.parentNode);
        this._bind('touchcancel', this.canvas.parentNode.parentNode);


        if (this.options.lights) {

            var sCol = o.lightColor;
            //sIntensity = 1
            var sl = new THREE.SpotLight(sCol);
            sl.intensity = o.lightIntensity;
            sl.position.set(o.lightPositionX, o.lightPositionY, o.lightPositionZ);
            // sl.position.set(0, 400, 2500);
            sl.distance = 4000;
            // sl.penumbra = .1;
            // sl.decay = 0;


            if (this.options.shadows) {

                sl.castShadow = true;
                // sl.shadow.bias = -0.0000015
                sl.shadow.bias = -0.000002;

                sl.shadow.mapSize.x = this.options.shadowMapSize;
                sl.shadow.mapSize.y = this.options.shadowMapSize;

                var mat = new THREE.ShadowMaterial();
                mat.opacity = this.options.shadowOpacity;

                var bg = new THREE.Mesh(new THREE.BoxGeometry(10000, 10000, 1, 1, 1, 1),
                    mat);

                bg.position.set(0, 0, -o.shadowDistance);
                this.Scene.add(bg);
                bg.receiveShadow = true;

            }

            this.Scene.add(sl);

            var ambCol = o.ambientLightColor || 0x333333;
            var al = new THREE.AmbientLight(ambCol);
            // this.Scene.add(al);

        }


        this.centerContainer.position.set(0, 0, 0);

        this.onResize();

        // align flipBook center container
        this.centerContainer.position.x = -this.pageW * .5 * this.centerContainer.scale.x;

        this.updateHtmlLayerPosition();

        this.flippedleft = 0;
        this.flippedright = 0;

        this.cameraZMin = 300;
        this.cameraZMax = 5000;


        //         var stats = new Stats();
        // stats.showPanel( 1 ); // 0: fps, 1: ms, 2: mb, 3+: custom
        // document.body.appendChild( stats.dom );



        (function a() {
            FLIPBOOK.TWEEN.update();
            if (self.rendering) {

                if (!self.enabled) {
                    return;
                }

                //FLIPBOOK.TWEEN.update();

                if(self.needsUpdate){
                // if(1){
                    // self.frame = self.frame || 1
                    // self.frame++
                    // console.log("render frame ",self.frame)
                    //self.renderer.clear()
                    self.renderer.render(self.Scene, self.Camera);
                    self.needsUpdate = false;


                //self.lh.update()
                if (self.htmlLayer)
                    self.cssRenderer.render(self.Scene, self.Camera);

            }

                // stats.update()

                //console.log(self.renderer.info.memory)

                // if(self.stats)
                // self.stats.update();
                // console.log("rendering..."+self.elementId)

                // if(window.rendererStats) window.rendererStats.update(renderer)



            }

            requestAnimationFrame(a);

        })();

    };

    FLIPBOOK.BookWebGL.prototype.onPageUnloaded = function(index, size) {

        //console.log('onPageUnloaded ', index, ' ', size)

        var side;
        var sheetIndex = Math.floor(index / 2);
        if (this.options.rightToLeft) {
            sheetIndex = this.pages.length - sheetIndex - 1;
            side = index % 2 == 0 ? 'back' : 'front';
        } else {
            side = index % 2 == 0 ? 'front' : 'back';
        }

        this.pages[sheetIndex].unload(side);

    };

    FLIPBOOK.BookWebGL.prototype.initHtmlContent = function() {

        var htmlLayer = document.createElement('div');
        htmlLayer.className = "htmlLayer " + Math.random();
        var $htmlLayer = jQuery(htmlLayer);
        this.$htmlLayer = $htmlLayer;
        //jQuery(number).append(jQuery('<img src="images/book1/page1.jpg">'))


        this.$pageR = jQuery(document.createElement('div'))
            .addClass('R')
            .css({
                'width': 1000 * this.options.pageWidth / this.options.pageHeight + 'px',
                'height': '1000px',
                'position': 'absolute',
                'top': '-500px',
                'pointer-events': 'none'
            })
            .appendTo($htmlLayer);

        this.$pageRInner = jQuery('<div>')
            .css('pointer-events', 'all')
            .appendTo(this.$pageR);

        this.$pageL = jQuery(document.createElement('div'))
            .addClass('L')
            .css({
                'width': 1000 * this.options.pageWidth / this.options.pageHeight + 'px',
                'height': '1000px',
                'position': 'absolute',
                'top': '-500px',
                'left': -1000 * this.options.pageWidth / this.options.pageHeight + 'px',
                'pointer-events': 'none'
            })
            .appendTo($htmlLayer);

        this.$pageLInner = jQuery(document.createElement('div'))
            .css('pointer-events', 'all')
            .appendTo(this.$pageL);

        this.$pageC = jQuery(document.createElement('div'))
            .addClass('C')
            .css({
                'width': 2 * 1000 * this.options.pageWidth / this.options.pageHeight + 'px',
                'height': '1000px',
                'position': 'absolute',
                'top': '-500px',
                'left': -1000 * this.options.pageWidth / this.options.pageHeight + 'px',
                'pointer-events': 'none'
            })
            .appendTo($htmlLayer);

        this.$pageCInner = jQuery(document.createElement('div'))
            .css('pointer-events', 'all')
            .appendTo(this.$pageC);


        this.htmlLayer = new FLIPBOOK.CSS3DObject(htmlLayer);
        //htmlObj.rotation.y = Math.PI/3

        this.Scene.add(this.htmlLayer);

        this.cssRenderer = new FLIPBOOK.CSS3DRenderer();
        var container = this.wrapper;
        // this.cssRenderer.setSize(container.clientWidth, container.clientHeight);

        this.wrapper.appendChild(this.cssRenderer.domElement);


        this.cssRenderer.domElement.style.position = 'absolute';
        this.cssRenderer.domElement.style.top = '0';
        this.cssRenderer.domElement.style.left = '0';
        this.cssRenderer.domElement.style.pointerEvents = 'none';
        this.cssRenderer.domElement.className = "cssRenderer " + Math.random();

        var self = this;

        this.model.on("toolSelect",function(){
            self.updateTool();
        });
        this.model.on("toolMove",function(){
            self.updateTool();
        });

    };

    FLIPBOOK.BookWebGL.prototype.enablePrev = function(val) {
        this.prevEnabled = val;
    };

    FLIPBOOK.BookWebGL.prototype.enableNext = function(val) {
        this.nextEnabled = val;
    };

    FLIPBOOK.BookWebGL.prototype.isZoomed = function() {
        return this.options.zoom > this.options.zoomMin && this.options.zoom > 1
    };
    FLIPBOOK.BookWebGL.prototype.getRightPage = function() {
        return this.pages[this.flippedleft]
    };

    FLIPBOOK.BookWebGL.prototype.getNextPage = function() {
        return this.pages[this.flippedleft + 1]
    };

    FLIPBOOK.BookWebGL.prototype.getLeftPage = function() {
        return this.pages[this.flippedleft - 1]
    };

    FLIPBOOK.BookWebGL.prototype.getPrevPage = function() {
        return this.pages[this.flippedleft - 2]
    };

    FLIPBOOK.BookWebGL.prototype.onSwipe = function(event, phase, direction, distance, duration, fingerCount, fingerData) {

        //Here we can check the:
        //phase : 'start', 'move', 'end', 'cancel'
        //direction : 'left', 'right', 'up', 'down'
        //distance : Distance finger is from initial touch point in px
        //duration : Length of swipe in MS
        //fingerCount : the number of fingers used

        if (this.isZoomed())
            return;

        // out - distance is already calculated
        //distance = fingerData[0].start.x - fingerData[0].end.x

        if (direction == "right")
            distance *= -1;


        var left = this.getLeftPage();
        var right = this.getRightPage();
        var next = this.getNextPage();
        var prev = this.getPrevPage();

        if (this.options.rotateCameraOnMouseDrag && (!right || !right.dragging) && (!left || !left.dragging) && (this.onMouseMove == 'rotate' || this.onMouseMove == 'scroll'))
            return

        if ((phase == 'cancel' || phase == 'end') && fingerCount <= 1) {

            if (this.view == 1 && this.draggingBook && direction == "left") {
                this.nextPage();
                this.draggingBook = false;
                return
            }

            if (this.view == 1 && this.draggingBook && direction == "right") {
                this.prevPage();
                this.draggingBook = false;
                return
            }


            if (distance < 0 && (!right || !right.dragging))
                this.prevPage();
            else if (distance > 0 && (!left || !left.dragging))
                this.nextPage();
            else if (distance == 0)
                this.clickedPage ? this.clickedPage.isFlippedLeft ? this.prevPage() : this.nextPage() : null;

            if (right)
                right.dragging = false;
            if (left)
                left.dragging = false;

        }

        if (phase == 'move' && fingerCount <= 1) {

            if (this.draggingBook) {
                this.centerContainer.position.x = this.draggingBookStartX - distance;
                this.updateHtmlLayerPosition();
                return
            }

            if (this.view == 1 && this.isFocusedLeft() && direction == "left") {
                this.draggingBookStartX = this.centerContainer.position.x;
                this.draggingBook = true;
                return
            }

            if (this.view == 1 && this.isFocusedRight() && direction == "right") {
                this.draggingBookStartX = this.centerContainer.position.x;
                this.draggingBook = true;
                return
            }


            // distance = 180 * (fingerData[0].start.x - fingerData[0].end.x) / jQuery(this.wrapper).width()

            // if(direction == "right")
            // distance *= -1;

            distance = 180 * distance / this.wrapperW;


            if ((left && left.flipping) || (right && right.flipping))
                return

            //both down
            //console.log(left,right,distance)
            if ((!right || !right.dragging) && (!left || !left.dragging)) {
                if (distance != 0) {
                    if (direction == 'right' && left && (!right || !right.dragging) && this.prevEnabled) {
                        left._setAngle(distance, direction);
                        left.positionZ(200);
                        if (prev)
                            prev.showMat();
                    } else if (direction == 'left' && right && this.nextEnabled) {
                        right._setAngle(distance, direction);
                        right.positionZ(200);
                        if (next)
                            next.showMat();
                    }
                }
            }
            //one is dragging
            else {
                if (left && !right || left && !right.dragging) {
                    if (distance <= 0)
                        left._setAngle(distance, direction);
                } else if (right && !left || right && !left.dragging) {
                    if (distance >= 0) {
                        right._setAngle(distance, direction);
                    }
                }
            }
        }
    };
    FLIPBOOK.BookWebGL.prototype.onResize = function() {
        var m = this.model,
            w = m.wrapperW,
            h = m.wrapperH,
            o = this.options,
            pw = o.pageWidth,
            ph = o.pageHeight,
            r1 = w / h,
            r2 = pw / ph;

        if(h < 1000 && window.devicePixelRatio == 1)
            this.renderer.setPixelRatio(2);
        else {
            var pr = window.devicePixelRatio < o.minPixelRatio ? o.minPixelRatio : window.devicePixelRatio;
            this.renderer.setPixelRatio(pr);
        }

        var s = Math.min(this.zoom, 1);

        var zoomMin = Number(o.zoomMin);

        if (o.responsiveView && w <= o.responsiveViewTreshold && r1 < 2 * r2) {
            //switch to single page mode
            this.view = 1;

            if (r2 > r1)
                this.sc = zoomMin * r1 / (r2 * s);
            else
                this.sc = 1;

            if (this.rightIndex == 0 || this.isFocusedRight()) this.focusRight();
            else this.focusLeft();
        // } else if(o.responsiveView && this.zoom > 1.2){
        //     this.view = 1
        //     this.sc = 1
        }else {
            this.view = 2;

            if (r1 < 2 * r2)
                this.sc = zoomMin * r1 / (2 * r2 * s);
            else
                this.sc = 1;

            if (this.flippedleft == 0)
                this.focusRight();
            else if (this.flippedright == 0)
                this.focusLeft();
            else
                this.focusBoth();
        }

        this.renderer.setSize(w, h);

        if (this.htmlLayer) {
            //this.cssRenderer.setSize(w*this.sc, h*this.sc);
            this.cssRenderer.setSize(w, h);
            this.htmlLayer.scale.set(this.sc, this.sc, this.sc);
        }

        // update the camera
        this.Camera.aspect = w / h;
        this.Camera.updateProjectionMatrix();
        this.updateCameraPosition();
        this.updateBookPosition();

        this.wrapperW = w;
        this.wrapperH = h;

    };

    FLIPBOOK.BookWebGL.prototype.updateCameraPosition = function() {
        //tilt
        var angle = Math.PI * this.tilt / 180;
        var cameraX = 0;
        var cameraY = this.options.cameraDistance * Math.sin(angle) / (this.zoom);
        var cameraZ = this.options.cameraDistance * Math.cos(angle) / (this.zoom);

        this.centerContainer.scale.set(this.sc, this.sc, this.sc);

        //pan
        angle = Math.PI * this.pan / 180;
        cameraX = Math.sin(angle) * cameraZ;
        cameraZ = Math.cos(angle) * cameraZ;
        this.cameraZ = cameraZ;

        //this.Camera.fov = 20
        //this.Camera.updateProjectionMatrix();

        this.Camera.position.set(Math.round(cameraX), Math.round(cameraY), Math.round(cameraZ));

        this.Camera.lookAt(this.Scene.position);

        this.needsUpdate = true;

    };
    FLIPBOOK.BookWebGL.prototype.createPages = function() {
        //create all pages
        var self = this;
        var hardness, page, i;

        /*if(self.options.rightToLeft){
        for (i=self.pagesArr.length-1;i>=0;i--)
            p.push(self.pagesArr[i])
    }else{
        p = self.pagesArr

    }*/

        var options = self.options;

        var marginW = options.pageMiddleShadowSize;

        var c = document.createElement("canvas");
        c.width = 64;
        c.height = 64;
        var ctx = c.getContext("2d");
        var grd = ctx.createLinearGradient(64 - marginW, 0, 64, 0);
        grd.addColorStop(0, "#AAAAAA");
        grd.addColorStop(1, options.pageMiddleShadowColorL);
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, 64, 64);
        var t = new THREE.CanvasTexture(c);
        /*console.log("new THREE.Texture")*/
        t.needsUpdate = true;
        self.specularB = t;

        var c2 = document.createElement("canvas");
        c2.width = 64;
        c2.height = 64;
        var ctx2 = c2.getContext("2d");
        var grd2 = ctx2.createLinearGradient(0, 0, marginW, 0);
        grd2.addColorStop(0, options.pageMiddleShadowColorR);
        grd2.addColorStop(1, "#AAAAAA");
        ctx2.fillStyle = grd2;
        ctx2.fillRect(0, 0, 64, 64);
        var t2 = new THREE.CanvasTexture(c2);
        /*console.log("new THREE.Texture")*/
        t2.needsUpdate = true;
        self.specularF = t2;



        var preloaderMatF, preloaderMatB;

        if (self.options.pagePreloader) {

            var tex = new THREE.TextureLoader().load(self.options.pagePreloader, function() {

            });



            if (self.options.lights) {
                preloaderMatF = new THREE.MeshStandardMaterial({
                    map: tex,
                    roughness: self.options.pageRoughness,
                    metalness: self.options.pageMetalness,
                    emissive: 0x000000,
                    color: 0xededed,
                    lightMap: self.specularF
                });
                preloaderMatB = new THREE.MeshStandardMaterial({
                    map: tex,
                    roughness: self.options.pageRoughness,
                    metalness: self.options.pageMetalness,
                    emissive: 0x000000,
                    color: 0xededed,
                    lightMap: self.specularB
                });
            } else {
                preloaderMatF = preloaderMatB = new THREE.MeshBasicMaterial({
                    map: tex,
                    color: 0xededed
                });
            }





        } else {


            if (self.options.lights) {
                preloaderMatF = new THREE.MeshStandardMaterial({
                    roughness: self.options.pageRoughness,
                    metalness: self.options.pageMetalness,
                    emissive: 0x000000,
                    color: 0xededed,
                    lightMap: self.specularF
                });
                preloaderMatB = new THREE.MeshStandardMaterial({
                    roughness: self.options.pageRoughness,
                    metalness: self.options.pageMetalness,
                    emissive: 0x000000,
                    color: 0xededed,
                    lightMap: self.specularB
                });
            } else {
                preloaderMatF = preloaderMatB = new THREE.MeshBasicMaterial({
                    color: 0xededed
                });
            }



        }




        var p = self.options.pages;

        for (i = 0; i < p.length / 2; i++) {
            hardness = (i == 0 || i == (p.length / 2 - 1)) ? self.options.coverHardness : self.options.pageHardness;
            page = new FLIPBOOK.PageWebGL(self, i, hardness, self.options, preloaderMatF, preloaderMatB);
            self.pages.push(page);
            self.centerContainer.add(page);
            self.flippedright++;

            /*if (self.options.loadAllPages)
                 page.load()*/

            var th = 4;
            if (i > 0) {
                page.position.z = self.pages[i - 1].position.z - th / 2 - th / 2 - 1;
                if (this.bg) this.bg.position.z = page.position.z - 5;
            } else
                page.position.z = th / 2;
        }

        self.initialized = true;

        /*window._m = new THREE.MeshBasicMaterial({color:0xff0000})
       var t =  new THREE.Mesh(new THREE.BoxGeometry(100,100,100), _m)
       this.Scene.add(t)

       console.log( "before", renderer.info.programs.length );
                t.material.dispose()
                console.log( "after", renderer.info.programs.length );*/


        /*  setTimeout(function(){
              console.log(window._m)
              window._m.dispose()
              setTimeout(function(){
                  console.log(window._m)
              },2000)
          },2000)*/

    };

    FLIPBOOK.BookWebGL.prototype.getNumPages = function() {
        return (this.pages.length);
    };

    FLIPBOOK.BookWebGL.prototype.centerContainer = function() {
        return (this.centerContainer);
    };

    FLIPBOOK.BookWebGL.prototype.goToPage = function(index, instant, moved) { //index in book.pages, not page number



        if (!this.initialized) {
            // console.log("initializing...")
            var self = this;
            setTimeout(function() {
                self.goToPage(index, instant);
            }, 100);
            return;
        }

        if (index < 0) index = 0;
        if (index > this.options.pages.length)
            index = this.options.pages.length;

        if(this.view == 1 && !moved){
            var time = instant ? 0 : 300;
            if(index % 2 == 0)
                this.focusLeft(time);
            else
                this.focusRight(time);
        }

        if (index % 2 != 0)
            index--;
        if (index == this.rightIndex) {
            this.loadPages();
            this.turnPageComplete();
            return;
        }

        this.goingToPage = true;

        var self = this;

        var delay = this.options.pageFlipDuration * 1000 / 6;

        if (typeof(instant) != 'undefined' && instant) {

            if (index > self.rightIndex) {
                while (self.rightIndex < index)
                    this.nextPageInstant();
            } else {
                while (self.rightIndex > index)
                    this.prevPageInstant();

            }

            this.updateBookPosition();
            this.loadPages();
            this.turnPageComplete();
            //this.updateHtmlLayer()
            return;
        }

        if (this.rightIndex > index) {

            delay = 1 / (this.rightIndex - index) * this.options.pageFlipDuration * 1000 / 6;
            if (this.rightIndex - index > 10) delay = 0;

            if (this.rightIndex - 2 > index) {
                this.prevPage(false);
                if (delay > 0)
                    setTimeout(function() {
                        self.goToPage(index, instant, 1);
                    }, delay);
                else
                    self.goToPage(index, instant, 1);
            } else {
                this.prevPage();
                setTimeout(function() {
                    if (typeof(instant) != 'undefined' && instant) {
                        for (var i = 0; i < self.pages.length; i++) {
                            self.pages[i].duration = self.options.pageFlipDuration;
                        }
                    }
                    self.loadPages();
                    //self.turnPageComplete()
                }, delay);
            }
        } else if (this.rightIndex < index) {

            delay = -1 / (this.rightIndex - index) * this.options.pageFlipDuration * 1000 / 6;
            if (this.rightIndex - index < -10) delay = 0;

            if ((this.rightIndex + 2) < index) {
                this.nextPage(false);
                if (delay > 0)
                    setTimeout(function() {
                        self.goToPage(index, instant, 1);
                    }, delay);
                else
                    self.goToPage(index, instant, 1);
            } else {
                this.nextPage();
                setTimeout(function() {
                    if (typeof(instant) != 'undefined' && instant) {
                        for (var i = 0; i < self.pages.length; i++) {
                            self.pages[i].duration = self.options.pageFlipDuration;
                        }
                    }
                    self.loadPages();
                    //self.turnPageComplete()
                }, delay);
            }
        }
    };

    FLIPBOOK.BookWebGL.prototype.nextPageInstant = function(load) {
        if (this.flippedright == 0)
            return;

        var i;
        for (i = 0; i < this.pages.length; i++) {
            if (this.pages[i].flippingRight)
                return;
        }


        if (this.view == 1) {
            if (this.isFocusedLeft()) {
                if( !this.goingToPage){
                    this.focusRight(0);
                    this.turnPageComplete();
                    return
                } else {
                    this.focusLeft(0, 0);
                }
            }
        } else {
            if (this.flippedright == 1)
                this.focusLeft(0);
            else
                this.focusBoth(0);

        }

        var page = this.pages[this.pages.length - this.flippedright];

        page.flipLeftInstant();
        this.flippedleft++;
        this.flippedright--;
        this.setRightIndex(this.rightIndex + 2);

        this.updateBookPosition();

    };

    FLIPBOOK.BookWebGL.prototype.setRightIndex = function(value) {

        this.rightIndex = value;

    },

    FLIPBOOK.BookWebGL.prototype.prevPageInstant = function(load) {
        if (this.flippedleft == 0)
            return;
        // if(!this.prevEnabled) return

        var i;
        for (i = 0; i < this.pages.length; i++) {
            if (this.pages[i].flippingLeft)
                return;
        }

        if (this.view == 1) {
            if( !this.goingToPage){
                if (this.isFocusedRight()) {
                    this.focusLeft(0);
                    this.turnPageComplete();
                    return
                } else {
                    this.focusRight(0, 0);
                }
            }
        } else {
            if (this.flippedleft == 1)
                this.focusRight(0);
            else
                this.focusBoth(0);
        }

        var page = this.pages[this.flippedleft - 1];

        page.flipRightInstant();
        this.flippedleft--;
        this.flippedright++;

        this.setRightIndex(this.rightIndex - 2);
        this.updateBookPosition();
    };

    FLIPBOOK.BookWebGL.prototype.nextPage = function(load) {

        // this.nextPageInstant();return;

        if (this.flippedright == 0)
            return;

        this.clickedPage = null;
        if (this.flippedright == 1 && this.pages.length * 2 > this.options.numPages && !this.options.rightToLeft)
            return;
        //    if flipping in opposite direction already - return
        var i;
        var flipping = 0;
        for (i = 0; i < this.pages.length; i++) {
            if (this.pages[i].flippingRight)
                return;
            if (this.pages[i].flipping) flipping++;
        }

        var page = this.pages[this.pages.length - this.flippedright];
        var prevPage = this.pages[page.index - 2];
        var beforePrevPage = this.pages[page.index - 3];
        var nextPage = this.pages[page.index + 1];

        if (nextPage && flipping < 5)
            nextPage.showMat();


        if (this.view == 1) {
            if( !this.goingToPage){

                if (this.isFocusedLeft()) {
                    this.focusRight(300, 0, this.turnPageComplete);
                    return
                } else {
                    this.focusLeft(600, 200);
                }

            }

        } else {
            if (this.flippedright == 1)
                this.focusLeft(500);
            else
                this.focusBoth(500);

        }

        if (!page.flipping) {
            var self = this,
                onComplete;
            if (typeof(load) == 'undefined' || load) {
                onComplete = function(page) {
                    self.loadPages();
                    self.turnPageComplete();
                };
            }

            page.flipLeft(onComplete);
        }
        this.flippedleft++;

        this.flippedright--;
        this.setRightIndex(this.rightIndex + 2);

    };

    FLIPBOOK.BookWebGL.prototype.updateBookPosition = function() {

        if (this.view == 1) {

            if(this.flippedright == 0)
                this.focusLeft();
            else if(this.flippedleft == 0 )
                this.focusRight();
            else
                this.isFocusedLeft() ? this.focusLeft() : this.focusRight();

        } else {
            if (this.rightIndex == 0)
                this.focusRight();
            else if (this.rightIndex >= this.options.numPages)
                this.focusLeft();
            else
                this.focusBoth();

        }

        // this.centerContainer.position.y = 0

        this.updateHtmlLayerPosition();

        this.needsUpdate = true;

    };

    FLIPBOOK.BookWebGL.prototype.updateHtmlLayerPosition = function() {

        if (this.htmlLayer) {
            this.htmlLayer.position.x = this.centerContainer.position.x;
            this.htmlLayer.position.y = this.centerContainer.position.y;
        }

        this.needsUpdate = true;

    };

    FLIPBOOK.BookWebGL.prototype.turnPageComplete = function() {

        this.goingToPage = false;

        this.options.main.turnPageComplete();

    };

    FLIPBOOK.BookWebGL.prototype.loadPages = function(){

        var self = this;

        var pages = this.pages;
        var main = this.options.main;
        for (var i = 0; i < pages.length; i++) {
            var p = pages[i];
            if (p.flippingLeft || p.flippingRight)
                return
        }



        if (this.options.cornerCurl) {
            if (this.flippedleft == 0)
                this.pages[0].startCornerCurl();
            else
                this.pages[0].stopCornerCurl();
        }

        var rightPage = this.pages[this.flippedleft];
        var leftPage = this.pages[this.flippedleft - 1];
        var prevPage = this.pages[this.flippedleft - 2];
        var nextPage = this.pages[this.flippedleft + 1];
        var beforePrevPage = this.pages[this.flippedleft - 3];
        var afterNextPage = this.pages[this.flippedleft + 2];
        var updateHtmlLayer = this.updateHtmlLayer;
        var loadMorePages = this.loadMorePages;


        for (var i = 0; i < pages.length; i++) {
            var p = pages[i];
            if (p === rightPage || p === leftPage)
                p.showMat();


            if (leftPage && p.index < (leftPage.index - 2)) {
                p.hideMat();
                if (!this.options.pdfMode) p.disposeMat();
            }

            if (rightPage && p.index > (rightPage.index + 2)) {
                p.hideMat();
                if (!this.options.pdfMode) p.disposeMat();
            }

        }

        var rightPage = this.pages[this.flippedleft];
        var leftPage = this.pages[this.flippedleft - 1];
        var prevPage = this.pages[this.flippedleft - 2];
        var nextPage = this.pages[this.flippedleft + 1];
        var beforePrevPage = this.pages[this.flippedleft - 3];
        var afterNextPage = this.pages[this.flippedleft + 2];
        var updateHtmlLayer = this.updateHtmlLayer;
        var loadMorePages = this.loadMorePages;
        var self = this;
        var pages = this.pages;
        var main = this.options.main;

        main.setLoadingProgress(.1);

        if (leftPage){
            leftPage.load("back", function(c) {
                if (rightPage){
                    rightPage.load("front", function(c) {
                        leftPage.loadHTML("back", function(){
                            rightPage.loadHTML("front", function(){
                                updateHtmlLayer.call(self);
                            });
                        });

                        main.setLoadingProgress(1);
                        loadMorePages.call(self);
                    });
                }else {
                    leftPage.loadHTML("back", function(){
                        updateHtmlLayer.call(self);
                    });
                    main.setLoadingProgress(1);
                    loadMorePages.call(self);
                }
            });
        } else {
            rightPage.load("front", function(c) {
                rightPage.loadHTML("front", function(){
                    updateHtmlLayer.call(self);
                });
                main.setLoadingProgress(1);
                loadMorePages.call(self);
            });
        }
    };

    FLIPBOOK.BookWebGL.prototype.focusLeft = function(time, delay, callback) {

        var ph = this.options.pageHeight;
        var pw = this.options.pageWidth;
        var cw = this.wrapperW;
        var ch = this.wrapperH;
        var zoom = this.zoom;
        var newX = pw * .5 * this.centerContainer.scale.x;
        var newY = 0;

        this.moveToPos({x:newX, y:newY}, time, delay, callback);

    };

    FLIPBOOK.BookWebGL.prototype.focusRight = function(time, delay, callback) {

        var ph = this.options.pageHeight;
        var pw = this.options.pageWidth;
        var cw = this.wrapperW;
        var ch = this.wrapperH;
        var zoom = this.zoom;
        var newX = -pw * .5 * this.centerContainer.scale.x;
        var newY = 0;

        this.moveToPos({x:newX, y:newY}, time, delay, callback);

    };

    FLIPBOOK.BookWebGL.prototype.focusBoth = function(time, delay, callback) {

        var ph = this.options.pageHeight;
        var pw = this.options.pageWidth;
        var cw = this.wrapperW;
        var ch = this.wrapperH;
        var zoom = this.zoom;
        var newX = 0;
        var newY = 0;

        this.moveToPos({x:newX, y:newY}, time, delay, callback);

    };

    FLIPBOOK.BookWebGL.prototype.moveToPos = function(pos, time, delay, callback) {

        if (time && this.movingTo != pos && this.centerContainer.position.x != pos.x) {
            var self = this;
            this.movingTo = pos;

            if(this.bookMoveTween) this.bookMoveTween.stop();
            this.bookMoveTween = new FLIPBOOK.TWEEN.Tween(this.centerContainer.position).to({
                    x: pos.x,
                    y: pos.y
                }, time)
                .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.Out)
                .onUpdate(function() {
                    self.updateHtmlLayerPosition();
                })
                .onComplete(function() {
                    self.movingTo = null;
                    self.updateHtmlLayerPosition();
                    if(callback) callback.call(self);
                })
                .delay(delay || 0)
                .start();

        } else {
            this.centerContainer.position.x = pos.x;
            this.centerContainer.position.y = pos.y;
            if(callback) callback.call(this);
        }
    };

    FLIPBOOK.BookWebGL.prototype.isFocusedLeft = function() {

        return this.centerContainer.position.x > 0

    };

    FLIPBOOK.BookWebGL.prototype.isFocusedRight = function() {

        return this.centerContainer.position.x < 0

    };

    FLIPBOOK.BookWebGL.prototype.getCurrentPageNumber = function() {
        if(this.view == 1){
            var ri;
            if(this.options.rightToLeft){
                ri = this.options.pages.length - this.rightIndex;
                return this.isFocusedRight() ? ri : ri + 1
            }else {
                ri = this.rightIndex;
                return this.isFocusedLeft() ? ri : ri + 1
            }
        }
    };

    FLIPBOOK.BookWebGL.prototype.prevPage = function(load) {

        // this.prevPageInstant();return;
        if (this.flippedleft == 0)
            return;

        this.clickedPage = null;

        if (this.flippedleft == 1 && this.pages.length * 2 == this.options.numPages && this.options.rightToLeft && this.options.oddPages)
            return;

        var i;
        var flipping = 0;
        for (i = 0; i < this.pages.length; i++) {
            if (this.pages[i].flippingLeft)
                return;

            if (this.pages[i].flipping) flipping++;
        }

        var page = this.pages[this.flippedleft - 1];

        var prevPage = this.pages[page.index - 1];
        var nextPage = this.pages[page.index + 2];
        var afterNextPage = this.pages[page.index + 3];

        if (prevPage && flipping < 5)
            prevPage.showMat();

        if (this.view == 1 ){
            if(!this.goingToPage){
                if (this.isFocusedRight()) {
                    this.focusLeft(300, 0, this.turnPageComplete);
                    return
                } else {
                    this.focusRight(600, 200);
                }
            }

        } else {
            if (this.flippedleft == 1)
                this.focusRight(500);
            else
                this.focusBoth(500);
        }

        if (!page.flipping) {
            var self = this,
                onComplete;
            if (typeof(load) == 'undefined' || load) {
                onComplete = function(page) {
                    self.loadPages();
                    self.turnPageComplete();
                };
            }
            page.flipRight(onComplete);
        }
        this.flippedleft--;
        this.flippedright++;

        this.setRightIndex(this.rightIndex - 2);

    };

    FLIPBOOK.BookWebGL.prototype.firstPage = function() {

    };

    FLIPBOOK.BookWebGL.prototype.flipFinnished = function() {

        this.needsUpdate = true;

    };

    FLIPBOOK.BookWebGL.prototype.lastPage = function() {

    };

    FLIPBOOK.BookWebGL.prototype.updateVisiblePages = function() {

    };

    FLIPBOOK.BookWebGL.prototype.loadMorePages = function() {

        var spreadsToLoadF = this.options.loadPagesF;
        var spreadsToLoadB = this.options.loadPagesB;

        var rightPage = this.pages[this.flippedleft];
        var leftPage = this.pages[this.flippedleft - 1];

        for (var i = 0; i < spreadsToLoadF; i++) {

            leftPage = this.pages[this.flippedleft + i];
            if (leftPage) leftPage.load("back", function() {});

            rightPage = this.pages[this.flippedleft + 1 + i];
            if (rightPage) rightPage.load("front", function() {});


        }

        for (var i = 0; i < spreadsToLoadB; i++) {

            leftPage = this.pages[this.flippedleft - 2 + i];
            if (leftPage) leftPage.load("back", function() {});

            rightPage = this.pages[this.flippedleft - 1 + i];
            if (rightPage) rightPage.load("front", function() {});

        }

    };

    FLIPBOOK.BookWebGL.prototype.updateHtmlLayer = function() {

        if (!this.htmlLayer)
            return;

        for (var i = 0; i < this.pages.length; i++) {
            if (this.pages[i].flipping)
                return
        }

        this.htmlContentRightIndex = this.rightIndex;

        this.htmlLayerVisible = false;

        var R = this.options.rightToLeft ? this.options.pages.length - this.rightIndex - 1 : this.rightIndex;
        var L = this.options.rightToLeft ? R + 1 : R - 1;

        if (this.options.doublePage) {

            //cover

            if (this.rightIndex == 0) {

                var html = this.options.pages[R].htmlContent;

                this.$pageL.hide();
                this.$pageC.hide();
                if (html) {

                    this.$pageRInner.empty();
                    var content = jQuery(html).appendTo(this.$pageRInner);
                    this.$pageR.show();
                    this.htmlLayerVisible = true;

                } else {

                    this.$pageR.hide();

                }

            //back cover

            } else if (this.rightIndex == this.pages.length * 2) {

                var html = this.options.pages[L].htmlContent;

                this.$pageR.hide();
                this.$pageC.hide();
                if (html) {

                    this.$pageLInner.empty();
                    var content = jQuery(html).appendTo(this.$pageLInner);
                    this.$pageL.show();
                    this.htmlLayerVisible = true;

                } else {

                    this.$pageL.hide();

                }

            //spreads

            } else {

                this.$pageL.hide();
                this.$pageR.hide();

                var html = this.options.pages[L].htmlContent || this.options.pages[R].htmlContent;

                if (html) {

                    this.$pageCInner.empty();
                    var content = jQuery(html).appendTo(this.$pageCInner);
                    this.$pageC.show();
                    this.htmlLayerVisible = true;

                } else {

                    this.$pageC.hide();

                }

            }

        } else {

            this.$pageC.hide();

            if (this.rightIndex == 0) {

                this.$pageL.hide();

            } else {

                if (this.options.pages[L].htmlContent) {

                    this.$pageLInner.empty();
                    var content = jQuery(this.options.pages[L].htmlContent).appendTo(this.$pageLInner);
                    this.$pageL.show();
                    this.htmlLayerVisible = true;

                } else {

                    this.$pageL.hide();

                }

            }

            if (this.rightIndex == this.pages.length * 2) {

                this.$pageR.hide();

            } else {

                if (this.options.pages[R].htmlContent) {

                    this.$pageRInner.empty();
                    var content = jQuery(this.options.pages[R].htmlContent).appendTo(this.$pageRInner);
                    this.$pageR.show();
                    this.htmlLayerVisible = true;

                } else {

                    this.$pageR.hide();

                }

            }

        }

        this.updateTool();

    };

    FLIPBOOK.BookWebGL.prototype.updateTool = function() {

        if(this.options.main.tool == "toolSelect"){
            jQuery(".flipbook-textLayer").css("pointer-events","auto").removeClass(".flipbook-noselect");
        }else {
            jQuery(".flipbook-textLayer").css("pointer-events","none").addClass(".flipbook-noselect");
        }

    };

    FLIPBOOK.BookWebGL.prototype.onZoom = function() {

    };

    FLIPBOOK.BookWebGL.prototype.render = function(rendering) {

        var self = this;
        self.rendering = rendering;

    };

    FLIPBOOK.BookWebGL.prototype.zoomTo = function(amount, time, x, y) {

        // console.log("zoom to ",amount)
        if (this.zooming)
            return;
        if (typeof(time) === 'undefined')
            time = 0;

        var newCenter = this.centerContainer.position;

        if (typeof x != 'undefined' && typeof y != 'undefined') {

            var ph = this.zoom * this.wrapper.clientHeight;
            var phNew = amount * this.wrapper.clientHeight;
            var scaleFactor = ph / 1000;
            var scaleFactorNew = phNew / 1000;
            var zoomFactor = amount / this.zoom;
            var center = this.centerContainer.position;
            var focus = { x: (x - this.wrapper.clientWidth / 2) / scaleFactor - center.x, y: (-y + this.wrapper.clientHeight / 2) / scaleFactor - center.y };
            var focusNew = { x: (x - this.wrapper.clientWidth / 2) / scaleFactorNew - center.x, y: (-y + this.wrapper.clientHeight / 2) / scaleFactorNew - center.y };

            newCenter = center;
            newCenter.x = center.x - (focus.x - focusNew.x);
            newCenter.y = center.y - (focus.y - focusNew.y);

        }

        var self = this;
        var o = this.options;
        let newZoom;
        newZoom = amount > this.options.zoomMax ? this.options.zoomMax : amount;
        newZoom = amount < this.options.zoomMin ? this.options.zoomMin : amount;

        if (newZoom == this.options.zoom) {
            //reset book position
            var o = this.options;
            var focusedLeft = this.isFocusedLeft();

            if (this.view == 1) {
                focusedLeft ? this.focusLeft() : this.focusRight();
            } else {
                this.centerContainer.position.set(0, 0, 0);
            }

            this.updateBookPosition();
        }

        time = 0;


        if (time > 0) {
            if (!this.zooming) {
                this.zooming = true;

                new FLIPBOOK.TWEEN.Tween(this).to({
                        zoom: newZoom,
                    }, time)
                    .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.In)
                    .onUpdate(this.updateCameraPosition)
                    .onComplete(function() {
                        self.zooming = false;

                    })
                    .start();

                 new FLIPBOOK.TWEEN.Tween(this.centerContainer.position).to({
                        x:newCenter.x,
                        y:newCenter.y
                    }, time)
                    .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.In)
                    .onUpdate(function(){
                        // console.log(self.centerContainer.position)
                    })
                    .onComplete(function() {
                        // console.log(self.centerContainer.position)

                    })
                    .start();

                if(this.htmlLayer)
                    new FLIPBOOK.TWEEN.Tween(this.htmlLayer.position).to({
                        x:newCenter.x,
                        y:newCenter.y
                    }, time)
                    .easing(FLIPBOOK.TWEEN.Easing.Sinusoidal.In)
                    .start();

            }
        } else {
            this.zoom = newZoom;

            this.centerContainer.position.set(newCenter.x, newCenter.y, 0);

            self.updateHtmlLayerPosition();

            this.updateCameraPosition();

            this.zooming = false;
        }


        if (amount <= 1 && amount <= this.zoom)
            this.updateBookPosition();

        this.options.main.onZoom(newZoom);

        this.loadPages();

        //switch to responsive view if page width is > than container
        // var cw = this.wrapperW
        // var ch = this.wrapperH
        // var bw = 2 * this.options.pageWidth
        // var ch2 = this.options.pageHeight
        // var cw2 = ch2 * cw / ch
        // if(o.responsiveView && bw * this.zoom > cw2){
        //     this.view = 1
        // }else{
        //     this.view = 2
        // }

    };

    FLIPBOOK.BookWebGL.prototype.tiltTo = function(amount) {

        var factor = .3;
        var newTilt = this.tilt + amount * factor;
        newTilt = newTilt > this.options.tiltMax ? this.options.tiltMax : newTilt;
        newTilt = newTilt < this.options.tiltMin ? this.options.tiltMin : newTilt;

        this.tilt = newTilt;
        this.updateCameraPosition();

    };

    FLIPBOOK.BookWebGL.prototype.panTo = function(amount) {

        var factor = .2;
        var newPan = this.pan - amount * factor;
        newPan = newPan > this.options.panMax ? this.options.panMax : newPan;
        newPan = newPan < this.options.panMin ? this.options.panMin : newPan;

        this.pan = newPan;
        this.updateCameraPosition();

    };

    FLIPBOOK.BookWebGL.prototype._bind = function(type, el, bubble) {

        (el || this.wrapper).addEventListener(type, this, !!bubble);

    };

    FLIPBOOK.BookWebGL.prototype.handleEvent = function(e) {

        var self = this;
        // e.preventDefault()
        //console.log(e);
        switch (e.type) {
            case 'mousedown':
                self._start(e);
                break;
            case 'touchstart':
                self._touchstart(e);
                break;
            case 'touchmove':
                self._touchmove(e);
                break;
            case 'mousemove':
                self._move(e);
                break;
            case 'mouseout':
            case 'mouseup':
            case 'touchend':
                self._end(e);
                break;
        }

    };

    FLIPBOOK.BookWebGL.prototype.resetCameraPosition = function() {

        this.centerContainer.position.set(0, 0, 0);

    };

    FLIPBOOK.BookWebGL.prototype._start = function(e) {

        this.mouseDown = true;
        this.onMouseMove = "";
        this.pointX = e.pageX;
        this.pointY = e.pageY;
        this.startPoint = e;
        var vector = this._getVector(e);
        vector.unproject(this.Camera);
        var raycaster = new THREE.Raycaster(this.Camera.position, vector.sub(this.Camera.position).normalize());
        var intersects = raycaster.intersectObjects(this.pages, true);
        this.pageMouseDown = (intersects.length > 0);
        var canvasClicked = e.target.nodeName.toLowerCase() == "canvas";
        if (canvasClicked && !this.pageMouseDown && this.options.lightBox && this.options.lightboxCloseOnClick) {
            this.options.main.lightbox.closeLightbox();
        }

    };

    FLIPBOOK.BookWebGL.prototype._touchstart = function(e) {

        if (e.touches.length > 1) {

            this.touches = [];

            this.touches[0] = {
                pageX: e.touches[0].pageX,
                pageY: e.touches[0].pageY
            };

            this.touches[1] = {
                pageX: e.touches[1].pageX,
                pageY: e.touches[1].pageY
            };

            var c1 = Math.abs(this.touches[0].pageX - this.touches[1].pageX);
            var c2 = Math.abs(this.touches[0].pageY - this.touches[1].pageY);
            this.touchesDistStart = Math.sqrt(c1 * c1 + c2 * c2);
            return;

        }

        e = e.touches[0];
        this._start(e);

    };

    FLIPBOOK.BookWebGL.prototype._getVector = function(e) {

        var w = jQuery(this.canvas).width(),
            h = jQuery(this.canvas).height(),
            // x = e.clientX - jQuery(this.canvas).offset().left,
            x = e.pageX - jQuery(this.canvas).offset().left,
            // y = e.clientY - jQuery(this.canvas).offset().top,
            y = e.pageY - jQuery(this.canvas).offset().top,
            cx = jQuery(this.canvas).offset().x,
            cy = jQuery(this.canvas).offset().y;
        return new THREE.Vector3((x / w) * 2 - 1, -(y / h) * 2 + 1, 0.5);

    };

    FLIPBOOK.BookWebGL.prototype._touchmove = function(e) {
        if (e.touches.length > 1) {
            return
        }

        e = e.touches[0];
        this._move(e);

    };

    FLIPBOOK.BookWebGL.prototype._move = function(e) {

        // return

        var vector = this._getVector(e);
        vector.unproject(this.Camera);
        var raycaster = new THREE.Raycaster(this.Camera.position, vector.sub(this.Camera.position).normalize());
        var intersects = raycaster.intersectObjects(this.pages, true);

        /*if(intersects.length > 0){
        this.wrapper.style.cursor = 'pointer';
    }else{
        this.wrapper.style.cursor = 'auto';
    }*/

        var point = e,
            deltaX = (point.pageX - this.pointX) * .5,
            deltaY = (point.pageY - this.pointY) * .5;

        this.pointX = point.pageX;
        this.pointY = point.pageY;

        if (!this.mouseDown) {
            this.onMouseMove = "";

            if (this.options.rotateCameraOnMouseMove) {
                this.tilt = this.options.tiltMin2 + (this.options.tiltMax2 - this.options.tiltMin2) * (1 - this.pointY / jQuery(this.canvas).height());
                this.pan = this.options.panMin2 + (this.options.panMax2 - this.options.panMin2) * this.pointX / jQuery(this.canvas).width();
                this.updateCameraPosition();
            }


            return;
        }

        if (intersects.length > 0) {
            if (this.onMouseMove == "") {
                if (this.zoom > 1)
                    this.onMouseMove = "scroll";
            }
        } else {
            if (this.onMouseMove == "")
                this.onMouseMove = "rotate";
        }

        if (this.onMouseMove == "scroll") {
            if(this.options.main.tool == "toolSelect")
                return
            if (deltaX != 0 || deltaY != 0) {
                this.moved = true;

                this.centerContainer.position.x += (10000 * deltaX / (this.cameraZ * this.zoom * this.zoom));
                this.centerContainer.position.y -= (10000 * deltaY / (this.cameraZ * this.zoom * this.zoom));

            }

            this.updateHtmlLayerPosition();

        } else if (this.onMouseMove == "rotate") {
            var right = this.getRightPage();
            var left = this.getLeftPage();
            if (!this.options.rotateCameraOnMouseMove && this.options.rotateCameraOnMouseDrag && (!left || !left.dragging) && (!right || !right.dragging)) {
                this.tiltTo(deltaY);
            }
        }
    };

    FLIPBOOK.BookWebGL.prototype._end = function(e) {

        this.mouseDown = false;
        if (typeof(e.changedTouches) != 'undefined')
            e = e.changedTouches[0];
        this.pointX = e.pageX;
        this.pointY = e.pageY;
        this.endPoint = e;
        var vector = this._getVector(this.endPoint);
        vector.unproject(this.Camera);
        var raycaster = new THREE.Raycaster(this.Camera.position, vector.sub(this.Camera.position).normalize());
        var intersects = raycaster.intersectObjects(this.pages, true);
        /*if(intersects.length > 0){
        if(this.pageMouseDown && !this.moved ){
            var intersect = intersects[0];
            var page = intersect.object;
            if(page.flipping || page.dragging)
                return;
            if(this.getLeftPage() && this.getLeftPage().dragging )
                return;
            if(this.getRightPage() && this.getRightPage().dragging )
                return;
            if(page.isFlippedLeft)
                this.prevPage();
            else
                this.nextPage();
        }
    }*/

        if (intersects.length > 0) {
            if (this.pageMouseDown && !this.moved) {
                var intersect = intersects[0];
                this.clickedPage = intersect.object.parent;
            }
        }
        this.pageMouseDown = false;
        this.moved = false;

    };

    FLIPBOOK.BookWebGL.prototype.moveCamera = function(deltaX, deltaY) {

    };

    FLIPBOOK.BookWebGL.prototype.enable = function() {

        if (this.enabled) {
            this.onResize();
            return;
        }
        this.enabled = true;

        if (!this.initialized) {
            this.init3d();
            this.createPages();
            this.rendering = false;
            // this.disable();
            this.onResize();
        }

        this.render(true);
        this.onResize();

    };
    FLIPBOOK.BookWebGL.prototype.disable = function() {
        this.enabled = false;
        this.render(false);
    };
}

{ /* MOD3D */
    /**
     *
     * http://github.com/foo123/MOD3
     *
     * MOD3 3D Modifier Library (port of actionscript AS3Mod to javascript)
     * supports: THREE.js, J3D, Copperlicht, Pre3D
     *
     * @author Nikos M.
     * @url http://nikos-web-development.netai.net/
     *
     **/
    var MOD3 = MOD3 || {};
    (function(a) {
        a.Constants = {
            PI: Math.PI,
            invPI: 1 / Math.PI,
            halfPI: 0.5 * Math.PI,
            doublePI: 2 * Math.PI,
            toRad: 1 / 180 * Math.PI,
            toDeg: 1 / 180 * Math.PI
        };
        a.ModConstant = {
            LEFT: -1,
            RIGHT: 1,
            NONE: 0,
            X: 1,
            Y: 2,
            Z: 4
        };
    })(MOD3);
    (function(a) {
        var c = a.Constants;
        a.XMath = {};
        a.XMath.normalize = function(c, d, e) {
            return d - c == 0 ? 1 : a.XMath.trim(0, 1, (e - c) / d)
        };
        a.XMath.toRange = function(a, c, e) {
            return c - a == 0 ? 0 : a + (c - a) * e
        };
        a.XMath.inRange = function(a, c, e, f) {
            typeof f == "undefined" && (f = !1);
            return f ? e >= a && e <= c : e > a && e < c
        };
        a.XMath.sign = function(a, c) {
            typeof c == "undefined" && (c = 0);
            return 0 == a ? c : a > 0 ? 1 : -1
        };
        a.XMath.trim = function(a, c, e) {
            return Math.min(c, Math.max(a, e))
        };
        a.XMath.wrap = function(a, c, e) {
            return e < a ? e + (c - a) : e >= c ? e - (c - a) : e
        };
        a.XMath.degToRad = function(a) {
            return a *
                c.toRad
        };
        a.XMath.radToDeg = function(a) {
            return a * c.toDeg
        };
        a.XMath.presicion = function(a, c) {
            var e = Math.pow(10, c);
            return Math.round(a * e) / e
        };
        a.XMath.uceil = function(a) {
            return a < 0 ? Math.floor(a) : Math.ceil(a)
        };
    })(MOD3);
    (function(a) {
        a.Range = function(a, b) {
            this.start = 0;
            this.end = 1;
            if (typeof a != "undefined") this.start = a;
            if (typeof b != "undefined") this.end = b;
        };
        a.Range.prototype.getSize = function() {
            return this.end - this.start
        };
        a.Range.prototype.move = function(a) {
            this.start += a;
            this.end += a;
        };
        a.Range.prototype.isIn = function(a) {
            return a >= this.start && a <= this.end
        };
        a.Range.prototype.normalize = function(c) {
            return a.XMath.normalize(this.start, this.end, c)
        };
        a.Range.prototype.toRange = function(c) {
            return a.XMath.toRange(this.start, this.end,
                c)
        };
        a.Range.prototype.trim = function(c) {
            return a.XMath.trim(this.start, this.end, c)
        };
        a.Range.prototype.interpolate = function(a, b) {
            return this.toRange(b.normalize(a))
        };
        a.Range.prototype.toString = function() {
            return "[" + this.start + " - " + this.end + "]"
        };
    })(MOD3);
    (function(a) {
        a.Phase = function(a) {
            this.value = 0;
            if (typeof a != "undefined") this.value = a;
        };
        a.Phase.prototype.getPhasedValue = function() {
            return Math.sin(this.value)
        };
        a.Phase.prototype.getAbsPhasedValue = function() {
            return Math.abs(this.getPhasedValue())
        };
        a.Phase.prototype.getNormValue = function() {
            return (this.getPhasedValue() + 1) * 0.5
        };
    })(MOD3);
    (function(a) {
        a.Point = function(a, b) {
            this.y = this.x = 0;
            if (typeof a != "undefined") this.x = a;
            if (typeof b != "undefined") this.y = b;
        };
        a.Point.prototype.clone = function() {
            return new a.Point(this.x, this.y)
        };
    })(MOD3);
    (function(a) {
        a.Matrix = function(a, b, d, e) {
            this.m11 = 1;
            this.m21 = this.m12 = 0;
            this.m22 = 1;
            if (typeof a != "undefined") this.m11 = a;
            if (typeof b != "undefined") this.m12 = b;
            if (typeof d != "undefined") this.m21 = d;
            if (typeof e != "undefined") this.m22 = e;
        };
        a.Matrix.prototype.rotate = function(a) {
            var b = Math.cos(a),
                a = Math.sin(a);
            this.m11 = b;
            this.m12 = -a;
            this.m21 = a;
            this.m22 = b;
            return this
        };
        a.Matrix.prototype.scale = function(a, b) {
            this.m21 = this.m12 = 0;
            if (typeof a != "undefined") this.m22 = this.m11 = a;
            if (typeof b != "undefined") this.m22 = b;
            return this
        };
        a.Matrix.prototype.multiply = function(a) {
            var b = this.m11,
                d = this.m12,
                e = this.m21,
                f = this.m22,
                g = a.m11,
                h = a.m12,
                i = a.m21,
                a = a.m22;
            this.m11 = b * g + d * i;
            this.m12 = b * h + d * a;
            this.m21 = e * g + f * i;
            this.m22 = e * h + f * a;
            return this
        };
        a.Matrix.prototype.transformPoint = function(c) {
            return new a.Point(this.m11 * c.x + this.m12 * c.y, this.m21 * c.x + this.m22 * c.y)
        };
    })(MOD3);
    (function(a) {
        a.Vector3 = function(a, b, d) {
            this.z = this.y = this.x = null;
            this.x = a;
            this.y = b;
            this.z = d;
        };
        a.Vector3.ZERO = function() {
            return new a.Vector3(0, 0, 0)
        };
        a.Vector3.dot = function(a, b) {
            return a.x * b.x + a.y * b.y + a.z * b.z
        };
        a.Vector3.prototype.clone = function() {
            return new a.Vector3(this.x, this.y, this.z)
        };
        a.Vector3.prototype.equals = function(a) {
            return this.x == a.x && this.y == a.y && this.z == a.z
        };
        a.Vector3.prototype.zero = function() {
            this.x = this.y = this.z = 0;
        };
        a.Vector3.prototype.negate = function() {
            return new a.Vector3(-this.x, -this.y, -this.z)
        };
        a.Vector3.prototype.add = function(c) {
            return new a.Vector3(this.x + c.x, this.y + c.y, this.z + c.z)
        };
        a.Vector3.prototype.subtract = function(c) {
            return new a.Vector3(this.x - c.x, this.y - c.y, this.z - c.z)
        };
        a.Vector3.prototype.multiplyScalar = function(c) {
            return new a.Vector3(this.x * c, this.y * c, this.z * c)
        };
        a.Vector3.prototype.multiply = function(c) {
            return new a.Vector3(this.x * c.x, this.y * c.y, this.z * c.z)
        };
        a.Vector3.prototype.divide = function(c) {
            c = 1 / c;
            return new a.Vector3(this.x * c, this.y * c, this.z * c)
        };
        a.Vector3.prototype.normalize =
            function() {
                var a = this.x,
                    b = this.y,
                    d = this.z,
                    a = a * a + b * b + d * d;
                a > 0 && (a = 1 / Math.sqrt(a), this.x *= a, this.y *= a, this.z *= a);
            };
        a.Vector3.prototype.getMagnitude = function() {
            var a = this.x,
                b = this.y,
                d = this.z;
            return Math.sqrt(a * a + b * b + d * d)
        };
        a.Vector3.prototype.setMagnitude = function(a) {
            this.normalize();
            this.x *= a;
            this.y *= a;
            this.z *= a;
        };
        a.Vector3.prototype.toString = function() {
            return "[" + this.x + " , " + this.y + " , " + this.z + "]"
        };
        a.Vector3.prototype.sum = function(a, b) {
            return a.add(b)
        };
        a.Vector3.prototype.dot = function(a, b) {
            return a.x *
                b.x + a.y * b.y + a.z * b.z
        };
        a.Vector3.prototype.cross = function(c, b) {
            var d = c.x,
                e = c.y,
                f = c.z,
                g = b.x,
                h = b.y,
                i = b.z;
            return new a.Vector3(e * i - f * h, f * g - d * i, d * h - e * g)
        };
        a.Vector3.prototype.distance = function(a, b) {
            var d = a.x - b.x,
                e = a.y - b.y,
                f = a.z - b.z;
            return Math.sqrt(d * d + e * e + f * f)
        };
    })(MOD3);
    (function(a) {
        a.Matrix4 = function(a, b, d, e, f, g, h, i, n, m, o, k, p, l, j, q) {
            this.n11 = 1;
            this.n21 = this.n14 = this.n13 = this.n12 = 0;
            this.n22 = 1;
            this.n32 = this.n31 = this.n24 = this.n23 = 0;
            this.n33 = 1;
            this.n43 = this.n42 = this.n41 = this.n34 = 0;
            this.n44 = 1;
            if (typeof a != "undefined") this.n11 = a;
            if (typeof b != "undefined") this.n12 = b;
            if (typeof d != "undefined") this.n13 = d;
            if (typeof e != "undefined") this.n14 = e;
            if (typeof f != "undefined") this.n21 = f;
            if (typeof g != "undefined") this.n22 = g;
            if (typeof h != "undefined") this.n23 = h;
            if (typeof i != "undefined") this.n24 =
                i;
            if (typeof n != "undefined") this.n31 = n;
            if (typeof m != "undefined") this.n32 = m;
            if (typeof o != "undefined") this.n33 = o;
            if (typeof k != "undefined") this.n34 = k;
            if (typeof p != "undefined") this.n41 = p;
            if (typeof l != "undefined") this.n42 = l;
            if (typeof j != "undefined") this.n43 = j;
            if (typeof q != "undefined") this.n44 = q;
        };
        a.Matrix4.prototype.translationMatrix = function(a, b, d) {
            this.n14 = a;
            this.n24 = b;
            this.n34 = d;
            return this
        };
        a.Matrix4.prototype.scaleMatrix = function(a, b, d) {
            this.n11 = a;
            this.n22 = b;
            this.n33 = d;
            return this
        };
        a.Matrix4.prototype.rotationMatrix =
            function(a, b, d, e) {
                var f = Math.cos(e),
                    g = Math.sin(e),
                    e = 1 - f,
                    h = a * b * e,
                    i = b * d * e,
                    n = a * d * e,
                    m = g * d,
                    o = g * b;
                g *= a;
                this.n11 = f + a * a * e;
                this.n12 = -m + h;
                this.n13 = o + n;
                this.n14 = 0;
                this.n21 = m + h;
                this.n22 = f + b * b * e;
                this.n23 = -g + i;
                this.n24 = 0;
                this.n31 = -o + n;
                this.n32 = g + i;
                this.n33 = f + d * d * e;
                this.n34 = 0;
                return this
            };
        a.Matrix4.prototype.calculateMultiply = function(a, b) {
            var d = a.n11,
                e = b.n11,
                f = a.n21,
                g = b.n21,
                h = a.n31,
                i = b.n31,
                n = a.n12,
                m = b.n12,
                o = a.n22,
                k = b.n22,
                p = a.n32,
                l = b.n32,
                j = a.n13,
                q = b.n13,
                r = a.n23,
                t = b.n23,
                s = a.n33,
                u = b.n33,
                v = a.n14,
                w = b.n14,
                z = a.n24,
                x =
                b.n24,
                A = a.n34,
                y = b.n34;
            this.n11 = d * e + n * g + j * i;
            this.n12 = d * m + n * k + j * l;
            this.n13 = d * q + n * t + j * u;
            this.n14 = d * w + n * x + j * y + v;
            this.n21 = f * e + o * g + r * i;
            this.n22 = f * m + o * k + r * l;
            this.n23 = f * q + o * t + r * u;
            this.n24 = f * w + o * x + r * y + z;
            this.n31 = h * e + p * g + s * i;
            this.n32 = h * m + p * k + s * l;
            this.n33 = h * q + p * t + s * u;
            this.n34 = h * w + p * x + s * y + A;
        };
        a.Matrix4.prototype.multiply = function(a, b) {
            this.calculateMultiply(a, b);
            return this
        };
        a.Matrix4.prototype.multiplyVector = function(a, b) {
            var d = b.x,
                e = b.y,
                f = b.z;
            b.x = d * a.n11 + e * a.n12 + f * a.n13 + a.n14;
            b.y = d * a.n21 + e * a.n22 + f * a.n23 + a.n24;
            b.z = d * a.n31 + e * a.n32 + f * a.n33 + a.n34;
        };
    })(MOD3);
    (function(a) {
        a.VertexProxy = function(a) {
            this.originalZ = this.originalY = this.originalX = this.ratioZ = this.ratioY = this.ratioX = null;
            if (typeof a != "undefined") this.vertex = a;
        };
        a.VertexProxy.prototype.setVertex = function() {};
        a.VertexProxy.prototype.setRatios = function(a, b, d) {
            this.ratioX = a;
            this.ratioY = b;
            this.ratioZ = d;
        };
        a.VertexProxy.prototype.setOriginalPosition = function(a, b, d) {
            this.originalX = a;
            this.originalY = b;
            this.originalZ = d;
        };
        a.VertexProxy.prototype.getX = function() {};
        a.VertexProxy.prototype.getY = function() {};
        a.VertexProxy.prototype.getZ = function() {};
        a.VertexProxy.prototype.setX = function() {};
        a.VertexProxy.prototype.setY = function() {};
        a.VertexProxy.prototype.setZ = function() {};
        a.VertexProxy.prototype.getValue = function(c) {
            switch (c) {
                case a.ModConstant.X:
                    return this.getX();
                case a.ModConstant.Y:
                    return this.getY();
                case a.ModConstant.Z:
                    return this.getZ()
            }
            return 0
        };
        a.VertexProxy.prototype.setValue = function(c, b) {
            switch (c) {
                case a.ModConstant.X:
                    this.setX(b);
                    break;
                case a.ModConstant.Y:
                    this.setY(b);
                    break;
                case a.ModConstant.Z:
                    this.setZ(b);
            }
        };
        a.VertexProxy.prototype.getRatio = function(c) {
            switch (c) {
                case a.ModConstant.X:
                    return this.ratioX;
                case a.ModConstant.Y:
                    return this.ratioY;
                case a.ModConstant.Z:
                    return this.ratioZ
            }
            return -1
        };
        a.VertexProxy.prototype.getOriginalValue = function(c) {
            switch (c) {
                case a.ModConstant.X:
                    return this.originalX;
                case a.ModConstant.Y:
                    return this.originalY;
                case a.ModConstant.Z:
                    return this.originalZ
            }
            return 0
        };
        a.VertexProxy.prototype.reset = function() {
            this.setX(this.originalX);
            this.setY(this.originalY);
            this.setZ(this.originalZ);
        };
        a.VertexProxy.prototype.collapse = function() {
            this.originalX = this.getX();
            this.originalY = this.getY();
            this.originalZ = this.getZ();
        };
        a.VertexProxy.prototype.getVector = function() {
            return new a.Vector3(this.getX(), this.getY(), this.getZ())
        };
        a.VertexProxy.prototype.setVector = function(a) {
            this.setX(a.x);
            this.setY(a.y);
            this.setZ(a.z);
        };
        a.VertexProxy.prototype.getRatioVector = function() {
            return new a.Vector3(this.ratioX, this.ratioY, this.ratioZ)
        };
    })(MOD3);
    (function(a) {
        a.FaceProxy = function() {
            this.vertices = [];
        };
        a.FaceProxy.prototype.addVertex = function(a) {
            this.vertices.push(a);
        };
        a.FaceProxy.prototype.getVertices = function() {
            return this.vertices
        };
    })(MOD3);
    (function(a) {
        a.MeshProxy = function() {
            this.depth = this.height = this.width = this.minAxis = this.midAxis = this.maxAxis = this.minZ = this.minY = this.minX = this.maxZ = this.maxY = this.maxX = null;
            this.vertices = [];
            this.faces = [];
            this.mesh = null;
        };
        a.MeshProxy.prototype.getVertices = function() {
            return this.vertices
        };
        a.MeshProxy.prototype.getFaces = function() {
            return this.faces
        };
        a.MeshProxy.prototype.analyzeGeometry = function() {
            for (var c = this.getVertices(), b = c.length, d = b, e, f, g, h, i, n, m, o, k, p, l = !0, j = Math.min, q = Math.max; --d >= 0;) e = c[d],
                f = e.getX(), g = e.getY(), h = e.getZ(), l ? (i = n = f, m = o = g, k = p = h, l = !1) : (i = j(i, f), m = j(m, g), k = j(k, h), n = q(n, f), o = q(o, g), p = q(p, h)), e.setOriginalPosition(f, g, h);
            f = n - i;
            g = o - m;
            let depth;
            depth = p - k;
            this.width = f;
            this.height = g;
            this.depth = depth;
            this.minX = i;
            this.maxX = n;
            this.minY = m;
            this.maxY = o;
            this.minZ = k;
            this.maxZ = p;
            d = q(f, q(g, depth));
            j = j(f, j(g, depth));
            if (d == f && j == g) this.minAxis = a.ModConstant.Y, this.midAxis = a.ModConstant.Z, this.maxAxis = a.ModConstant.X;
            else if (d == f && j == depth) this.minAxis = a.ModConstant.Z, this.midAxis = a.ModConstant.Y,
                this.maxAxis = a.ModConstant.X;
            else if (d == g && j == f) this.minAxis = a.ModConstant.X, this.midAxis = a.ModConstant.Z, this.maxAxis = a.ModConstant.Y;
            else if (d == g && j == depth) this.minAxis = a.ModConstant.Z, this.midAxis = a.ModConstant.X, this.maxAxis = a.ModConstant.Y;
            else if (d == depth && j == f) this.minAxis = a.ModConstant.X, this.midAxis = a.ModConstant.Y, this.maxAxis = a.ModConstant.Z;
            else if (d == depth && j == g) this.minAxis = a.ModConstant.Y, this.midAxis = a.ModConstant.X, this.maxAxis = a.ModConstant.Z;
            for (d = b; --d >= 0;) e = c[d], e.setRatios((e.getX() -
                i) / f, (e.getY() - m) / g, (e.getZ() - k) / depth);
        };
        a.MeshProxy.prototype.resetGeometry = function() {
            for (var a = this.getVertices(), b = a.length; --b >= 0;) a[b].reset();
        };
        a.MeshProxy.prototype.collapseGeometry = function() {
            for (var a = this.getVertices(), b = a.length; --b >= 0;) a[b].collapse();
            this.analyzeGeometry();
        };
        a.MeshProxy.prototype.getMin = function(c) {
            switch (c) {
                case a.ModConstant.X:
                    return this.minX;
                case a.ModConstant.Y:
                    return this.minY;
                case a.ModConstant.Z:
                    return this.minZ
            }
            return -1
        };
        a.MeshProxy.prototype.getMax = function(c) {
            switch (c) {
                case a.ModConstant.X:
                    return this.maxX;
                case a.ModConstant.Y:
                    return this.maxY;
                case a.ModConstant.Z:
                    return this.maxZ
            }
            return -1
        };
        a.MeshProxy.prototype.getSize = function(c) {
            switch (c) {
                case a.ModConstant.X:
                    return this.width;
                case a.ModConstant.Y:
                    return this.height;
                case a.ModConstant.Z:
                    return this.depth
            }
            return -1
        };
        a.MeshProxy.prototype.setMesh = function(a) {
            this.mesh = a;
            this.vertices = [];
            this.faces = [];
        };
        a.MeshProxy.prototype.postApply = function() {};
        a.MeshProxy.prototype.updateMeshPosition = function() {};
    })(MOD3);
    (function(a) {
        a.Modifier = function() {
            this.mod = null;
        };
        a.Modifier.prototype.setModifiable = function(a) {
            this.mod = a;
        };
        a.Modifier.prototype.getVertices = function() {
            return this.mod.getVertices()
        };
        a.Modifier.prototype.apply = function() {};
    })(MOD3);
    (function(a) {
        a.Library3d = function() {
            this.id = "";
            this.vertexClass = this.meshClass = null;
        };
    })(MOD3);
    (function(a) {
        a.PluginFactory = {};
        a.PluginFactory.getMeshProxy = function(a) {
            return new a.meshClass
        };
    })(MOD3);
    (function(a) {
        a.ModifierStack = function(c, b) {
            this.lib3d = c;
            this.stack = this.baseMesh = null;
            this.baseMesh = a.PluginFactory.getMeshProxy(c);
            this.baseMesh.setMesh(b);
            this.baseMesh.analyzeGeometry();
            this.stack = [];
        };
        a.ModifierStack.prototype.addModifier = function(a) {
            a.setModifiable(this.baseMesh);
            this.stack.push(a);
        };
        a.ModifierStack.prototype.apply = function() {
            this.baseMesh.resetGeometry();
            for (var a = this.stack, b = a.length, d = 0; d < b;) a[d++].apply();
            this.baseMesh.postApply();
        };
        a.ModifierStack.prototype.collapse = function() {
            this.apply();
            this.baseMesh.collapseGeometry();
            this.stack = [];
        };
        a.ModifierStack.prototype.clear = function() {
            this.stack = [];
        };
        a.ModifierStack.prototype.getMeshInfo = function() {
            return this.baseMesh
        };
    })(MOD3);
    (function(a) {
        a.Pivot = function(c, b, d) {
            this.pivot = new a.Vector3(c, b, d);
        };
        a.Pivot.prototype = new a.Modifier;
        a.Pivot.prototype.constructor = a.Pivot;
        a.Pivot.prototype.setMeshCenter = function() {
            var c = this.mod;
            this.pivot = new a.Vector3(-(c.minX + 0.5 * c.width), -(c.minY + 0.5 * c.height), -(c.minZ + 0.5 * c.depth));
        };
        a.Pivot.prototype.apply = function() {
            for (var a = this.mod.getVertices(), b = a.length, d = this.pivot, e, f; --b >= 0;) e = a[b], f = e.getVector().clone(), e.setVector(f.add(d));
            this.mod.updateMeshPosition(d.clone().negate());
        };
    })(MOD3);
    (function(a) {
        a.Bend = function(c, b, d) {
            this.diagAngle = this.angle = this.offset = this.force = null;
            this.constraint = a.ModConstant.NONE;
            this.m2 = this.m1 = this.origin = this.height = this.width = this.mid = this.min = this.max = null;
            this.switchAxes = !1;
            this.force = c;
            this.offset = b;
            this.setAngle(d);
        };
        a.Bend.prototype = new a.Modifier;
        a.Bend.prototype.constructor = a.Bend;
        a.Bend.prototype.setAngle = function(c) {
            this.angle = c;
            this.m1 = new a.Matrix;
            this.m1.rotate(c);
            this.m2 = new a.Matrix;
            this.m2.rotate(-c);
        };
        a.Bend.prototype.setModifiable =
            function(c) {
                a.Modifier.prototype.setModifiable.call(this, c);
                this.max = this.switchAxes ? this.mod.midAxis : this.mod.maxAxis;
                this.min = this.mod.minAxis;
                this.mid = this.switchAxes ? this.mod.maxAxis : this.mod.midAxis;
                this.width = this.mod.getSize(this.max);
                this.height = this.mod.getSize(this.mid);
                this.origin = this.mod.getMin(this.max);
                this.diagAngle = Math.atan(this.width / this.height);
            };
        a.Bend.prototype.apply = function() {
            if (this.force != 0)
                for (var c = this.mod.getVertices(), b = c.length, d = this.width, e = this.offset, f = this.origin,
                        g = this.max, h = this.min, i = this.mid, n = this.m1, m = this.m2, o = f + d * e, k = d / Math.PI / this.force, p = a.Constants.doublePI * (d / (k * a.Constants.doublePI)), l, j, q, r, t = 1 / d, s = a.Constants.halfPI, u = Math.sin, v = Math.cos; --b >= 0;) d = c[b], l = d.getValue(g), j = d.getValue(i), q = d.getValue(h), j = n.transformPoint(new a.Point(l, j)), l = j.x, j = j.y, r = (l - f) * t, this.constraint == a.ModConstant.LEFT && r <= e || this.constraint == a.ModConstant.RIGHT && r >= e || (r = s - p * e + p * r, l = u(r) * (k + q), r = v(r) * (k + q), q = l - k, l = o - r), j = m.transformPoint(new a.Point(l, j)), l = j.x, j = j.y,
                    d.setValue(g, l), d.setValue(i, j), d.setValue(h, q);
        };
    })(MOD3);
    (function(a) {
        a.Bloat = function() {
            this.center = a.Vector3.ZERO();
            this.radius = 0;
            this.a = 0.01;
            this.u = a.Vector3.ZERO();
        };
        a.Bloat.prototype = new a.Modifier;
        a.Bloat.prototype.constructor = a.Bloat;
        a.Bloat.prototype.setRadius = function(a) {
            this.radius = Math.max(0, a);
        };
        a.Bloat.prototype.setA = function(a) {
            this.a = Math.max(0, a);
        };
        a.Bloat.prototype.apply = function() {
            for (var a = this.mod.getVertices(), b = a.length, d = this.center, e = this.radius, f = this.a, g, h; --b >= 0;) g = a[b], this.u.x = g.getX() - d.x, this.u.y = g.getY() - d.y, this.u.z = g.getZ() -
                d.z, h = this.u.getMagnitude(), this.u.setMagnitude(h + e * Math.exp(-h * f)), g.setX(this.u.x + d.x), g.setY(this.u.y + d.y), g.setZ(this.u.z + d.z);
        };
    })(MOD3);
    (function(a) {
        a.Twist = function(c) {
            this.vector = new a.Vector3(0, 1, 0);
            this.angle = c;
            this.center = a.Vector3.ZERO();
        };
        a.Twist.prototype = new a.Modifier;
        a.Twist.prototype.constructor = a.Twist;
        a.Twist.prototype.apply = function() {
            this.vector.normalize();
            for (var c = this.mod, b = c.getVertices(), d = b.length, e = this.vector, f = this.angle, g = this.center, c = 1 / (new a.Vector3(0.5 * c.maxX, 0.5 * c.maxY, 0.5 * c.maxZ)).getMagnitude() * f, g = -a.Vector3.dot(e, g), h; --d >= 0;) f = b[d], h = f.getX() * e.x + f.getY() * e.y + f.getZ() * e.z + g, this.twistPoint(f, h *
                c);
        };
        a.Twist.prototype.twistPoint = function(c, b) {
            var d = (new a.Matrix4).translationMatrix(c.getX(), c.getY(), c.getZ()),
                d = (new a.Matrix4).multiply((new a.Matrix4).rotationMatrix(this.vector.x, this.vector.y, this.vector.z, b), d);
            c.setX(d.n14);
            c.setY(d.n24);
            c.setZ(d.n34);
        };
    })(MOD3);
    (function(a) {
        a.Skew = function(c) {
            this.force = 0;
            this.skewAxis = null;
            if (typeof c != "undefined") this.force = c;
            this.offset = 0.5;
            this.constraint = a.ModConstant.NONE;
            this.falloff = this.power = 1;
            this.swapAxes = this.oneSide = this.inverseFalloff = !1;
        };
        a.Skew.prototype = new a.Modifier;
        a.Skew.prototype.constructor = a.Skew;
        a.Skew.prototype.setModifiable = function(c) {
            a.Modifier.prototype.setModifiable.call(this, c);
            this.skewAxis = this.skewAxis || this.mod.maxAxis;
        };
        a.Skew.prototype.apply = function() {
            for (var c = this.mod.getVertices(),
                    b = c.length, d = this.constraint, e = this.skewAxis, f = this.offset, g = this.oneSide, h = this.inverseFalloff, i = this.falloff, n = 1 - i, m = this.power, o = this.force, k = this.getDisplaceAxis(), p, l, j; --b >= 0;) p = c[b], !(d == a.ModConstant.LEFT && p.getRatio(e) <= f) && !(d == a.ModConstant.RIGHT && p.getRatio(e) > f) && (l = p.getRatio(e) - f, g && (l = Math.abs(l)), j = p.getRatio(k), h && (j = 1 - j), j = i + j * n, l = Math.pow(Math.abs(l), m) * a.XMath.sign(l, 1), l = p.getValue(k) + o * l * j, p.setValue(k, l));
        };
        a.Skew.prototype.getDisplaceAxis = function() {
            switch (this.skewAxis) {
                case a.ModConstant.X:
                    return this.swapAxes ?
                        a.ModConstant.Z : a.ModConstant.Y;
                case a.ModConstant.Y:
                    return this.swapAxes ? a.ModConstant.Z : a.ModConstant.X;
                case a.ModConstant.Z:
                    return this.swapAxes ? a.ModConstant.Y : a.ModConstant.X;
                default:
                    return 0
            }
        };
    })(MOD3);
    (function(a) {
        a.Taper = function(c) {
            this.power = this.force = null;
            this.start = 0;
            this.end = 1;
            this.vector = new a.Vector3(1, 0, 1);
            this.vector2 = new a.Vector3(0, 1, 0);
            if (typeof c != "undefined") this.force = c;
            this.power = 1;
        };
        a.Taper.prototype = new a.Modifier;
        a.Taper.prototype.constructor = a.Taper;
        a.Taper.prototype.setFalloff = function(a, b) {
            this.start = 0;
            this.end = 1;
            if (typeof a != "undefined") this.start = a;
            if (typeof b != "undefined") this.end = b;
        };
        a.Taper.prototype.apply = function() {
            for (var c = this.mod.getVertices(), b = c.length, d = this.vector,
                    e = this.vector2, f = this.force, g = this.power, h, i, n; --b >= 0;) h = c[b], i = h.getRatioVector().multiply(e), i = f * Math.pow(i.getMagnitude(), g), i = (new a.Matrix4).scaleMatrix(1 + i * d.x, 1 + i * d.y, 1 + i * d.z), n = h.getVector(), (new a.Matrix4).multiplyVector(i, n), h.setVector(n);
        };
    })(MOD3);
    (function(a) {
        a.Wheel = function() {
            this.radius = this.roll = this.turn = this.speed = null;
            this.steerVector = new a.Vector3(0, 1, 0);
            this.rollVector = new a.Vector3(0, 0, 1);
            this.roll = this.turn = this.speed = 0;
        };
        a.Wheel.prototype = new a.Modifier;
        a.Wheel.prototype.constructor = a.Wheel;
        a.Wheel.prototype.setModifiable = function(c) {
            a.Modifier.prototype.setModifiable.call(this, c);
            this.radius = 0.5 * this.mod.width;
        };
        a.Wheel.prototype.apply = function() {
            this.roll += this.speed;
            var c = this.mod.getVertices(),
                b = c.length,
                d = this.steerVector,
                e =
                this.turn,
                f = this.rollVector,
                g = this.roll,
                h;
            0 != e ? (h = (new a.Matrix4).rotationMatrix(d.x, d.y, d.z, e), d = f.clone(), (new a.Matrix4).multiplyVector(h, d), g = (new a.Matrix4).rotationMatrix(d.x, d.y, d.z, g)) : g = (new a.Matrix4).rotationMatrix(f.x, f.y, f.z, g);
            for (; --b >= 0;) d = c[b], f = d.getVector().clone(), 0 != e && (new a.Matrix4).multiplyVector(h, f), (new a.Matrix4).multiplyVector(g, f), d.setX(f.x), d.setY(f.y), d.setZ(f.z);
        };
        a.Wheel.prototype.getStep = function() {
            return this.radius * this.speed * a.Constants.invPI
        };
        a.Wheel.prototype.getPerimeter =
            function() {
                return this.radius * a.Constants.doublePI
            };
    })(MOD3);
    (function(a) {
        a.Break = function(c, b) {
            this.bv = new a.Vector3(0, 1, 0);
            this.angle = this.offset = 0;
            if (typeof c != "undefined") this.offset = c;
            if (typeof b != "undefined") this.angle = b;
            this.range = new a.Range(0, 1);
        };
        a.Break.prototype = new a.Modifier;
        a.Break.prototype.constructor = a.Break;
        a.Break.prototype.apply = function() {
            var c = this.mod,
                b = c.getVertices(),
                d = b.length,
                e = this.range,
                f = this.angle,
                g = this.bv,
                h, i, c = new a.Vector3(0, 0, -(c.minZ + c.depth * this.offset));
            h = c.negate();
            for (i = (new a.Matrix4).rotationMatrix(g.x, g.y, g.z, f); --d >=
                0;) f = b[d], g = f.getVector(), g = g.add(c), g.z >= 0 && e.isIn(f.ratioY) && (new a.Matrix4).multiplyVector(i, g), g = g.add(h), f.setX(g.x), f.setY(g.y), f.setZ(g.z);
        };
    })(MOD3);
    (function(a) {
        a.Noise = function(c) {
            this.force = 0;
            this.axc = a.ModConstant.NONE;
            this.end = this.start = 0;
            if (typeof c != "undefined") this.force = c;
        };
        a.Noise.prototype = new a.Modifier;
        a.Noise.prototype.constructor = a.Noise;
        a.Noise.prototype.constraintAxes = function(a) {
            this.axc = a;
        };
        a.Noise.prototype.setFalloff = function(a, b) {
            this.start = 0;
            this.end = 1;
            if (typeof a != "undefined") this.start = a;
            if (typeof b != "undefined") this.end = b;
        };
        a.Noise.prototype.apply = function() {
            for (var a = this.mod, b = this.axc, d = this.start, e = this.end, f = a.getVertices(),
                    g = f.length, h = this.force, i = 0.5 * h, n = Math.random, m, o, k; --g >= 0;) m = f[g], o = n() * h - i, k = m.getRatio(a.maxAxis), d < e ? (k < d && (k = 0), k > e && (k = 1)) : d > e ? (k = 1 - k, k > d && (k = 0), k < e && (k = 1)) : k = 1, b & 1 || m.setX(m.getX() + o * k), b >> 1 & 1 || m.setY(m.getY() + o * k), b >> 2 & 1 || m.setZ(m.getZ() + o * k);
        };
    })(MOD3);
    (function(a) {
        a.LibraryThree = function() {
            this.id = "Three.js";
            this.meshClass = a.MeshThree;
            this.vertexClass = a.VertexThree;
        };
        a.LibraryThree.prototype = new a.Library3d;
        a.LibraryThree.prototype.constructor = a.LibraryThree;
    })(MOD3);
    (function(a) {
        a.VertexThree = function(a) {
            this.mesh = a;
        };
        a.VertexThree.prototype = new a.VertexProxy;
        a.VertexThree.prototype.setVertex = function(a) {
            this.vertex = a;
            this.originalX = a.x;
            this.originalY = a.y;
            this.originalZ = a.z;
        };
        a.VertexThree.prototype.getX = function() {
            return this.vertex.x
        };
        a.VertexThree.prototype.getY = function() {
            return this.vertex.y
        };
        a.VertexThree.prototype.getZ = function() {
            return this.vertex.z
        };
        a.VertexThree.prototype.setX = function(a) {
            this.vertex.x = a;
            a = this.mesh;
            a.geometry.verticesNeedUpdate = !0;
            a.geometry.normalsNeedUpdate = !0;
            a.geometry.buffersNeedUpdate = !0;
            a.geometry.dynamic = !0;
        };
        a.VertexThree.prototype.setY = function(a) {
            this.vertex.y = a;
            a = this.mesh;
            a.geometry.verticesNeedUpdate = !0;
            a.geometry.normalsNeedUpdate = !0;
            a.geometry.buffersNeedUpdate = !0;
            a.geometry.dynamic = !0;
        };
        a.VertexThree.prototype.setZ = function(a) {
            this.vertex.z = a;
            a = this.mesh;
            a.geometry.verticesNeedUpdate = !0;
            a.geometry.normalsNeedUpdate = !0;
            a.geometry.buffersNeedUpdate = !0;
            a.geometry.dynamic = !0;
        };
    })(MOD3);
    (function(a) {
        a.MeshThree = function() {};
        a.MeshThree.prototype = new a.MeshProxy;
        a.MeshThree.prototype.setMesh = function(c) {
            a.MeshProxy.prototype.setMesh.call(this, c);
            for (var c = [], b = 0, d = this.mesh.geometry.vertices, e = d.length, f = this.mesh.geometry.faces, g = f.length, h, b = 0; b < e;) h = new a.VertexThree(this.mesh), h.setVertex(d[b]), this.vertices.push(h), c[d[b]] = h, b++;
            for (b = 0; b < g;) e = new a.FaceProxy, f[b] instanceof THREE.Face3 ? (e.addVertex(c[d[f[b].a]]), e.addVertex(c[d[f[b].b]]), e.addVertex(c[d[f[b].c]])) : f[b] instanceof
            THREE.Face4 && (e.addVertex(c[d[f[b].a]]), e.addVertex(c[d[f[b].b]]), e.addVertex(c[d[f[b].c]]), e.addVertex(c[d[f[b].d]])), this.faces.push(e), b++;
            this.lookup = null;
        };
        a.MeshThree.prototype.updateMeshPosition = function(a) {
            var b = this.mesh;
            b.position.x += a.x;
            b.position.y += a.y;
            b.position.z += a.z;
        };
    })(MOD3);
    (function(a) {
        a.LibraryPre3D = function() {
            this.id = "pre3d.js";
            this.meshClass = a.MeshPre3D;
            this.vertexClass = a.VertexPre3D;
        };
        a.LibraryThree.prototype = new a.Library3d;
        a.LibraryThree.prototype.constructor = a.LibraryPre3D;
    })(MOD3);
    (function(a) {
        a.VertexPre3D = function() {};
        a.VertexPre3D.prototype = new a.VertexProxy;
        a.VertexPre3D.prototype.setVertex = function(a) {
            this.vertex = a;
            this.originalX = a.x;
            this.originalY = a.y;
            this.originalZ = a.z;
        };
        a.VertexPre3D.prototype.getX = function() {
            return this.vertex.x
        };
        a.VertexPre3D.prototype.getY = function() {
            return this.vertex.y
        };
        a.VertexPre3D.prototype.getZ = function() {
            return this.vertex.z
        };
        a.VertexPre3D.prototype.setX = function(a) {
            this.vertex.x = a;
        };
        a.VertexPre3D.prototype.setY = function(a) {
            this.vertex.y = a;
        };
        a.VertexPre3D.prototype.setZ = function(a) {
            this.vertex.z = a;
        };
    })(MOD3);
    (function(a) {
        a.MeshPre3D = function() {};
        a.MeshPre3D.prototype = new a.MeshProxy;
        a.MeshPre3D.prototype.setMesh = function(c) {
            a.MeshProxy.prototype.setMesh.call(this, c);
            for (var c = [], b = this.mesh.vertices, d = this.mesh.quads, e = b.length, f = d.length, g = 0; g < e; g++) {
                var h = new a.VertexPre3D;
                h.setVertex(b[g]);
                this.vertices.push(h);
                c[b[g]] = h;
            }
            for (g = 0; g < f; g++) e = new a.FaceProxy, d[g] instanceof Pre3d.QuadFace && (e.addVertex(c[b[d[g].i0]]), e.addVertex(c[b[d[g].i1]]), e.addVertex(c[b[d[g].i2]]), d[g].i3 != null && e.addVertex(c[b[d[g].i3]])),
                this.faces.push(e);
            this.lookup = null;
        };
        a.MeshPre3D.prototype.updateMeshPosition = function() {};
    })(MOD3);
    (function(a) {
        a.LibraryJ3D = function() {
            this.id = "J3D";
            this.meshClass = a.MeshJ3D;
            this.vertexClass = a.VertexJ3D;
        };
        a.LibraryJ3D.prototype = new a.Library3d;
        a.LibraryJ3D.prototype.constructor = a.LibraryJ3D;
    })(MOD3);
    (function(a) {
        a.VertexJ3D = function(a) {
            this.geometry = a;
        };
        a.VertexJ3D.prototype = new a.VertexProxy;
        a.VertexJ3D.prototype.setVertex = function(a) {
            this.vertex = a;
            var b = this.geometry;
            this.originalX = b.vertexPositionBuffer.data[a];
            this.originalY = b.vertexPositionBuffer.data[a + 1];
            this.originalZ = b.vertexPositionBuffer.data[a + 2];
        };
        a.VertexJ3D.prototype.getX = function() {
            return this.geometry.vertexPositionBuffer.data[this.vertex]
        };
        a.VertexJ3D.prototype.getY = function() {
            return this.geometry.vertexPositionBuffer.data[this.vertex +
                1]
        };
        a.VertexJ3D.prototype.getZ = function() {
            return this.geometry.vertexPositionBuffer.data[this.vertex + 2]
        };
        a.VertexJ3D.prototype.setX = function(a) {
            var b = this.geometry;
            b.vertexPositionBuffer.data[this.vertex] = a;
            b.replaceArray(b.vertexPositionBuffer, b.vertexPositionBuffer.data);
        };
        a.VertexJ3D.prototype.setY = function(a) {
            var b = this.geometry;
            b.vertexPositionBuffer.data[this.vertex + 1] = a;
            b.replaceArray(b.vertexPositionBuffer, b.vertexPositionBuffer.data);
        };
        a.VertexJ3D.prototype.setZ = function(a) {
            var b = this.geometry;
            b.vertexPositionBuffer.data[this.vertex + 2] = a;
            b.replaceArray(b.vertexPositionBuffer, b.vertexPositionBuffer.data);
        };
    })(MOD3);
    (function(a) {
        a.MeshJ3D = function() {};
        a.MeshJ3D.prototype = new a.MeshProxy;
        a.MeshJ3D.prototype.setMesh = function(c) {
            a.MeshProxy.prototype.setMesh.call(this, c);
            for (var b = 0, d = c.geometry.vertexPositionBuffer.data.length, e = c.geometry.vertexPositionBuffer.itemSize, f, b = 0; b < d;) f = new a.VertexJ3D(c.geometry), f.setVertex(b), this.vertices.push(f), b += e;
            this.faces = null;
        };
        a.MeshJ3D.prototype.updateMeshPosition = function(a) {
            var b = this.mesh;
            b.position.x += a.x;
            b.position.y += a.y;
            b.position.z += a.z;
        };
    })(MOD3);
    (function(a) {
        a.LibraryCopperlicht = function() {
            this.id = "Copperlicht";
            this.meshClass = a.MeshCopperlicht;
            this.vertexClass = a.VertexCopperlicht;
        };
        a.LibraryCopperlicht.prototype = new a.Library3d;
        a.LibraryCopperlicht.prototype.constructor = a.LibraryCopperlicht;
    })(MOD3);
    (function(a) {
        a.VertexCopperlicht = function(a, b) {
            this.node = a;
            this.buffer = b;
        };
        a.VertexCopperlicht.prototype = new a.VertexProxy;
        a.VertexCopperlicht.prototype.setVertex = function(a) {
            this.vertex = a;
            this.originalX = this.vertex.Pos.X;
            this.originalY = this.vertex.Pos.Y;
            this.originalZ = this.vertex.Pos.Z;
        };
        a.VertexCopperlicht.prototype.getX = function() {
            return this.vertex.Pos.X
        };
        a.VertexCopperlicht.prototype.getY = function() {
            return this.vertex.Pos.Y
        };
        a.VertexCopperlicht.prototype.getZ = function() {
            return this.vertex.Pos.Z
        };
        a.VertexCopperlicht.prototype.setX = function(a) {
            this.vertex.Pos.X = a;
            this.buffer.update(!0);
        };
        a.VertexCopperlicht.prototype.setY = function(a) {
            this.vertex.Pos.Y = a;
            this.buffer.update(!0);
        };
        a.VertexCopperlicht.prototype.setZ = function(a) {
            this.vertex.Pos.Z = a;
            this.buffer.update(!0);
        };
    })(MOD3);
    (function(a) {
        a.MeshCopperlicht = function() {};
        a.MeshCopperlicht.prototype = new a.MeshProxy;
        a.MeshCopperlicht.prototype.setMesh = function(c) {
            a.MeshProxy.prototype.setMesh.call(this, c);
            for (var c = this.mesh.getMesh().GetMeshBuffers(), b = [], d = 0; d < c.length; d++)
                for (var b = c[d].Vertices, e = b.length, f = 0; f < e; f++) {
                    var g = new a.VertexCopperlicht(this.mesh, c[d]);
                    g.setVertex(b[f]);
                    this.vertices.push(g);
                }
            this.faces = null;
            this.lookup = null;
        };
        a.MeshCopperlicht.prototype.updateMeshPosition = function(a) {
            this.mesh.Pos.X += a.x;
            this.mesh.Pos.Y +=
                a.y;
            this.mesh.Pos.Z += a.z;
        };
    })(MOD3);
}



{
    /**
     * Tween.js - Licensed under the MIT license
     * https://github.com/sole/tween.js
     * ----------------------------------------------
     *
     * See https://github.com/sole/tween.js/graphs/contributors for the full list of contributors.
     * Thank you all, you're awesome!
     */

    // performance.now polyfill
    (function(root) {

        if ('performance' in root === false) {
            root.performance = {};
        }

        // IE 8
        Date.now = (Date.now || function() {
            return new Date().getTime();
        });

        if ('now' in root.performance === false) {
            var offset = root.performance.timing && root.performance.timing.navigationStart ? performance.timing.navigationStart : Date.now();

            root.performance.now = function() {
                return Date.now() - offset;
            };
        }

    })(this);

    FLIPBOOK.TWEEN = FLIPBOOK.TWEEN || (function() {

        var _tweens = [];

        return {

            REVISION: '14',

            getAll: function() {

                return _tweens;

            },

            removeAll: function() {

                _tweens = [];

            },

            add: function(tween) {

                _tweens.push(tween);

            },

            remove: function(tween) {

                var i = _tweens.indexOf(tween);

                if (i !== -1) {

                    _tweens.splice(i, 1);

                }

            },

            update: function(time) {

                if (_tweens.length === 0) return false;

                var i = 0;

                time = time !== undefined ? time : window.performance.now();

                while (i < _tweens.length) {

                    if (_tweens[i].update(time)) {

                        i++;

                    } else {

                        _tweens.splice(i, 1);

                    }

                }

                return true;

            }
        };

    })();

    FLIPBOOK.TWEEN.Tween = function(object) {

        var _object = object;
        var _valuesStart = {};
        var _valuesEnd = {};
        var _valuesStartRepeat = {};
        var _duration = 1000;
        var _repeat = 0;
        var _yoyo = false;
        var _isPlaying = false;
        var _delayTime = 0;
        var _startTime = null;
        var _easingFunction = FLIPBOOK.TWEEN.Easing.Linear.None;
        var _interpolationFunction = FLIPBOOK.TWEEN.Interpolation.Linear;
        var _chainedTweens = [];
        var _onStartCallback = null;
        var _onStartCallbackFired = false;
        var _onUpdateCallback = null;
        var _onCompleteCallback = null;
        var _onStopCallback = null;

        // Set all starting values present on the target object
        for (var field in object) {

            _valuesStart[field] = parseFloat(object[field], 10);

        }

        this.to = function(properties, duration) {

            if (duration !== undefined) {

                _duration = duration;

            }

            _valuesEnd = properties;

            return this;

        };

        this.start = function(time) {

            FLIPBOOK.TWEEN.add(this);

            _isPlaying = true;

            _onStartCallbackFired = false;

            _startTime = time !== undefined ? time : window.performance.now();
            _startTime += _delayTime;

            for (var property in _valuesEnd) {

                // check if an Array was provided as property value
                if (_valuesEnd[property] instanceof Array) {

                    if (_valuesEnd[property].length === 0) {

                        continue;

                    }

                    // create a local copy of the Array with the start value at the front
                    _valuesEnd[property] = [_object[property]].concat(_valuesEnd[property]);

                }

                _valuesStart[property] = _object[property];

                if ((_valuesStart[property] instanceof Array) === false) {
                    _valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                }

                _valuesStartRepeat[property] = _valuesStart[property] || 0;

            }

            return this;

        };

        this.stop = function() {

            if (!_isPlaying) {
                return this;
            }

            FLIPBOOK.TWEEN.remove(this);
            _isPlaying = false;

            if (_onStopCallback !== null) {

                _onStopCallback.call(_object);

            }

            this.stopChainedTweens();
            return this;

        };

        this.stopChainedTweens = function() {

            for (var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++) {

                _chainedTweens[i].stop();

            }

        };

        this.delay = function(amount) {

            _delayTime = amount;
            return this;

        };

        this.repeat = function(times) {

            _repeat = times;
            return this;

        };

        this.yoyo = function(yoyo) {

            _yoyo = yoyo;
            return this;

        };


        this.easing = function(easing) {

            _easingFunction = easing;
            return this;

        };

        this.interpolation = function(interpolation) {

            _interpolationFunction = interpolation;
            return this;

        };

        this.chain = function() {

            _chainedTweens = arguments;
            return this;

        };

        this.onStart = function(callback) {

            _onStartCallback = callback;
            return this;

        };

        this.onUpdate = function(callback) {

            _onUpdateCallback = callback;
            return this;

        };

        this.onComplete = function(callback) {

            _onCompleteCallback = callback;
            return this;

        };

        this.onStop = function(callback) {

            _onStopCallback = callback;
            return this;

        };

        this.update = function(time) {

            var property;

            if (time < _startTime) {

                return true;

            }

            if (_onStartCallbackFired === false) {

                if (_onStartCallback !== null) {

                    _onStartCallback.call(_object);

                }

                _onStartCallbackFired = true;

            }

            var elapsed = (time - _startTime) / _duration;
            elapsed = elapsed > 1 ? 1 : elapsed;

            var value = _easingFunction(elapsed);

            for (property in _valuesEnd) {

                var start = _valuesStart[property] || 0;
                var end = _valuesEnd[property];

                if (end instanceof Array) {

                    _object[property] = _interpolationFunction(end, value);

                } else {

                    // Parses relative end values with start as base (e.g.: +10, -3)
                    if (typeof(end) === "string") {
                        end = start + parseFloat(end, 10);
                    }

                    // protect against non numeric properties.
                    if (typeof(end) === "number") {
                        _object[property] = start + (end - start) * value;
                    }

                }

            }

            if (_onUpdateCallback !== null) {

                _onUpdateCallback.call(_object, value);

            }

            if (elapsed == 1) {

                if (_repeat > 0) {

                    if (isFinite(_repeat)) {
                        _repeat--;
                    }

                    // reassign starting values, restart by making startTime = now
                    for (property in _valuesStartRepeat) {

                        if (typeof(_valuesEnd[property]) === "string") {
                            _valuesStartRepeat[property] = _valuesStartRepeat[property] + parseFloat(_valuesEnd[property], 10);
                        }

                        if (_yoyo) {
                            var tmp = _valuesStartRepeat[property];
                            _valuesStartRepeat[property] = _valuesEnd[property];
                            _valuesEnd[property] = tmp;
                        }

                        _valuesStart[property] = _valuesStartRepeat[property];

                    }

                    _startTime = time + _delayTime;

                    return true;

                } else {

                    if (_onCompleteCallback !== null) {

                        _onCompleteCallback.call(_object);

                    }

                    for (var i = 0, numChainedTweens = _chainedTweens.length; i < numChainedTweens; i++) {

                        _chainedTweens[i].start(time);

                    }

                    return false;

                }

            }

            return true;

        };

    };


    FLIPBOOK.TWEEN.Easing = {

        Linear: {

            None: function(k) {

                return k;

            }

        },

        Quadratic: {

            In: function(k) {

                return k * k;

            },

            Out: function(k) {

                return k * (2 - k);

            },

            InOut: function(k) {

                if ((k *= 2) < 1) return 0.5 * k * k;
                return -0.5 * (--k * (k - 2) - 1);

            }

        },

        Cubic: {

            In: function(k) {

                return k * k * k;

            },

            Out: function(k) {

                return --k * k * k + 1;

            },

            InOut: function(k) {

                if ((k *= 2) < 1) return 0.5 * k * k * k;
                return 0.5 * ((k -= 2) * k * k + 2);

            }

        },

        Quartic: {

            In: function(k) {

                return k * k * k * k;

            },

            Out: function(k) {

                return 1 - (--k * k * k * k);

            },

            InOut: function(k) {

                if ((k *= 2) < 1) return 0.5 * k * k * k * k;
                return -0.5 * ((k -= 2) * k * k * k - 2);

            }

        },

        Quintic: {

            In: function(k) {

                return k * k * k * k * k;

            },

            Out: function(k) {

                return --k * k * k * k * k + 1;

            },

            InOut: function(k) {

                if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
                return 0.5 * ((k -= 2) * k * k * k * k + 2);

            }

        },

        Sinusoidal: {

            In: function(k) {

                return 1 - Math.cos(k * Math.PI / 2);

            },

            Out: function(k) {

                return Math.sin(k * Math.PI / 2);

            },

            InOut: function(k) {

                return 0.5 * (1 - Math.cos(Math.PI * k));

            }

        },

        Exponential: {

            In: function(k) {

                return k === 0 ? 0 : Math.pow(1024, k - 1);

            },

            Out: function(k) {

                return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);

            },

            InOut: function(k) {

                if (k === 0) return 0;
                if (k === 1) return 1;
                if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
                return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);

            }

        },

        Circular: {

            In: function(k) {

                return 1 - Math.sqrt(1 - k * k);

            },

            Out: function(k) {

                return Math.sqrt(1 - (--k * k));

            },

            InOut: function(k) {

                if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
                return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);

            }

        },

        Elastic: {

            In: function(k) {

                var s, a = 0.1,
                    p = 0.4;
                if (k === 0) return 0;
                if (k === 1) return 1;
                if (!a || a < 1) {
                    a = 1;
                    s = p / 4;
                } else s = p * Math.asin(1 / a) / (2 * Math.PI);
                return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));

            },

            Out: function(k) {

                var s, a = 0.1,
                    p = 0.4;
                if (k === 0) return 0;
                if (k === 1) return 1;
                if (!a || a < 1) {
                    a = 1;
                    s = p / 4;
                } else s = p * Math.asin(1 / a) / (2 * Math.PI);
                return (a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1);

            },

            InOut: function(k) {

                var s, a = 0.1,
                    p = 0.4;
                if (k === 0) return 0;
                if (k === 1) return 1;
                if (!a || a < 1) {
                    a = 1;
                    s = p / 4;
                } else s = p * Math.asin(1 / a) / (2 * Math.PI);
                if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
                return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;

            }

        },

        Back: {

            In: function(k) {

                var s = 1.70158;
                return k * k * ((s + 1) * k - s);

            },

            Out: function(k) {

                var s = 1.70158;
                return --k * k * ((s + 1) * k + s) + 1;

            },

            InOut: function(k) {

                var s = 1.70158 * 1.525;
                if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
                return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);

            }

        },

        Bounce: {

            In: function(k) {

                return 1 - FLIPBOOK.TWEEN.Easing.Bounce.Out(1 - k);

            },

            Out: function(k) {

                if (k < (1 / 2.75)) {

                    return 7.5625 * k * k;

                } else if (k < (2 / 2.75)) {

                    return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;

                } else if (k < (2.5 / 2.75)) {

                    return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;

                } else {

                    return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;

                }

            },

            InOut: function(k) {

                if (k < 0.5) return FLIPBOOK.TWEEN.Easing.Bounce.In(k * 2) * 0.5;
                return FLIPBOOK.TWEEN.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;

            }

        }

    };

    FLIPBOOK.TWEEN.Interpolation = {

        Linear: function(v, k) {

            var m = v.length - 1,
                f = m * k,
                i = Math.floor(f),
                fn = FLIPBOOK.TWEEN.Interpolation.Utils.Linear;

            if (k < 0) return fn(v[0], v[1], f);
            if (k > 1) return fn(v[m], v[m - 1], m - f);

            return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);

        },

        Bezier: function(v, k) {

            var b = 0,
                n = v.length - 1,
                pw = Math.pow,
                bn = FLIPBOOK.TWEEN.Interpolation.Utils.Bernstein,
                i;

            for (i = 0; i <= n; i++) {
                b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
            }

            return b;

        },

        CatmullRom: function(v, k) {

            var m = v.length - 1,
                f = m * k,
                i = Math.floor(f),
                fn = FLIPBOOK.TWEEN.Interpolation.Utils.CatmullRom;

            if (v[0] === v[m]) {

                if (k < 0) i = Math.floor(f = m * (1 + k));

                return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);

            } else {

                if (k < 0) return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
                if (k > 1) return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);

                return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);

            }

        },

        Utils: {

            Linear: function(p0, p1, t) {

                return (p1 - p0) * t + p0;

            },

            Bernstein: function(n, i) {

                var fc = FLIPBOOK.TWEEN.Interpolation.Utils.Factorial;
                return fc(n) / fc(i) / fc(n - i);

            },

            Factorial: (function() {

                var a = [1];

                return function(n) {

                    var s = 1,
                        i;
                    if (a[n]) return a[n];
                    for (i = n; i > 1; i--) s *= i;
                    return a[n] = s;

                };

            })(),

            CatmullRom: function(p0, p1, p2, p3, t) {

                var v0 = (p2 - p0) * 0.5,
                    v1 = (p3 - p1) * 0.5,
                    t2 = t * t,
                    t3 = t * t2;
                return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;

            }

        }

    };

}

{


    /**
     * Based on http://www.emagix.net/academic/mscs-project/item/camera-sync-with-css3-and-webgl-threejs
     * @author mrdoob / http://mrdoob.com/
     * @author yomotsu / https://yomotsu.net/
     */

    FLIPBOOK.CSS3DObject = function ( element ) {

        THREE.Object3D.call( this );

        this.element = element;
        this.element.style.position = 'absolute';
        this.element.style.pointerEvents = 'auto';

        this.addEventListener( 'removed', function () {

            this.traverse( function ( object ) {

                if ( object.element instanceof Element && object.element.parentNode !== null ) {

                    object.element.parentNode.removeChild( object.element );

                }

            } );

        } );

    };

    FLIPBOOK.CSS3DObject.prototype = Object.create( THREE.Object3D.prototype );
    FLIPBOOK.CSS3DObject.prototype.constructor = FLIPBOOK.CSS3DObject;

    FLIPBOOK.CSS3DSprite = function ( element ) {

        FLIPBOOK.CSS3DObject.call( this, element );

    };

    FLIPBOOK.CSS3DSprite.prototype = Object.create( FLIPBOOK.CSS3DObject.prototype );
    FLIPBOOK.CSS3DSprite.prototype.constructor = FLIPBOOK.CSS3DSprite;

    //

    FLIPBOOK.CSS3DRenderer = function () {

        var _this = this;

        var _width, _height;
        var _widthHalf, _heightHalf;

        var matrix = new THREE.Matrix4();

        var cache = {
            camera: { fov: 0, style: '' },
            objects: new WeakMap()
        };

        var domElement = document.createElement( 'div' );
        domElement.style.overflow = 'hidden';

        this.domElement = domElement;

        var cameraElement = document.createElement( 'div' );

        cameraElement.style.WebkitTransformStyle = 'preserve-3d';
        cameraElement.style.transformStyle = 'preserve-3d';
        cameraElement.style.pointerEvents = 'none';

        domElement.appendChild( cameraElement );

        var isIE = /Trident/i.test( navigator.userAgent );

        this.getSize = function () {

            return {
                width: _width,
                height: _height
            };

        };

        this.setSize = function ( width, height ) {

            _width = width;
            _height = height;
            _widthHalf = _width / 2;
            _heightHalf = _height / 2;

            domElement.style.width = width + 'px';
            domElement.style.height = height + 'px';

            cameraElement.style.width = width + 'px';
            cameraElement.style.height = height + 'px';

        };

        function epsilon( value ) {

            return Math.abs( value ) < 1e-10 ? 0 : value;

        }

        function getCameraCSSMatrix( matrix ) {

            var elements = matrix.elements;

            return 'matrix3d(' +
                epsilon( elements[ 0 ] ) + ',' +
                epsilon( - elements[ 1 ] ) + ',' +
                epsilon( elements[ 2 ] ) + ',' +
                epsilon( elements[ 3 ] ) + ',' +
                epsilon( elements[ 4 ] ) + ',' +
                epsilon( - elements[ 5 ] ) + ',' +
                epsilon( elements[ 6 ] ) + ',' +
                epsilon( elements[ 7 ] ) + ',' +
                epsilon( elements[ 8 ] ) + ',' +
                epsilon( - elements[ 9 ] ) + ',' +
                epsilon( elements[ 10 ] ) + ',' +
                epsilon( elements[ 11 ] ) + ',' +
                epsilon( elements[ 12 ] ) + ',' +
                epsilon( - elements[ 13 ] ) + ',' +
                epsilon( elements[ 14 ] ) + ',' +
                epsilon( elements[ 15 ] ) +
            ')';

        }

        function getObjectCSSMatrix( matrix, cameraCSSMatrix ) {

            var elements = matrix.elements;
            var matrix3d = 'matrix3d(' +
                epsilon( elements[ 0 ] ) + ',' +
                epsilon( elements[ 1 ] ) + ',' +
                epsilon( elements[ 2 ] ) + ',' +
                epsilon( elements[ 3 ] ) + ',' +
                epsilon( - elements[ 4 ] ) + ',' +
                epsilon( - elements[ 5 ] ) + ',' +
                epsilon( - elements[ 6 ] ) + ',' +
                epsilon( - elements[ 7 ] ) + ',' +
                epsilon( elements[ 8 ] ) + ',' +
                epsilon( elements[ 9 ] ) + ',' +
                epsilon( elements[ 10 ] ) + ',' +
                epsilon( elements[ 11 ] ) + ',' +
                epsilon( elements[ 12 ] ) + ',' +
                epsilon( elements[ 13 ] ) + ',' +
                epsilon( elements[ 14 ] ) + ',' +
                epsilon( elements[ 15 ] ) +
            ')';

            if ( isIE ) {

                return 'translate(-50%,-50%)' +
                    'translate(' + _widthHalf + 'px,' + _heightHalf + 'px)' +
                    cameraCSSMatrix +
                    matrix3d;

            }

            return 'translate(-50%,-50%)' + matrix3d;

        }

        function renderObject( object, scene, camera, cameraCSSMatrix ) {

            if ( object instanceof FLIPBOOK.CSS3DObject ) {

                object.onBeforeRender( _this, scene, camera );

                var style;

                if ( object instanceof FLIPBOOK.CSS3DSprite ) {

                    // http://swiftcoder.wordpress.com/2008/11/25/constructing-a-billboard-matrix/

                    matrix.copy( camera.matrixWorldInverse );
                    matrix.transpose();
                    matrix.copyPosition( object.matrixWorld );
                    matrix.scale( object.scale );

                    matrix.elements[ 3 ] = 0;
                    matrix.elements[ 7 ] = 0;
                    matrix.elements[ 11 ] = 0;
                    matrix.elements[ 15 ] = 1;

                    style = getObjectCSSMatrix( matrix, cameraCSSMatrix );

                } else {

                    style = getObjectCSSMatrix( object.matrixWorld, cameraCSSMatrix );

                }

                var element = object.element;
                var cachedObject = cache.objects.get( object );

                if ( cachedObject === undefined || cachedObject.style !== style ) {

                    element.style.WebkitTransform = style;
                    element.style.transform = style;

                    var objectData = { style: style };

                    if ( isIE ) {

                        objectData.distanceToCameraSquared = getDistanceToSquared( camera, object );

                    }

                    cache.objects.set( object, objectData );

                }

                if ( element.parentNode !== cameraElement ) {

                    cameraElement.appendChild( element );

                }

                object.onAfterRender( _this, scene, camera );

            }

            for ( var i = 0, l = object.children.length; i < l; i ++ ) {

                renderObject( object.children[ i ], scene, camera, cameraCSSMatrix );

            }

        }

        var getDistanceToSquared = function () {

            var a = new THREE.Vector3();
            var b = new THREE.Vector3();

            return function ( object1, object2 ) {

                a.setFromMatrixPosition( object1.matrixWorld );
                b.setFromMatrixPosition( object2.matrixWorld );

                return a.distanceToSquared( b );

            };

        }();

        function filterAndFlatten( scene ) {

            var result = [];

            scene.traverse( function ( object ) {

                if ( object instanceof THREE.CSS3DObject ) result.push( object );

            } );

            return result;

        }

        function zOrder( scene ) {

            var sorted = filterAndFlatten( scene ).sort( function ( a, b ) {

                var distanceA = cache.objects.get( a ).distanceToCameraSquared;
                var distanceB = cache.objects.get( b ).distanceToCameraSquared;

                return distanceA - distanceB;

            } );

            var zMax = sorted.length;

            for ( var i = 0, l = sorted.length; i < l; i ++ ) {

                sorted[ i ].element.style.zIndex = zMax - i;

            }

        }

        this.render = function ( scene, camera ) {

            var fov = camera.projectionMatrix.elements[ 5 ] * _heightHalf;

            if ( cache.camera.fov !== fov ) {

                if ( camera.isPerspectiveCamera ) {

                    domElement.style.WebkitPerspective = fov + 'px';
                    domElement.style.perspective = fov + 'px';

                } else {

                    domElement.style.WebkitPerspective = '';
                    domElement.style.perspective = '';

                }

                cache.camera.fov = fov;

            }

            if ( scene.autoUpdate === true ) scene.updateMatrixWorld();
            if ( camera.parent === null ) camera.updateMatrixWorld();

            if ( camera.isOrthographicCamera ) {

                var tx = - ( camera.right + camera.left ) / 2;
                var ty = ( camera.top + camera.bottom ) / 2;

            }

            var cameraCSSMatrix = camera.isOrthographicCamera ?
                'scale(' + fov + ')' + 'translate(' + epsilon( tx ) + 'px,' + epsilon( ty ) + 'px)' + getCameraCSSMatrix( camera.matrixWorldInverse ) :
                'translateZ(' + fov + 'px)' + getCameraCSSMatrix( camera.matrixWorldInverse );

            var style = cameraCSSMatrix +
                'translate(' + _widthHalf + 'px,' + _heightHalf + 'px)';

            if ( cache.camera.style !== style && ! isIE ) {

                cameraElement.style.WebkitTransform = style;
                cameraElement.style.transform = style;

                cache.camera.style = style;

            }

            renderObject( scene, scene, camera, cameraCSSMatrix );

            if ( isIE ) {

                // IE10 and 11 does not support 'preserve-3d'.
                // Thus, z-order in 3D will not work.
                // We have to calc z-order manually and set CSS z-index for IE.
                // FYI: z-index can't handle object intersection
                zOrder( scene );

            }

        };

    };

}
